var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};

// src/components/Map.tsx
import { useEffect as useEffect3, useState as useState5, useCallback as useCallback2, useMemo as useMemo2 } from "react";
import { CRS } from "leaflet";
import { MapContainer, ImageOverlay } from "react-leaflet";
import styled from "styled-components";

// src/assets/default_bg.png
var default_bg_default = "./default_bg-LGOODZN5.png";

// src/components/DraggableRectangle.tsx
import { Rectangle } from "react-leaflet";

// src/hooks/useDraggableShape.ts
import { LatLngBounds, tooltip as LeafletTooltip } from "leaflet";
import { useCallback, useEffect, useRef, useState } from "react";
import { useMap, useMapEvents } from "react-leaflet";

// ../node_modules/zod/lib/index.mjs
var util;
(function(util2) {
  util2.assertEqual = (val) => val;
  function assertIs(_arg) {
  }
  util2.assertIs = assertIs;
  function assertNever(_x) {
    throw new Error();
  }
  util2.assertNever = assertNever;
  util2.arrayToEnum = (items) => {
    const obj = {};
    for (const item of items) {
      obj[item] = item;
    }
    return obj;
  };
  util2.getValidEnumValues = (obj) => {
    const validKeys = util2.objectKeys(obj).filter((k) => typeof obj[obj[k]] !== "number");
    const filtered = {};
    for (const k of validKeys) {
      filtered[k] = obj[k];
    }
    return util2.objectValues(filtered);
  };
  util2.objectValues = (obj) => {
    return util2.objectKeys(obj).map(function(e) {
      return obj[e];
    });
  };
  util2.objectKeys = typeof Object.keys === "function" ? (obj) => Object.keys(obj) : (object) => {
    const keys = [];
    for (const key in object) {
      if (Object.prototype.hasOwnProperty.call(object, key)) {
        keys.push(key);
      }
    }
    return keys;
  };
  util2.find = (arr, checker) => {
    for (const item of arr) {
      if (checker(item))
        return item;
    }
    return void 0;
  };
  util2.isInteger = typeof Number.isInteger === "function" ? (val) => Number.isInteger(val) : (val) => typeof val === "number" && isFinite(val) && Math.floor(val) === val;
  function joinValues(array, separator = " | ") {
    return array.map((val) => typeof val === "string" ? `'${val}'` : val).join(separator);
  }
  util2.joinValues = joinValues;
  util2.jsonStringifyReplacer = (_, value) => {
    if (typeof value === "bigint") {
      return value.toString();
    }
    return value;
  };
})(util || (util = {}));
var objectUtil;
(function(objectUtil2) {
  objectUtil2.mergeShapes = (first, second) => {
    return {
      ...first,
      ...second
      // second overwrites first
    };
  };
})(objectUtil || (objectUtil = {}));
var ZodParsedType = util.arrayToEnum([
  "string",
  "nan",
  "number",
  "integer",
  "float",
  "boolean",
  "date",
  "bigint",
  "symbol",
  "function",
  "undefined",
  "null",
  "array",
  "object",
  "unknown",
  "promise",
  "void",
  "never",
  "map",
  "set"
]);
var getParsedType = (data) => {
  const t = typeof data;
  switch (t) {
    case "undefined":
      return ZodParsedType.undefined;
    case "string":
      return ZodParsedType.string;
    case "number":
      return isNaN(data) ? ZodParsedType.nan : ZodParsedType.number;
    case "boolean":
      return ZodParsedType.boolean;
    case "function":
      return ZodParsedType.function;
    case "bigint":
      return ZodParsedType.bigint;
    case "symbol":
      return ZodParsedType.symbol;
    case "object":
      if (Array.isArray(data)) {
        return ZodParsedType.array;
      }
      if (data === null) {
        return ZodParsedType.null;
      }
      if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") {
        return ZodParsedType.promise;
      }
      if (typeof Map !== "undefined" && data instanceof Map) {
        return ZodParsedType.map;
      }
      if (typeof Set !== "undefined" && data instanceof Set) {
        return ZodParsedType.set;
      }
      if (typeof Date !== "undefined" && data instanceof Date) {
        return ZodParsedType.date;
      }
      return ZodParsedType.object;
    default:
      return ZodParsedType.unknown;
  }
};
var ZodIssueCode = util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
var quotelessJson = (obj) => {
  const json = JSON.stringify(obj, null, 2);
  return json.replace(/"([^"]+)":/g, "$1:");
};
var ZodError = class extends Error {
  constructor(issues) {
    super();
    this.issues = [];
    this.addIssue = (sub) => {
      this.issues = [...this.issues, sub];
    };
    this.addIssues = (subs = []) => {
      this.issues = [...this.issues, ...subs];
    };
    const actualProto = new.target.prototype;
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(this, actualProto);
    } else {
      this.__proto__ = actualProto;
    }
    this.name = "ZodError";
    this.issues = issues;
  }
  get errors() {
    return this.issues;
  }
  format(_mapper) {
    const mapper = _mapper || function(issue) {
      return issue.message;
    };
    const fieldErrors = { _errors: [] };
    const processError = (error) => {
      for (const issue of error.issues) {
        if (issue.code === "invalid_union") {
          issue.unionErrors.map(processError);
        } else if (issue.code === "invalid_return_type") {
          processError(issue.returnTypeError);
        } else if (issue.code === "invalid_arguments") {
          processError(issue.argumentsError);
        } else if (issue.path.length === 0) {
          fieldErrors._errors.push(mapper(issue));
        } else {
          let curr = fieldErrors;
          let i = 0;
          while (i < issue.path.length) {
            const el = issue.path[i];
            const terminal = i === issue.path.length - 1;
            if (!terminal) {
              curr[el] = curr[el] || { _errors: [] };
            } else {
              curr[el] = curr[el] || { _errors: [] };
              curr[el]._errors.push(mapper(issue));
            }
            curr = curr[el];
            i++;
          }
        }
      }
    };
    processError(this);
    return fieldErrors;
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(mapper = (issue) => issue.message) {
    const fieldErrors = {};
    const formErrors = [];
    for (const sub of this.issues) {
      if (sub.path.length > 0) {
        fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
        fieldErrors[sub.path[0]].push(mapper(sub));
      } else {
        formErrors.push(mapper(sub));
      }
    }
    return { formErrors, fieldErrors };
  }
  get formErrors() {
    return this.flatten();
  }
};
ZodError.create = (issues) => {
  const error = new ZodError(issues);
  return error;
};
var errorMap = (issue, _ctx) => {
  let message;
  switch (issue.code) {
    case ZodIssueCode.invalid_type:
      if (issue.received === ZodParsedType.undefined) {
        message = "Required";
      } else {
        message = `Expected ${issue.expected}, received ${issue.received}`;
      }
      break;
    case ZodIssueCode.invalid_literal:
      message = `Invalid literal value, expected ${JSON.stringify(issue.expected, util.jsonStringifyReplacer)}`;
      break;
    case ZodIssueCode.unrecognized_keys:
      message = `Unrecognized key(s) in object: ${util.joinValues(issue.keys, ", ")}`;
      break;
    case ZodIssueCode.invalid_union:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_union_discriminator:
      message = `Invalid discriminator value. Expected ${util.joinValues(issue.options)}`;
      break;
    case ZodIssueCode.invalid_enum_value:
      message = `Invalid enum value. Expected ${util.joinValues(issue.options)}, received '${issue.received}'`;
      break;
    case ZodIssueCode.invalid_arguments:
      message = `Invalid function arguments`;
      break;
    case ZodIssueCode.invalid_return_type:
      message = `Invalid function return type`;
      break;
    case ZodIssueCode.invalid_date:
      message = `Invalid date`;
      break;
    case ZodIssueCode.invalid_string:
      if (typeof issue.validation === "object") {
        if ("includes" in issue.validation) {
          message = `Invalid input: must include "${issue.validation.includes}"`;
          if (typeof issue.validation.position === "number") {
            message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
          }
        } else if ("startsWith" in issue.validation) {
          message = `Invalid input: must start with "${issue.validation.startsWith}"`;
        } else if ("endsWith" in issue.validation) {
          message = `Invalid input: must end with "${issue.validation.endsWith}"`;
        } else {
          util.assertNever(issue.validation);
        }
      } else if (issue.validation !== "regex") {
        message = `Invalid ${issue.validation}`;
      } else {
        message = "Invalid";
      }
      break;
    case ZodIssueCode.too_small:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.too_big:
      if (issue.type === "array")
        message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
      else if (issue.type === "string")
        message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
      else if (issue.type === "number")
        message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "bigint")
        message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
      else if (issue.type === "date")
        message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
      else
        message = "Invalid input";
      break;
    case ZodIssueCode.custom:
      message = `Invalid input`;
      break;
    case ZodIssueCode.invalid_intersection_types:
      message = `Intersection results could not be merged`;
      break;
    case ZodIssueCode.not_multiple_of:
      message = `Number must be a multiple of ${issue.multipleOf}`;
      break;
    case ZodIssueCode.not_finite:
      message = "Number must be finite";
      break;
    default:
      message = _ctx.defaultError;
      util.assertNever(issue);
  }
  return { message };
};
var overrideErrorMap = errorMap;
function setErrorMap(map) {
  overrideErrorMap = map;
}
function getErrorMap() {
  return overrideErrorMap;
}
var makeIssue = (params) => {
  const { data, path, errorMaps, issueData } = params;
  const fullPath = [...path, ...issueData.path || []];
  const fullIssue = {
    ...issueData,
    path: fullPath
  };
  let errorMessage = "";
  const maps = errorMaps.filter((m) => !!m).slice().reverse();
  for (const map of maps) {
    errorMessage = map(fullIssue, { data, defaultError: errorMessage }).message;
  }
  return {
    ...issueData,
    path: fullPath,
    message: issueData.message || errorMessage
  };
};
var EMPTY_PATH = [];
function addIssueToContext(ctx, issueData) {
  const issue = makeIssue({
    issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [
      ctx.common.contextualErrorMap,
      ctx.schemaErrorMap,
      getErrorMap(),
      errorMap
      // then global default map
    ].filter((x) => !!x)
  });
  ctx.common.issues.push(issue);
}
var ParseStatus = class {
  constructor() {
    this.value = "valid";
  }
  dirty() {
    if (this.value === "valid")
      this.value = "dirty";
  }
  abort() {
    if (this.value !== "aborted")
      this.value = "aborted";
  }
  static mergeArray(status, results) {
    const arrayValue = [];
    for (const s of results) {
      if (s.status === "aborted")
        return INVALID;
      if (s.status === "dirty")
        status.dirty();
      arrayValue.push(s.value);
    }
    return { status: status.value, value: arrayValue };
  }
  static async mergeObjectAsync(status, pairs) {
    const syncPairs = [];
    for (const pair of pairs) {
      syncPairs.push({
        key: await pair.key,
        value: await pair.value
      });
    }
    return ParseStatus.mergeObjectSync(status, syncPairs);
  }
  static mergeObjectSync(status, pairs) {
    const finalObject = {};
    for (const pair of pairs) {
      const { key, value } = pair;
      if (key.status === "aborted")
        return INVALID;
      if (value.status === "aborted")
        return INVALID;
      if (key.status === "dirty")
        status.dirty();
      if (value.status === "dirty")
        status.dirty();
      if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
        finalObject[key.value] = value.value;
      }
    }
    return { status: status.value, value: finalObject };
  }
};
var INVALID = Object.freeze({
  status: "aborted"
});
var DIRTY = (value) => ({ status: "dirty", value });
var OK = (value) => ({ status: "valid", value });
var isAborted = (x) => x.status === "aborted";
var isDirty = (x) => x.status === "dirty";
var isValid = (x) => x.status === "valid";
var isAsync = (x) => typeof Promise !== "undefined" && x instanceof Promise;
var errorUtil;
(function(errorUtil2) {
  errorUtil2.errToObj = (message) => typeof message === "string" ? { message } : message || {};
  errorUtil2.toString = (message) => typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})(errorUtil || (errorUtil = {}));
var ParseInputLazyPath = class {
  constructor(parent, value, path, key) {
    this._cachedPath = [];
    this.parent = parent;
    this.data = value;
    this._path = path;
    this._key = key;
  }
  get path() {
    if (!this._cachedPath.length) {
      if (this._key instanceof Array) {
        this._cachedPath.push(...this._path, ...this._key);
      } else {
        this._cachedPath.push(...this._path, this._key);
      }
    }
    return this._cachedPath;
  }
};
var handleResult = (ctx, result2) => {
  if (isValid(result2)) {
    return { success: true, data: result2.value };
  } else {
    if (!ctx.common.issues.length) {
      throw new Error("Validation failed but no issues detected.");
    }
    return {
      success: false,
      get error() {
        if (this._error)
          return this._error;
        const error = new ZodError(ctx.common.issues);
        this._error = error;
        return this._error;
      }
    };
  }
};
function processCreateParams(params) {
  if (!params)
    return {};
  const { errorMap: errorMap2, invalid_type_error, required_error, description } = params;
  if (errorMap2 && (invalid_type_error || required_error)) {
    throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
  }
  if (errorMap2)
    return { errorMap: errorMap2, description };
  const customMap = (iss, ctx) => {
    if (iss.code !== "invalid_type")
      return { message: ctx.defaultError };
    if (typeof ctx.data === "undefined") {
      return { message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError };
    }
    return { message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError };
  };
  return { errorMap: customMap, description };
}
var ZodType = class {
  constructor(def) {
    this.spa = this.safeParseAsync;
    this._def = def;
    this.parse = this.parse.bind(this);
    this.safeParse = this.safeParse.bind(this);
    this.parseAsync = this.parseAsync.bind(this);
    this.safeParseAsync = this.safeParseAsync.bind(this);
    this.spa = this.spa.bind(this);
    this.refine = this.refine.bind(this);
    this.refinement = this.refinement.bind(this);
    this.superRefine = this.superRefine.bind(this);
    this.optional = this.optional.bind(this);
    this.nullable = this.nullable.bind(this);
    this.nullish = this.nullish.bind(this);
    this.array = this.array.bind(this);
    this.promise = this.promise.bind(this);
    this.or = this.or.bind(this);
    this.and = this.and.bind(this);
    this.transform = this.transform.bind(this);
    this.brand = this.brand.bind(this);
    this.default = this.default.bind(this);
    this.catch = this.catch.bind(this);
    this.describe = this.describe.bind(this);
    this.pipe = this.pipe.bind(this);
    this.readonly = this.readonly.bind(this);
    this.isNullable = this.isNullable.bind(this);
    this.isOptional = this.isOptional.bind(this);
  }
  get description() {
    return this._def.description;
  }
  _getType(input) {
    return getParsedType(input.data);
  }
  _getOrReturnCtx(input, ctx) {
    return ctx || {
      common: input.parent.common,
      data: input.data,
      parsedType: getParsedType(input.data),
      schemaErrorMap: this._def.errorMap,
      path: input.path,
      parent: input.parent
    };
  }
  _processInputParams(input) {
    return {
      status: new ParseStatus(),
      ctx: {
        common: input.parent.common,
        data: input.data,
        parsedType: getParsedType(input.data),
        schemaErrorMap: this._def.errorMap,
        path: input.path,
        parent: input.parent
      }
    };
  }
  _parseSync(input) {
    const result2 = this._parse(input);
    if (isAsync(result2)) {
      throw new Error("Synchronous parse encountered promise.");
    }
    return result2;
  }
  _parseAsync(input) {
    const result2 = this._parse(input);
    return Promise.resolve(result2);
  }
  parse(data, params) {
    const result2 = this.safeParse(data, params);
    if (result2.success)
      return result2.data;
    throw result2.error;
  }
  safeParse(data, params) {
    var _a2;
    const ctx = {
      common: {
        issues: [],
        async: (_a2 = params === null || params === void 0 ? void 0 : params.async) !== null && _a2 !== void 0 ? _a2 : false,
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const result2 = this._parseSync({ data, path: ctx.path, parent: ctx });
    return handleResult(ctx, result2);
  }
  async parseAsync(data, params) {
    const result2 = await this.safeParseAsync(data, params);
    if (result2.success)
      return result2.data;
    throw result2.error;
  }
  async safeParseAsync(data, params) {
    const ctx = {
      common: {
        issues: [],
        contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
        async: true
      },
      path: (params === null || params === void 0 ? void 0 : params.path) || [],
      schemaErrorMap: this._def.errorMap,
      parent: null,
      data,
      parsedType: getParsedType(data)
    };
    const maybeAsyncResult = this._parse({ data, path: ctx.path, parent: ctx });
    const result2 = await (isAsync(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
    return handleResult(ctx, result2);
  }
  refine(check, message) {
    const getIssueProperties = (val) => {
      if (typeof message === "string" || typeof message === "undefined") {
        return { message };
      } else if (typeof message === "function") {
        return message(val);
      } else {
        return message;
      }
    };
    return this._refinement((val, ctx) => {
      const result2 = check(val);
      const setError = () => ctx.addIssue({
        code: ZodIssueCode.custom,
        ...getIssueProperties(val)
      });
      if (typeof Promise !== "undefined" && result2 instanceof Promise) {
        return result2.then((data) => {
          if (!data) {
            setError();
            return false;
          } else {
            return true;
          }
        });
      }
      if (!result2) {
        setError();
        return false;
      } else {
        return true;
      }
    });
  }
  refinement(check, refinementData) {
    return this._refinement((val, ctx) => {
      if (!check(val)) {
        ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
        return false;
      } else {
        return true;
      }
    });
  }
  _refinement(refinement) {
    return new ZodEffects({
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "refinement", refinement }
    });
  }
  superRefine(refinement) {
    return this._refinement(refinement);
  }
  optional() {
    return ZodOptional.create(this, this._def);
  }
  nullable() {
    return ZodNullable.create(this, this._def);
  }
  nullish() {
    return this.nullable().optional();
  }
  array() {
    return ZodArray.create(this, this._def);
  }
  promise() {
    return ZodPromise.create(this, this._def);
  }
  or(option) {
    return ZodUnion.create([this, option], this._def);
  }
  and(incoming) {
    return ZodIntersection.create(this, incoming, this._def);
  }
  transform(transform) {
    return new ZodEffects({
      ...processCreateParams(this._def),
      schema: this,
      typeName: ZodFirstPartyTypeKind.ZodEffects,
      effect: { type: "transform", transform }
    });
  }
  default(def) {
    const defaultValueFunc = typeof def === "function" ? def : () => def;
    return new ZodDefault({
      ...processCreateParams(this._def),
      innerType: this,
      defaultValue: defaultValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodDefault
    });
  }
  brand() {
    return new ZodBranded({
      typeName: ZodFirstPartyTypeKind.ZodBranded,
      type: this,
      ...processCreateParams(this._def)
    });
  }
  catch(def) {
    const catchValueFunc = typeof def === "function" ? def : () => def;
    return new ZodCatch({
      ...processCreateParams(this._def),
      innerType: this,
      catchValue: catchValueFunc,
      typeName: ZodFirstPartyTypeKind.ZodCatch
    });
  }
  describe(description) {
    const This = this.constructor;
    return new This({
      ...this._def,
      description
    });
  }
  pipe(target) {
    return ZodPipeline.create(this, target);
  }
  readonly() {
    return ZodReadonly.create(this);
  }
  isOptional() {
    return this.safeParse(void 0).success;
  }
  isNullable() {
    return this.safeParse(null).success;
  }
};
var cuidRegex = /^c[^\s-]{8,}$/i;
var cuid2Regex = /^[a-z][a-z0-9]*$/;
var ulidRegex = /[0-9A-HJKMNP-TV-Z]{26}/;
var uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
var emailRegex = /^([A-Z0-9_+-]+\.?)*[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
var emojiRegex = /^(\p{Extended_Pictographic}|\p{Emoji_Component})+$/u;
var ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
var ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
var datetimeRegex = (args) => {
  if (args.precision) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    }
  } else if (args.precision === 0) {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    }
  } else {
    if (args.offset) {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
    } else {
      return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
  }
};
function isValidIP(ip, version) {
  if ((version === "v4" || !version) && ipv4Regex.test(ip)) {
    return true;
  }
  if ((version === "v6" || !version) && ipv6Regex.test(ip)) {
    return true;
  }
  return false;
}
var ZodString = class extends ZodType {
  constructor() {
    super(...arguments);
    this._regex = (regex, validation, message) => this.refinement((data) => regex.test(data), {
      validation,
      code: ZodIssueCode.invalid_string,
      ...errorUtil.errToObj(message)
    });
    this.nonempty = (message) => this.min(1, errorUtil.errToObj(message));
    this.trim = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "trim" }]
    });
    this.toLowerCase = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toLowerCase" }]
    });
    this.toUpperCase = () => new ZodString({
      ...this._def,
      checks: [...this._def.checks, { kind: "toUpperCase" }]
    });
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = String(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.string) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(
        ctx2,
        {
          code: ZodIssueCode.invalid_type,
          expected: ZodParsedType.string,
          received: ctx2.parsedType
        }
        //
      );
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.length < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.length > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "string",
            inclusive: true,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "length") {
        const tooBig = input.data.length > check.value;
        const tooSmall = input.data.length < check.value;
        if (tooBig || tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          if (tooBig) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_big,
              maximum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          } else if (tooSmall) {
            addIssueToContext(ctx, {
              code: ZodIssueCode.too_small,
              minimum: check.value,
              type: "string",
              inclusive: true,
              exact: true,
              message: check.message
            });
          }
          status.dirty();
        }
      } else if (check.kind === "email") {
        if (!emailRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "email",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "emoji") {
        if (!emojiRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "emoji",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "uuid") {
        if (!uuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "uuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid") {
        if (!cuidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "cuid2") {
        if (!cuid2Regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "cuid2",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ulid") {
        if (!ulidRegex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ulid",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "url") {
        try {
          new URL(input.data);
        } catch (_a2) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "url",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "regex") {
        check.regex.lastIndex = 0;
        const testResult = check.regex.test(input.data);
        if (!testResult) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "regex",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "trim") {
        input.data = input.data.trim();
      } else if (check.kind === "includes") {
        if (!input.data.includes(check.value, check.position)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { includes: check.value, position: check.position },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "toLowerCase") {
        input.data = input.data.toLowerCase();
      } else if (check.kind === "toUpperCase") {
        input.data = input.data.toUpperCase();
      } else if (check.kind === "startsWith") {
        if (!input.data.startsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { startsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "endsWith") {
        if (!input.data.endsWith(check.value)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: { endsWith: check.value },
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "datetime") {
        const regex = datetimeRegex(check);
        if (!regex.test(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_string,
            validation: "datetime",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "ip") {
        if (!isValidIP(input.data, check.version)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            validation: "ip",
            code: ZodIssueCode.invalid_string,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  _addCheck(check) {
    return new ZodString({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  email(message) {
    return this._addCheck({ kind: "email", ...errorUtil.errToObj(message) });
  }
  url(message) {
    return this._addCheck({ kind: "url", ...errorUtil.errToObj(message) });
  }
  emoji(message) {
    return this._addCheck({ kind: "emoji", ...errorUtil.errToObj(message) });
  }
  uuid(message) {
    return this._addCheck({ kind: "uuid", ...errorUtil.errToObj(message) });
  }
  cuid(message) {
    return this._addCheck({ kind: "cuid", ...errorUtil.errToObj(message) });
  }
  cuid2(message) {
    return this._addCheck({ kind: "cuid2", ...errorUtil.errToObj(message) });
  }
  ulid(message) {
    return this._addCheck({ kind: "ulid", ...errorUtil.errToObj(message) });
  }
  ip(options) {
    return this._addCheck({ kind: "ip", ...errorUtil.errToObj(options) });
  }
  datetime(options) {
    var _a2;
    if (typeof options === "string") {
      return this._addCheck({
        kind: "datetime",
        precision: null,
        offset: false,
        message: options
      });
    }
    return this._addCheck({
      kind: "datetime",
      precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
      offset: (_a2 = options === null || options === void 0 ? void 0 : options.offset) !== null && _a2 !== void 0 ? _a2 : false,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  regex(regex, message) {
    return this._addCheck({
      kind: "regex",
      regex,
      ...errorUtil.errToObj(message)
    });
  }
  includes(value, options) {
    return this._addCheck({
      kind: "includes",
      value,
      position: options === null || options === void 0 ? void 0 : options.position,
      ...errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
    });
  }
  startsWith(value, message) {
    return this._addCheck({
      kind: "startsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  endsWith(value, message) {
    return this._addCheck({
      kind: "endsWith",
      value,
      ...errorUtil.errToObj(message)
    });
  }
  min(minLength, message) {
    return this._addCheck({
      kind: "min",
      value: minLength,
      ...errorUtil.errToObj(message)
    });
  }
  max(maxLength, message) {
    return this._addCheck({
      kind: "max",
      value: maxLength,
      ...errorUtil.errToObj(message)
    });
  }
  length(len, message) {
    return this._addCheck({
      kind: "length",
      value: len,
      ...errorUtil.errToObj(message)
    });
  }
  get isDatetime() {
    return !!this._def.checks.find((ch) => ch.kind === "datetime");
  }
  get isEmail() {
    return !!this._def.checks.find((ch) => ch.kind === "email");
  }
  get isURL() {
    return !!this._def.checks.find((ch) => ch.kind === "url");
  }
  get isEmoji() {
    return !!this._def.checks.find((ch) => ch.kind === "emoji");
  }
  get isUUID() {
    return !!this._def.checks.find((ch) => ch.kind === "uuid");
  }
  get isCUID() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid");
  }
  get isCUID2() {
    return !!this._def.checks.find((ch) => ch.kind === "cuid2");
  }
  get isULID() {
    return !!this._def.checks.find((ch) => ch.kind === "ulid");
  }
  get isIP() {
    return !!this._def.checks.find((ch) => ch.kind === "ip");
  }
  get minLength() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxLength() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodString.create = (params) => {
  var _a2;
  return new ZodString({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodString,
    coerce: (_a2 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a2 !== void 0 ? _a2 : false,
    ...processCreateParams(params)
  });
};
function floatSafeRemainder(val, step) {
  const valDecCount = (val.toString().split(".")[1] || "").length;
  const stepDecCount = (step.toString().split(".")[1] || "").length;
  const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
  const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
  const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
  return valInt % stepInt / Math.pow(10, decCount);
}
var ZodNumber = class extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
    this.step = this.multipleOf;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = Number(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.number) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.number,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "int") {
        if (!util.isInteger(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.invalid_type,
            expected: "integer",
            received: "float",
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            minimum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            maximum: check.value,
            type: "number",
            inclusive: check.inclusive,
            exact: false,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (floatSafeRemainder(input.data, check.value) !== 0) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "finite") {
        if (!Number.isFinite(input.data)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_finite,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodNumber({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodNumber({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  int(message) {
    return this._addCheck({
      kind: "int",
      message: errorUtil.toString(message)
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: 0,
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  finite(message) {
    return this._addCheck({
      kind: "finite",
      message: errorUtil.toString(message)
    });
  }
  safe(message) {
    return this._addCheck({
      kind: "min",
      inclusive: true,
      value: Number.MIN_SAFE_INTEGER,
      message: errorUtil.toString(message)
    })._addCheck({
      kind: "max",
      inclusive: true,
      value: Number.MAX_SAFE_INTEGER,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
  get isInt() {
    return !!this._def.checks.find((ch) => ch.kind === "int" || ch.kind === "multipleOf" && util.isInteger(ch.value));
  }
  get isFinite() {
    let max = null, min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") {
        return true;
      } else if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      } else if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return Number.isFinite(min) && Number.isFinite(max);
  }
};
ZodNumber.create = (params) => {
  return new ZodNumber({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodNumber,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodBigInt = class extends ZodType {
  constructor() {
    super(...arguments);
    this.min = this.gte;
    this.max = this.lte;
  }
  _parse(input) {
    if (this._def.coerce) {
      input.data = BigInt(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.bigint) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.bigint,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    let ctx = void 0;
    const status = new ParseStatus();
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
        if (tooSmall) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            type: "bigint",
            minimum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
        if (tooBig) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            type: "bigint",
            maximum: check.value,
            inclusive: check.inclusive,
            message: check.message
          });
          status.dirty();
        }
      } else if (check.kind === "multipleOf") {
        if (input.data % check.value !== BigInt(0)) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.not_multiple_of,
            multipleOf: check.value,
            message: check.message
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return { status: status.value, value: input.data };
  }
  gte(value, message) {
    return this.setLimit("min", value, true, errorUtil.toString(message));
  }
  gt(value, message) {
    return this.setLimit("min", value, false, errorUtil.toString(message));
  }
  lte(value, message) {
    return this.setLimit("max", value, true, errorUtil.toString(message));
  }
  lt(value, message) {
    return this.setLimit("max", value, false, errorUtil.toString(message));
  }
  setLimit(kind, value, inclusive, message) {
    return new ZodBigInt({
      ...this._def,
      checks: [
        ...this._def.checks,
        {
          kind,
          value,
          inclusive,
          message: errorUtil.toString(message)
        }
      ]
    });
  }
  _addCheck(check) {
    return new ZodBigInt({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  positive(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  negative(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: false,
      message: errorUtil.toString(message)
    });
  }
  nonpositive(message) {
    return this._addCheck({
      kind: "max",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  nonnegative(message) {
    return this._addCheck({
      kind: "min",
      value: BigInt(0),
      inclusive: true,
      message: errorUtil.toString(message)
    });
  }
  multipleOf(value, message) {
    return this._addCheck({
      kind: "multipleOf",
      value,
      message: errorUtil.toString(message)
    });
  }
  get minValue() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min;
  }
  get maxValue() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max;
  }
};
ZodBigInt.create = (params) => {
  var _a2;
  return new ZodBigInt({
    checks: [],
    typeName: ZodFirstPartyTypeKind.ZodBigInt,
    coerce: (_a2 = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a2 !== void 0 ? _a2 : false,
    ...processCreateParams(params)
  });
};
var ZodBoolean = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = Boolean(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.boolean) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.boolean,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodBoolean.create = (params) => {
  return new ZodBoolean({
    typeName: ZodFirstPartyTypeKind.ZodBoolean,
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    ...processCreateParams(params)
  });
};
var ZodDate = class extends ZodType {
  _parse(input) {
    if (this._def.coerce) {
      input.data = new Date(input.data);
    }
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.date) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.date,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    if (isNaN(input.data.getTime())) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_date
      });
      return INVALID;
    }
    const status = new ParseStatus();
    let ctx = void 0;
    for (const check of this._def.checks) {
      if (check.kind === "min") {
        if (input.data.getTime() < check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_small,
            message: check.message,
            inclusive: true,
            exact: false,
            minimum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else if (check.kind === "max") {
        if (input.data.getTime() > check.value) {
          ctx = this._getOrReturnCtx(input, ctx);
          addIssueToContext(ctx, {
            code: ZodIssueCode.too_big,
            message: check.message,
            inclusive: true,
            exact: false,
            maximum: check.value,
            type: "date"
          });
          status.dirty();
        }
      } else {
        util.assertNever(check);
      }
    }
    return {
      status: status.value,
      value: new Date(input.data.getTime())
    };
  }
  _addCheck(check) {
    return new ZodDate({
      ...this._def,
      checks: [...this._def.checks, check]
    });
  }
  min(minDate, message) {
    return this._addCheck({
      kind: "min",
      value: minDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  max(maxDate, message) {
    return this._addCheck({
      kind: "max",
      value: maxDate.getTime(),
      message: errorUtil.toString(message)
    });
  }
  get minDate() {
    let min = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "min") {
        if (min === null || ch.value > min)
          min = ch.value;
      }
    }
    return min != null ? new Date(min) : null;
  }
  get maxDate() {
    let max = null;
    for (const ch of this._def.checks) {
      if (ch.kind === "max") {
        if (max === null || ch.value < max)
          max = ch.value;
      }
    }
    return max != null ? new Date(max) : null;
  }
};
ZodDate.create = (params) => {
  return new ZodDate({
    checks: [],
    coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
    typeName: ZodFirstPartyTypeKind.ZodDate,
    ...processCreateParams(params)
  });
};
var ZodSymbol = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.symbol) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.symbol,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodSymbol.create = (params) => {
  return new ZodSymbol({
    typeName: ZodFirstPartyTypeKind.ZodSymbol,
    ...processCreateParams(params)
  });
};
var ZodUndefined = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.undefined,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodUndefined.create = (params) => {
  return new ZodUndefined({
    typeName: ZodFirstPartyTypeKind.ZodUndefined,
    ...processCreateParams(params)
  });
};
var ZodNull = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.null) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.null,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodNull.create = (params) => {
  return new ZodNull({
    typeName: ZodFirstPartyTypeKind.ZodNull,
    ...processCreateParams(params)
  });
};
var ZodAny = class extends ZodType {
  constructor() {
    super(...arguments);
    this._any = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodAny.create = (params) => {
  return new ZodAny({
    typeName: ZodFirstPartyTypeKind.ZodAny,
    ...processCreateParams(params)
  });
};
var ZodUnknown = class extends ZodType {
  constructor() {
    super(...arguments);
    this._unknown = true;
  }
  _parse(input) {
    return OK(input.data);
  }
};
ZodUnknown.create = (params) => {
  return new ZodUnknown({
    typeName: ZodFirstPartyTypeKind.ZodUnknown,
    ...processCreateParams(params)
  });
};
var ZodNever = class extends ZodType {
  _parse(input) {
    const ctx = this._getOrReturnCtx(input);
    addIssueToContext(ctx, {
      code: ZodIssueCode.invalid_type,
      expected: ZodParsedType.never,
      received: ctx.parsedType
    });
    return INVALID;
  }
};
ZodNever.create = (params) => {
  return new ZodNever({
    typeName: ZodFirstPartyTypeKind.ZodNever,
    ...processCreateParams(params)
  });
};
var ZodVoid = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.undefined) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.void,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return OK(input.data);
  }
};
ZodVoid.create = (params) => {
  return new ZodVoid({
    typeName: ZodFirstPartyTypeKind.ZodVoid,
    ...processCreateParams(params)
  });
};
var ZodArray = class extends ZodType {
  _parse(input) {
    const { ctx, status } = this._processInputParams(input);
    const def = this._def;
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (def.exactLength !== null) {
      const tooBig = ctx.data.length > def.exactLength.value;
      const tooSmall = ctx.data.length < def.exactLength.value;
      if (tooBig || tooSmall) {
        addIssueToContext(ctx, {
          code: tooBig ? ZodIssueCode.too_big : ZodIssueCode.too_small,
          minimum: tooSmall ? def.exactLength.value : void 0,
          maximum: tooBig ? def.exactLength.value : void 0,
          type: "array",
          inclusive: true,
          exact: true,
          message: def.exactLength.message
        });
        status.dirty();
      }
    }
    if (def.minLength !== null) {
      if (ctx.data.length < def.minLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.minLength.message
        });
        status.dirty();
      }
    }
    if (def.maxLength !== null) {
      if (ctx.data.length > def.maxLength.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxLength.value,
          type: "array",
          inclusive: true,
          exact: false,
          message: def.maxLength.message
        });
        status.dirty();
      }
    }
    if (ctx.common.async) {
      return Promise.all([...ctx.data].map((item, i) => {
        return def.type._parseAsync(new ParseInputLazyPath(ctx, item, ctx.path, i));
      })).then((result3) => {
        return ParseStatus.mergeArray(status, result3);
      });
    }
    const result2 = [...ctx.data].map((item, i) => {
      return def.type._parseSync(new ParseInputLazyPath(ctx, item, ctx.path, i));
    });
    return ParseStatus.mergeArray(status, result2);
  }
  get element() {
    return this._def.type;
  }
  min(minLength, message) {
    return new ZodArray({
      ...this._def,
      minLength: { value: minLength, message: errorUtil.toString(message) }
    });
  }
  max(maxLength, message) {
    return new ZodArray({
      ...this._def,
      maxLength: { value: maxLength, message: errorUtil.toString(message) }
    });
  }
  length(len, message) {
    return new ZodArray({
      ...this._def,
      exactLength: { value: len, message: errorUtil.toString(message) }
    });
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodArray.create = (schema, params) => {
  return new ZodArray({
    type: schema,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: ZodFirstPartyTypeKind.ZodArray,
    ...processCreateParams(params)
  });
};
function deepPartialify(schema) {
  if (schema instanceof ZodObject) {
    const newShape = {};
    for (const key in schema.shape) {
      const fieldSchema = schema.shape[key];
      newShape[key] = ZodOptional.create(deepPartialify(fieldSchema));
    }
    return new ZodObject({
      ...schema._def,
      shape: () => newShape
    });
  } else if (schema instanceof ZodArray) {
    return new ZodArray({
      ...schema._def,
      type: deepPartialify(schema.element)
    });
  } else if (schema instanceof ZodOptional) {
    return ZodOptional.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodNullable) {
    return ZodNullable.create(deepPartialify(schema.unwrap()));
  } else if (schema instanceof ZodTuple) {
    return ZodTuple.create(schema.items.map((item) => deepPartialify(item)));
  } else {
    return schema;
  }
}
var ZodObject = class extends ZodType {
  constructor() {
    super(...arguments);
    this._cached = null;
    this.nonstrict = this.passthrough;
    this.augment = this.extend;
  }
  _getCached() {
    if (this._cached !== null)
      return this._cached;
    const shape = this._def.shape();
    const keys = util.objectKeys(shape);
    return this._cached = { shape, keys };
  }
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.object) {
      const ctx2 = this._getOrReturnCtx(input);
      addIssueToContext(ctx2, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx2.parsedType
      });
      return INVALID;
    }
    const { status, ctx } = this._processInputParams(input);
    const { shape, keys: shapeKeys } = this._getCached();
    const extraKeys = [];
    if (!(this._def.catchall instanceof ZodNever && this._def.unknownKeys === "strip")) {
      for (const key in ctx.data) {
        if (!shapeKeys.includes(key)) {
          extraKeys.push(key);
        }
      }
    }
    const pairs = [];
    for (const key of shapeKeys) {
      const keyValidator = shape[key];
      const value = ctx.data[key];
      pairs.push({
        key: { status: "valid", value: key },
        value: keyValidator._parse(new ParseInputLazyPath(ctx, value, ctx.path, key)),
        alwaysSet: key in ctx.data
      });
    }
    if (this._def.catchall instanceof ZodNever) {
      const unknownKeys = this._def.unknownKeys;
      if (unknownKeys === "passthrough") {
        for (const key of extraKeys) {
          pairs.push({
            key: { status: "valid", value: key },
            value: { status: "valid", value: ctx.data[key] }
          });
        }
      } else if (unknownKeys === "strict") {
        if (extraKeys.length > 0) {
          addIssueToContext(ctx, {
            code: ZodIssueCode.unrecognized_keys,
            keys: extraKeys
          });
          status.dirty();
        }
      } else if (unknownKeys === "strip")
        ;
      else {
        throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
      }
    } else {
      const catchall = this._def.catchall;
      for (const key of extraKeys) {
        const value = ctx.data[key];
        pairs.push({
          key: { status: "valid", value: key },
          value: catchall._parse(
            new ParseInputLazyPath(ctx, value, ctx.path, key)
            //, ctx.child(key), value, getParsedType(value)
          ),
          alwaysSet: key in ctx.data
        });
      }
    }
    if (ctx.common.async) {
      return Promise.resolve().then(async () => {
        const syncPairs = [];
        for (const pair of pairs) {
          const key = await pair.key;
          syncPairs.push({
            key,
            value: await pair.value,
            alwaysSet: pair.alwaysSet
          });
        }
        return syncPairs;
      }).then((syncPairs) => {
        return ParseStatus.mergeObjectSync(status, syncPairs);
      });
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get shape() {
    return this._def.shape();
  }
  strict(message) {
    errorUtil.errToObj;
    return new ZodObject({
      ...this._def,
      unknownKeys: "strict",
      ...message !== void 0 ? {
        errorMap: (issue, ctx) => {
          var _a2, _b, _c, _d;
          const defaultError = (_c = (_b = (_a2 = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a2, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
          if (issue.code === "unrecognized_keys")
            return {
              message: (_d = errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
            };
          return {
            message: defaultError
          };
        }
      } : {}
    });
  }
  strip() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "strip"
    });
  }
  passthrough() {
    return new ZodObject({
      ...this._def,
      unknownKeys: "passthrough"
    });
  }
  // const AugmentFactory =
  //   <Def extends ZodObjectDef>(def: Def) =>
  //   <Augmentation extends ZodRawShape>(
  //     augmentation: Augmentation
  //   ): ZodObject<
  //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
  //     Def["unknownKeys"],
  //     Def["catchall"]
  //   > => {
  //     return new ZodObject({
  //       ...def,
  //       shape: () => ({
  //         ...def.shape(),
  //         ...augmentation,
  //       }),
  //     }) as any;
  //   };
  extend(augmentation) {
    return new ZodObject({
      ...this._def,
      shape: () => ({
        ...this._def.shape(),
        ...augmentation
      })
    });
  }
  /**
   * Prior to zod@1.0.12 there was a bug in the
   * inferred type of merged objects. Please
   * upgrade if you are experiencing issues.
   */
  merge(merging) {
    const merged = new ZodObject({
      unknownKeys: merging._def.unknownKeys,
      catchall: merging._def.catchall,
      shape: () => ({
        ...this._def.shape(),
        ...merging._def.shape()
      }),
      typeName: ZodFirstPartyTypeKind.ZodObject
    });
    return merged;
  }
  // merge<
  //   Incoming extends AnyZodObject,
  //   Augmentation extends Incoming["shape"],
  //   NewOutput extends {
  //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
  //       ? Augmentation[k]["_output"]
  //       : k extends keyof Output
  //       ? Output[k]
  //       : never;
  //   },
  //   NewInput extends {
  //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
  //       ? Augmentation[k]["_input"]
  //       : k extends keyof Input
  //       ? Input[k]
  //       : never;
  //   }
  // >(
  //   merging: Incoming
  // ): ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"],
  //   NewOutput,
  //   NewInput
  // > {
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  setKey(key, schema) {
    return this.augment({ [key]: schema });
  }
  // merge<Incoming extends AnyZodObject>(
  //   merging: Incoming
  // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
  // ZodObject<
  //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
  //   Incoming["_def"]["unknownKeys"],
  //   Incoming["_def"]["catchall"]
  // > {
  //   // const mergedShape = objectUtil.mergeShapes(
  //   //   this._def.shape(),
  //   //   merging._def.shape()
  //   // );
  //   const merged: any = new ZodObject({
  //     unknownKeys: merging._def.unknownKeys,
  //     catchall: merging._def.catchall,
  //     shape: () =>
  //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
  //     typeName: ZodFirstPartyTypeKind.ZodObject,
  //   }) as any;
  //   return merged;
  // }
  catchall(index) {
    return new ZodObject({
      ...this._def,
      catchall: index
    });
  }
  pick(mask) {
    const shape = {};
    util.objectKeys(mask).forEach((key) => {
      if (mask[key] && this.shape[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  omit(mask) {
    const shape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (!mask[key]) {
        shape[key] = this.shape[key];
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => shape
    });
  }
  /**
   * @deprecated
   */
  deepPartial() {
    return deepPartialify(this);
  }
  partial(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      const fieldSchema = this.shape[key];
      if (mask && !mask[key]) {
        newShape[key] = fieldSchema;
      } else {
        newShape[key] = fieldSchema.optional();
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  required(mask) {
    const newShape = {};
    util.objectKeys(this.shape).forEach((key) => {
      if (mask && !mask[key]) {
        newShape[key] = this.shape[key];
      } else {
        const fieldSchema = this.shape[key];
        let newField = fieldSchema;
        while (newField instanceof ZodOptional) {
          newField = newField._def.innerType;
        }
        newShape[key] = newField;
      }
    });
    return new ZodObject({
      ...this._def,
      shape: () => newShape
    });
  }
  keyof() {
    return createZodEnum(util.objectKeys(this.shape));
  }
};
ZodObject.create = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.strictCreate = (shape, params) => {
  return new ZodObject({
    shape: () => shape,
    unknownKeys: "strict",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
ZodObject.lazycreate = (shape, params) => {
  return new ZodObject({
    shape,
    unknownKeys: "strip",
    catchall: ZodNever.create(),
    typeName: ZodFirstPartyTypeKind.ZodObject,
    ...processCreateParams(params)
  });
};
var ZodUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const options = this._def.options;
    function handleResults(results) {
      for (const result2 of results) {
        if (result2.result.status === "valid") {
          return result2.result;
        }
      }
      for (const result2 of results) {
        if (result2.result.status === "dirty") {
          ctx.common.issues.push(...result2.ctx.common.issues);
          return result2.result;
        }
      }
      const unionErrors = results.map((result2) => new ZodError(result2.ctx.common.issues));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return Promise.all(options.map(async (option) => {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        return {
          result: await option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: childCtx
          }),
          ctx: childCtx
        };
      })).then(handleResults);
    } else {
      let dirty = void 0;
      const issues = [];
      for (const option of options) {
        const childCtx = {
          ...ctx,
          common: {
            ...ctx.common,
            issues: []
          },
          parent: null
        };
        const result2 = option._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: childCtx
        });
        if (result2.status === "valid") {
          return result2;
        } else if (result2.status === "dirty" && !dirty) {
          dirty = { result: result2, ctx: childCtx };
        }
        if (childCtx.common.issues.length) {
          issues.push(childCtx.common.issues);
        }
      }
      if (dirty) {
        ctx.common.issues.push(...dirty.ctx.common.issues);
        return dirty.result;
      }
      const unionErrors = issues.map((issues2) => new ZodError(issues2));
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union,
        unionErrors
      });
      return INVALID;
    }
  }
  get options() {
    return this._def.options;
  }
};
ZodUnion.create = (types, params) => {
  return new ZodUnion({
    options: types,
    typeName: ZodFirstPartyTypeKind.ZodUnion,
    ...processCreateParams(params)
  });
};
var getDiscriminator = (type) => {
  if (type instanceof ZodLazy) {
    return getDiscriminator(type.schema);
  } else if (type instanceof ZodEffects) {
    return getDiscriminator(type.innerType());
  } else if (type instanceof ZodLiteral) {
    return [type.value];
  } else if (type instanceof ZodEnum) {
    return type.options;
  } else if (type instanceof ZodNativeEnum) {
    return Object.keys(type.enum);
  } else if (type instanceof ZodDefault) {
    return getDiscriminator(type._def.innerType);
  } else if (type instanceof ZodUndefined) {
    return [void 0];
  } else if (type instanceof ZodNull) {
    return [null];
  } else {
    return null;
  }
};
var ZodDiscriminatedUnion = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const discriminator = this.discriminator;
    const discriminatorValue = ctx.data[discriminator];
    const option = this.optionsMap.get(discriminatorValue);
    if (!option) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [discriminator]
      });
      return INVALID;
    }
    if (ctx.common.async) {
      return option._parseAsync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    } else {
      return option._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
    }
  }
  get discriminator() {
    return this._def.discriminator;
  }
  get options() {
    return this._def.options;
  }
  get optionsMap() {
    return this._def.optionsMap;
  }
  /**
   * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
   * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
   * have a different value for each object in the union.
   * @param discriminator the name of the discriminator property
   * @param types an array of object schemas
   * @param params
   */
  static create(discriminator, options, params) {
    const optionsMap = /* @__PURE__ */ new Map();
    for (const type of options) {
      const discriminatorValues = getDiscriminator(type.shape[discriminator]);
      if (!discriminatorValues) {
        throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
      }
      for (const value of discriminatorValues) {
        if (optionsMap.has(value)) {
          throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
        }
        optionsMap.set(value, type);
      }
    }
    return new ZodDiscriminatedUnion({
      typeName: ZodFirstPartyTypeKind.ZodDiscriminatedUnion,
      discriminator,
      options,
      optionsMap,
      ...processCreateParams(params)
    });
  }
};
function mergeValues(a, b) {
  const aType = getParsedType(a);
  const bType = getParsedType(b);
  if (a === b) {
    return { valid: true, data: a };
  } else if (aType === ZodParsedType.object && bType === ZodParsedType.object) {
    const bKeys = util.objectKeys(b);
    const sharedKeys = util.objectKeys(a).filter((key) => bKeys.indexOf(key) !== -1);
    const newObj = { ...a, ...b };
    for (const key of sharedKeys) {
      const sharedValue = mergeValues(a[key], b[key]);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newObj[key] = sharedValue.data;
    }
    return { valid: true, data: newObj };
  } else if (aType === ZodParsedType.array && bType === ZodParsedType.array) {
    if (a.length !== b.length) {
      return { valid: false };
    }
    const newArray = [];
    for (let index = 0; index < a.length; index++) {
      const itemA = a[index];
      const itemB = b[index];
      const sharedValue = mergeValues(itemA, itemB);
      if (!sharedValue.valid) {
        return { valid: false };
      }
      newArray.push(sharedValue.data);
    }
    return { valid: true, data: newArray };
  } else if (aType === ZodParsedType.date && bType === ZodParsedType.date && +a === +b) {
    return { valid: true, data: a };
  } else {
    return { valid: false };
  }
}
var ZodIntersection = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const handleParsed = (parsedLeft, parsedRight) => {
      if (isAborted(parsedLeft) || isAborted(parsedRight)) {
        return INVALID;
      }
      const merged = mergeValues(parsedLeft.value, parsedRight.value);
      if (!merged.valid) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.invalid_intersection_types
        });
        return INVALID;
      }
      if (isDirty(parsedLeft) || isDirty(parsedRight)) {
        status.dirty();
      }
      return { status: status.value, value: merged.data };
    };
    if (ctx.common.async) {
      return Promise.all([
        this._def.left._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        }),
        this._def.right._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        })
      ]).then(([left, right]) => handleParsed(left, right));
    } else {
      return handleParsed(this._def.left._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }), this._def.right._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      }));
    }
  }
};
ZodIntersection.create = (left, right, params) => {
  return new ZodIntersection({
    left,
    right,
    typeName: ZodFirstPartyTypeKind.ZodIntersection,
    ...processCreateParams(params)
  });
};
var ZodTuple = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.array) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.array,
        received: ctx.parsedType
      });
      return INVALID;
    }
    if (ctx.data.length < this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_small,
        minimum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      return INVALID;
    }
    const rest = this._def.rest;
    if (!rest && ctx.data.length > this._def.items.length) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: true,
        exact: false,
        type: "array"
      });
      status.dirty();
    }
    const items = [...ctx.data].map((item, itemIndex) => {
      const schema = this._def.items[itemIndex] || this._def.rest;
      if (!schema)
        return null;
      return schema._parse(new ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
    }).filter((x) => !!x);
    if (ctx.common.async) {
      return Promise.all(items).then((results) => {
        return ParseStatus.mergeArray(status, results);
      });
    } else {
      return ParseStatus.mergeArray(status, items);
    }
  }
  get items() {
    return this._def.items;
  }
  rest(rest) {
    return new ZodTuple({
      ...this._def,
      rest
    });
  }
};
ZodTuple.create = (schemas, params) => {
  if (!Array.isArray(schemas)) {
    throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
  }
  return new ZodTuple({
    items: schemas,
    typeName: ZodFirstPartyTypeKind.ZodTuple,
    rest: null,
    ...processCreateParams(params)
  });
};
var ZodRecord = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.object) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.object,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const pairs = [];
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    for (const key in ctx.data) {
      pairs.push({
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, key)),
        value: valueType._parse(new ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
      });
    }
    if (ctx.common.async) {
      return ParseStatus.mergeObjectAsync(status, pairs);
    } else {
      return ParseStatus.mergeObjectSync(status, pairs);
    }
  }
  get element() {
    return this._def.valueType;
  }
  static create(first, second, third) {
    if (second instanceof ZodType) {
      return new ZodRecord({
        keyType: first,
        valueType: second,
        typeName: ZodFirstPartyTypeKind.ZodRecord,
        ...processCreateParams(third)
      });
    }
    return new ZodRecord({
      keyType: ZodString.create(),
      valueType: first,
      typeName: ZodFirstPartyTypeKind.ZodRecord,
      ...processCreateParams(second)
    });
  }
};
var ZodMap = class extends ZodType {
  get keySchema() {
    return this._def.keyType;
  }
  get valueSchema() {
    return this._def.valueType;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.map) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.map,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const keyType = this._def.keyType;
    const valueType = this._def.valueType;
    const pairs = [...ctx.data.entries()].map(([key, value], index) => {
      return {
        key: keyType._parse(new ParseInputLazyPath(ctx, key, ctx.path, [index, "key"])),
        value: valueType._parse(new ParseInputLazyPath(ctx, value, ctx.path, [index, "value"]))
      };
    });
    if (ctx.common.async) {
      const finalMap = /* @__PURE__ */ new Map();
      return Promise.resolve().then(async () => {
        for (const pair of pairs) {
          const key = await pair.key;
          const value = await pair.value;
          if (key.status === "aborted" || value.status === "aborted") {
            return INVALID;
          }
          if (key.status === "dirty" || value.status === "dirty") {
            status.dirty();
          }
          finalMap.set(key.value, value.value);
        }
        return { status: status.value, value: finalMap };
      });
    } else {
      const finalMap = /* @__PURE__ */ new Map();
      for (const pair of pairs) {
        const key = pair.key;
        const value = pair.value;
        if (key.status === "aborted" || value.status === "aborted") {
          return INVALID;
        }
        if (key.status === "dirty" || value.status === "dirty") {
          status.dirty();
        }
        finalMap.set(key.value, value.value);
      }
      return { status: status.value, value: finalMap };
    }
  }
};
ZodMap.create = (keyType, valueType, params) => {
  return new ZodMap({
    valueType,
    keyType,
    typeName: ZodFirstPartyTypeKind.ZodMap,
    ...processCreateParams(params)
  });
};
var ZodSet = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.set) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.set,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const def = this._def;
    if (def.minSize !== null) {
      if (ctx.data.size < def.minSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_small,
          minimum: def.minSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.minSize.message
        });
        status.dirty();
      }
    }
    if (def.maxSize !== null) {
      if (ctx.data.size > def.maxSize.value) {
        addIssueToContext(ctx, {
          code: ZodIssueCode.too_big,
          maximum: def.maxSize.value,
          type: "set",
          inclusive: true,
          exact: false,
          message: def.maxSize.message
        });
        status.dirty();
      }
    }
    const valueType = this._def.valueType;
    function finalizeSet(elements2) {
      const parsedSet = /* @__PURE__ */ new Set();
      for (const element of elements2) {
        if (element.status === "aborted")
          return INVALID;
        if (element.status === "dirty")
          status.dirty();
        parsedSet.add(element.value);
      }
      return { status: status.value, value: parsedSet };
    }
    const elements = [...ctx.data.values()].map((item, i) => valueType._parse(new ParseInputLazyPath(ctx, item, ctx.path, i)));
    if (ctx.common.async) {
      return Promise.all(elements).then((elements2) => finalizeSet(elements2));
    } else {
      return finalizeSet(elements);
    }
  }
  min(minSize, message) {
    return new ZodSet({
      ...this._def,
      minSize: { value: minSize, message: errorUtil.toString(message) }
    });
  }
  max(maxSize, message) {
    return new ZodSet({
      ...this._def,
      maxSize: { value: maxSize, message: errorUtil.toString(message) }
    });
  }
  size(size, message) {
    return this.min(size, message).max(size, message);
  }
  nonempty(message) {
    return this.min(1, message);
  }
};
ZodSet.create = (valueType, params) => {
  return new ZodSet({
    valueType,
    minSize: null,
    maxSize: null,
    typeName: ZodFirstPartyTypeKind.ZodSet,
    ...processCreateParams(params)
  });
};
var ZodFunction = class extends ZodType {
  constructor() {
    super(...arguments);
    this.validate = this.implement;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.function) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.function,
        received: ctx.parsedType
      });
      return INVALID;
    }
    function makeArgsIssue(args, error) {
      return makeIssue({
        data: args,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_arguments,
          argumentsError: error
        }
      });
    }
    function makeReturnsIssue(returns, error) {
      return makeIssue({
        data: returns,
        path: ctx.path,
        errorMaps: [
          ctx.common.contextualErrorMap,
          ctx.schemaErrorMap,
          getErrorMap(),
          errorMap
        ].filter((x) => !!x),
        issueData: {
          code: ZodIssueCode.invalid_return_type,
          returnTypeError: error
        }
      });
    }
    const params = { errorMap: ctx.common.contextualErrorMap };
    const fn = ctx.data;
    if (this._def.returns instanceof ZodPromise) {
      const me = this;
      return OK(async function(...args) {
        const error = new ZodError([]);
        const parsedArgs = await me._def.args.parseAsync(args, params).catch((e) => {
          error.addIssue(makeArgsIssue(args, e));
          throw error;
        });
        const result2 = await Reflect.apply(fn, this, parsedArgs);
        const parsedReturns = await me._def.returns._def.type.parseAsync(result2, params).catch((e) => {
          error.addIssue(makeReturnsIssue(result2, e));
          throw error;
        });
        return parsedReturns;
      });
    } else {
      const me = this;
      return OK(function(...args) {
        const parsedArgs = me._def.args.safeParse(args, params);
        if (!parsedArgs.success) {
          throw new ZodError([makeArgsIssue(args, parsedArgs.error)]);
        }
        const result2 = Reflect.apply(fn, this, parsedArgs.data);
        const parsedReturns = me._def.returns.safeParse(result2, params);
        if (!parsedReturns.success) {
          throw new ZodError([makeReturnsIssue(result2, parsedReturns.error)]);
        }
        return parsedReturns.data;
      });
    }
  }
  parameters() {
    return this._def.args;
  }
  returnType() {
    return this._def.returns;
  }
  args(...items) {
    return new ZodFunction({
      ...this._def,
      args: ZodTuple.create(items).rest(ZodUnknown.create())
    });
  }
  returns(returnType) {
    return new ZodFunction({
      ...this._def,
      returns: returnType
    });
  }
  implement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  strictImplement(func) {
    const validatedFunc = this.parse(func);
    return validatedFunc;
  }
  static create(args, returns, params) {
    return new ZodFunction({
      args: args ? args : ZodTuple.create([]).rest(ZodUnknown.create()),
      returns: returns || ZodUnknown.create(),
      typeName: ZodFirstPartyTypeKind.ZodFunction,
      ...processCreateParams(params)
    });
  }
};
var ZodLazy = class extends ZodType {
  get schema() {
    return this._def.getter();
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const lazySchema = this._def.getter();
    return lazySchema._parse({ data: ctx.data, path: ctx.path, parent: ctx });
  }
};
ZodLazy.create = (getter, params) => {
  return new ZodLazy({
    getter,
    typeName: ZodFirstPartyTypeKind.ZodLazy,
    ...processCreateParams(params)
  });
};
var ZodLiteral = class extends ZodType {
  _parse(input) {
    if (input.data !== this._def.value) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_literal,
        expected: this._def.value
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
  get value() {
    return this._def.value;
  }
};
ZodLiteral.create = (value, params) => {
  return new ZodLiteral({
    value,
    typeName: ZodFirstPartyTypeKind.ZodLiteral,
    ...processCreateParams(params)
  });
};
function createZodEnum(values, params) {
  return new ZodEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodEnum,
    ...processCreateParams(params)
  });
}
var ZodEnum = class extends ZodType {
  _parse(input) {
    if (typeof input.data !== "string") {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (this._def.values.indexOf(input.data) === -1) {
      const ctx = this._getOrReturnCtx(input);
      const expectedValues = this._def.values;
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get options() {
    return this._def.values;
  }
  get enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Values() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  get Enum() {
    const enumValues = {};
    for (const val of this._def.values) {
      enumValues[val] = val;
    }
    return enumValues;
  }
  extract(values) {
    return ZodEnum.create(values);
  }
  exclude(values) {
    return ZodEnum.create(this.options.filter((opt) => !values.includes(opt)));
  }
};
ZodEnum.create = createZodEnum;
var ZodNativeEnum = class extends ZodType {
  _parse(input) {
    const nativeEnumValues = util.getValidEnumValues(this._def.values);
    const ctx = this._getOrReturnCtx(input);
    if (ctx.parsedType !== ZodParsedType.string && ctx.parsedType !== ZodParsedType.number) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        expected: util.joinValues(expectedValues),
        received: ctx.parsedType,
        code: ZodIssueCode.invalid_type
      });
      return INVALID;
    }
    if (nativeEnumValues.indexOf(input.data) === -1) {
      const expectedValues = util.objectValues(nativeEnumValues);
      addIssueToContext(ctx, {
        received: ctx.data,
        code: ZodIssueCode.invalid_enum_value,
        options: expectedValues
      });
      return INVALID;
    }
    return OK(input.data);
  }
  get enum() {
    return this._def.values;
  }
};
ZodNativeEnum.create = (values, params) => {
  return new ZodNativeEnum({
    values,
    typeName: ZodFirstPartyTypeKind.ZodNativeEnum,
    ...processCreateParams(params)
  });
};
var ZodPromise = class extends ZodType {
  unwrap() {
    return this._def.type;
  }
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    if (ctx.parsedType !== ZodParsedType.promise && ctx.common.async === false) {
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.promise,
        received: ctx.parsedType
      });
      return INVALID;
    }
    const promisified = ctx.parsedType === ZodParsedType.promise ? ctx.data : Promise.resolve(ctx.data);
    return OK(promisified.then((data) => {
      return this._def.type.parseAsync(data, {
        path: ctx.path,
        errorMap: ctx.common.contextualErrorMap
      });
    }));
  }
};
ZodPromise.create = (schema, params) => {
  return new ZodPromise({
    type: schema,
    typeName: ZodFirstPartyTypeKind.ZodPromise,
    ...processCreateParams(params)
  });
};
var ZodEffects = class extends ZodType {
  innerType() {
    return this._def.schema;
  }
  sourceType() {
    return this._def.schema._def.typeName === ZodFirstPartyTypeKind.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
  }
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    const effect = this._def.effect || null;
    const checkCtx = {
      addIssue: (arg) => {
        addIssueToContext(ctx, arg);
        if (arg.fatal) {
          status.abort();
        } else {
          status.dirty();
        }
      },
      get path() {
        return ctx.path;
      }
    };
    checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
    if (effect.type === "preprocess") {
      const processed = effect.transform(ctx.data, checkCtx);
      if (ctx.common.issues.length) {
        return {
          status: "dirty",
          value: ctx.data
        };
      }
      if (ctx.common.async) {
        return Promise.resolve(processed).then((processed2) => {
          return this._def.schema._parseAsync({
            data: processed2,
            path: ctx.path,
            parent: ctx
          });
        });
      } else {
        return this._def.schema._parseSync({
          data: processed,
          path: ctx.path,
          parent: ctx
        });
      }
    }
    if (effect.type === "refinement") {
      const executeRefinement = (acc) => {
        const result2 = effect.refinement(acc, checkCtx);
        if (ctx.common.async) {
          return Promise.resolve(result2);
        }
        if (result2 instanceof Promise) {
          throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
        }
        return acc;
      };
      if (ctx.common.async === false) {
        const inner = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inner.status === "aborted")
          return INVALID;
        if (inner.status === "dirty")
          status.dirty();
        executeRefinement(inner.value);
        return { status: status.value, value: inner.value };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((inner) => {
          if (inner.status === "aborted")
            return INVALID;
          if (inner.status === "dirty")
            status.dirty();
          return executeRefinement(inner.value).then(() => {
            return { status: status.value, value: inner.value };
          });
        });
      }
    }
    if (effect.type === "transform") {
      if (ctx.common.async === false) {
        const base = this._def.schema._parseSync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (!isValid(base))
          return base;
        const result2 = effect.transform(base.value, checkCtx);
        if (result2 instanceof Promise) {
          throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
        }
        return { status: status.value, value: result2 };
      } else {
        return this._def.schema._parseAsync({ data: ctx.data, path: ctx.path, parent: ctx }).then((base) => {
          if (!isValid(base))
            return base;
          return Promise.resolve(effect.transform(base.value, checkCtx)).then((result2) => ({ status: status.value, value: result2 }));
        });
      }
    }
    util.assertNever(effect);
  }
};
ZodEffects.create = (schema, effect, params) => {
  return new ZodEffects({
    schema,
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    effect,
    ...processCreateParams(params)
  });
};
ZodEffects.createWithPreprocess = (preprocess, schema, params) => {
  return new ZodEffects({
    schema,
    effect: { type: "preprocess", transform: preprocess },
    typeName: ZodFirstPartyTypeKind.ZodEffects,
    ...processCreateParams(params)
  });
};
var ZodOptional = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.undefined) {
      return OK(void 0);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodOptional.create = (type, params) => {
  return new ZodOptional({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodOptional,
    ...processCreateParams(params)
  });
};
var ZodNullable = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType === ZodParsedType.null) {
      return OK(null);
    }
    return this._def.innerType._parse(input);
  }
  unwrap() {
    return this._def.innerType;
  }
};
ZodNullable.create = (type, params) => {
  return new ZodNullable({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodNullable,
    ...processCreateParams(params)
  });
};
var ZodDefault = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    let data = ctx.data;
    if (ctx.parsedType === ZodParsedType.undefined) {
      data = this._def.defaultValue();
    }
    return this._def.innerType._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  removeDefault() {
    return this._def.innerType;
  }
};
ZodDefault.create = (type, params) => {
  return new ZodDefault({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodDefault,
    defaultValue: typeof params.default === "function" ? params.default : () => params.default,
    ...processCreateParams(params)
  });
};
var ZodCatch = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const newCtx = {
      ...ctx,
      common: {
        ...ctx.common,
        issues: []
      }
    };
    const result2 = this._def.innerType._parse({
      data: newCtx.data,
      path: newCtx.path,
      parent: {
        ...newCtx
      }
    });
    if (isAsync(result2)) {
      return result2.then((result3) => {
        return {
          status: "valid",
          value: result3.status === "valid" ? result3.value : this._def.catchValue({
            get error() {
              return new ZodError(newCtx.common.issues);
            },
            input: newCtx.data
          })
        };
      });
    } else {
      return {
        status: "valid",
        value: result2.status === "valid" ? result2.value : this._def.catchValue({
          get error() {
            return new ZodError(newCtx.common.issues);
          },
          input: newCtx.data
        })
      };
    }
  }
  removeCatch() {
    return this._def.innerType;
  }
};
ZodCatch.create = (type, params) => {
  return new ZodCatch({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodCatch,
    catchValue: typeof params.catch === "function" ? params.catch : () => params.catch,
    ...processCreateParams(params)
  });
};
var ZodNaN = class extends ZodType {
  _parse(input) {
    const parsedType = this._getType(input);
    if (parsedType !== ZodParsedType.nan) {
      const ctx = this._getOrReturnCtx(input);
      addIssueToContext(ctx, {
        code: ZodIssueCode.invalid_type,
        expected: ZodParsedType.nan,
        received: ctx.parsedType
      });
      return INVALID;
    }
    return { status: "valid", value: input.data };
  }
};
ZodNaN.create = (params) => {
  return new ZodNaN({
    typeName: ZodFirstPartyTypeKind.ZodNaN,
    ...processCreateParams(params)
  });
};
var BRAND = Symbol("zod_brand");
var ZodBranded = class extends ZodType {
  _parse(input) {
    const { ctx } = this._processInputParams(input);
    const data = ctx.data;
    return this._def.type._parse({
      data,
      path: ctx.path,
      parent: ctx
    });
  }
  unwrap() {
    return this._def.type;
  }
};
var ZodPipeline = class extends ZodType {
  _parse(input) {
    const { status, ctx } = this._processInputParams(input);
    if (ctx.common.async) {
      const handleAsync = async () => {
        const inResult = await this._def.in._parseAsync({
          data: ctx.data,
          path: ctx.path,
          parent: ctx
        });
        if (inResult.status === "aborted")
          return INVALID;
        if (inResult.status === "dirty") {
          status.dirty();
          return DIRTY(inResult.value);
        } else {
          return this._def.out._parseAsync({
            data: inResult.value,
            path: ctx.path,
            parent: ctx
          });
        }
      };
      return handleAsync();
    } else {
      const inResult = this._def.in._parseSync({
        data: ctx.data,
        path: ctx.path,
        parent: ctx
      });
      if (inResult.status === "aborted")
        return INVALID;
      if (inResult.status === "dirty") {
        status.dirty();
        return {
          status: "dirty",
          value: inResult.value
        };
      } else {
        return this._def.out._parseSync({
          data: inResult.value,
          path: ctx.path,
          parent: ctx
        });
      }
    }
  }
  static create(a, b) {
    return new ZodPipeline({
      in: a,
      out: b,
      typeName: ZodFirstPartyTypeKind.ZodPipeline
    });
  }
};
var ZodReadonly = class extends ZodType {
  _parse(input) {
    const result2 = this._def.innerType._parse(input);
    if (isValid(result2)) {
      result2.value = Object.freeze(result2.value);
    }
    return result2;
  }
};
ZodReadonly.create = (type, params) => {
  return new ZodReadonly({
    innerType: type,
    typeName: ZodFirstPartyTypeKind.ZodReadonly,
    ...processCreateParams(params)
  });
};
var custom = (check, params = {}, fatal) => {
  if (check)
    return ZodAny.create().superRefine((data, ctx) => {
      var _a2, _b;
      if (!check(data)) {
        const p = typeof params === "function" ? params(data) : typeof params === "string" ? { message: params } : params;
        const _fatal = (_b = (_a2 = p.fatal) !== null && _a2 !== void 0 ? _a2 : fatal) !== null && _b !== void 0 ? _b : true;
        const p2 = typeof p === "string" ? { message: p } : p;
        ctx.addIssue({ code: "custom", ...p2, fatal: _fatal });
      }
    });
  return ZodAny.create();
};
var late = {
  object: ZodObject.lazycreate
};
var ZodFirstPartyTypeKind;
(function(ZodFirstPartyTypeKind2) {
  ZodFirstPartyTypeKind2["ZodString"] = "ZodString";
  ZodFirstPartyTypeKind2["ZodNumber"] = "ZodNumber";
  ZodFirstPartyTypeKind2["ZodNaN"] = "ZodNaN";
  ZodFirstPartyTypeKind2["ZodBigInt"] = "ZodBigInt";
  ZodFirstPartyTypeKind2["ZodBoolean"] = "ZodBoolean";
  ZodFirstPartyTypeKind2["ZodDate"] = "ZodDate";
  ZodFirstPartyTypeKind2["ZodSymbol"] = "ZodSymbol";
  ZodFirstPartyTypeKind2["ZodUndefined"] = "ZodUndefined";
  ZodFirstPartyTypeKind2["ZodNull"] = "ZodNull";
  ZodFirstPartyTypeKind2["ZodAny"] = "ZodAny";
  ZodFirstPartyTypeKind2["ZodUnknown"] = "ZodUnknown";
  ZodFirstPartyTypeKind2["ZodNever"] = "ZodNever";
  ZodFirstPartyTypeKind2["ZodVoid"] = "ZodVoid";
  ZodFirstPartyTypeKind2["ZodArray"] = "ZodArray";
  ZodFirstPartyTypeKind2["ZodObject"] = "ZodObject";
  ZodFirstPartyTypeKind2["ZodUnion"] = "ZodUnion";
  ZodFirstPartyTypeKind2["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
  ZodFirstPartyTypeKind2["ZodIntersection"] = "ZodIntersection";
  ZodFirstPartyTypeKind2["ZodTuple"] = "ZodTuple";
  ZodFirstPartyTypeKind2["ZodRecord"] = "ZodRecord";
  ZodFirstPartyTypeKind2["ZodMap"] = "ZodMap";
  ZodFirstPartyTypeKind2["ZodSet"] = "ZodSet";
  ZodFirstPartyTypeKind2["ZodFunction"] = "ZodFunction";
  ZodFirstPartyTypeKind2["ZodLazy"] = "ZodLazy";
  ZodFirstPartyTypeKind2["ZodLiteral"] = "ZodLiteral";
  ZodFirstPartyTypeKind2["ZodEnum"] = "ZodEnum";
  ZodFirstPartyTypeKind2["ZodEffects"] = "ZodEffects";
  ZodFirstPartyTypeKind2["ZodNativeEnum"] = "ZodNativeEnum";
  ZodFirstPartyTypeKind2["ZodOptional"] = "ZodOptional";
  ZodFirstPartyTypeKind2["ZodNullable"] = "ZodNullable";
  ZodFirstPartyTypeKind2["ZodDefault"] = "ZodDefault";
  ZodFirstPartyTypeKind2["ZodCatch"] = "ZodCatch";
  ZodFirstPartyTypeKind2["ZodPromise"] = "ZodPromise";
  ZodFirstPartyTypeKind2["ZodBranded"] = "ZodBranded";
  ZodFirstPartyTypeKind2["ZodPipeline"] = "ZodPipeline";
  ZodFirstPartyTypeKind2["ZodReadonly"] = "ZodReadonly";
})(ZodFirstPartyTypeKind || (ZodFirstPartyTypeKind = {}));
var instanceOfType = (cls, params = {
  message: `Input not instance of ${cls.name}`
}) => custom((data) => data instanceof cls, params);
var stringType = ZodString.create;
var numberType = ZodNumber.create;
var nanType = ZodNaN.create;
var bigIntType = ZodBigInt.create;
var booleanType = ZodBoolean.create;
var dateType = ZodDate.create;
var symbolType = ZodSymbol.create;
var undefinedType = ZodUndefined.create;
var nullType = ZodNull.create;
var anyType = ZodAny.create;
var unknownType = ZodUnknown.create;
var neverType = ZodNever.create;
var voidType = ZodVoid.create;
var arrayType = ZodArray.create;
var objectType = ZodObject.create;
var strictObjectType = ZodObject.strictCreate;
var unionType = ZodUnion.create;
var discriminatedUnionType = ZodDiscriminatedUnion.create;
var intersectionType = ZodIntersection.create;
var tupleType = ZodTuple.create;
var recordType = ZodRecord.create;
var mapType = ZodMap.create;
var setType = ZodSet.create;
var functionType = ZodFunction.create;
var lazyType = ZodLazy.create;
var literalType = ZodLiteral.create;
var enumType = ZodEnum.create;
var nativeEnumType = ZodNativeEnum.create;
var promiseType = ZodPromise.create;
var effectsType = ZodEffects.create;
var optionalType = ZodOptional.create;
var nullableType = ZodNullable.create;
var preprocessType = ZodEffects.createWithPreprocess;
var pipelineType = ZodPipeline.create;
var ostring = () => stringType().optional();
var onumber = () => numberType().optional();
var oboolean = () => booleanType().optional();
var coerce = {
  string: (arg) => ZodString.create({ ...arg, coerce: true }),
  number: (arg) => ZodNumber.create({ ...arg, coerce: true }),
  boolean: (arg) => ZodBoolean.create({
    ...arg,
    coerce: true
  }),
  bigint: (arg) => ZodBigInt.create({ ...arg, coerce: true }),
  date: (arg) => ZodDate.create({ ...arg, coerce: true })
};
var NEVER = INVALID;
var z = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  defaultErrorMap: errorMap,
  setErrorMap,
  getErrorMap,
  makeIssue,
  EMPTY_PATH,
  addIssueToContext,
  ParseStatus,
  INVALID,
  DIRTY,
  OK,
  isAborted,
  isDirty,
  isValid,
  isAsync,
  get util() {
    return util;
  },
  get objectUtil() {
    return objectUtil;
  },
  ZodParsedType,
  getParsedType,
  ZodType,
  ZodString,
  ZodNumber,
  ZodBigInt,
  ZodBoolean,
  ZodDate,
  ZodSymbol,
  ZodUndefined,
  ZodNull,
  ZodAny,
  ZodUnknown,
  ZodNever,
  ZodVoid,
  ZodArray,
  ZodObject,
  ZodUnion,
  ZodDiscriminatedUnion,
  ZodIntersection,
  ZodTuple,
  ZodRecord,
  ZodMap,
  ZodSet,
  ZodFunction,
  ZodLazy,
  ZodLiteral,
  ZodEnum,
  ZodNativeEnum,
  ZodPromise,
  ZodEffects,
  ZodTransformer: ZodEffects,
  ZodOptional,
  ZodNullable,
  ZodDefault,
  ZodCatch,
  ZodNaN,
  BRAND,
  ZodBranded,
  ZodPipeline,
  ZodReadonly,
  custom,
  Schema: ZodType,
  ZodSchema: ZodType,
  late,
  get ZodFirstPartyTypeKind() {
    return ZodFirstPartyTypeKind;
  },
  coerce,
  any: anyType,
  array: arrayType,
  bigint: bigIntType,
  boolean: booleanType,
  date: dateType,
  discriminatedUnion: discriminatedUnionType,
  effect: effectsType,
  "enum": enumType,
  "function": functionType,
  "instanceof": instanceOfType,
  intersection: intersectionType,
  lazy: lazyType,
  literal: literalType,
  map: mapType,
  nan: nanType,
  nativeEnum: nativeEnumType,
  never: neverType,
  "null": nullType,
  nullable: nullableType,
  number: numberType,
  object: objectType,
  oboolean,
  onumber,
  optional: optionalType,
  ostring,
  pipeline: pipelineType,
  preprocess: preprocessType,
  promise: promiseType,
  record: recordType,
  set: setType,
  strictObject: strictObjectType,
  string: stringType,
  symbol: symbolType,
  transformer: effectsType,
  tuple: tupleType,
  "undefined": undefinedType,
  union: unionType,
  unknown: unknownType,
  "void": voidType,
  NEVER,
  ZodIssueCode,
  quotelessJson,
  ZodError
});

// ../dashboard/utils/colors.ts
var HexColorSchema = z.string().regex(/^#([0-9A-Fa-f]{3}){1,2}$/);
function hexToRgb(hex) {
  const { success } = HexColorSchema.safeParse(hex);
  if (!success) {
    throw new Error("invalid hex color");
  }
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return [r, g, b];
}
function getContrastYIQ(inputColor) {
  let rgb;
  try {
    if (typeof inputColor === "string") {
      rgb = hexToRgb(inputColor);
    } else {
      rgb = inputColor;
    }
    const [r, g, b] = rgb;
    const yiq = (r * 299 + g * 587 + b * 114) / 1e3;
    return yiq >= 128 ? "black" : "white";
  } catch (e) {
    return "black";
  }
}

// src/hooks/useDraggableShape.ts
var useDraggableShape = (shape, canDragOutsideMap, mapSize) => {
  const map = useMap();
  const [bounds, setBounds] = useState(
    new LatLngBounds([
      [shape.y - shape.height / 2, shape.x - shape.width / 2],
      [shape.y + shape.height / 2, shape.x + shape.width / 2]
    ])
  );
  const shapeRef = useRef(null);
  const moveCountRef = useRef(0);
  const dragStartBoundsRef = useRef();
  const dragStartEventLatLngRef = useRef();
  useEffect(() => {
    if (!shapeRef.current) {
      return;
    }
    const el = shapeRef.current.getElement();
    el?.classList.toggle("disabled", !!shape.disabled);
  }, [shape.disabled, shapeRef]);
  useEffect(() => {
    if (!shape.name) {
      return;
    }
    const el = shapeRef.current?.getElement();
    el?.setAttribute("role", "button");
    el?.setAttribute("aria-label", shape.name);
  }, [shapeRef, shape.name]);
  const onMouseDown = useCallback(
    (event) => {
      if (!shapeRef.current)
        return;
      if (!shape.draggable) {
        if (!shape.disabled) {
          shape.onClick?.(shape);
        }
        return;
      }
      map.dragging.disable();
      moveCountRef.current = 0;
      dragStartBoundsRef.current = shapeRef.current.getBounds();
      dragStartEventLatLngRef.current = event.latlng;
    },
    [map.dragging, shape, shapeRef]
  );
  const onMouseMove = (event) => {
    if (!dragStartBoundsRef.current || !dragStartEventLatLngRef.current)
      return;
    moveCountRef.current += 1;
    const delta = {
      lat: dragStartEventLatLngRef.current.lat - event.latlng.lat,
      lng: dragStartEventLatLngRef.current.lng - event.latlng.lng
    };
    const newBounds = new LatLngBounds([
      [
        dragStartBoundsRef.current.getSouthWest().lat - delta.lat,
        dragStartBoundsRef.current.getSouthWest().lng - delta.lng
      ],
      [
        dragStartBoundsRef.current.getNorthEast().lat - delta.lat,
        dragStartBoundsRef.current.getNorthEast().lng - delta.lng
      ]
    ]);
    const newShapeCenter = newBounds.getCenter();
    if (!canDragOutsideMap && (newShapeCenter.lat < 0 || newShapeCenter.lng < 0 || newShapeCenter.lat > mapSize.height || newShapeCenter.lng > mapSize.width)) {
      return;
    }
    const tooltip = shapeRef.current?.getTooltip();
    tooltip?.setLatLng(newBounds.getCenter());
    setBounds(newBounds);
  };
  const onMouseEnd = () => {
    if (!dragStartBoundsRef.current || !dragStartEventLatLngRef.current)
      return;
    if (moveCountRef.current === 0) {
      if (!shape.disabled) {
        shape.onClick?.(shape);
      }
    } else {
      shape.onDrag?.({
        ...shape,
        x: bounds.getCenter().lng,
        y: bounds.getCenter().lat
      });
    }
    map.dragging.enable();
    dragStartBoundsRef.current = void 0;
    dragStartEventLatLngRef.current = void 0;
  };
  useMapEvents({
    mousemove: onMouseMove,
    mouseup: onMouseEnd,
    mouseout: onMouseEnd
  });
  useEffect(() => {
    const el = shapeRef.current?.getElement();
    const tooltip = shapeRef.current?.getTooltip();
    const tooltipContent = tooltip?.getElement()?.firstElementChild;
    if (shape.isSelected) {
      tooltipContent?.classList.add("selected");
      el?.classList.remove("focused");
      el?.classList.add("selected");
      shapeRef.current?.setStyle({
        fillColor: `#fff`,
        color: shape.color
      });
    } else if (shape.isFocused) {
      tooltipContent?.classList.remove("selected");
      el?.classList.remove("selected");
      el?.classList.add("focused");
      shapeRef.current?.setStyle({
        fillColor: `color-mix(in oklab, ${shape.color}, #000 20%)`,
        color: "#fff"
      });
    } else {
      tooltipContent?.classList.remove("selected");
      el?.classList.remove("focused");
      el?.classList.remove("selected");
      shapeRef.current?.setStyle({ fillColor: shape.color, color: "#fff" });
    }
  }, [shape.color, shape.isSelected, shape.isFocused]);
  useEffect(() => {
    if (shapeRef.current) {
      if (!shapeRef.current.getTooltip()) {
        const span = document.createElement("span");
        span.innerHTML = shape.label;
        span.style.color = shape.isSelected ? "#000" : getContrastYIQ(shape.color);
        const tooltip = LeafletTooltip({
          permanent: true,
          direction: "center",
          className: "shape-tooltip"
        }).setContent(span).setLatLng(shapeRef.current.getBounds().getCenter());
        shapeRef.current.bindTooltip(tooltip).openTooltip();
      }
      shapeRef.current.on("mousedown", onMouseDown);
      shapeRef.current.on("mouseover", () => {
        if (shape.disabled)
          return;
        if (shape.isSelected) {
          shapeRef.current?.setStyle({
            fillColor: `color-mix(in oklab, #fff, #000 20%)`,
            color: shape.color
          });
        } else {
          shapeRef.current?.setStyle({
            fillColor: `color-mix(in oklab, ${shape.color}, #000 20%)`,
            color: "#fff"
          });
        }
      });
      shapeRef.current.on("mouseout", () => {
        if (shape.disabled)
          return;
        if (shape.isSelected) {
          shapeRef.current?.setStyle({
            fillColor: `#fff`,
            color: shape.color
          });
        } else {
          shapeRef.current?.setStyle({ fillColor: shape.color, color: "#fff" });
        }
      });
    }
    const _shape = shapeRef.current;
    return () => {
      if (_shape) {
        _shape.off("mousedown");
        _shape.off("mouseover");
        _shape.off("mouseout");
      }
    };
  }, [
    shape.label,
    shape.color,
    shape.disabled,
    shape.isFocused,
    shape.isSelected,
    shapeRef,
    onMouseDown
  ]);
  return { bounds, shapeRef };
};

// src/hooks/useShapes.ts
import { useContext } from "react";

// src/components/ShapesContext.tsx
import { createContext, useState as useState2 } from "react";

// src/lib/utils.ts
import { LatLngBounds as LatLngBounds3 } from "leaflet";

// ../types/dist/index.js
var __create = Object.create;
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp2(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp2(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var require_lodash = __commonJS({
  "../node_modules/lodash/lodash.js"(exports, module) {
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
        while (++index < length) {
          result2[index] = iteratee(array[index], index, array);
        }
        return result2;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result2;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result2 = key;
            return false;
          }
        });
        return result2;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result2, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result2 = result2 === undefined2 ? current : result2 + current;
          }
        }
        return result2;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result2 = Array(n);
        while (++index < n) {
          result2[index] = iteratee(index);
        }
        return result2;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result2 = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result2;
          }
        }
        return result2;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result2 = [];
        while (!(data = iterator.next()).done) {
          result2.push(data.value);
        }
        return result2;
      }
      function mapToArray(map) {
        var index = -1, result2 = Array(map.size);
        map.forEach(function(value, key) {
          result2[++index] = [key, value];
        });
        return result2;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result2[resIndex++] = index;
          }
        }
        return result2;
      }
      function setToArray(set) {
        var index = -1, result2 = Array(set.size);
        set.forEach(function(value) {
          result2[++index] = value;
        });
        return result2;
      }
      function setToPairs(set) {
        var index = -1, result2 = Array(set.size);
        set.forEach(function(value) {
          result2[++index] = [value, value];
        });
        return result2;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result2 = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result2;
        }
        return result2;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map22 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map22), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result3 = new object();
            object.prototype = undefined2;
            return result3;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result3 = new LazyWrapper(this.__wrapped__);
          result3.__actions__ = copyArray(this.__actions__);
          result3.__dir__ = this.__dir__;
          result3.__filtered__ = this.__filtered__;
          result3.__iteratees__ = copyArray(this.__iteratees__);
          result3.__takeCount__ = this.__takeCount__;
          result3.__views__ = copyArray(this.__views__);
          return result3;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result3 = new LazyWrapper(this);
            result3.__dir__ = -1;
            result3.__filtered__ = true;
          } else {
            result3 = this.clone();
            result3.__dir__ *= -1;
          }
          return result3;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result3 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result3[resIndex++] = value;
            }
          return result3;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result3 = this.has(key) && delete this.__data__[key];
          this.size -= result3 ? 1 : 0;
          return result3;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result3 = data[key];
            return result3 === HASH_UNDEFINED ? undefined2 : result3;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map22 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result3 = getMapData(this, key)["delete"](key);
          this.size -= result3 ? 1 : 0;
          return result3;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result3 = data["delete"](key);
          this.size = data.size;
          return result3;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map22 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result3 = skipIndexes ? baseTimes(value.length, String2) : [], length = result3.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result3.push(key);
            }
          }
          return result3;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result3 = Array2(length), skip = object == null;
          while (++index < length) {
            result3[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result3;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result3, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result3 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result3 !== undefined2) {
            return result3;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result3 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result3);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result3 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result3, value)) : copySymbols(value, baseAssign(result3, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result3 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result3);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result3.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result3.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result3, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result3;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result3 = [], valuesLength = values2.length;
          if (!length) {
            return result3;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result3.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result3.push(value);
              }
            }
          return result3;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result3 = true;
          baseEach(collection, function(value, index, collection2) {
            result3 = !!predicate(value, index, collection2);
            return result3;
          });
          return result3;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result3 = value;
            }
          }
          return result3;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result3 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result3.push(value);
            }
          });
          return result3;
        }
        function baseFlatten(array, depth, predicate, isStrict, result3) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result3 || (result3 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result3);
              } else {
                arrayPush(result3, value);
              }
            } else if (!isStrict) {
              result3[result3.length] = value;
            }
          }
          return result3;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result3 = keysFunc(object);
          return isArray(object) ? result3 : arrayPush(result3, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result3 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result3.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result3, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result3.push(value);
              }
            }
          return result3;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result3 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result3 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result3)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result3 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result3.push(key);
            }
          }
          return result3;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result3 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result3.push(key);
            }
          }
          return result3;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result3 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result3[++index] = iteratee2(value, key, collection2);
          });
          return result3;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result3 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result3, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result3 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result3, castPath(path, object), value);
            }
          }
          return result3;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result3 = Array2(length);
          while (length--) {
            result3[fromRight ? length : ++index] = start;
            start += step;
          }
          return result3;
        }
        function baseRepeat(string, n) {
          var result3 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result3;
          }
          do {
            if (n % 2) {
              result3 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result3;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result3 = Array2(length);
          while (++index < length) {
            result3[index] = array[index + start];
          }
          return result3;
        }
        function baseSome(collection, predicate) {
          var result3;
          baseEach(collection, function(value, index, collection2) {
            result3 = predicate(value, index, collection2);
            return !result3;
          });
          return !!result3;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result3 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result3[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result3;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result3 = value + "";
          return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result3 = [], seen = result3;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result3;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result3.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result3) {
                  seen.push(computed);
                }
                result3.push(value);
              }
            }
          return result3;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result3 = value;
          if (result3 instanceof LazyWrapper) {
            result3 = result3.value();
          }
          return arrayReduce(actions, function(result4, action) {
            return action.func.apply(action.thisArg, arrayPush([result4], action.args));
          }, result3);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result3 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result3[index] = baseDifference(result3[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result3, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result3 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result3, props[index], value);
          }
          return result3;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result3 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result3);
          return result3;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result3 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result3).set(new Uint8Array2(arrayBuffer));
          return result3;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result3 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result3.lastIndex = regexp.lastIndex;
          return result3;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result3 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result3) {
              if (index >= ordersLength) {
                return result3;
              }
              var order = orders[index];
              return result3 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result3[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result3[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result3[leftIndex++] = args[argsIndex++];
          }
          return result3;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result3[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result3[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result3[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result3;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result3 = Ctor.apply(thisBinding, args);
            return isObject2(result3) ? result3 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result3 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result3 = funcs[index2].call(this, result3);
              }
              return result3;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result3;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result3 = value;
            }
            if (other !== undefined2) {
              if (result3 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result3 = operator(value, other);
            }
            return result3;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result3 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result3), 0, length).join("") : result3.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result3 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result3, newData);
          }
          result3.placeholder = placeholder;
          return setWrapToString(result3, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result3 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result3 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result3 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result3 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result3, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result3 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result3 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result3 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result3 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result3;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result3 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result3;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result3 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result3 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result3 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result3 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result3;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result3 = func.name + "", array = realNames[result3], length = hasOwnProperty.call(realNames, result3) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result3;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result3 = lodash.iteratee || iteratee;
          result3 = result3 === iteratee ? baseIteratee : result3;
          return arguments.length ? result3(arguments[0], arguments[1]) : result3;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result3 = keys(object), length = result3.length;
          while (length--) {
            var key = result3[length], value = object[key];
            result3[length] = [key, value, isStrictComparable(value)];
          }
          return result3;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result3 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result3;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result3 = [];
          while (object) {
            arrayPush(result3, getSymbols(object));
            object = getPrototype(object);
          }
          return result3;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map22 && getTag(new Map22()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result3 = baseGetTag(value), Ctor = result3 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result3;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result3 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result3 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result3 || ++index != length) {
            return result3;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result3 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result3.index = array.index;
            result3.input = array.input;
          }
          return result3;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result3 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result3.cache;
          return result3;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result3 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result3.push(key);
            }
          }
          return result3;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result3 = [];
          if (string.charCodeAt(0) === 46) {
            result3.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result3.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result3;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result3 = value + "";
          return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result3 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result3.__actions__ = copyArray(wrapper.__actions__);
          result3.__index__ = wrapper.__index__;
          result3.__values__ = wrapper.__values__;
          return result3;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result3 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result3[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result3;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result3 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result3[resIndex++] = value;
            }
          }
          return result3;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result3 = {};
          while (++index < length) {
            var pair = pairs[index];
            result3[pair[0]] = pair[1];
          }
          return result3;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result3 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result3;
        });
        function remove(array, predicate) {
          var result3 = [];
          if (!(array && array.length)) {
            return result3;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result3.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result3;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result3 = unzip(array);
          if (iteratee2 == null) {
            return result3;
          }
          return arrayMap(result3, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result3 = lodash(value);
          result3.__chain__ = true;
          return result3;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result3, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result3) {
              previous.__wrapped__ = clone2;
            } else {
              result3 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result3;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result3, value, key) {
          if (hasOwnProperty.call(result3, key)) {
            ++result3[key];
          } else {
            baseAssignValue(result3, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result3, value, key) {
          if (hasOwnProperty.call(result3, key)) {
            result3[key].push(value);
          } else {
            baseAssignValue(result3, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result3 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result3[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result3;
        });
        var keyBy = createAggregator(function(result3, value, key) {
          baseAssignValue(result3, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition2 = createAggregator(function(result3, value, key) {
          result3[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result3;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result3 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result3;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result3 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result3.placeholder = curry.placeholder;
          return result3;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result3 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result3.placeholder = curryRight.placeholder;
          return result3;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result3, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result3 = func.apply(thisArg, args);
            return result3;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout(timerExpired, wait);
            return leading ? invokeFunc(time) : result3;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result3;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result3 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result3;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result3 = func.apply(this, args);
            memoized.cache = cache.set(key, result3) || cache;
            return result3;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result3 = customizer ? customizer(value, other) : undefined2;
          return result3 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result3;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite2(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined2(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result3 = toFinite(value), remainder = result3 % 1;
          return result3 === result3 ? remainder ? result3 - remainder : result3 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result3 = baseCreate(prototype);
          return properties == null ? result3 : baseAssign(result3, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result3 = object == null ? undefined2 : baseGet(object, path);
          return result3 === undefined2 ? defaultValue : result3;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result3, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result3[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result3, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result3, value)) {
            result3[value].push(key);
          } else {
            result3[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result3 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result3, iteratee2(value, key, object2), value);
          });
          return result3;
        }
        function mapValues(object, iteratee2) {
          var result3 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result3, key, iteratee2(value, key, object2));
          });
          return result3;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result3 = {};
          if (object == null) {
            return result3;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result3);
          if (isDeep) {
            result3 = baseClone(result3, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result3, paths[length]);
          }
          return result3;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result2(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result3, word, index) {
          word = word.toLowerCase();
          return result3 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result3 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result3.source = source;
          if (isError(result3)) {
            throw result3;
          }
          return result3;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result3 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result3 + omission;
          }
          if (strSymbols) {
            end += result3.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result3;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result3 = result3.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result3.lastIndexOf(separator);
            if (index > -1) {
              result3 = result3.slice(0, index);
            }
          }
          return result3 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result3 = object(this.__wrapped__), actions = result3.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result3.__chain__ = chainAll;
                  return result3;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result3 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result3;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition2;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite2;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject2;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined2;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result2;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result3 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result3.__filtered__) {
              result3.__takeCount__ = nativeMin(n, result3.__takeCount__);
            } else {
              result3.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result3.__dir__ < 0 ? "Right" : "")
              });
            }
            return result3;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result3 = this.clone();
            result3.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result3.__filtered__ = result3.__filtered__ || isFilter;
            return result3;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result3 = this;
          if (result3.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result3);
          }
          if (start < 0) {
            result3 = result3.takeRight(-start);
          } else if (start) {
            result3 = result3.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result3 = end < 0 ? result3.dropRight(-end) : result3.take(end - start);
          }
          return result3;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result4 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result4[0] : result4;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result3 = func.apply(value, args);
              result3.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result3, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result3 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result3.value()[0] : result3.value() : result3;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});
function buildQueryString(params, parentKey) {
  const queryParts = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];
      if (typeof value === "undefined")
        continue;
      if (value === null) {
        queryParts.push(`${key}=`);
        continue;
      }
      const keyName = parentKey ? `${parentKey}${encodeURIComponent(`[${key}]`)}` : encodeURIComponent(key);
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          queryParts.push(buildQueryString({ [index]: item }, keyName));
        });
      } else if (typeof value === "object") {
        queryParts.push(buildQueryString(value, keyName));
      } else {
        queryParts.push(`${keyName}=${encodeURIComponent(value != null ? value : "")}`);
      }
    }
  }
  return queryParts.join("&");
}
var PERMISSION = /* @__PURE__ */ ((PERMISSION2) => {
  PERMISSION2["VIEW_EXPERIENCE"] = "experience:read";
  PERMISSION2["MANAGE_EXPERIENCE"] = "experience:manage";
  PERMISSION2["CURATE_EXPERIENCE"] = "experience:curate";
  PERMISSION2["CREATE_BOOKING"] = "booking:create";
  PERMISSION2["VIEW_BOOKING"] = "booking:read";
  PERMISSION2["VOID_BOOKING"] = "booking:void";
  PERMISSION2["REFUND_BOOKING"] = "booking:refund";
  PERMISSION2["CANCEL_BOOKING"] = "booking:cancel";
  PERMISSION2["RESCHEDULE_BOOKING"] = "booking:reschedule";
  PERMISSION2["CHECK_IN_BOOKING"] = "booking:check-in";
  PERMISSION2["VIEW_ALL_BOOKING"] = "booking:viewAll";
  PERMISSION2["VIEW_SESSION"] = "session:read";
  PERMISSION2["EDIT_SESSION"] = "session:edit";
  PERMISSION2["VIEW_HOST"] = "host:read";
  PERMISSION2["VIEW_HOST_FINANCIAL"] = "host:readFinancial";
  PERMISSION2["VIEW_HOST_INFO"] = "host:readInfo";
  PERMISSION2["MANAGE_HOST_IAM"] = "host:manageIAM";
  PERMISSION2["VIEW_ANALYTICS"] = "analytics:read";
  PERMISSION2["VIEW_BRAND_FINANCIAL"] = "brand:readFinancial";
  PERMISSION2["VIEW_FINANCIAL_REPORT"] = "financialReport:read";
  PERMISSION2["VIEW_GUEST_REPORT"] = "guestReport:read";
  PERMISSION2["VIEW_EXPERIENCE_REPORT"] = "experienceReport:read";
  PERMISSION2["MANAGE_BUSINESS_INFO"] = "businessInfo:manage";
  PERMISSION2["MANAGE_BANK_ACCOUNT"] = "bankAccount:manage";
  PERMISSION2["MANAGE_BRAND_IAM"] = "brand:manageIAM";
  PERMISSION2["MANAGE_BRANDING"] = "branding:manage";
  PERMISSION2["MANAGE_CATEGORY_VIBE"] = "category:manage";
  PERMISSION2["MANAGE_EMAIL"] = "email:manage";
  PERMISSION2["MANAGE_ROOM_NUMBER"] = "roomNumber:manage";
  PERMISSION2["MANAGE_LEGAL_DOCUMENT"] = "legalDocument:manage";
  PERMISSION2["MANAGE_CODE"] = "code:manage";
  PERMISSION2["MANAGE_TAX_FEE"] = "taxFee:manage";
  PERMISSION2["MANAGE_DEVELOPER"] = "developer:manage";
  PERMISSION2["MANAGE_INTEGRATION"] = "integration:manage";
  PERMISSION2["VIEW_REVIEW"] = "review:read";
  PERMISSION2["VIEW_MESSAGE"] = "messages:read";
  PERMISSION2["SEND_MESSAGE"] = "messages:send";
  PERMISSION2["VIEW_BUSINESS_INFO"] = "businessInfo:read";
  PERMISSION2["VIEW_CATEGORY_VIBE"] = "category:read";
  PERMISSION2["VIEW_TAX_FEE"] = "tax:read";
  PERMISSION2["MANAGE_MINIMAL_EXPERIENCE"] = "experience:manageMinimal";
  PERMISSION2["MANAGE_BRAND"] = "brand:manage";
  PERMISSION2["VIEW_QUESTIONS_RESPONSE"] = "booking:readCustomQuestionsResponse";
  PERMISSION2["MANAGE_QUESTIONS_RESPONSE"] = "booking:manageCustomQuestionsResponse";
  PERMISSION2["VIEW_BRAND"] = "brand:view";
  PERMISSION2["VIEW_STAFF_USER"] = "staffUser:view";
  PERMISSION2["MANAGE_STAFF_USER"] = "staffUser:manage";
  PERMISSION2["VIEW_USER"] = "user:view";
  PERMISSION2["MANAGE_USER"] = "user:manage";
  PERMISSION2["MANAGE_ORGANIZATION"] = "organization:manage";
  PERMISSION2["MANAGE_GUEST_SURVEY"] = "guestSurvey:manage";
  return PERMISSION2;
})(PERMISSION || {});
var BRAND_MEMBERSHIP_PERMISSIONS = [
  "experience:read",
  "experience:manage",
  "booking:create",
  "booking:read",
  "booking:void",
  "booking:refund",
  "booking:cancel",
  "booking:reschedule",
  "booking:check-in",
  "session:read",
  "session:edit",
  "host:read",
  "host:readFinancial",
  "host:readInfo",
  "host:manageIAM",
  "analytics:read",
  "brand:readFinancial",
  "financialReport:read",
  "experienceReport:read",
  "guestReport:read",
  "businessInfo:manage",
  "bankAccount:manage",
  "brand:manageIAM",
  "branding:manage",
  "category:manage",
  "email:manage",
  "roomNumber:manage",
  "legalDocument:manage",
  "code:manage",
  "taxFee:manage",
  "developer:manage",
  "integration:manage",
  "review:read",
  "messages:read",
  "messages:send",
  "businessInfo:read",
  "category:read",
  "tax:read",
  "experience:manageMinimal",
  "booking:readCustomQuestionsResponse",
  "booking:manageCustomQuestionsResponse"
  /* MANAGE_QUESTIONS_RESPONSE */
];
var ORGANIZATION_MEMBERSHIP_PERMISSIONS = [
  ...BRAND_MEMBERSHIP_PERMISSIONS,
  "organization:manage"
  /* MANAGE_ORGANIZATION */
];
var ACCOUNT_EXECUTIVE_PERMISSIONS = [
  "experience:read",
  "booking:read",
  "session:read",
  "host:read",
  "host:readFinancial",
  "host:readInfo",
  "analytics:read",
  "brand:readFinancial",
  "financialReport:read",
  "experienceReport:read",
  "guestReport:read",
  "review:read",
  "businessInfo:read",
  "category:read",
  "tax:read",
  "booking:readCustomQuestionsResponse",
  "messages:read",
  "brand:view"
  /* VIEW_BRAND */
];
var CUSTOMER_SUCCESS_MANAGEMENT_PERMISSIONS = [
  ...ACCOUNT_EXECUTIVE_PERMISSIONS,
  "booking:create",
  "booking:void",
  "booking:refund",
  "booking:cancel",
  "booking:reschedule",
  "booking:viewAll",
  "session:edit",
  "user:view",
  "user:manage",
  "host:manageIAM",
  "businessInfo:manage",
  "bankAccount:manage",
  "brand:manageIAM",
  "category:manage",
  "email:manage",
  "roomNumber:manage",
  "legalDocument:manage",
  "code:manage",
  "taxFee:manage",
  "developer:manage",
  "integration:manage",
  "experience:manageMinimal",
  "experience:curate",
  "booking:manageCustomQuestionsResponse",
  "experience:manage",
  "messages:send",
  "booking:check-in",
  "organization:manage"
  /* MANAGE_ORGANIZATION */
];
var STAFF_ADMIN_PERMISSIONS = [
  ...CUSTOMER_SUCCESS_MANAGEMENT_PERMISSIONS,
  "brand:manage",
  "staffUser:view",
  "staffUser:manage",
  "guestSurvey:manage"
  /* MANAGE_GUEST_SURVEY */
];
var StaffRole = /* @__PURE__ */ ((StaffRole2) => {
  StaffRole2["OWNER"] = "owner";
  StaffRole2["ADMIN"] = "admin";
  StaffRole2["CSM"] = "csm";
  StaffRole2["AE"] = "ae";
  return StaffRole2;
})(StaffRole || {});
var ImageSizeInUriSchemaBuilder = (imageSizes) => {
  return z.object(
    Object.fromEntries(imageSizes.map((size) => [`${size}w`, z.string()]))
  );
};
var ImageSizeWithOriginalInUriSchemaBuilder = (imageSizes) => {
  return ImageSizeInUriSchemaBuilder(imageSizes).extend({ original: z.string() });
};
var IMediaReferenceSchema = z.object({
  id: z.string(),
  uri: z.object({
    original: z.string()
  })
});
var DocumentCategory = /* @__PURE__ */ ((DocumentCategory2) => {
  DocumentCategory2["CERTIFICATE_OF_INSURANCE"] = "certificate_of_insurance";
  DocumentCategory2["BRAND_HOST_AGREEMENT"] = "brand_host_agreement";
  DocumentCategory2["OTHER"] = "other";
  return DocumentCategory2;
})(DocumentCategory || {});
var DocumentSchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  uri: z.string(),
  brandId: z.string().uuid(),
  userId: z.string().uuid().nullable(),
  uploadedById: z.string().uuid(),
  category: z.nativeEnum(DocumentCategory),
  metadata: z.record(z.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null),
  uploadedAt: z.string().datetime(),
  updatedAt: z.string().datetime()
});
var GetDocumentsQuerySchema = z.object({
  userId: z.string().uuid().optional()
});
var GetDocumentSignedUrlResponseSchema = z.object({
  name: z.string(),
  url: z.string()
});
var UploadDocumentRequestSchema = z.object({
  userId: z.string().uuid(),
  category: z.nativeEnum(DocumentCategory),
  label: z.string().nullable().optional()
});
var UpdateDocumentRequestSchema = z.object({
  label: z.string()
});
var GetDocumentsResponseSchema = z.array(DocumentSchema);
var metadata_min_json_default = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata_min_json_default);
  return func.apply(this, args);
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";
function semver_compare_default(a, b) {
  a = a.split("-");
  b = b.split("-");
  var pa = a[0].split(".");
  var pb = b[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== void 0 && object !== null && object.constructor === objectConstructor;
}
function _typeof2(obj) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof2(obj);
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata) {
    _classCallCheck2(this, Metadata2);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  _createClass2(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata, globalMetadataObject) {
    _classCallCheck2(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass2(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata) {
    _classCallCheck2(this, Format2);
    this._format = format;
    this.metadata = metadata;
  }
  _createClass2(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata) {
    _classCallCheck2(this, Type2);
    this.type = type;
    this.metadata = metadata;
  }
  _createClass2(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + typeOf(metadata) + ": " + metadata, "."));
  }
}
var typeOf = function typeOf2(_) {
  return _typeof2(_);
};
function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);
  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  return metadata.countries.hasOwnProperty(country);
}
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare_default(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare_default(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  // Fullwidth digit 0
  "\uFF11": "1",
  // Fullwidth digit 1
  "\uFF12": "2",
  // Fullwidth digit 2
  "\uFF13": "3",
  // Fullwidth digit 3
  "\uFF14": "4",
  // Fullwidth digit 4
  "\uFF15": "5",
  // Fullwidth digit 5
  "\uFF16": "6",
  // Fullwidth digit 6
  "\uFF17": "7",
  // Fullwidth digit 7
  "\uFF18": "8",
  // Fullwidth digit 8
  "\uFF19": "9",
  // Fullwidth digit 9
  "\u0660": "0",
  // Arabic-indic digit 0
  "\u0661": "1",
  // Arabic-indic digit 1
  "\u0662": "2",
  // Arabic-indic digit 2
  "\u0663": "3",
  // Arabic-indic digit 3
  "\u0664": "4",
  // Arabic-indic digit 4
  "\u0665": "5",
  // Arabic-indic digit 5
  "\u0666": "6",
  // Arabic-indic digit 6
  "\u0667": "7",
  // Arabic-indic digit 7
  "\u0668": "8",
  // Arabic-indic digit 8
  "\u0669": "9",
  // Arabic-indic digit 9
  "\u06F0": "0",
  // Eastern-Arabic digit 0
  "\u06F1": "1",
  // Eastern-Arabic digit 1
  "\u06F2": "2",
  // Eastern-Arabic digit 2
  "\u06F3": "3",
  // Eastern-Arabic digit 3
  "\u06F4": "4",
  // Eastern-Arabic digit 4
  "\u06F5": "5",
  // Eastern-Arabic digit 5
  "\u06F6": "6",
  // Eastern-Arabic digit 6
  "\u06F7": "7",
  // Eastern-Arabic digit 7
  "\u06F8": "8",
  // Eastern-Arabic digit 8
  "\u06F9": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      if (typeof emitEvent === "function") {
        emitEvent("end");
      }
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function _createForOfIteratorHelperLoose2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose2(b), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a2, b2) {
    return a2 - b2;
  });
}
function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata);
}
function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata);
    }
    var mobile_type = metadata.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata) {
  if (options === void 0) {
    options = {};
  }
  metadata = new Metadata(metadata);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray3(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata)) {
    if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose3(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}
function isValidNumber(input, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function formatRFC3966(_ref) {
  var number = _ref.number, ext = _ref.ext;
  if (!number) {
    return "";
  }
  if (number[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}
function _createForOfIteratorHelperLoose4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray4(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata) {
  if (options) {
    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata = new Metadata(metadata);
  if (input.country && input.country !== "001") {
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose4(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format = _step.value;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
  }
}
function ownKeys2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
      _defineProperty2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck3(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata) {
      throw new TypeError("`metadata` not passed");
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata;
    };
  }
  _createClass3(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid2() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread2(_objectSpread2({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = "001";
      }
    }
  }
  return {
    country,
    countryCallingCode
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}
function extractNationalNumber(number, metadata) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number
  };
}
function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number
      };
    }
  }
  if (number[1] === "0") {
    return {};
  }
  metadata = new Metadata(metadata);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}
function _createForOfIteratorHelperLoose5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray5(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray5(o, minLen);
}
function _arrayLikeToArray5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
  metadata = new Metadata(metadata);
  var matchingCountries = [];
  for (var _iterator = _createForOfIteratorHelperLoose5(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata.country(country);
    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata.metadata)) {
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }
        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  }
  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE2 = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE2) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry,
    metadata: metadata.metadata
  });
}
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
var USE_NON_GEOGRAPHIC_COUNTRY_CODE3 = false;
function parse(text, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    } else {
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE3) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = "001";
        }
      }
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else
    return {};
  if (!number) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001") {
    } else {
      metadata.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
function ownKeys3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys3(Object(source), true).forEach(function(key) {
      _defineProperty3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread3(_objectSpread3({}, options), {}, {
    v2: true
  }), metadata);
}
function ownKeys4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys4(Object(source), true).forEach(function(key) {
      _defineProperty4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray6(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray6(o, minLen);
}
function _arrayLikeToArray6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = void 0;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread4({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata
  };
}
function ownKeys5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys5(Object(source), true).forEach(function(key) {
      _defineProperty5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber2(text, options, metadata) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread5(_objectSpread5({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    if (error instanceof ParseError) {
    } else {
      throw error;
    }
  }
}
function parsePhoneNumber3() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  return parsePhoneNumber2(text, options, metadata);
}
function parsePhoneNumber4() {
  return withMetadataArgument(parsePhoneNumber3, arguments);
}
var import_lodash = __toESM(require_lodash(), 1);
var AllCountries = /* @__PURE__ */ ((AllCountries2) => {
  AllCountries2["AF"] = "Afghanistan";
  AllCountries2["AX"] = "land Islands";
  AllCountries2["AL"] = "Albania";
  AllCountries2["DZ"] = "Algeria";
  AllCountries2["AS"] = "American Samoa";
  AllCountries2["AD"] = "AndorrA";
  AllCountries2["AO"] = "Angola";
  AllCountries2["AI"] = "Anguilla";
  AllCountries2["AQ"] = "Antarctica";
  AllCountries2["AG"] = "Antigua and Barbuda";
  AllCountries2["AR"] = "Argentina";
  AllCountries2["AM"] = "Armenia";
  AllCountries2["AW"] = "Aruba";
  AllCountries2["AU"] = "Australia";
  AllCountries2["AT"] = "Austria";
  AllCountries2["AZ"] = "Azerbaijan";
  AllCountries2["BS"] = "Bahamas";
  AllCountries2["BH"] = "Bahrain";
  AllCountries2["BD"] = "Bangladesh";
  AllCountries2["BB"] = "Barbados";
  AllCountries2["BY"] = "Belarus";
  AllCountries2["BE"] = "Belgium";
  AllCountries2["BZ"] = "Belize";
  AllCountries2["BJ"] = "Benin";
  AllCountries2["BM"] = "Bermuda";
  AllCountries2["BT"] = "Bhutan";
  AllCountries2["BO"] = "Bolivia";
  AllCountries2["BA"] = "Bosnia and Herzegovina";
  AllCountries2["BW"] = "Botswana";
  AllCountries2["BV"] = "Bouvet Island";
  AllCountries2["BR"] = "Brazil";
  AllCountries2["IO"] = "British Indian Ocean Territory";
  AllCountries2["BN"] = "Brunei Darussalam";
  AllCountries2["BG"] = "Bulgaria";
  AllCountries2["BF"] = "Burkina Faso";
  AllCountries2["BI"] = "Burundi";
  AllCountries2["KH"] = "Cambodia";
  AllCountries2["CM"] = "Cameroon";
  AllCountries2["CA"] = "Canada";
  AllCountries2["CV"] = "Cape Verde";
  AllCountries2["KY"] = "Cayman Islands";
  AllCountries2["CF"] = "Central African Republic";
  AllCountries2["TD"] = "Chad";
  AllCountries2["CL"] = "Chile";
  AllCountries2["CN"] = "China";
  AllCountries2["CX"] = "Christmas Island";
  AllCountries2["CC"] = "Cocos (Keeling) Islands";
  AllCountries2["CO"] = "Colombia";
  AllCountries2["KM"] = "Comoros";
  AllCountries2["CG"] = "Congo";
  AllCountries2["CD"] = "Congo, The Democratic Republic of the";
  AllCountries2["CK"] = "Cook Islands";
  AllCountries2["CR"] = "Costa Rica";
  AllCountries2["CI"] = "Cote D'Ivoire";
  AllCountries2["HR"] = "Croatia";
  AllCountries2["CU"] = "Cuba";
  AllCountries2["CY"] = "Cyprus";
  AllCountries2["CZ"] = "Czech Republic";
  AllCountries2["DK"] = "Denmark";
  AllCountries2["DJ"] = "Djibouti";
  AllCountries2["DM"] = "Dominica";
  AllCountries2["DO"] = "Dominican Republic";
  AllCountries2["EC"] = "Ecuador";
  AllCountries2["EG"] = "Egypt";
  AllCountries2["SV"] = "El Salvador";
  AllCountries2["GQ"] = "Equatorial Guinea";
  AllCountries2["ER"] = "Eritrea";
  AllCountries2["EE"] = "Estonia";
  AllCountries2["ET"] = "Ethiopia";
  AllCountries2["FK"] = "Falkland Islands (Malvinas)";
  AllCountries2["FO"] = "Faroe Islands";
  AllCountries2["FJ"] = "Fiji";
  AllCountries2["FI"] = "Finland";
  AllCountries2["FR"] = "France";
  AllCountries2["GF"] = "French Guiana";
  AllCountries2["PF"] = "French Polynesia";
  AllCountries2["TF"] = "French Southern Territories";
  AllCountries2["GA"] = "Gabon";
  AllCountries2["GM"] = "Gambia";
  AllCountries2["GE"] = "Georgia";
  AllCountries2["DE"] = "Germany";
  AllCountries2["GH"] = "Ghana";
  AllCountries2["GI"] = "Gibraltar";
  AllCountries2["GR"] = "Greece";
  AllCountries2["GL"] = "Greenland";
  AllCountries2["GD"] = "Grenada";
  AllCountries2["GP"] = "Guadeloupe";
  AllCountries2["GU"] = "Guam";
  AllCountries2["GT"] = "Guatemala";
  AllCountries2["GG"] = "Guernsey";
  AllCountries2["GN"] = "Guinea";
  AllCountries2["GW"] = "Guinea-Bissau";
  AllCountries2["GY"] = "Guyana";
  AllCountries2["HT"] = "Haiti";
  AllCountries2["HM"] = "Heard Island and Mcdonald Islands";
  AllCountries2["VA"] = "Holy See (Vatican City State)";
  AllCountries2["HN"] = "Honduras";
  AllCountries2["HK"] = "Hong Kong";
  AllCountries2["HU"] = "Hungary";
  AllCountries2["IS"] = "Iceland";
  AllCountries2["IN"] = "India";
  AllCountries2["ID"] = "Indonesia";
  AllCountries2["IR"] = "Iran, Islamic Republic Of";
  AllCountries2["IQ"] = "Iraq";
  AllCountries2["IE"] = "Ireland";
  AllCountries2["IM"] = "Isle of Man";
  AllCountries2["IL"] = "Israel";
  AllCountries2["IT"] = "Italy";
  AllCountries2["JM"] = "Jamaica";
  AllCountries2["JP"] = "Japan";
  AllCountries2["JE"] = "Jersey";
  AllCountries2["JO"] = "Jordan";
  AllCountries2["KZ"] = "Kazakhstan";
  AllCountries2["KE"] = "Kenya";
  AllCountries2["KI"] = "Kiribati";
  AllCountries2["KP"] = "Korea, Democratic People'S Republic of";
  AllCountries2["KR"] = "Korea, Republic of";
  AllCountries2["KW"] = "Kuwait";
  AllCountries2["KG"] = "Kyrgyzstan";
  AllCountries2["LA"] = "Lao People'S Democratic Republic";
  AllCountries2["LV"] = "Latvia";
  AllCountries2["LB"] = "Lebanon";
  AllCountries2["LS"] = "Lesotho";
  AllCountries2["LR"] = "Liberia";
  AllCountries2["LY"] = "Libyan Arab Jamahiriya";
  AllCountries2["LI"] = "Liechtenstein";
  AllCountries2["LT"] = "Lithuania";
  AllCountries2["LU"] = "Luxembourg";
  AllCountries2["MO"] = "Macao";
  AllCountries2["MK"] = "Macedonia, The Former Yugoslav Republic of";
  AllCountries2["MG"] = "Madagascar";
  AllCountries2["MW"] = "Malawi";
  AllCountries2["MY"] = "Malaysia";
  AllCountries2["MV"] = "Maldives";
  AllCountries2["ML"] = "Mali";
  AllCountries2["MT"] = "Malta";
  AllCountries2["MH"] = "Marshall Islands";
  AllCountries2["MQ"] = "Martinique";
  AllCountries2["MR"] = "Mauritania";
  AllCountries2["MU"] = "Mauritius";
  AllCountries2["YT"] = "Mayotte";
  AllCountries2["MX"] = "Mexico";
  AllCountries2["FM"] = "Micronesia, Federated States of";
  AllCountries2["MD"] = "Moldova, Republic of";
  AllCountries2["MC"] = "Monaco";
  AllCountries2["MN"] = "Mongolia";
  AllCountries2["ME"] = "Montenegro";
  AllCountries2["MS"] = "Montserrat";
  AllCountries2["MA"] = "Morocco";
  AllCountries2["MZ"] = "Mozambique";
  AllCountries2["MM"] = "Myanmar";
  AllCountries2["NA"] = "Namibia";
  AllCountries2["NR"] = "Nauru";
  AllCountries2["NP"] = "Nepal";
  AllCountries2["NL"] = "Netherlands";
  AllCountries2["AN"] = "Netherlands Antilles";
  AllCountries2["NC"] = "New Caledonia";
  AllCountries2["NZ"] = "New Zealand";
  AllCountries2["NI"] = "Nicaragua";
  AllCountries2["NE"] = "Niger";
  AllCountries2["NG"] = "Nigeria";
  AllCountries2["NU"] = "Niue";
  AllCountries2["NF"] = "Norfolk Island";
  AllCountries2["MP"] = "Northern Mariana Islands";
  AllCountries2["NO"] = "Norway";
  AllCountries2["OM"] = "Oman";
  AllCountries2["PK"] = "Pakistan";
  AllCountries2["PW"] = "Palau";
  AllCountries2["PS"] = "Palestinian Territory, Occupied";
  AllCountries2["PA"] = "Panama";
  AllCountries2["PG"] = "Papua New Guinea";
  AllCountries2["PY"] = "Paraguay";
  AllCountries2["PE"] = "Peru";
  AllCountries2["PH"] = "Philippines";
  AllCountries2["PN"] = "Pitcairn";
  AllCountries2["PL"] = "Poland";
  AllCountries2["PT"] = "Portugal";
  AllCountries2["PR"] = "Puerto Rico";
  AllCountries2["QA"] = "Qatar";
  AllCountries2["RE"] = "Reunion";
  AllCountries2["RO"] = "Romania";
  AllCountries2["RU"] = "Russian Federation";
  AllCountries2["RW"] = "RWANDA";
  AllCountries2["SH"] = "Saint Helena";
  AllCountries2["KN"] = "Saint Kitts and Nevis";
  AllCountries2["LC"] = "Saint Lucia";
  AllCountries2["PM"] = "Saint Pierre and Miquelon";
  AllCountries2["VC"] = "Saint Vincent and the Grenadines";
  AllCountries2["WS"] = "Samoa";
  AllCountries2["SM"] = "San Marino";
  AllCountries2["ST"] = "Sao Tome and Principe";
  AllCountries2["SA"] = "Saudi Arabia";
  AllCountries2["SN"] = "Senegal";
  AllCountries2["RS"] = "Serbia";
  AllCountries2["SC"] = "Seychelles";
  AllCountries2["SL"] = "Sierra Leone";
  AllCountries2["SG"] = "Singapore";
  AllCountries2["SK"] = "Slovakia";
  AllCountries2["SI"] = "Slovenia";
  AllCountries2["SB"] = "Solomon Islands";
  AllCountries2["SO"] = "Somalia";
  AllCountries2["ZA"] = "South Africa";
  AllCountries2["GS"] = "South Georgia and the South Sandwich Islands";
  AllCountries2["ES"] = "Spain";
  AllCountries2["LK"] = "Sri Lanka";
  AllCountries2["SD"] = "Sudan";
  AllCountries2["SR"] = "Suriname";
  AllCountries2["SJ"] = "Svalbard and Jan Mayen";
  AllCountries2["SZ"] = "Swaziland";
  AllCountries2["SE"] = "Sweden";
  AllCountries2["CH"] = "Switzerland";
  AllCountries2["SY"] = "Syrian Arab Republic";
  AllCountries2["TW"] = "Taiwan, Province of China";
  AllCountries2["TJ"] = "Tajikistan";
  AllCountries2["TZ"] = "Tanzania, United Republic of";
  AllCountries2["TH"] = "Thailand";
  AllCountries2["TL"] = "Timor-Leste";
  AllCountries2["TG"] = "Togo";
  AllCountries2["TK"] = "Tokelau";
  AllCountries2["TO"] = "Tonga";
  AllCountries2["TT"] = "Trinidad and Tobago";
  AllCountries2["TN"] = "Tunisia";
  AllCountries2["TR"] = "Turkey";
  AllCountries2["TM"] = "Turkmenistan";
  AllCountries2["TC"] = "Turks and Caicos Islands";
  AllCountries2["TV"] = "Tuvalu";
  AllCountries2["UG"] = "Uganda";
  AllCountries2["UA"] = "Ukraine";
  AllCountries2["AE"] = "United Arab Emirates";
  AllCountries2["GB"] = "United Kingdom";
  AllCountries2["US"] = "United States";
  AllCountries2["UM"] = "United States Minor Outlying Islands";
  AllCountries2["UY"] = "Uruguay";
  AllCountries2["UZ"] = "Uzbekistan";
  AllCountries2["VU"] = "Vanuatu";
  AllCountries2["VE"] = "Venezuela";
  AllCountries2["VN"] = "Viet Nam";
  AllCountries2["VG"] = "Virgin Islands, British";
  AllCountries2["VI"] = "Virgin Islands, U.S.";
  AllCountries2["WF"] = "Wallis and Futuna";
  AllCountries2["EH"] = "Western Sahara";
  AllCountries2["YE"] = "Yemen";
  AllCountries2["ZM"] = "Zambia";
  AllCountries2["ZW"] = "Zimbabwe";
  return AllCountries2;
})(AllCountries || {});
var isValidCountryCode = (code) => {
  return code in AllCountries;
};
var isPhoneNumber = (value, { validateOnlyCountry = false } = {}) => {
  var _a2;
  if (typeof value !== "string") {
    return false;
  }
  const parsed = parsePhoneNumber4(value);
  if ((0, import_lodash.isUndefined)(parsed)) {
    return false;
  }
  const countryCode = (_a2 = parsed.country) == null ? void 0 : _a2.toString();
  return !!countryCode && isValidCountryCode(countryCode) && (validateOnlyCountry || parsed.isValid());
};
var sortOptions = ["ASC", "DESC"];
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var PaginationMetaSchema = z.object({
  totalItems: z.number().optional(),
  itemCount: z.number(),
  itemsPerPage: z.number(),
  totalPages: z.number().optional(),
  currentPage: z.number()
});
var PaginationLinkSchema = z.object({
  first: z.string(),
  previous: z.string(),
  next: z.string(),
  last: z.string()
}).partial().optional();
var paginateResponseSchema = (schema) => z.object({
  items: z.array(schema),
  meta: PaginationMetaSchema,
  links: PaginationLinkSchema
});
var ComparableFilterSchema = z.object({
  operator: z.enum(["equals", "greater_than", "less_than"]),
  name: z.string(),
  value: z.string()
});
var InFilterSchema = z.object({
  operator: z.literal("in"),
  name: z.string(),
  value: z.array(z.string())
});
var RangeFilterSchema = z.object({
  operator: z.literal("range"),
  name: z.string(),
  value: z.object({ from: z.string(), to: z.string() })
});
var FiltersSchema = z.array(z.union([ComparableFilterSchema, InFilterSchema, RangeFilterSchema]));
var paginateQuerySchema = ({
  sortBy
} = {}) => {
  return z.object({
    page: z.coerce.number().min(1).default(1),
    limit: z.coerce.number().min(0).default(10),
    sortDir: z.enum(sortOptions).optional(),
    sortBy: sortBy === void 0 ? z.never().optional() : z.enum(sortBy).optional(),
    filters: FiltersSchema.optional(),
    q: z.string().optional()
  });
};
var LiteralSchema = z.union([z.string(), z.number(), z.boolean(), z.null()]);
var JsonSchema = z.lazy(() => z.union([LiteralSchema, z.array(JsonSchema), z.record(JsonSchema)]));
var makeEndpoint = (endpoint) => endpoint;
var PhoneNumberValidationSchema = z.string().refine((phoneNumber) => isPhoneNumber(phoneNumber, { validateOnlyCountry: true }), {
  message: "Invalid phone number, please verify proper format."
});
var MinimalHostSchema = z.object({
  id: z.string(),
  fullName: z.string(),
  profilePicture: IMediaReferenceSchema.nullable()
});
var HostSchema = MinimalHostSchema.extend({
  firstName: z.string(),
  lastName: z.string(),
  allowOverlappingBookings: z.boolean()
});
var HostCommissionType = /* @__PURE__ */ ((HostCommissionType2) => {
  HostCommissionType2["PERCENT"] = "percent";
  HostCommissionType2["FLAT_RATE"] = "flat-rate";
  HostCommissionType2["PER_PARTICIPANT"] = "per-participant";
  HostCommissionType2["NO_COMMISSION"] = "no-commission";
  return HostCommissionType2;
})(HostCommissionType || {});
var PositionSchema = z.object({ x: z.number(), y: z.number() });
var HexColorSchema2 = z.string().regex(/^#[A-F0-9]{6}$/i);
var LocalDateTimeStringSchema = z.string().refine(
  (str) => z.string().datetime().safeParse(`${str.padEnd(19, ":00")}Z`).success,
  { message: "Invalid date time" }
);
var DateStringSchema = z.string().regex(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, { message: "Invalid date" });
var TimeStringSchema = z.string().regex(/^([0-1]\d|2[0-3])(?::([0-5]\d)){1,2}$/, { message: "Invalid time" });
var EmailStringSchema = z.string().regex(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
var BooleanStringSchema = z.enum(["true", "false"]);
var DateRangePriceTierConditionSchema = z.object({
  type: z.literal(
    "date_range"
    /* DATE_RANGE */
  ),
  param: z.array(
    z.object({ from: DateStringSchema, to: DateStringSchema }).refine(({ from, to }) => from <= to, {
      message: 'The "from" date must be less than or equal to the "to" date.'
    })
  ).min(1)
});
var DurationRangePriceTierConditionSchema = z.object({
  type: z.literal(
    "duration_range"
    /* DURATION_RANGE */
  ),
  param: z.array(z.object({ from: z.number(), to: z.number() })).min(1)
});
var MatchDatePriceTierConditionSchema = z.object({
  type: z.literal(
    "match_date"
    /* MATCH_DATE */
  ),
  param: z.array(LocalDateTimeStringSchema).min(1)
});
var DayOfWeekPriceTierConditionSchema = z.object({
  type: z.literal(
    "day_of_week"
    /* DAY_OF_WEEK */
  ),
  param: z.array(z.number().min(
    1
    /* MONDAY */
  ).max(
    7
    /* SUNDAY */
  )).min(1).refine((days) => days.every((day) => day >= 1 && day <= 7), {
    message: "Days of the week must be between 1 (Monday) and 7 (Sunday)."
  })
});
var MatchDurationPriceTierConditionSchema = z.object({
  type: z.literal(
    "match_duration"
    /* MATCH_DURATION */
  ),
  param: z.array(z.number().min(1)).min(1, {
    message: "Required"
  })
});
var PriceTierConditionSchema = z.discriminatedUnion("type", [
  DateRangePriceTierConditionSchema,
  DurationRangePriceTierConditionSchema,
  MatchDatePriceTierConditionSchema,
  DayOfWeekPriceTierConditionSchema,
  MatchDurationPriceTierConditionSchema
]);
var PriceTierSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  price: z.number(),
  maxQuantity: z.number().min(0).optional()
});
var PostSessionPriceTierRuleRequestSchema = z.object({
  id: z.string().uuid(),
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z.number().min(1).optional(),
  priceTiers: z.array(PriceTierSchema).min(1)
});
var PostSessionPriceTierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `/v1/brands/${brandId}/experiences/${experienceId}/price-tier-rule/session`,
  requestSchema: PostSessionPriceTierRuleRequestSchema,
  responseSchema: z.void()
});
var PriceTierRulesSchema = z.object({
  id: z.string().uuid(),
  name: z.string().nonempty(),
  order: z.number(),
  type: z.literal(
    "rule"
    /* RULE */
  ),
  isActive: z.boolean(),
  conditions: z.array(PriceTierConditionSchema).min(1),
  priceTiers: z.array(PriceTierSchema).min(1)
});
var PostPriceTierRuleRequestSchema = z.object({
  id: z.string().uuid(),
  name: z.string().nonempty(),
  order: z.number(),
  isActive: z.boolean(),
  conditions: z.array(PriceTierConditionSchema).min(1),
  priceTiers: z.array(PriceTierSchema).min(1)
});
var PostPriceTrierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `/v1/brands/${brandId}/experiences/${experienceId}/price-tier-rule`,
  requestSchema: PostPriceTierRuleRequestSchema,
  responseSchema: z.void()
});
var SessionDataSchema = z.object({
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z.number().min(1).optional()
});
var PostResourceGroupSessionPriceTierRuleRequestSchema = z.object({
  sessions: z.array(SessionDataSchema).min(1),
  priceTiers: z.array(PriceTierSchema).min(1)
});
var PostResourceGroupSessionPriceTierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupId }) => `/v1/brands/${brandId}/experiences/resource-groups/${resourceGroupId}/price-tier-rule/resource-group-session`,
  requestSchema: PostResourceGroupSessionPriceTierRuleRequestSchema,
  responseSchema: z.void()
});
var ShapeType = /* @__PURE__ */ ((ShapeType2) => {
  ShapeType2["CIRCLE"] = "circle";
  ShapeType2["RECTANGLE"] = "rectangle";
  ShapeType2["TABLE"] = "table";
  return ShapeType2;
})(ShapeType || {});
var ShapeSchema = z.object({
  type: z.nativeEnum(ShapeType),
  width: z.number(),
  height: z.number(),
  color: z.string()
});
var ExperienceImageSizes = /* @__PURE__ */ ((ExperienceImageSizes2) => {
  ExperienceImageSizes2["W384"] = "384";
  ExperienceImageSizes2["W480"] = "480";
  ExperienceImageSizes2["W640"] = "640";
  ExperienceImageSizes2["W750"] = "750";
  ExperienceImageSizes2["W1080"] = "1080";
  return ExperienceImageSizes2;
})(ExperienceImageSizes || {});
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["IMAGE"] = "image";
  MediaType2["VIDEO"] = "video";
  return MediaType2;
})(MediaType || {});
var MediaLinkResolution = /* @__PURE__ */ ((MediaLinkResolution2) => {
  MediaLinkResolution2["ORIGINAL"] = "original";
  MediaLinkResolution2["ADAPTATIVE"] = "adaptative";
  MediaLinkResolution2["240p"] = "240";
  MediaLinkResolution2["36Op"] = "360";
  MediaLinkResolution2["480p"] = "480";
  MediaLinkResolution2["540p"] = "540";
  MediaLinkResolution2["640p"] = "640";
  MediaLinkResolution2["720p"] = "720";
  MediaLinkResolution2["1080p"] = "1080";
  return MediaLinkResolution2;
})(MediaLinkResolution || {});
var ExperienceImageSizeWithOriginalInUriSchema = ImageSizeWithOriginalInUriSchemaBuilder(
  Object.values(ExperienceImageSizes)
);
var ExperienceKind = /* @__PURE__ */ ((ExperienceKind2) => {
  ExperienceKind2["EXPERIENCE"] = "experience";
  ExperienceKind2["RESOURCE"] = "resource";
  return ExperienceKind2;
})(ExperienceKind || {});
var ExperienceVersion = /* @__PURE__ */ ((ExperienceVersion3) => {
  ExperienceVersion3["LATEST"] = "latest";
  ExperienceVersion3["PUBLISHED"] = "published";
  return ExperienceVersion3;
})(ExperienceVersion || {});
var ExperienceStatus = /* @__PURE__ */ ((ExperienceStatus2) => {
  ExperienceStatus2["DRAFT"] = "draft";
  ExperienceStatus2["PENDING"] = "pending";
  ExperienceStatus2["PUBLISHED"] = "published";
  ExperienceStatus2["UNPUBLISHED"] = "unpublished";
  return ExperienceStatus2;
})(ExperienceStatus || {});
var ContactRole = /* @__PURE__ */ ((ContactRole2) => {
  ContactRole2["DECISION_MAKER"] = "decision_maker";
  ContactRole2["POINT_OF_CONTACT"] = "point_of_contact";
  return ContactRole2;
})(ContactRole || {});
var ContactRoleSchema = z.nativeEnum(ContactRole, {
  invalid_type_error: "Invalid contact role",
  required_error: "Contact role is required"
});
var ContactSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string().min(2, "First name must be at least 2 characters").max(100, "First name must be less than 100 characters"),
  lastName: z.string().min(2, "Last name must be at least 2 characters").max(100, "Last name must be less than 100 characters"),
  emailAddress: EmailStringSchema.max(255, "Email Address must be less than 255 characters"),
  role: ContactRoleSchema
});
var ContactResponseSchema = z.array(ContactSchema);
var THEME = /* @__PURE__ */ ((THEME2) => {
  THEME2["DEFAULT"] = "default";
  THEME2["DARK"] = "dark";
  return THEME2;
})(THEME || {});
var PaymentMethodSettingsSchema = z.object({
  [
    "apple_pay"
    /* APPLE_PAY */
  ]: z.boolean().optional(),
  [
    "google_pay"
    /* GOOGLE_PAY */
  ]: z.boolean().optional(),
  [
    "amazon_pay"
    /* AMAZON_PAY */
  ]: z.boolean().optional(),
  [
    "cashapp"
    /* CASH_APP_PAY */
  ]: z.boolean().optional(),
  [
    "link"
    /* LINK */
  ]: z.boolean().optional(),
  [
    "alipay"
    /* ALI_PAY */
  ]: z.boolean().optional(),
  [
    "wechat_pay"
    /* WECHAT_PAY */
  ]: z.boolean().optional()
});
var AVAILABLE_BRAND_FEATURES = /* @__PURE__ */ ((AVAILABLE_BRAND_FEATURES2) => {
  AVAILABLE_BRAND_FEATURES2["REVIEWS"] = "reviews";
  AVAILABLE_BRAND_FEATURES2["API_ACCESS"] = "apiAccess";
  AVAILABLE_BRAND_FEATURES2["UNLIMITED_HOST"] = "unlimitedHost";
  AVAILABLE_BRAND_FEATURES2["EXCLUSIVE_EXPERIENCE"] = "exclusiveExperiences";
  AVAILABLE_BRAND_FEATURES2["DATA_PLUS"] = "dataPlus";
  AVAILABLE_BRAND_FEATURES2["EXPERIENCE_COMMENTS"] = "experienceComments";
  AVAILABLE_BRAND_FEATURES2["CUSTOM_BOOKING_EMAIL_MESSAGE"] = "customBookingEmailMessage";
  AVAILABLE_BRAND_FEATURES2["SMS_NOTIFICATION"] = "smsNotifications";
  AVAILABLE_BRAND_FEATURES2["EXPERIENCE_LISTING_TYPE"] = "experienceListingType";
  AVAILABLE_BRAND_FEATURES2["ENHANCED_HOST_COMMISSION"] = "enhancedHostCommission";
  AVAILABLE_BRAND_FEATURES2["PRICE_TIERS"] = "priceTiers";
  AVAILABLE_BRAND_FEATURES2["SHOPPING_CART"] = "shoppingCart";
  AVAILABLE_BRAND_FEATURES2["ENHANCED_NOTIFICATIONS"] = "enhancedNotifications";
  AVAILABLE_BRAND_FEATURES2["EMAIL_CUSTOMIZATION"] = "emailCustomization";
  AVAILABLE_BRAND_FEATURES2["EMAIL_DNS_SETTINGS"] = "emailDnsSettings";
  AVAILABLE_BRAND_FEATURES2["CUSTOM_QUESTIONS"] = "customQuestions";
  AVAILABLE_BRAND_FEATURES2["CONDITIONAL_PRICING"] = "conditionalPricing";
  AVAILABLE_BRAND_FEATURES2["ROOM_MEMBER_CHARGE"] = "roomMemberCharge";
  AVAILABLE_BRAND_FEATURES2["CREDIT_CARD"] = "creditCard";
  AVAILABLE_BRAND_FEATURES2["KICC"] = "kicc";
  AVAILABLE_BRAND_FEATURES2["UNLISTED_EXPERIENCE"] = "unlistedExperience";
  AVAILABLE_BRAND_FEATURES2["IN_APP_MESSAGING"] = "inAppMessaging";
  AVAILABLE_BRAND_FEATURES2["CHECK_IN"] = "check-in";
  AVAILABLE_BRAND_FEATURES2["TICKET_SCANNING"] = "ticketScanning";
  AVAILABLE_BRAND_FEATURES2["OPERA"] = "integrations:opera";
  AVAILABLE_BRAND_FEATURES2["STAYNTOUCH"] = "integrations:stayntouch";
  AVAILABLE_BRAND_FEATURES2["REVINATE"] = "integrations:revinate";
  AVAILABLE_BRAND_FEATURES2["BACKEND_BOOKING"] = "backendBooking";
  AVAILABLE_BRAND_FEATURES2["INFOR"] = "integrations:infor";
  AVAILABLE_BRAND_FEATURES2["AI_CURATION"] = "aiCuration";
  AVAILABLE_BRAND_FEATURES2["ALICE"] = "integrations:alice";
  AVAILABLE_BRAND_FEATURES2["SIMPHONY"] = "integrations:simphony";
  AVAILABLE_BRAND_FEATURES2["BYPASS_CTA_BLOCK"] = "bypassCTABlock";
  AVAILABLE_BRAND_FEATURES2["PAY_UPON_ARRIVAL"] = "payUponArrival";
  AVAILABLE_BRAND_FEATURES2["REMOVE_CASH_PAYMENT"] = "removeCashPayment";
  AVAILABLE_BRAND_FEATURES2["GUEST_MICRO_SURVEY"] = "guestMicroSurvey";
  AVAILABLE_BRAND_FEATURES2["TEALIUM_ANALYTICS"] = "integrations:tealiumAnalytics";
  AVAILABLE_BRAND_FEATURES2["GTM_ANALYTICS"] = "integrations:gtmAnalytics";
  AVAILABLE_BRAND_FEATURES2["GA4_ANALYTICS"] = "integrations:ga4Analytics";
  AVAILABLE_BRAND_FEATURES2["SEAT_CHART"] = "seatChart";
  AVAILABLE_BRAND_FEATURES2["FLEXIBLE_DURATION"] = "flexibleDuration";
  AVAILABLE_BRAND_FEATURES2["PAUSE_AVAILABILITY_REMINDER"] = "pauseAvailabilityReminder";
  AVAILABLE_BRAND_FEATURES2["NEW_SESSION_UI"] = "newSessionUi";
  AVAILABLE_BRAND_FEATURES2["DISABLE_ACTIVATE_SCROLLING_ANIMATION"] = "disableActivateScrollingAnimation";
  AVAILABLE_BRAND_FEATURES2["ENABLE_NEW_LANDING_PAGE"] = "enableNewLandingPage";
  AVAILABLE_BRAND_FEATURES2["ENABLE_WALLETS_PAYMENT"] = "enableWalletsPayment";
  AVAILABLE_BRAND_FEATURES2["ENABLE_HYATT_LMS"] = "enableHyattLms";
  AVAILABLE_BRAND_FEATURES2["ENABLE_PROMOTER"] = "enablePromoter";
  AVAILABLE_BRAND_FEATURES2["ENABLE_VIBES_V2"] = "enableVibesV2";
  AVAILABLE_BRAND_FEATURES2["PREVENT_CATEGORY_MANAGEMENT"] = "preventCategoryManagement";
  AVAILABLE_BRAND_FEATURES2["ENABLE_TRANSLATIONS"] = "enableTranslations";
  AVAILABLE_BRAND_FEATURES2["ENABLE_DURATIONS"] = "enableDurations";
  AVAILABLE_BRAND_FEATURES2["ENABLE_RESCHEDULE_BOOKINGS"] = "enableRescheduleBookings";
  AVAILABLE_BRAND_FEATURES2["ENABLE_REQUEST_BOOKINGS"] = "enableRequestBookings";
  AVAILABLE_BRAND_FEATURES2["ENABLE_AUCTIONS_DEBUG"] = "enableAuctionsDebug";
  AVAILABLE_BRAND_FEATURES2["PREVENT_PMS_LOOKUP"] = "preventPmsLookup";
  AVAILABLE_BRAND_FEATURES2["ENABLE_NEW_PMS_TOTALS_CALCULATION"] = "enableNewPmsTotalsCalculation";
  AVAILABLE_BRAND_FEATURES2["ENABLE_AUCTIONS"] = "enableAuctions";
  AVAILABLE_BRAND_FEATURES2["ENABLE_BOOKING_SURCHARGE"] = "enableBookingSurcharge";
  AVAILABLE_BRAND_FEATURES2["ENABLE_PARTNER_INVITATIONS"] = "enablePartnerInvitations";
  return AVAILABLE_BRAND_FEATURES2;
})(AVAILABLE_BRAND_FEATURES || {});
var DesignElementSchema = z.object({
  logoId: z.string().uuid().nullable(),
  primaryColor: HexColorSchema2.nullable(),
  secondaryColor: HexColorSchema2.nullable(),
  buttonColor: HexColorSchema2.nullable(),
  primaryFont: z.string().nullable(),
  secondaryFont: z.string().nullable(),
  theme: z.nativeEnum(THEME)
}).partial();
var TemplateElementSchema = z.object({
  hero: z.object({
    desktopImageId: z.string().uuid().nullable(),
    mobileImageId: z.string().uuid().nullable(),
    intro: z.string().max(150).nullable(),
    heading: z.string().max(150).nullable(),
    description: z.string().nullable()
  }).partial()
});
var EmailSettingSchema = z.object({
  booking: z.object({ confirmationMessage: z.string().nullable() })
});
var TermsAndConditionsSchema = z.object({
  documents: z.array(z.object({ title: z.string(), mediaId: z.string().uuid() }))
});
var WhitelistedUrlSchema = z.string().refine((url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:" && parsedUrl.hostname === "localhost";
  } catch {
    return false;
  }
});
var WhitelistedDomainsSchema = z.array(WhitelistedUrlSchema);
var SeoSchema = z.object({
  sitemapBaseUrls: z.array(z.string())
});
var FeaturesSchema = z.record(z.nativeEnum(AVAILABLE_BRAND_FEATURES), z.boolean());
var PromotionSchema = z.object({
  exclusiveTag: z.string()
});
var DataPlusSettingsSchema = z.object({
  operatingAccountNumber: z.string().or(z.number()),
  propertyId: z.string().or(z.number()),
  advanceDepositAccountNumber: z.string().nullable(),
  emailAddress: z.string().nullable()
});
var CustomStyleSchema = z.string();
var HostSignupSchema = z.object({
  headingText: z.string(),
  experienceOverview: z.string(),
  joinCommunityOverview: z.string(),
  hostFeaturedImageId: z.string().nullable(),
  experienceFeaturedImageId: z.string().nullable(),
  signupFeaturedImageId: z.string().nullable()
});
var ControlCadenceBefore = /* @__PURE__ */ ((ControlCadenceBefore2) => {
  ControlCadenceBefore2["HOUR_BEFORE"] = "hours_before";
  ControlCadenceBefore2["WEEK_BEFORE"] = "week_before";
  return ControlCadenceBefore2;
})(ControlCadenceBefore || {});
var ControlCadenceAfter = /* @__PURE__ */ ((ControlCadenceAfter2) => {
  ControlCadenceAfter2["HOUR_AFTER"] = "hours_after";
  ControlCadenceAfter2["WEEK_AFTER"] = "week_after";
  return ControlCadenceAfter2;
})(ControlCadenceAfter || {});
var PayoutSchedule = /* @__PURE__ */ ((PayoutSchedule2) => {
  PayoutSchedule2["TRANSACTION_DATE"] = "transaction_date";
  PayoutSchedule2["EXPERIENCE_DATE"] = "experience_date";
  return PayoutSchedule2;
})(PayoutSchedule || {});
var PaymentSettingSchema = z.object({
  payoutSchedule: z.nativeEnum(PayoutSchedule)
});
var BrandEmailNotificationSettingsSchema = z.object({
  [
    "booking:confirmation"
    /* BOOKING_CONFIRMATION */
  ]: z.object({ enabled: z.boolean() }),
  [
    "booking:refunded"
    /* BOOKING_REFUNDED */
  ]: z.object({ enabled: z.boolean() }),
  [
    "booking:cancelled"
    /* BOOKING_CANCELLED */
  ]: z.object({ enabled: z.boolean() }),
  [
    "booking:rescheduled"
    /* BOOKING_RESCHEDULED */
  ]: z.object({ enabled: z.boolean() }),
  [
    "review:request"
    /* REVIEW_REQUEST */
  ]: z.object({
    enabled: z.boolean(),
    config: z.object({ value: z.number(), cadence: z.nativeEnum(ControlCadenceAfter) }).optional()
  }),
  [
    "review:reminder"
    /* REVIEW_REMINDER */
  ]: z.object({
    enabled: z.boolean(),
    config: z.object({ value: z.number(), cadence: z.nativeEnum(ControlCadenceAfter) }).optional()
  }),
  [
    "event:reminder"
    /* EVENT_REMINDER */
  ]: z.object({
    enabled: z.boolean(),
    config: z.object({ value: z.number(), cadence: z.nativeEnum(ControlCadenceBefore) }).optional()
  }),
  [
    "event:second-reminder"
    /* EVENT_SECOND_REMINDER */
  ]: z.object({
    enabled: z.boolean(),
    config: z.object({ value: z.number(), cadence: z.nativeEnum(ControlCadenceBefore) }).optional()
  })
}).partial();
var BrandSmsNotificationSettingsSchema = BrandEmailNotificationSettingsSchema.omit({
  [
    "review:reminder"
    /* REVIEW_REMINDER */
  ]: true,
  [
    "review:request"
    /* REVIEW_REQUEST */
  ]: true
});
var BrandNotificationSchema = z.object({
  [
    "email"
    /* EMAIL */
  ]: BrandEmailNotificationSettingsSchema,
  [
    "sms"
    /* SMS */
  ]: BrandSmsNotificationSettingsSchema
}).partial();
var BrandEmailAddressesSchema = z.object({
  [
    "from"
    /* FROM */
  ]: EmailStringSchema.or(z.literal("")),
  [
    "bookings"
    /* BOOKINGS */
  ]: EmailStringSchema.or(z.literal("")),
  [
    "hostSubmissions"
    /* HOST_SUBMISSIONS */
  ]: EmailStringSchema.or(z.literal(""))
}).partial();
var ShouldValidateComplimentaryBookingSchema = z.object({
  roomCharge: z.boolean(),
  memberCharge: z.boolean()
}).partial();
var StripeSchema = z.record(z.unknown());
var PutBrandSettingsRequestSchema = z.object({
  designElement: DesignElementSchema.optional(),
  templateElement: TemplateElementSchema.optional(),
  email: EmailSettingSchema.optional(),
  termsAndConditions: TermsAndConditionsSchema.optional(),
  whitelistedDomains: WhitelistedDomainsSchema.optional(),
  seo: SeoSchema.optional(),
  features: FeaturesSchema.optional(),
  promotion: PromotionSchema.optional(),
  dataPlus: DataPlusSettingsSchema.optional(),
  customStyle: CustomStyleSchema.optional(),
  hostSignup: HostSignupSchema.optional(),
  notifications: BrandNotificationSchema.optional(),
  emailAddresses: BrandEmailAddressesSchema.optional(),
  shouldValidateComplimentaryBooking: ShouldValidateComplimentaryBookingSchema.optional(),
  stripe: StripeSchema.optional(),
  payment: PaymentSettingSchema.optional(),
  paymentMethods: PaymentMethodSettingsSchema.optional(),
  cancellationPolicyId: z.string().uuid().nullable().optional(),
  reschedulePolicyId: z.string().uuid().nullable().optional()
});
var DnsSettingsSchema = z.object({
  valid: z.boolean(),
  type: z.string(),
  host: z.string(),
  data: z.string()
});
var BrandDnsSettingsResponseSchema = z.object({
  mx: DnsSettingsSchema,
  spf: DnsSettingsSchema,
  dkim: DnsSettingsSchema
});
var DnsValidationSchema = z.object({
  valid: z.boolean(),
  reason: z.string().nullable()
});
var BrandDnsValidationResponseSchema = z.object({
  mx: DnsValidationSchema,
  spf: DnsValidationSchema,
  dkim: DnsValidationSchema
});
var UpdateBrandSettingsEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `v1/brands/${brandId}/settings`,
  responseSchema: z.void(),
  requestSchema: PutBrandSettingsRequestSchema
});
var UpdateBrandWebsiteUrlsRequestSchema = z.object({
  urls: WhitelistedDomainsSchema
});
var UpdateBrandWebsiteUrlsEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `v1/brands/${brandId}/website-urls`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandWebsiteUrlsRequestSchema
});
var StripeAccountStatus = /* @__PURE__ */ ((StripeAccountStatus2) => {
  StripeAccountStatus2["ACTIVE"] = "active";
  StripeAccountStatus2["INACTIVE"] = "inactive";
  return StripeAccountStatus2;
})(StripeAccountStatus || {});
var StripeAccountServiceAgreement = /* @__PURE__ */ ((StripeAccountServiceAgreement2) => {
  StripeAccountServiceAgreement2["FULL_AGREEMENT"] = "full_agreement";
  StripeAccountServiceAgreement2["RECIPIENT"] = "recipient";
  return StripeAccountServiceAgreement2;
})(StripeAccountServiceAgreement || {});
var GetServiceAgreementQuerySchema = z.object({
  brandId: z.string().uuid()
});
var GetStripeAccountServiceAgreementTypeResponseSchema = z.object({
  serviceAgreement: z.nativeEnum(StripeAccountServiceAgreement)
});
var GetStripeAccountServiceAgreementTypeResponseEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/stripe-accounts/service-agreement-type`,
  responseSchema: GetStripeAccountServiceAgreementTypeResponseSchema,
  requestSchema: z.void()
});
var TranslationSchema = z.object({
  id: z.string().nullable().optional(),
  parentId: z.string(),
  fieldName: z.string(),
  languageCode: z.string(),
  isManuallySet: z.boolean(),
  value: z.string(),
  createdAt: z.coerce.date().optional(),
  updatedAt: z.coerce.date().optional(),
  version: z.nativeEnum(ExperienceVersion).optional()
});
var TranslationsSchema = z.array(TranslationSchema);
var TranslationWithIdSchema = TranslationSchema.required({ id: true });
var TranslationsWithIdSchema = z.array(TranslationWithIdSchema);
var BrandMembershipRole = /* @__PURE__ */ ((BrandMembershipRole2) => {
  BrandMembershipRole2["OWNER"] = "owner";
  BrandMembershipRole2["ADMIN"] = "admin";
  BrandMembershipRole2["HOST"] = "host";
  return BrandMembershipRole2;
})(BrandMembershipRole || {});
var BrandMembershipRolesSchema = z.nativeEnum(BrandMembershipRole);
var UserAddressSchema = z.object({
  street: z.string(),
  city: z.string(),
  state: z.string(),
  zip: z.string()
}).partial();
var UserSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z.string().nullable(),
  role: z.nativeEnum(BrandMembershipRole).nullable(),
  title: z.string().nullable(),
  id: z.string().uuid(),
  lastAccessedAt: z.string().datetime().nullable(),
  profilePictureId: z.string().uuid().nullable(),
  countryCode: z.string().nullable()
});
var UserImageSizes = /* @__PURE__ */ ((UserImageSizes2) => {
  UserImageSizes2["W48"] = "48";
  UserImageSizes2["W256"] = "256";
  return UserImageSizes2;
})(UserImageSizes || {});
var UserImageSizeInUriSchema = z.object(
  Object.fromEntries(Object.values(UserImageSizes).map((size) => [`${size}w`, z.string()]))
);
var UserImageSizeWithOriginalInUriSchema = UserImageSizeInUriSchema.extend({ original: z.string() });
var UserImageSizeMediaSchema = z.object({ id: z.string().uuid(), uri: UserImageSizeWithOriginalInUriSchema });
var UserResponseSchema = UserSchema.omit({ profilePictureId: true }).extend({
  profilePicture: UserImageSizeMediaSchema.nullable()
});
var PaginatedUsersResponseSchema = paginateResponseSchema(UserResponseSchema);
var PaymentPlatform = /* @__PURE__ */ ((PaymentPlatform2) => {
  PaymentPlatform2["STRIPE_US"] = "stripe-us";
  PaymentPlatform2["STRIPE_EU"] = "stripe-eu";
  PaymentPlatform2["KICC"] = "kicc";
  return PaymentPlatform2;
})(PaymentPlatform || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["CUSTOMER"] = "customer";
  Role2["BRAND_USER"] = "brand-user";
  Role2["STAFF_ADMIN"] = "staff-admin";
  Role2["INTEGRATION"] = "integration";
  Role2["SYSTEM"] = "system";
  Role2["ORG_USER"] = "org-user";
  return Role2;
})(Role || {});
var BrandSchema = z.object({
  id: z.string(),
  name: z.string(),
  currency: z.string(),
  paymentPlatform: z.nativeEnum(PaymentPlatform)
});
var MembershipSchema = z.object({
  brand: BrandSchema,
  id: z.string().uuid(),
  role: z.nativeEnum(BrandMembershipRole),
  isConfirmed: z.boolean(),
  permissions: z.array(z.string()).nullable(),
  lastAccessedAt: z.string().datetime().nullable()
});
var UserDetailSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z.string().nullable(),
  address: UserAddressSchema.nullable(),
  role: z.nativeEnum(Role),
  title: z.string().nullable(),
  dateOfBirth: z.string().nullable(),
  description: z.string().nullable(),
  memberships: z.array(MembershipSchema),
  confirmedAt: z.string().datetime().nullable(),
  isResetPassword: z.boolean().nullable(),
  profilePicture: z.object({
    id: z.string(),
    uri: z.object({ original: z.string() }).and(z.record(z.string()))
  }).nullable(),
  countryCode: z.string().nullable()
});
var UserSortBy = /* @__PURE__ */ ((UserSortBy2) => {
  UserSortBy2["FIRST_NAME"] = "firstName";
  UserSortBy2["LAST_NAME"] = "lastName";
  UserSortBy2["LAST_ACCESS_AT"] = "lastAccessedAt";
  return UserSortBy2;
})(UserSortBy || {});
var GetUsersQuerySchema = z.object({
  q: z.string().optional(),
  sortBy: z.nativeEnum(UserSortBy).optional(),
  sortDir: z.enum(sortOptions).optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).default(10)
}).strict();
var UserRequestSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.nullable(),
  dateOfBirth: z.coerce.date(),
  description: z.string().nullable(),
  profilePictureId: z.string().uuid().nullable(),
  role: z.nativeEnum(Role),
  title: z.string().nullable(),
  countryCode: z.string().nullable(),
  allowOverlappingBookings: z.boolean(),
  auth0Id: z.string().uuid().nullable().optional(),
  acceptedTermsAndConditions: z.boolean().nullable(),
  address: UserAddressSchema,
  socialMediaHandle: z.object({
    instagram: z.string(),
    twitter: z.string()
  }).partial(),
  verifyBrands: z.array(
    z.object({
      brandId: z.string(),
      verify: z.boolean()
    })
  )
}).partial();
var ChangePasswordSchema = z.object({
  currentPassword: z.string(),
  newPassword: z.string().min(6)
});
var ResetPasswordSchema = z.object({
  password: z.string().min(6)
});
var EmailAddressSchema = z.object({
  emailAddress: EmailStringSchema,
  skipId: z.string().uuid()
});
var PhoneNumberSchema = z.object({
  phoneNumber: PhoneNumberValidationSchema
});
var UpdateUserCountryCodeRequestSchema = z.object({
  countryCode: z.string().nullable()
});
var UpdateUserCountryCodeEndpoint = makeEndpoint({
  method: "PATCH",
  url: () => `/v1/users/me/country-code`,
  requestSchema: UpdateUserCountryCodeRequestSchema,
  responseSchema: z.void()
});
var GetHostsResponseSchema = z.array(
  z.object({
    id: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string(),
    description: z.string().nullable(),
    profilePicture: z.object({
      id: z.string().uuid(),
      uri: UserImageSizeWithOriginalInUriSchema
    }).nullable()
  })
);
var GetHostsQuerySchema = z.object({
  userIds: z.array(z.string().uuid()),
  language: z.string().optional()
});
var GetHostsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `/v1/users/hosts`,
  requestSchema: z.void(),
  responseSchema: GetHostsResponseSchema,
  querySchema: GetHostsQuerySchema
});
var isValidCurrencyCode = (code) => {
  return code in Currency;
};
var Tier = /* @__PURE__ */ ((Tier2) => {
  Tier2["GROWTH"] = "growth";
  Tier2["PRO"] = "pro";
  Tier2["STARTER"] = "starter";
  Tier2["STANDARD"] = "standard";
  Tier2["CUSTOM"] = "custom";
  return Tier2;
})(Tier || {});
var LanguageCode = /* @__PURE__ */ ((LanguageCode2) => {
  LanguageCode2["DE_DE"] = "de-DE";
  LanguageCode2["EN_GB"] = "en-GB";
  LanguageCode2["EN_US"] = "en-US";
  LanguageCode2["ES_ES"] = "es-ES";
  LanguageCode2["FR_FR"] = "fr-FR";
  LanguageCode2["IT_IT"] = "it-IT";
  LanguageCode2["JA_JP"] = "ja-JP";
  LanguageCode2["KO_KR"] = "ko-KR";
  LanguageCode2["PT_BR"] = "pt-BR";
  LanguageCode2["RU_RU"] = "ru-RU";
  LanguageCode2["ZH_HANS"] = "zh-Hans";
  LanguageCode2["ZH_HANT"] = "zh-Hant";
  return LanguageCode2;
})(LanguageCode || {});
var LocationSchema = z.object({
  longitude: z.number(),
  latitude: z.number(),
  name: z.string()
});
var BrandCategory = /* @__PURE__ */ ((BrandCategory2) => {
  BrandCategory2["LUXURY"] = "luxury";
  BrandCategory2["LIFESTYLE"] = "lifestyle";
  BrandCategory2["BOUTIQUE"] = "boutique";
  BrandCategory2["INDEPENDENT"] = "independent";
  BrandCategory2["DESTINATION"] = "destination";
  return BrandCategory2;
})(BrandCategory || {});
var TravelProfile = /* @__PURE__ */ ((TravelProfile2) => {
  TravelProfile2["LUXURY_TRAVELERS"] = "luxury-travelers";
  TravelProfile2["FAMILY_TRAVELERS"] = "family-travelers";
  TravelProfile2["ADVENTURE_SEEKERS"] = "adventure-seekers";
  TravelProfile2["NATURE_LOVERS"] = "nature-lovers";
  TravelProfile2["CULTURE_EXPLORERS"] = "culture-explorers";
  TravelProfile2["DIGITAL_NOMADS"] = "digital-nomads";
  TravelProfile2["RELAXATION_WELLNESS_SEEKERS"] = "relaxation-wellness-seekers";
  return TravelProfile2;
})(TravelProfile || {});
var WayVersion = /* @__PURE__ */ ((WayVersion2) => {
  WayVersion2["V1"] = "V1";
  WayVersion2["V2"] = "V2";
  return WayVersion2;
})(WayVersion || {});
var ProductLine = /* @__PURE__ */ ((ProductLine2) => {
  ProductLine2["ACTIVATE"] = "activate";
  ProductLine2["HOST"] = "host";
  ProductLine2["RESERVE"] = "reserve";
  return ProductLine2;
})(ProductLine || {});
var BrandSchema2 = z.object({
  id: z.string().uuid(),
  name: z.string(),
  tier: z.nativeEnum(Tier, { invalid_type_error: "Invalid tier supplied" }),
  products: z.array(z.nativeEnum(ProductLine)).nullable(),
  countryCode: z.enum(Object.keys(AllCountries)),
  currency: z.string().refine((code) => isValidCurrencyCode(code), {
    message: "Currency is invalid"
  }),
  defaultLanguageCode: z.nativeEnum(LanguageCode),
  manuallyTranslatedLanguages: z.array(z.nativeEnum(LanguageCode)).nullable(),
  creditCardFeePercentage: z.number().min(0).max(100, "Credit card fee % must be less than 100"),
  features: z.record(z.string(), z.boolean()),
  location: LocationSchema.nullable(),
  category: z.nativeEnum(BrandCategory).nullable(),
  adr: z.number().nullable(),
  keys: z.number().nullable(),
  propertyType: z.string().nullable().optional(),
  vision: z.string().nullable(),
  pillars: z.string().nullable(),
  travelProfile: z.nativeEnum(TravelProfile).nullable(),
  availableSpacesAndAmenities: z.string().nullable(),
  contacts: z.array(ContactSchema).optional(),
  churnedAt: z.string().datetime().nullable().optional(),
  brandLaunchedAt: z.string().datetime().nullable(),
  isTestBrand: z.boolean().nullable().optional(),
  isCuratedBrand: z.boolean().nullable().optional(),
  csmUserId: z.string().uuid().nullable().optional(),
  organizationId: z.string().uuid().nullable().optional(),
  enableAutomaticExperienceSorting: z.boolean().optional()
});
var CreateBrandRequestSchema = BrandSchema2.pick({
  name: true,
  tier: true,
  countryCode: true,
  currency: true,
  defaultLanguageCode: true,
  creditCardFeePercentage: true,
  features: true,
  contacts: true,
  isTestBrand: true,
  isCuratedBrand: true,
  csmUserId: true,
  products: true
}).extend({
  owner: z.object({
    firstName: z.string().min(2, "First name must be at least 2 characters").max(100, "First name must be less than 100 characters"),
    lastName: z.string().min(2, "Last name must be at least 2 characters").max(100, "Last name must be less than 100 characters"),
    emailAddress: EmailStringSchema.max(255, "Email Address must be less than 255 characters"),
    phoneNumber: PhoneNumberValidationSchema.optional()
  }),
  isBrandLaunched: z.boolean().optional(),
  csmUserId: z.string().uuid().optional(),
  organizationId: z.string().uuid().optional(),
  externalReferenceId: z.string().optional(),
  wayVersion: z.nativeEnum(WayVersion).optional()
}).strict();
var UpdateBrandRequestSchema = BrandSchema2.omit({ id: true, churnedAt: true }).extend({
  emailAddress: EmailStringSchema,
  globalCommissionPercentage: z.number().min(0).max(100),
  creditCardFeePaidByBrand: z.boolean(),
  isBrandLaunched: z.boolean().optional(),
  externalReferenceId: z.string().optional(),
  enableAutomaticExperienceSorting: z.boolean().optional(),
  wayVersion: z.nativeEnum(WayVersion).optional()
}).partial().strict();
var BrandDetailResponseSchema = BrandSchema2.omit({
  csmUserId: true
}).extend({
  emailAddress: EmailStringSchema,
  creditCardFeePaidByBrand: z.boolean(),
  globalCommissionPercentage: z.number().nullable(),
  paymentPlatform: z.string(),
  features: z.object({
    active: z.array(z.nativeEnum(AVAILABLE_BRAND_FEATURES)).optional(),
    hostsLimit: z.number().optional(),
    updatedAt: z.string().datetime().optional()
  }),
  csmUser: UserSchema.pick({
    id: true,
    firstName: true,
    lastName: true
  }).nullable(),
  externalReferenceId: z.string().nullable(),
  enableAutomaticExperienceSorting: z.boolean(),
  wayVersion: z.nativeEnum(WayVersion),
  manuallyTranslatedLanguages: z.array(z.nativeEnum(LanguageCode)).nullable(),
  wayCode: z.string().nullable()
}).strict();
var BrandQueryFilter = /* @__PURE__ */ ((BrandQueryFilter2) => {
  BrandQueryFilter2["CHURNED"] = "churned";
  BrandQueryFilter2["DELETED"] = "deleted";
  BrandQueryFilter2["ACTIVE"] = "active";
  return BrandQueryFilter2;
})(BrandQueryFilter || {});
var BrandSortBy = /* @__PURE__ */ ((BrandSortBy2) => {
  BrandSortBy2["NAME"] = "name";
  BrandSortBy2["EMAIL"] = "emailAddress";
  BrandSortBy2["TIER"] = "tier";
  BrandSortBy2["FEE"] = "creditCardFeePercentage";
  return BrandSortBy2;
})(BrandSortBy || {});
var GetBrandsQuerySchema = z.object({
  q: z.string().optional(),
  status: z.nativeEnum(BrandQueryFilter).optional(),
  isTestBrand: z.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  isCuratedBrand: z.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  organizationId: z.string().optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).default(10),
  sortBy: z.nativeEnum(BrandSortBy).optional(),
  sortDir: z.enum(sortOptions).optional()
}).strict();
var GetOrganizationBrandsQuerySchema = z.object({
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).default(10),
  sortBy: z.nativeEnum(BrandSortBy).optional(),
  sortDir: z.enum(sortOptions).optional()
}).strict();
var BrandPaginatedResponseSchema = paginateResponseSchema(
  BrandSchema2.pick({
    id: true,
    name: true,
    tier: true,
    countryCode: true,
    currency: true,
    creditCardFeePercentage: true,
    isTestBrand: true,
    isCuratedBrand: true,
    churnedAt: true,
    organizationId: true,
    products: true
  }).extend({
    emailAddress: EmailStringSchema,
    externalReferenceId: z.string().nullable().optional(),
    csmUser: UserSchema.pick({
      id: true,
      firstName: true,
      lastName: true
    }).nullable(),
    logoUri: z.string().nullable(),
    deletedAt: z.string().datetime().nullable()
  }).strict()
);
var BrandPaginatedByUserResponseSchema = paginateResponseSchema(
  BrandSchema2.pick({
    id: true,
    name: true,
    tier: true
    // products: true,
  }).extend({
    emailAddress: EmailStringSchema,
    brandLogo: IMediaReferenceSchema.nullable()
  }).strict()
);
var PaginatedBrandsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `brands`,
  responseSchema: BrandPaginatedResponseSchema,
  requestSchema: GetBrandsQuerySchema
});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["AED"] = "AED";
  Currency2["ALL"] = "ALL";
  Currency2["AMD"] = "AMD";
  Currency2["AOA"] = "AOA";
  Currency2["ARS"] = "ARS";
  Currency2["AUD"] = "AUD";
  Currency2["AZN"] = "AZN";
  Currency2["BAM"] = "BAM";
  Currency2["BDT"] = "BDT";
  Currency2["BGN"] = "BGN";
  Currency2["BHD"] = "BHD";
  Currency2["BND"] = "BND";
  Currency2["BOB"] = "BOB";
  Currency2["BRL"] = "BRL";
  Currency2["BSD"] = "BSD";
  Currency2["BTN"] = "BTN";
  Currency2["BWP"] = "BWP";
  Currency2["CAD"] = "CAD";
  Currency2["CHF"] = "CHF";
  Currency2["CLP"] = "CLP";
  Currency2["COP"] = "COP";
  Currency2["CRC"] = "CRC";
  Currency2["CZK"] = "CZK";
  Currency2["DKK"] = "DKK";
  Currency2["DOP"] = "DOP";
  Currency2["DZD"] = "DZD";
  Currency2["EGP"] = "EGP";
  Currency2["ETB"] = "ETB";
  Currency2["EUR"] = "EUR";
  Currency2["GBP"] = "GBP";
  Currency2["GHS"] = "GHS";
  Currency2["GMD"] = "GMD";
  Currency2["GTQ"] = "GTQ";
  Currency2["GYD"] = "GYD";
  Currency2["HKD"] = "HKD";
  Currency2["HUF"] = "HUF";
  Currency2["IDR"] = "IDR";
  Currency2["ILS"] = "ILS";
  Currency2["INR"] = "INR";
  Currency2["JMD"] = "JMD";
  Currency2["JOD"] = "JOD";
  Currency2["JPY"] = "JPY";
  Currency2["KES"] = "KES";
  Currency2["KHR"] = "KHR";
  Currency2["KRW"] = "KRW";
  Currency2["KWD"] = "KWD";
  Currency2["KZT"] = "KZT";
  Currency2["LAK"] = "LAK";
  Currency2["LKR"] = "LKR";
  Currency2["MAD"] = "MAD";
  Currency2["MDL"] = "MDL";
  Currency2["MGA"] = "MGA";
  Currency2["MKD"] = "MKD";
  Currency2["MNT"] = "MNT";
  Currency2["MOP"] = "MOP";
  Currency2["MUR"] = "MUR";
  Currency2["MXN"] = "MXN";
  Currency2["MYR"] = "MYR";
  Currency2["MZN"] = "MZN";
  Currency2["NAD"] = "NAD";
  Currency2["NGN"] = "NGN";
  Currency2["NOK"] = "NOK";
  Currency2["NZD"] = "NZD";
  Currency2["OMR"] = "OMR";
  Currency2["PEN"] = "PEN";
  Currency2["PHP"] = "PHP";
  Currency2["PKR"] = "PKR";
  Currency2["PLN"] = "PLN";
  Currency2["PYG"] = "PYG";
  Currency2["QAR"] = "QAR";
  Currency2["RON"] = "RON";
  Currency2["RSD"] = "RSD";
  Currency2["RWF"] = "RWF";
  Currency2["SAR"] = "SAR";
  Currency2["SEK"] = "SEK";
  Currency2["SGD"] = "SGD";
  Currency2["THB"] = "THB";
  Currency2["TND"] = "TND";
  Currency2["TRY"] = "TRY";
  Currency2["TTD"] = "TTD";
  Currency2["TWD"] = "TWD";
  Currency2["TZS"] = "TZS";
  Currency2["USD"] = "USD";
  Currency2["UYU"] = "UYU";
  Currency2["UZS"] = "UZS";
  Currency2["VND"] = "VND";
  Currency2["XAF"] = "XAF";
  Currency2["XCD"] = "XCD";
  Currency2["XOF"] = "XOF";
  Currency2["ZAR"] = "ZAR";
  return Currency2;
})(Currency || {});
var UpdateBrandExperienceSortingRequestSchema = z.object({
  enableAutomaticExperienceSorting: z.boolean()
});
var UpdateBrandExperienceSorting = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/experiences-sorting`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandExperienceSortingRequestSchema
});
var PublicBrandDetailResponseSchema = BrandSchema2.pick({
  id: true,
  name: true,
  countryCode: true,
  currency: true,
  location: true,
  organizationId: true
}).extend({
  externalReferenceId: z.string().nullable()
});
var GetPublicBrandDetails = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}`,
  responseSchema: PublicBrandDetailResponseSchema,
  requestSchema: z.void()
});
var GetBrandCoreTranslationsResponseSchema = z.object({
  vibes: z.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  categories: z.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  cancellationPolicies: z.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  reschedulePolicies: z.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  taxes: z.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true }))
});
var GetBrandCoreTranslationsQuerySchema = z.object({
  language: z.nativeEnum(LanguageCode).optional()
}).default({});
var GetBrandCoreTranslationsEndpoint = makeEndpoint({
  method: "GET",
  url: (params) => {
    var _a2;
    return ((_a2 = params.query) == null ? void 0 : _a2.language) ? `v1/brands/${params["brandId"]}/i18n?${buildQueryString({ language: params.query.language })}` : `v1/brands/${params["brandId"]}/i18n`;
  },
  responseSchema: GetBrandCoreTranslationsResponseSchema,
  requestSchema: z.void(),
  querySchema: GetBrandCoreTranslationsQuerySchema
});
var PatchBrandCoreTranslationsRequestSchema = z.object({
  vibes: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  categories: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  cancellationPolicies: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  reschedulePolicies: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  taxes: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchBrandCoreTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/i18n`,
  responseSchema: z.void(),
  requestSchema: PatchBrandCoreTranslationsRequestSchema
});
var GetBrandParentOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/parent-organizations`,
  responseSchema: z.object({
    items: z.array(
      z.object({
        id: z.string().uuid(),
        name: z.string()
      })
    )
  }).strict(),
  requestSchema: z.void()
});
var IntegrationName = /* @__PURE__ */ ((IntegrationName3) => {
  IntegrationName3["OPERA"] = "opera";
  IntegrationName3["STAYNTOUCH"] = "stayntouch";
  IntegrationName3["KICC"] = "kicc";
  IntegrationName3["REVINATE"] = "revinate";
  IntegrationName3["INFOR"] = "infor";
  IntegrationName3["ALICE"] = "alice";
  IntegrationName3["TEALIUM_ANALYTICS"] = "tealiumAnalytics";
  IntegrationName3["GTM_ANALYTICS"] = "gtmAnalytics";
  IntegrationName3["GA4_ANALYTICS"] = "ga4Analytics";
  IntegrationName3["SIMPHONY"] = "simphony";
  return IntegrationName3;
})(IntegrationName || {});
var IntegrationKeys = /* @__PURE__ */ ((IntegrationKeys2) => {
  IntegrationKeys2["TransactionCode"] = "transactionCode";
  IntegrationKeys2["IntegrationAddOn"] = "integrationAddOn";
  IntegrationKeys2["LocRef"] = "locRef";
  IntegrationKeys2["RvcRef"] = "rvcRef";
  IntegrationKeys2["MenuId"] = "menuId";
  IntegrationKeys2["MenuItemId"] = "menuItemId";
  return IntegrationKeys2;
})(IntegrationKeys || {});
var stripIntegrationPrefix = (str) => (str || "").replace("integrations:", "");
var integrationUrl = ({ brandId, integrationType }) => `v1/brands/${brandId}/integrations/${stripIntegrationPrefix(integrationType)}`;
var IntegrationConfigResponseSchema = z.record(z.unknown());
var Integrations = {
  [
    "crm"
    /* CRM */
  ]: [
    "alice",
    "revinate"
    /* REVINATE */
  ],
  [
    "pms"
    /* PMS */
  ]: [
    "infor",
    "opera",
    "stayntouch"
    /* STAYNTOUCH */
  ],
  [
    "analytics"
    /* ANALYTICS */
  ]: [
    "tealiumAnalytics",
    "gtmAnalytics",
    "ga4Analytics"
    /* GA4_ANALYTICS */
  ]
};
var PaymentMethods = /* @__PURE__ */ ((PaymentMethods2) => {
  PaymentMethods2["CREDIT_CARD"] = "credit-card";
  PaymentMethods2["ROOM_CHARGE"] = "room-charge";
  PaymentMethods2["MEMBER_NUMBER"] = "member-number";
  PaymentMethods2["LOYALTY"] = "loyalty";
  PaymentMethods2["KICC"] = "kicc";
  PaymentMethods2["CASH"] = "cash";
  PaymentMethods2["PAY_LATER"] = "pay-later";
  PaymentMethods2["PAY_UPON_ARRIVAL"] = "pay-upon-arrival";
  return PaymentMethods2;
})(PaymentMethods || {});
var PaymentMethodNumberSchema = z.object({ number: z.string().trim().nonempty() });
var ImportPaymentMethodsRequestSchema = z.object({
  data: z.array(PaymentMethodNumberSchema)
});
var DomainNameSchema = z.object({
  id: z.string(),
  domainName: z.string(),
  hasActiveApplePay: z.boolean()
});
var _a;
var ValidatePaymentMethodDomainsEndpoint = makeEndpoint({
  url: ({ brandId }) => `v1/brands/${brandId}/validate-payment-method-domains`,
  method: "POST",
  requestSchema: z.object({
    forceValidation: (_a = z.boolean()) == null ? void 0 : _a.optional()
  }),
  responseSchema: z.array(DomainNameSchema)
});
var GetExperienceVersionQuerySchema = z.object({
  brandId: z.string().uuid().optional(),
  includeFirstAvailableDate: z.string().optional()
});
var ExperienceLocationSchema = z.object({
  longitude: z.number(),
  latitude: z.number(),
  name: z.string(),
  additionalInfo: z.string().optional()
});
var ExperienceLocationWithTimezoneSchema = ExperienceLocationSchema.extend({
  timezoneId: z.string()
});
var ExperienceNotificationOverridesSchema = z.object({
  [
    "email"
    /* EMAIL */
  ]: BrandEmailNotificationSettingsSchema.optional(),
  [
    "sms"
    /* SMS */
  ]: BrandSmsNotificationSettingsSchema.optional()
});
var BaseTaxSchema = z.object({
  id: z.string().uuid(),
  includedInPrice: z.boolean()
});
var PercentageTaxSchema = BaseTaxSchema.extend({
  percentage: z.number().min(0)
});
var AmountTaxSchema = BaseTaxSchema.extend({
  amount: z.number().min(0)
});
var TaxSchema = z.union([PercentageTaxSchema, AmountTaxSchema]);
var StrictTaxSchema = z.union([AmountTaxSchema.strict(), PercentageTaxSchema.strict()]);
var StrictTaxWithNameSchema = z.union([
  AmountTaxSchema.extend({ name: z.string() }).strict(),
  PercentageTaxSchema.extend({ name: z.string() }).strict()
]);
var ExternalFieldType = /* @__PURE__ */ ((ExternalFieldType2) => {
  ExternalFieldType2["URL"] = "url";
  ExternalFieldType2["EMAIL"] = "email";
  ExternalFieldType2["PHONE"] = "phone";
  return ExternalFieldType2;
})(ExternalFieldType || {});
var ExternalFieldSchema = z.object({
  type: z.nativeEnum(ExternalFieldType),
  value: z.string().nullable()
});
var ShouldValidateComplimentaryBookingSchema2 = z.object({
  roomCharge: z.boolean().optional(),
  memberCharge: z.boolean().optional()
});
var BookingAvailabilityModeValue = /* @__PURE__ */ ((BookingAvailabilityModeValue2) => {
  BookingAvailabilityModeValue2["PRIVATE_ONLY"] = "private";
  BookingAvailabilityModeValue2["GROUP_ONLY"] = "group";
  BookingAvailabilityModeValue2["NON_RESTRICTED"] = "non-restricted";
  return BookingAvailabilityModeValue2;
})(BookingAvailabilityModeValue || {});
var ExperienceType = /* @__PURE__ */ ((ExperienceType2) => {
  ExperienceType2["RECURRING"] = "recurring";
  ExperienceType2["ONE_TIME"] = "one-time";
  return ExperienceType2;
})(ExperienceType || {});
var IntegrationMetaSchema = z.object({
  type: z.nativeEnum(IntegrationName),
  key: z.nativeEnum(IntegrationKeys),
  value: z.record(z.unknown())
});
var UpdateExperienceRequestSchema = z.object({
  title: z.string().max(128, { message: "Title must be at most 128 characters long." }),
  headline: z.string().max(280).optional(),
  description: z.string().optional(),
  categoryId: z.string().uuid().optional(),
  vibeIds: z.array(z.string().uuid()).max(3, { message: "A maximum of 3 vibes can be selected for an experience" }).refine((vibeIds) => new Set(vibeIds).size === vibeIds.length, { message: "must be unique" }).optional(),
  location: ExperienceLocationSchema.optional(),
  minAge: z.number().int().min(1).max(150).optional(),
  maxAge: z.number().int().min(1).max(150).optional(),
  medias: z.array(z.object({ id: z.string().uuid(), kind: z.string() })).optional(),
  // TODO: Use MediaInputSchema instead when circular dependency is resolved
  coverPictureId: z.string().uuid().optional(),
  pictureIds: z.array(z.string().uuid()).max(10).refine((pictureIds) => new Set(pictureIds).size === pictureIds.length, { message: "must be unique" }).optional(),
  descriptionPictureId: z.string().uuid().optional().nullable(),
  bookingAvailabilityMode: z.nativeEnum(BookingAvailabilityModeValue).optional(),
  maxParticipantsCount: z.number().int().min(0).optional(),
  sessionDurationMinutes: z.number().int().min(1).optional(),
  isBookable: z.boolean(),
  isUnlisted: z.boolean().optional(),
  type: z.nativeEnum(ExperienceType).optional(),
  providedItems: z.array(z.string()).max(20).optional(),
  healthAndSafety: z.string().optional(),
  emailMessage: z.string().optional().nullable(),
  onlineBookingCutoffHours: z.number().max(1e3).optional(),
  hostedById: z.string().uuid().optional(),
  hostCommission: z.number().optional(),
  hostCommissionType: z.nativeEnum(HostCommissionType).optional(),
  externalField: ExternalFieldSchema.optional(),
  paymentMethods: z.array(z.nativeEnum(PaymentMethods)).max(3).optional(),
  priceTiers: z.array(PriceTierSchema).min(1).optional(),
  taxes: z.array(TaxSchema).optional(),
  integrationMeta: z.array(IntegrationMetaSchema).min(1).optional(),
  partySize: z.number().int().optional().nullable(),
  hidePrice: z.boolean().optional(),
  isNoHost: z.boolean().optional(),
  isTicketed: z.boolean().optional(),
  autoUnpublishAt: LocalDateTimeStringSchema.optional().nullable(),
  notificationEmails: z.array(EmailStringSchema).max(10).optional().nullable(),
  notificationOverrides: ExperienceNotificationOverridesSchema.optional().nullable(),
  shouldValidateComplimentaryBooking: ShouldValidateComplimentaryBookingSchema2.optional(),
  kind: z.nativeEnum(ExperienceKind).optional(),
  minimumRequiredToBook: z.number().int().min(1).optional(),
  maximumAllowedToBook: z.number().int().min(1).optional(),
  resourceGroupId: z.string().uuid().optional(),
  number: z.string().nonempty().optional(),
  displayedCapacity: z.number().optional(),
  shape: ShapeSchema.optional(),
  position: PositionSchema.optional(),
  cancellationPolicyId: z.string().uuid().optional().nullable(),
  reschedulePolicyId: z.string().uuid().optional().nullable(),
  requestToBook: z.boolean().optional(),
  customCallToAction: z.string().optional().nullable()
});
var CreateExperienceRequestSchema = UpdateExperienceRequestSchema.required({
  sessionDurationMinutes: true,
  location: true,
  customCallToAction: true
}).extend({
  id: z.string().uuid().optional(),
  createdByAi: z.boolean().optional().default(false),
  aiExperienceId: z.string().uuid().optional(),
  isBookable: UpdateExperienceRequestSchema.shape.isBookable.default(true),
  type: UpdateExperienceRequestSchema.shape.type.default(
    "recurring"
    /* RECURRING */
  )
});
var CreateExperienceResponseSchema = z.void();
var CreateExperienceEndpoint = makeEndpoint({
  url: ({ brandId }) => `/v2/brands/${brandId}/experiences`,
  method: "POST",
  requestSchema: CreateExperienceRequestSchema,
  responseSchema: CreateExperienceResponseSchema
});
var UpdateExperienceEndpoint = makeEndpoint({
  url: ({ experienceId }) => `/v1/experiences/${experienceId}`,
  method: "PATCH",
  requestSchema: UpdateExperienceRequestSchema,
  responseSchema: z.void()
});
var GetTranslationsForCategoriesQuerySchema = z.object({
  categoryId: z.string().uuid().optional(),
  language: z.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForCategoriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/categories/i18n?${buildQueryString(query)}`,
  responseSchema: z.object({
    translations: z.array(TranslationSchema)
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForCategoriesQuerySchema
});
var GetTranslationsForExperienceQuerySchema = z.object({
  language: z.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    experienceId,
    version,
    query
  }) => `/v1/experiences/${experienceId}/version/${version}/i18n?${buildQueryString(query)}`,
  responseSchema: z.object({
    translations: z.object({
      experience: z.array(TranslationWithIdSchema),
      listingAddOns: z.array(TranslationWithIdSchema),
      customQuestions: z.array(TranslationWithIdSchema),
      cancellationPolicy: z.array(TranslationWithIdSchema),
      listingIncluded: z.array(TranslationWithIdSchema),
      location: z.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForExperienceQuerySchema
});
var PatchTranslationsForExperienceEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ experienceId, version }) => `/v1/experiences/${experienceId}/version/${version}/i18n`,
  responseSchema: z.void(),
  requestSchema: z.object({
    translations: z.array(TranslationSchema)
  })
});
var AddOnStatus = /* @__PURE__ */ ((AddOnStatus2) => {
  AddOnStatus2["AVAILABLE"] = "available";
  AddOnStatus2["UNAVAILABLE"] = "unavailable";
  return AddOnStatus2;
})(AddOnStatus || {});
var AddOnImageSize = /* @__PURE__ */ ((AddOnImageSize2) => {
  AddOnImageSize2["W360"] = "360";
  AddOnImageSize2["W720"] = "720";
  AddOnImageSize2["W1080"] = "1080";
  return AddOnImageSize2;
})(AddOnImageSize || {});
var AddOnImageSizeWithOriginalInUriSchema = ImageSizeWithOriginalInUriSchemaBuilder(Object.values(AddOnImageSize));
var AddOnImageSizeMediaSchema = z.object({
  id: z.string().uuid(),
  uri: AddOnImageSizeWithOriginalInUriSchema
});
var BaseAddOnSchema = z.strictObject({
  id: z.string().uuid(),
  price: z.number().finite().nonnegative(),
  label: z.string().nonempty(),
  description: z.string(),
  status: z.nativeEnum(AddOnStatus),
  integrationMeta: z.array(IntegrationMetaSchema)
});
var RequestAddOnSchema = BaseAddOnSchema.partial({ id: true }).extend({
  pictureId: z.string().uuid().nullable(),
  taxes: z.array(StrictTaxSchema)
});
var ResponseAddOnSchema = BaseAddOnSchema.extend({
  picture: AddOnImageSizeMediaSchema.nullable(),
  taxes: z.array(StrictTaxWithNameSchema)
});
var GetAddOnsQuerySchema = z.object({
  status: z.nativeEnum(AddOnStatus),
  language: z.string().optional().nullable()
}).partial().strict();
var GetAddOnsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/add-ons?${buildQueryString(query)}`,
  responseSchema: z.object({ items: z.array(ResponseAddOnSchema) }).strict(),
  requestSchema: z.void(),
  querySchema: GetAddOnsQuerySchema
});
var PatchAddOnsRequestSchema = BaseAddOnSchema.pick({ label: true }).required({ label: true }).strict();
var DeleteAddOnEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, addOnId }) => `v1/brands/${brandId}/add-ons/${addOnId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var PatchAddOnEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, addOnId }) => `v1/brands/${brandId}/add-ons/${addOnId}`,
  responseSchema: z.void(),
  requestSchema: PatchAddOnsRequestSchema
});
var ListingAddOnLimitType = /* @__PURE__ */ ((ListingAddOnLimitType2) => {
  ListingAddOnLimitType2["PER_PARTICIPANT"] = "PER_PARTICIPANT";
  ListingAddOnLimitType2["PER_BOOKING"] = "PER_BOOKING";
  return ListingAddOnLimitType2;
})(ListingAddOnLimitType || {});
var ListingAddOnLimitSchema = z.strictObject({
  type: z.nativeEnum(ListingAddOnLimitType),
  value: z.number().nonnegative().finite().int()
});
var PropertiesOnlyForListingAddOnSchema = z.strictObject({
  limit: ListingAddOnLimitSchema.nullable(),
  hostCommissionType: z.nativeEnum(HostCommissionType),
  hostCommission: z.number().nonnegative().finite(),
  experienceId: z.string().uuid().nullable(),
  resourceGroupId: z.string().uuid().nullable(),
  resourceGroupCollectionId: z.string().uuid().nullable(),
  addOnId: z.string().uuid()
});
var RequestListingAddOnSchema = RequestAddOnSchema.merge(PropertiesOnlyForListingAddOnSchema).partial({
  experienceId: true,
  resourceGroupId: true,
  resourceGroupCollectionId: true,
  addOnId: true
});
var ResponseListingAddOnSchema = ResponseAddOnSchema.merge(PropertiesOnlyForListingAddOnSchema);
var PublicResponseListingAddOnSchema = ResponseListingAddOnSchema.pick({
  id: true,
  label: true,
  description: true,
  status: true,
  price: true,
  picture: true,
  taxes: true,
  limit: true
});
var CreateListingAddOnRequestSchema = z.union([
  RequestListingAddOnSchema.extend({ addOnId: z.undefined().optional() }),
  RequestListingAddOnSchema.partial().required({ addOnId: true, hostCommissionType: true, hostCommission: true })
]);
var UpdateListingAddOnRequestSchema = RequestListingAddOnSchema.partial().omit({
  experienceId: true,
  resourceGroupId: true,
  resourceGroupCollectionId: true,
  addOnId: true
});
var CreateListingAddOnEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/listing-add-ons`,
  responseSchema: z.void(),
  requestSchema: CreateListingAddOnRequestSchema
});
var GetListingAddOnsQuerySchema = z.object({
  experienceId: z.string().uuid(),
  resourceGroupCollectionId: z.string().uuid(),
  resourceGroupId: z.string().uuid(),
  status: z.nativeEnum(AddOnStatus),
  language: z.nativeEnum(LanguageCode).optional().nullable()
}).partial().strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var GetListingAddOnsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/listing-add-ons?${buildQueryString(query)}`,
  responseSchema: z.object({ items: z.array(ResponseListingAddOnSchema) }).strict(),
  requestSchema: z.void(),
  querySchema: GetListingAddOnsQuerySchema
});
var DeleteListingAddOnEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, listingAddOnId }) => `v1/brands/${brandId}/listing-add-ons/${listingAddOnId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var UpdateListingAddOnEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, listingAddOnId }) => `v1/brands/${brandId}/listing-add-ons/${listingAddOnId}`,
  responseSchema: z.void(),
  requestSchema: UpdateListingAddOnRequestSchema
});
var OrderListingAddOnRequestSchema = z.object({
  listingAddOns: z.array(z.object({ id: z.string().uuid() }).strict()).min(1)
}).strict();
var OrderListingAddOnEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/order-listing-add-ons`,
  requestSchema: OrderListingAddOnRequestSchema,
  responseSchema: z.void()
});
var PromptAuthor = /* @__PURE__ */ ((PromptAuthor2) => {
  PromptAuthor2["USER"] = "user";
  PromptAuthor2["BOT"] = "bot";
  PromptAuthor2["SYSTEM"] = "system";
  return PromptAuthor2;
})(PromptAuthor || {});
var TextPromptSchema = z.object({ text: z.string() });
var TextPromptWithIdSchema = TextPromptSchema.extend({ id: z.string() });
var TextRequestSchema = z.object({ text: z.string() });
var TextResponseSchema = z.object({ data: z.object({ response: JsonSchema }) });
var ChatPromptSchema = z.object({ author: z.nativeEnum(PromptAuthor), text: z.string() });
var ChatPromptWithIdSchema = ChatPromptSchema.extend({ id: z.string() });
var ChatRequestSchema = z.object({ prompt: ChatPromptSchema, context: z.array(ChatPromptSchema).optional() });
var ChatResponseSchema = z.object({ data: z.object({ response: JsonSchema }) });
var CurationSessionLocation = /* @__PURE__ */ ((CurationSessionLocation2) => {
  CurationSessionLocation2["ON_PROPERTY"] = "on-property";
  CurationSessionLocation2["OFF_PROPERTY"] = "off-property";
  CurationSessionLocation2["BOTH"] = "both";
  return CurationSessionLocation2;
})(CurationSessionLocation || {});
var BaseAiCurationSessionSchema = z.object({
  id: z.string().uuid().optional(),
  count: z.number().positive(),
  creativity: z.number().min(0).max(100),
  location: z.nativeEnum(CurationSessionLocation),
  prompt: z.string().nullable()
});
var AiCurationSessionSchema = BaseAiCurationSessionSchema.extend({
  id: z.string().uuid(),
  generatedExperienceCount: z.number(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime()
});
var GetAiCurationSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: z.void(),
  responseSchema: z.array(AiCurationSessionSchema)
});
var PostAiCurationSessionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: BaseAiCurationSessionSchema,
  responseSchema: AiCurationSessionSchema
});
var PutAiCurationSessionEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, curationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  requestSchema: BaseAiCurationSessionSchema.omit({ id: true }),
  responseSchema: AiCurationSessionSchema
});
var DeleteAiCurationSessionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, curationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var IdeatedExperienceSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  headline: z.string(),
  description: z.string(),
  price: z.number(),
  vibeIds: z.array(z.string().uuid()).max(3),
  categoryId: z.string().uuid().nullable(),
  duration: z.number(),
  capacity: z.number(),
  refinementPrompt: z.string().nullable(),
  versionsCount: z.number(),
  updatedAt: z.date().transform((date) => date.toISOString()).or(z.string().datetime()),
  aiCurationSessionId: z.string().uuid(),
  experienceId: z.string().uuid().nullable()
});
var IdeatedExperienceResponseSchema = IdeatedExperienceSchema;
var IdeatedExperiencesResponseSchema = z.array(IdeatedExperienceSchema);
var PostIdeatedExperiencesEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, aiCurationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences`,
  requestSchema: z.void(),
  responseSchema: IdeatedExperiencesResponseSchema
});
var GetIdeatedExperiencesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, aiCurationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences`,
  requestSchema: z.void(),
  responseSchema: IdeatedExperiencesResponseSchema
});
var GetIdeatedExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: z.void(),
  responseSchema: IdeatedExperienceResponseSchema
});
var DeleteIdeatedExperienceEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var RestoreIdeatedExperienceEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}/restore`,
  requestSchema: z.void(),
  responseSchema: IdeatedExperienceSchema
});
var FineTuneIdeatedExperienceRequestSchema = z.object({
  refinementPrompt: z.string().trim().nonempty()
});
var FineTuneIdeatedExperienceEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: FineTuneIdeatedExperienceRequestSchema,
  responseSchema: IdeatedExperienceSchema
});
var IdeateExperienceDescriptionsRequestSchema = z.object({
  experiences: z.array(IdeatedExperienceSchema)
});
var IdeateExperienceDescriptionsResponseSchema = z.object({
  data: z.array(z.string())
});
var IdeateNewExperienceImagesRequestSchema = z.object({
  count: z.number().positive(),
  prompt: z.string().trim().nonempty()
});
var IdeateNewExperienceImagesResponseSchema = z.object({
  data: z.array(z.string())
});
var summaryGroupingOptions = ["brand", "host", "experience"];
var ApiKeySchema = z.object({
  id: z.string(),
  brandId: z.string().nullable(),
  organizationId: z.string().nullable(),
  token: z.string(),
  name: z.string().nullable()
});
var GetApiKeysResponseSchema = z.object({ items: z.array(ApiKeySchema) });
var PostApiKeysRequestSchema = z.object({ name: z.string().nullable().default(null) });
var PostApiKeysResponseSchema = ApiKeySchema;
var GetApiKeysEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/api-keys`,
  requestSchema: z.void(),
  responseSchema: GetApiKeysResponseSchema
});
var PostApiKeyEndpoint = makeEndpoint({
  method: "POST",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/api-keys`,
  requestSchema: PostApiKeysRequestSchema,
  responseSchema: PostApiKeysResponseSchema
});
var DeleteApiKeyEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ entityType, entityId, apiKeyId }) => `v1/${entityType}/${entityId}/api-keys/${apiKeyId}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var CurateHostSchema = z.object({
  isCurated: z.boolean()
});
var HostStatus = /* @__PURE__ */ ((HostStatus2) => {
  HostStatus2["ACTIVE"] = "active";
  HostStatus2["INACTIVE"] = "inactive";
  return HostStatus2;
})(HostStatus || {});
var UpdateBrandMemberRoleRequestSchema = z.object({
  role: z.nativeEnum(BrandMembershipRole),
  permissions: z.array(z.enum(BRAND_MEMBERSHIP_PERMISSIONS))
}).strict();
var UpdateBrandMemberRoleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, memberId }) => `v1/brands/${brandId}/members/${memberId}/role`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandMemberRoleRequestSchema
});
var InviteBrandMemberRequestSchema = z.object({
  firstName: z.string().nonempty(),
  lastName: z.string().nonempty(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.optional(),
  permissions: z.array(z.enum(BRAND_MEMBERSHIP_PERMISSIONS)).optional(),
  products: z.array(z.nativeEnum(ProductLine)).nullable().optional()
}).strict();
var InviteBrandMemberEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/members`,
  responseSchema: z.void(),
  requestSchema: InviteBrandMemberRequestSchema
});
var GetBrandMembersQuerySchema = paginateQuerySchema({
  sortBy: ["name", "email", "phone", "status", "totalEarning"]
}).extend({
  onlyHosts: z.literal("true").optional(),
  status: z.nativeEnum(HostStatus).optional()
});
var BrandMemberSchema = z.object({
  id: z.string().uuid(),
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.nullable(),
  dateOfBirth: DateStringSchema.nullable(),
  role: z.string(),
  // use the enum?
  address: UserAddressSchema.nullable(),
  description: z.string().nullable(),
  profilePicture: UserImageSizeMediaSchema.nullable(),
  commissionPercentage: z.number().nullable(),
  ratings: z.object({ rating: z.number(), recommendability: z.number(), total: z.number().optional() }).optional(),
  membershipRole: z.nativeEnum(BrandMembershipRole),
  hasFutureConfirmedSession: z.boolean(),
  isConfirmed: z.boolean(),
  stripeAccountStatus: z.nativeEnum(StripeAccountStatus),
  confirmedAt: z.string().datetime().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  status: z.nativeEnum(HostStatus),
  totalEarning: z.number(),
  permissions: z.array(z.enum(BRAND_MEMBERSHIP_PERMISSIONS)),
  settings: z.object({
    isCurated: z.boolean().optional(),
    notifications: BrandNotificationSchema.optional()
  }).nullable(),
  products: z.array(z.nativeEnum(ProductLine)).nullable()
});
var GetBrandMembersEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/members?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(BrandMemberSchema),
  requestSchema: z.void(),
  querySchema: GetBrandMembersQuerySchema
});
var UpdateBrandMemberRequestSchema = z.object({
  permissions: z.array(z.enum(BRAND_MEMBERSHIP_PERMISSIONS)),
  products: z.array(z.nativeEnum(ProductLine)).optional()
});
var UpdateBrandMemberPermissionsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, memberId }) => `v1/brands/${brandId}/members/${memberId}/permissions`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandMemberRequestSchema
});
var BrandHostSchema = BrandMemberSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  profilePicture: true,
  emailAddress: true,
  description: true
});
var BrandResponseSchema = z.object({
  items: z.array(BrandHostSchema)
});
var PublicBrandHostEndpoint = makeEndpoint({
  url: () => `/v1/hosts`,
  method: "GET",
  responseSchema: BrandResponseSchema,
  requestSchema: z.void()
});
var HostCommissionSortBy = /* @__PURE__ */ ((HostCommissionSortBy2) => {
  HostCommissionSortBy2["START_DATE_TIME"] = "startDateTime";
  HostCommissionSortBy2["AMOUNT"] = "amount";
  HostCommissionSortBy2["INITIATED_ON"] = "scheduledAt";
  HostCommissionSortBy2["PAYOUT_DATE"] = "payoutArrivalDate";
  return HostCommissionSortBy2;
})(HostCommissionSortBy || {});
var PatchBrandHostRequestSchema = z.object({
  allowOverlappingBookings: z.boolean()
});
var PatchBrandHostEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, hostId }) => `/brands/${brandId}/hosts/${hostId}`,
  responseSchema: z.void(),
  requestSchema: PatchBrandHostRequestSchema
});
var AllPaginatedHostsResponse = paginateResponseSchema(
  z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema,
    profilePicture: z.object({ id: z.string(), uri: z.object({ original: z.string() }) }).nullable()
  })
);
var GetAllHostsQuerySchema = z.object({
  q: z.string().optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).default(10)
}).strict();
var GetBrandHostsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/hosts?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(BrandMemberSchema),
  requestSchema: z.void(),
  querySchema: GetBrandMembersQuerySchema
});
var GetBrandsHostCommissionQuerySchema = paginateQuerySchema({}).omit({
  q: true,
  filters: true,
  sortBy: true,
  sortDir: true
}).extend({
  sortBy: z.nativeEnum(HostCommissionSortBy).optional(),
  sortOrder: z.enum(sortOptions).optional()
});
var LiveStatusSchema = z.object({
  brandId: z.string().uuid(),
  live: z.boolean(),
  enforcedBy: z.object({
    id: z.string().uuid(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema
  }).nullable(),
  updatedAt: z.string().datetime()
});
var LiveStatusWithBreakdownSchema = LiveStatusSchema.extend({
  isScriptEmbedded: z.boolean().nullable(),
  isBankAccountConnected: z.boolean().nullable(),
  isBrandInfoSet: z.boolean().nullable(),
  bookableExperiencesCount: z.number().nullable()
});
var LiveStatusResponseSchema = LiveStatusSchema;
var GetBrandLiveStatusEndpoint = makeEndpoint({
  method: "GET",
  url: (params) => `/brands/${params.brandId}/live-status`,
  requestSchema: z.void(),
  responseSchema: LiveStatusResponseSchema
});
var RefreshBrandLiveStatusEndpoint = makeEndpoint({
  method: "POST",
  url: (params) => `v1/brands/${params.brandId}/live-status/refresh?${params.force ? "force=true" : ""}`,
  requestSchema: z.void(),
  responseSchema: LiveStatusResponseSchema
});
var PutLiveStatusRequestSchema = z.object({
  live: z.boolean()
});
var PutBrandLiveStatusEndpoint = makeEndpoint({
  method: "PUT",
  url: (params) => `/brands/${params.brandId}/live-status`,
  requestSchema: PutLiveStatusRequestSchema,
  responseSchema: LiveStatusResponseSchema
});
var BrandStatus = /* @__PURE__ */ ((BrandStatus2) => {
  BrandStatus2["ACTIVE"] = "active";
  BrandStatus2["CHURNED"] = "churned";
  BrandStatus2["DELETED"] = "deleted";
  return BrandStatus2;
})(BrandStatus || {});
var BrandReportQuerySchema = z.object({
  types: z.array(z.nativeEnum(BrandStatus))
});
var BrandReportHeaderSchema = z.object({
  ID: z.string(),
  Name: z.string(),
  "Email Address": EmailStringSchema,
  Version: z.enum(["1.0", "2.0"]).nullable(),
  Tier: z.string(),
  Host: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  Activate: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  Reserve: z.boolean().pipe(z.coerce.string().toUpperCase()).nullable(),
  "Country Code": z.string(),
  "Currency Code": z.string(),
  "Credit Card Fee Percentage": z.number(),
  "Payment Platform": z.string(),
  "Created At": z.string().datetime(),
  Status: z.string(),
  CSM: z.string().optional(),
  "Decision Makers": z.string().optional(),
  "Point of contacts": z.string().optional(),
  "Test brand": z.boolean().nullable().optional(),
  Live: z.boolean().nullable().optional(),
  "Churned At": z.union([z.string().trim().length(0), z.string().datetime()]).optional().nullable(),
  "Launched At": z.union([z.string().trim().length(0), z.string().datetime()]).optional().nullable()
});
var BulkUpdateTaxSchema = z.object({
  id: z.string().uuid().optional(),
  name: z.string()
});
var UpdateBrandTaxesSchema = z.object({
  taxes: z.array(BulkUpdateTaxSchema)
});
var UpdateBrandTaxesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/taxes`,
  responseSchema: z.void(),
  requestSchema: UpdateBrandTaxesSchema
});
var BrandTaxSchema = z.object({
  id: z.string().uuid(),
  name: z.string()
});
var BrandsFinancialSummarySchema = z.object({
  brandId: z.string(),
  currency: z.string(),
  host: MinimalHostSchema.optional(),
  experience: z.object({
    id: z.string(),
    title: z.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  resourceGroup: z.object({
    id: z.string(),
    title: z.string(),
    coverPicture: IMediaReferenceSchema.nullable(),
    resourceGroupCollectionId: z.string()
  }).optional(),
  brand: z.object({
    id: z.string(),
    name: z.string(),
    logo: IMediaReferenceSchema.nullable()
  }).optional(),
  grossRevenue: z.number(),
  netProfit: z.number(),
  totalHostEarning: z.number(),
  averageTransactionValue: z.number(),
  bookingCount: z.number()
}).strict();
var BrandsFinancialSummaryResponseSchema = paginateResponseSchema(BrandsFinancialSummarySchema).strict();
var financialSummaryGroupingOptions = ["experience", "collection", "listing", "host", "brand"];
var GetBrandsFinancialSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["grossRevenue", "netProfit", "totalHostEarning", "averageTransactionValue"]
}).omit({ sortDir: true, filters: true, q: true }).extend({
  sortDir: z.enum(sortOptions).optional(),
  experienceId: z.string().uuid().optional(),
  resourceGroupCollectionId: z.string().uuid().optional(),
  groupBy: z.enum(financialSummaryGroupingOptions)
});
var GetBrandsFinancialSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `/v1/${entityType}/${entityId}/financial-summary?${buildQueryString(query)}`,
  responseSchema: BrandsFinancialSummaryResponseSchema,
  requestSchema: z.void(),
  querySchema: GetBrandsFinancialSummaryQuerySchema
});
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["INPUT"] = "input";
  FieldType2["TEXTAREA"] = "textarea";
  FieldType2["MULTIPLE_SELECT"] = "multiple_select";
  FieldType2["SINGLE_SELECT"] = "single_select";
  FieldType2["TERMS_AND_CONDITIONS"] = "terms_and_conditions";
  return FieldType2;
})(FieldType || {});
var OptionSchema = z.object({
  key: z.string().uuid(),
  value: z.string()
});
var CustomQuestionScope = /* @__PURE__ */ ((CustomQuestionScope2) => {
  CustomQuestionScope2["PURCHASER"] = "purchaser";
  CustomQuestionScope2["PARTICIPANT"] = "participant";
  return CustomQuestionScope2;
})(CustomQuestionScope || {});
var ConditionMatchType = /* @__PURE__ */ ((ConditionMatchType2) => {
  ConditionMatchType2["ANY"] = "any";
  ConditionMatchType2["ALL"] = "all";
  return ConditionMatchType2;
})(ConditionMatchType || {});
var ConditionRule = /* @__PURE__ */ ((ConditionRule2) => {
  ConditionRule2["VALUE_MATCHES"] = "value_matches";
  return ConditionRule2;
})(ConditionRule || {});
var ConditionSchema = z.object({
  rule: z.nativeEnum(ConditionRule),
  conditionKey: z.string().uuid(),
  conditionValue: z.string().uuid()
});
var ConfigSchema = z.object({
  isRequired: z.boolean(),
  scope: z.nativeEnum(CustomQuestionScope),
  conditionsMatchType: z.nativeEnum(ConditionMatchType).nullable(),
  isActive: z.boolean(),
  conditions: z.array(ConditionSchema).nullable(),
  order: z.number(),
  isDefault: z.boolean().optional(),
  disabled: z.boolean().optional()
});
var TermAndConditionSchema = z.object({
  label: z.string(),
  mediaId: z.string().uuid(),
  mediaURL: z.string(),
  isOverrided: z.boolean()
});
var CustomQuestionSchema = z.object({
  id: z.string().uuid(),
  prompt: z.string(),
  fieldType: z.nativeEnum(FieldType),
  options: z.array(OptionSchema).nullable(),
  termsAndConditions: TermAndConditionSchema.nullable(),
  config: ConfigSchema
});
var AnswerSchema = z.object({
  value: z.union([z.string(), z.array(z.string()), z.boolean()]).nullable(),
  key: z.string().nullable().optional()
});
var AggregateQuestionSchema = z.object({
  customQuestionId: z.string(),
  prompt: z.string(),
  fieldType: z.nativeEnum(FieldType),
  options: z.array(OptionSchema).nullable(),
  termsAndConditions: z.object({
    label: z.string(),
    mediaId: z.string(),
    isOverrided: z.boolean(),
    mediaUrl: z.string().optional()
  }).nullable(),
  config: z.object({
    experienceId: z.string(),
    experienceQuestionId: z.string(),
    isRequired: z.boolean(),
    isActive: z.boolean(),
    order: z.number(),
    scope: z.nativeEnum(CustomQuestionScope),
    conditions: z.array(ConditionSchema).nullable(),
    conditionsMatchType: z.nativeEnum(ConditionMatchType).nullable()
  })
});
var CustomQuestionAnswerBookingResponseSchema = z.object({
  id: z.string(),
  answer: z.array(AnswerSchema),
  question: AggregateQuestionSchema
});
var BookingCustomQuestionSchema = z.object({
  questionId: z.string(),
  answer: z.array(
    z.object({
      value: z.union([z.string(), z.boolean()]),
      key: z.string().optional().nullable().transform((key) => key || null)
    })
  )
});
var BookingCustomQuestionWithAnswerSchema = BookingCustomQuestionSchema.extend({
  answerId: z.string().optional()
});
var BookingCustomQuestionResponseSchema = BookingCustomQuestionWithAnswerSchema;
var ParticipantType = /* @__PURE__ */ ((ParticipantType2) => {
  ParticipantType2["PARTICIPANT"] = "participant";
  ParticipantType2["PURCHASER"] = "purchaser";
  return ParticipantType2;
})(ParticipantType || {});
var BaseParticipantOrPurchaserSchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema.optional().nullable(),
  phoneNumber: z.string().optional().nullable(),
  type: z.nativeEnum(ParticipantType)
});
var BaseParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z.string().uuid(),
  priceTierName: z.string(),
  cancelledAt: z.string().datetime().nullable()
});
var ParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  priceTierName: z.string(),
  customQuestionResponses: z.array(BookingCustomQuestionSchema).optional()
});
var PurchaserSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).required({ emailAddress: true }).extend({ id: z.string().uuid() });
var PurchaserWithCustomQuestionsSchema = PurchaserSchema.extend({
  customQuestionResponses: z.array(BookingCustomQuestionSchema).optional()
});
var ParticipantUpdateSchema = z.object({
  experienceId: z.string().uuid().optional(),
  participant: BaseParticipantOrPurchaserSchema,
  customQuestionResponses: z.array(BookingCustomQuestionResponseSchema).optional()
});
var BookingPriceTierSchema = z.object({
  name: z.string(),
  participantsCount: z.number(),
  price: z.number(),
  amount: z.number()
});
var PmsType = /* @__PURE__ */ ((PmsType2) => {
  PmsType2["OPERA"] = "opera";
  PmsType2["STAYNTOUCH"] = "stayntouch";
  PmsType2["INFOR"] = "infor";
  return PmsType2;
})(PmsType || {});
var PaymentDetailSchema = z.object({
  lastName: z.string().optional(),
  methodNumber: z.string().optional(),
  pmsType: z.nativeEnum(PmsType).optional(),
  reservationId: z.union([z.number().transform((id) => `${id}`), z.string()]).optional(),
  confirmationId: z.string().optional(),
  collectionDetail: z.string().optional()
});
var BookingFormSchema = z.object({
  scope: z.nativeEnum(CustomQuestionScope),
  fields: z.object({
    emailAddress: z.object({
      isRequired: z.boolean(),
      isActive: z.boolean()
    }),
    phoneNumber: z.object({
      isRequired: z.boolean(),
      isActive: z.boolean()
    })
  })
});
var ExperienceSettingsSchema = z.object({
  bookingForm: z.array(BookingFormSchema).optional(),
  isCurated: z.boolean().optional()
});
var BookingMode = /* @__PURE__ */ ((BookingMode2) => {
  BookingMode2["PRIVATE"] = "private";
  BookingMode2["SHARED"] = "shared";
  return BookingMode2;
})(BookingMode || {});
var DeviceType = /* @__PURE__ */ ((DeviceType2) => {
  DeviceType2["PC"] = "pc";
  DeviceType2["MOBILE"] = "mobile";
  return DeviceType2;
})(DeviceType || {});
var RefundHistorySchema = z.object({
  amount: z.coerce.number(),
  refundedAt: z.string().datetime(),
  refundedBy: z.string()
});
var BookingListingAddOnItemSchema = z.object({
  listingAddOnId: z.string().uuid(),
  quantity: z.number().positive()
});
var DetailedBookingAddOnItemSchema = z.object({
  id: z.string().uuid(),
  listingAddOnId: z.string().uuid(),
  label: z.string(),
  paidAmount: z.number(),
  price: z.number(),
  discountedAmount: z.number(),
  refundedAmount: z.number(),
  refundHistories: z.array(RefundHistorySchema),
  cancelledAt: z.string().datetime().nullable()
});
var MinimalBookingRequestSchema = z.object({
  sessionTime: LocalDateTimeStringSchema,
  sessionDuration: z.number().optional(),
  participants: z.array(ParticipantSchema),
  mode: z.nativeEnum(BookingMode),
  couponCode: z.string().nullable().optional().transform((couponCode) => couponCode != null ? couponCode : null),
  discountAmount: z.number().nullable().optional().transform((discountAmount) => discountAmount != null ? discountAmount : null),
  discountPercentage: z.number().nullable().optional().transform((discountPercentage) => discountPercentage != null ? discountPercentage : null),
  accessCode: z.string().nullable().optional().transform((accessCode) => accessCode != null ? accessCode : null),
  notes: z.string().optional().nullable().transform((notes) => notes != null ? notes : null),
  metadata: z.record(z.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null),
  internalNotes: z.string().optional().nullable().transform((internalNotes) => internalNotes != null ? internalNotes : null),
  listingAddOns: z.array(BookingListingAddOnItemSchema).default([]),
  appliedCreditCodes: z.array(
    z.object({
      code: z.string(),
      appliedValue: z.number(),
      sequence: z.number()
    })
  ).nullable().optional(),
  intendedConfirmationCode: z.string().optional()
});
var CommonBookingRequestSchema = MinimalBookingRequestSchema.extend({
  waitlistEntryId: z.string().uuid().optional()
});
var BookingRequestSchema = CommonBookingRequestSchema.extend({
  purchaser: z.object({
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema,
    phoneNumber: z.string().optional(),
    customQuestionResponses: z.array(BookingCustomQuestionSchema).optional()
  }),
  paymentMethod: z.nativeEnum(PaymentMethods).optional().transform((paymentMethod) => paymentMethod || null),
  paymentDetail: PaymentDetailSchema.nullable().optional().transform((paymentDetail) => paymentDetail || null),
  bookingScriptUrl: z.string().url().optional(),
  externalAnalyticsUserId: z.string().optional(),
  siteLanguage: z.string().optional(),
  waitlistEntryId: z.string().uuid().optional(),
  deviceType: z.nativeEnum(DeviceType).optional(),
  cartId: z.string().uuid().optional()
});
var BulkBookingExperienceSchema = CommonBookingRequestSchema.extend({
  experienceId: z.string(),
  additionalCustomQuestionResponses: z.array(BookingCustomQuestionResponseSchema).optional(),
  externalAnalyticsUserId: z.string().optional()
});
var BulkBookingRequestSchema = z.object({
  data: z.array(
    CommonBookingRequestSchema.extend({
      experienceId: z.string(),
      resourceGroupId: z.string().optional(),
      resourceQuantity: z.number().optional(),
      additionalCustomQuestionResponses: z.array(BookingCustomQuestionResponseSchema).optional()
    })
  ),
  purchaser: z.object({
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema,
    phoneNumber: z.string().optional(),
    customQuestionResponses: z.array(BookingCustomQuestionSchema).optional()
  }),
  loyaltyProgramData: z.object({
    loyaltyProgramId: z.string(),
    memberId: z.string()
  }).optional(),
  paymentMethod: z.nativeEnum(PaymentMethods).optional().transform((paymentMethod) => paymentMethod || null),
  paymentDetail: PaymentDetailSchema.nullable().optional().transform((paymentDetail) => paymentDetail || null),
  bookingScriptUrl: z.string().url().optional(),
  externalAnalyticsUserId: z.string().optional(),
  siteLanguage: z.string().optional(),
  deviceType: z.nativeEnum(DeviceType).optional(),
  cartId: z.string().uuid().optional(),
  sendEmail: z.boolean().optional()
});
var BookingStatus = /* @__PURE__ */ ((BookingStatus2) => {
  BookingStatus2["CONFIRMED"] = "confirmed";
  BookingStatus2["REFUNDED"] = "refunded";
  BookingStatus2["PROCESSING"] = "processing";
  BookingStatus2["FAILED"] = "failed";
  BookingStatus2["CANCELLED"] = "cancelled";
  return BookingStatus2;
})(BookingStatus || {});
var ItemType = /* @__PURE__ */ ((ItemType2) => {
  ItemType2["PRICE_TIER"] = "Price tier";
  ItemType2["ADD_ON"] = "Add-on";
  return ItemType2;
})(ItemType || {});
var PaymentStatusSchema = z.object({
  code: z.string(),
  message: z.string()
});
var PaymentMethodDetailSchema = z.object({
  fixedChargeId: z.string().optional(),
  billingChargeId: z.union([z.string(), z.number()]).optional(),
  commentId: z.string().optional(),
  transactionCode: z.object({
    code: z.string(),
    description: z.string()
  }).optional(),
  pgCno: z.string().optional(),
  msgAuthValue: z.string().optional(),
  shopTransactionId: z.string().optional()
});
var MetaSchema = z.object({
  paymentStatus: PaymentStatusSchema.optional(),
  paymentDetail: PaymentDetailSchema.nullable(),
  paymentMethodDetail: PaymentMethodDetailSchema.nullable()
}).partial();
var BookingDetailSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  amount: z.coerce.number(),
  experiencePaidAmount: z.number(),
  experienceRefundedAmount: z.number(),
  currency: z.string(),
  amountRefunded: z.coerce.number(),
  date: z.string(),
  confirmationCode: z.string(),
  status: z.nativeEnum(BookingStatus),
  sessionDate: z.string(),
  sessionDuration: z.number(),
  isCancelled: z.boolean(),
  isPartiallyCancelled: z.boolean(),
  createdAt: z.string().datetime(),
  experience: z.object({
    id: z.string(),
    title: z.string(),
    hostName: z.string(),
    location: z.object({
      longitude: z.coerce.number(),
      latitude: z.coerce.number(),
      name: z.string(),
      timezoneId: z.string(),
      additionalInfo: z.string().optional()
    }),
    number: z.string().nullable()
  }),
  customer: z.object({
    id: z.string(),
    name: z.string(),
    emailAddress: z.string()
  }),
  purchaser: z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  participants: z.array(
    BaseParticipantSchema.extend({
      customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional(),
      cancelledAt: z.string().datetime().nullable()
    })
  ),
  earning: z.coerce.number().nullable(),
  hostCommissionType: z.nativeEnum(HostCommissionType),
  paymentMethod: z.nativeEnum(PaymentMethods),
  isVoided: z.boolean(),
  priceTiers: z.array(BookingPriceTierSchema),
  isFullyRefunded: z.boolean(),
  isPartiallyRefunded: z.boolean(),
  refundHistory: z.array(RefundHistorySchema).nullable(),
  notes: z.string().nullable(),
  experienceCoverPicture: IMediaReferenceSchema.nullable(),
  chargeId: z.string().nullable(),
  cancellationPolicyId: z.string().nullable(),
  reschedulePolicyId: z.string().nullable(),
  experienceSettings: ExperienceSettingsSchema,
  meta: MetaSchema.nullable(),
  brand: z.object({
    id: z.string(),
    name: z.string()
  }),
  internalNotes: z.string().nullable(),
  integrations: z.object({
    alice: z.object({
      ticketIds: z.array(z.coerce.number())
    })
  }),
  isDisputed: z.boolean(),
  disputedReason: z.string().nullable(),
  cartId: z.string().uuid().nullable(),
  cartConfirmationCode: z.string().nullable(),
  addOns: z.array(DetailedBookingAddOnItemSchema).nullable(),
  cardBrand: z.string().nullable().optional(),
  cardLast4: z.string().nullable().optional()
});
var BookingDetailResponseSchema = paginateResponseSchema(BookingDetailSchema);
var BookingStatusFilterValues = /* @__PURE__ */ ((BookingStatusFilterValues2) => {
  BookingStatusFilterValues2["ACTIVE"] = "active";
  BookingStatusFilterValues2["CANCELLED"] = "cancelled";
  BookingStatusFilterValues2["REFUNDED"] = "refunded";
  BookingStatusFilterValues2["PARTIALLY_REFUNDED"] = "partially_refunded";
  BookingStatusFilterValues2["VOIDED"] = "voided";
  return BookingStatusFilterValues2;
})(BookingStatusFilterValues || {});
var GetPaginatedBookingsQuerySchema = paginateQuerySchema({
  sortBy: ["purchaser", "experience", "dateBooked", "amount", "status", "brand", "sessionDate"]
}).extend({
  organizationId: z.string().uuid().optional(),
  experienceId: z.string().uuid().optional(),
  resourceGroupCollectionId: z.string().uuid().optional(),
  excludeFailed: BooleanStringSchema.optional(),
  excludeCancelled: BooleanStringSchema.optional(),
  cartId: z.string().uuid().optional(),
  cartConfirmationCode: z.string().optional(),
  confirmationCode: z.string().optional(),
  createdFrom: DateStringSchema.optional(),
  createdTo: DateStringSchema.optional(),
  updatedFrom: DateStringSchema.optional(),
  updatedTo: DateStringSchema.optional(),
  bookingIds: z.array(z.string().uuid()).min(1).optional(),
  purchaserLastName: z.string().optional(),
  purchaserEmail: z.string().optional(),
  methodNumber: z.string().optional(),
  loyaltyProgramId: z.string().optional(),
  memberId: z.string().optional(),
  filters: z.array(
    z.union([
      z.object({
        operator: z.literal("range"),
        name: z.literal("transactionDateRange"),
        value: z.object({ from: DateStringSchema, to: DateStringSchema })
      }),
      z.object({
        operator: z.literal("range"),
        name: z.literal("experienceDateRange"),
        value: z.object({ from: DateStringSchema, to: DateStringSchema })
      }),
      z.object({
        operator: z.enum(["equals", "greater_than", "less_than"]),
        name: z.literal("amount"),
        value: z.coerce.number().pipe(z.coerce.string())
      }),
      z.object({
        operator: z.literal("range"),
        name: z.literal("amount"),
        value: z.object({
          from: z.coerce.number().pipe(z.coerce.string()),
          to: z.coerce.number().pipe(z.coerce.string())
        })
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("hosts"),
        value: z.array(z.string().uuid())
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("status"),
        value: z.array(z.nativeEnum(BookingStatusFilterValues))
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("paymentMethod"),
        value: z.array(z.nativeEnum(PaymentMethods))
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("products"),
        value: z.array(z.nativeEnum(ProductLine))
      }),
      z.object({
        name: z.literal("disputed"),
        operator: z.literal("equals"),
        value: z.enum(["true", "false"])
      })
    ])
  ).optional()
});
var GetPaginatedBookingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/bookings?${buildQueryString(query)}`,
  responseSchema: BookingDetailResponseSchema,
  requestSchema: z.void(),
  querySchema: GetPaginatedBookingsQuerySchema
});
var GetPaginatedBrandBookingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/bookings?${buildQueryString(query)}`,
  responseSchema: BookingDetailResponseSchema,
  requestSchema: z.void(),
  querySchema: GetPaginatedBookingsQuerySchema
});
var PaymentResultSchema = z.object({
  amount: z.coerce.number(),
  currency: z.string(),
  confirmationCode: z.string(),
  subjectId: z.string(),
  subjectType: z.string(),
  clientSecret: z.string().nullable().optional(),
  metadata: z.record(z.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null)
});
var PublicBookingResponseSchema = BookingDetailSchema.pick({
  id: true,
  confirmationCode: true,
  cartId: true,
  cartConfirmationCode: true,
  amount: true,
  currency: true,
  amountRefunded: true,
  status: true,
  purchaser: true,
  participants: true,
  paymentMethod: true,
  createdAt: true,
  notes: true,
  internalNotes: true
}).extend({
  event: z.object({
    timezone: z.string(),
    startDateTime: LocalDateTimeStringSchema
  }),
  experience: z.object({
    id: z.string().uuid(),
    title: z.string()
  })
});
var PublicCancelBookingRequestItemSchema = z.object({
  bookingId: z.string().uuid(),
  cancel: z.literal(true).optional(),
  participants: z.array(z.string().uuid()).min(1).optional(),
  refundAmount: z.number().optional()
});
var PublicCancelBookingsRequestSchema = z.object({
  bookings: z.array(PublicCancelBookingRequestItemSchema)
});
var PublicCancelBookingEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/bookings/cancel`,
  responseSchema: z.object({ items: z.array(PublicBookingResponseSchema) }),
  requestSchema: PublicCancelBookingsRequestSchema
});
var RefundBookingRequestSchema = z.object({
  refundAmount: z.number().nonnegative(),
  bookingAddOnItems: z.array(
    z.object({
      id: z.string().uuid(),
      refundAmount: z.number().nonnegative()
    })
  )
});
var RefundBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/refund`,
  responseSchema: z.void(),
  requestSchema: RefundBookingRequestSchema
});
var CancelBookingRequestSchema = z.object({
  participantIds: z.array(z.object({ id: z.string().uuid() })),
  bookedAddOnIds: z.array(z.object({ id: z.string().uuid() }))
});
var CancelBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/cancel`,
  responseSchema: z.void(),
  requestSchema: CancelBookingRequestSchema
});
var GetPromoterBookingIdsResponseSchema = z.array(z.string().uuid());
var GetPromoterBookingIdsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/promoted-booking-ids`,
  responseSchema: GetPromoterBookingIdsResponseSchema,
  requestSchema: z.void()
});
var BookingsByCartIdSchema = z.object({
  id: z.string(),
  eventId: z.string(),
  amount: z.coerce.number(),
  experiencePaidAmount: z.number(),
  experienceRefundedAmount: z.number(),
  currency: z.string(),
  amountRefunded: z.coerce.number(),
  date: z.string(),
  confirmationCode: z.string(),
  status: z.nativeEnum(BookingStatus),
  sessionDate: z.string(),
  sessionDuration: z.number(),
  isCancelled: z.boolean(),
  isPartiallyCancelled: z.boolean(),
  cancellationPolicyId: z.string().nullable(),
  reschedulePolicyId: z.string().nullable(),
  createdAt: z.string().datetime(),
  experience: z.object({
    id: z.string(),
    title: z.string(),
    hostName: z.string(),
    location: z.object({
      longitude: z.coerce.number(),
      latitude: z.coerce.number(),
      name: z.string(),
      timezoneId: z.string(),
      additionalInfo: z.string().optional()
    }),
    number: z.string().nullable()
  }),
  customer: z.object({
    id: z.string(),
    name: z.string(),
    emailAddress: z.string()
  }),
  purchaser: z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: z.string().nullable(),
    phoneNumber: z.string().nullable(),
    customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  participants: z.array(
    BaseParticipantSchema.extend({
      customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional(),
      cancelledAt: z.string().datetime().nullable(),
      priceTierPrice: z.number().nullable().optional(),
      priceTierId: z.string().nullable().optional()
    })
  ),
  earning: z.coerce.number().nullable(),
  hostCommissionType: z.nativeEnum(HostCommissionType),
  paymentMethod: z.nativeEnum(PaymentMethods),
  isVoided: z.boolean(),
  priceTiers: z.array(BookingPriceTierSchema),
  isFullyRefunded: z.boolean(),
  isPartiallyRefunded: z.boolean(),
  refundHistory: z.array(RefundHistorySchema).nullable(),
  notes: z.string().nullable(),
  experienceCoverPicture: IMediaReferenceSchema.nullable(),
  chargeId: z.string().nullable(),
  experienceSettings: ExperienceSettingsSchema,
  meta: MetaSchema.nullable(),
  brand: z.object({
    id: z.string(),
    name: z.string()
  }),
  internalNotes: z.string().nullable(),
  integrations: z.object({
    alice: z.object({
      ticketIds: z.array(z.coerce.number())
    })
  }),
  isDisputed: z.boolean(),
  disputedReason: z.string().nullable(),
  cartId: z.string().uuid().nullable(),
  cartConfirmationCode: z.string().nullable(),
  addOns: z.array(DetailedBookingAddOnItemSchema).nullable(),
  listingId: z.string().nullable()
});
var PersonSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string()
});
var WaitlistActivity = /* @__PURE__ */ ((WaitlistActivity2) => {
  WaitlistActivity2["WAITLIST_JOINED"] = "waitlist-joined";
  WaitlistActivity2["WAITLIST_INVITATION_OFFERED"] = "waitlist-invitation-offered";
  return WaitlistActivity2;
})(WaitlistActivity || {});
var BaseWaitlistEntryActivitySchema = z.object({
  topic: z.nativeEnum(WaitlistActivity),
  issuer: PersonSchema.extend({
    emailAddress: EmailStringSchema
  }),
  createdAt: z.string().datetime()
});
var WaitlistJoinedActivitySchema = BaseWaitlistEntryActivitySchema;
var WaitlistInvitationOfferedActivitySchema = BaseWaitlistEntryActivitySchema;
var WaitlistEntryActivitySchema = z.union([WaitlistJoinedActivitySchema, WaitlistInvitationOfferedActivitySchema]);
var WaitlistEntriesActivitiesResponseSchema = z.array(WaitlistEntryActivitySchema);
var GetWaitlistEntryActivitiesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/activities`,
  requestSchema: z.void(),
  responseSchema: WaitlistEntriesActivitiesResponseSchema
});
var BookingActivity = /* @__PURE__ */ ((BookingActivity2) => {
  BookingActivity2["BOOKING_CREATED"] = "booking-created";
  BookingActivity2["BOOKING_REFUNDED"] = "booking-refunded";
  BookingActivity2["BOOKING_CANCELLED"] = "booking-cancelled";
  BookingActivity2["BOOKING_VOIDED"] = "booking-voided";
  BookingActivity2["BOOKING_RESCHEDULED"] = "booking-rescheduled";
  return BookingActivity2;
})(BookingActivity || {});
var BaseBookingActivityResponseSchema = z.object({
  topic: z.nativeEnum(BookingActivity),
  issuer: PersonSchema,
  createdAt: z.string()
});
var BookingCreatedActivitySchema = BaseBookingActivityResponseSchema.extend({
  paymentMethod: z.nativeEnum(PaymentMethods),
  issuer: PersonSchema.nullable(),
  paymentDetail: PaymentDetailSchema.nullable()
});
var BookingRefundedActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestCancellation: z.boolean().default(false),
  refundedAmount: z.number()
});
var BookingRescheduledActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestRescheduled: z.boolean().default(false),
  previousDate: z.string(),
  newDate: z.string(),
  experienceTimezone: z.string().optional()
});
var BookingCancelledActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestCancellation: z.boolean().default(false),
  participants: z.array(PersonSchema),
  bookingAddOnItems: z.array(
    z.object({
      label: z.string(),
      quantity: z.number()
    })
  )
});
var BookingVoidedActivitySchema = BaseBookingActivityResponseSchema.extend({
  voidedAmount: z.number()
});
var BookingActivitySchema = z.union([
  BookingCreatedActivitySchema,
  BookingRefundedActivitySchema,
  BookingRescheduledActivitySchema,
  BookingCancelledActivitySchema,
  BookingVoidedActivitySchema
]);
var BookingActivityResponseSchema = z.array(z.union([BookingActivitySchema, WaitlistEntryActivitySchema]));
var BookingActivityEndpoint = makeEndpoint({
  method: "GET",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/activities`,
  requestSchema: z.void(),
  responseSchema: BookingActivityResponseSchema
});
var CheckInHistoryActionEnum = /* @__PURE__ */ ((CheckInHistoryActionEnum2) => {
  CheckInHistoryActionEnum2["CHECK_IN"] = "check-in";
  CheckInHistoryActionEnum2["CHECK_OUT"] = "check-out";
  return CheckInHistoryActionEnum2;
})(CheckInHistoryActionEnum || {});
var CheckInHistorySchema = z.object({
  id: z.string(),
  action: z.nativeEnum(CheckInHistoryActionEnum),
  scanned: z.boolean(),
  effectiveAt: z.union([z.string().datetime(), z.date().transform((effectiveAt) => effectiveAt.toISOString())]),
  author: z.object({
    fullName: z.string()
  })
});
var BookingWithParticipantSchema = z.object({
  bookingId: z.string().uuid(),
  experienceId: z.string().uuid(),
  startDateTime: z.string(),
  sessionDuration: z.number(),
  confirmationCode: z.string(),
  chargeId: z.string(),
  isCancelled: z.boolean(),
  isPartiallyCancelled: z.boolean(),
  mode: z.nativeEnum(BookingMode),
  eventId: z.string().uuid(),
  purchaser: z.object({
    id: z.string(),
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: EmailStringSchema.nullable(),
    phoneNumber: z.string().optional().nullable(),
    customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  notes: z.string().nullable(),
  amount: z.number(),
  participants: z.array(
    BaseParticipantSchema.extend({
      isCheckedIn: z.boolean(),
      ticketNumber: z.string().nullable(),
      checkInHistories: z.array(CheckInHistorySchema),
      customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
    })
  ),
  paymentMethod: z.nativeEnum(PaymentMethods),
  isVoided: z.boolean(),
  isFullyRefunded: z.boolean(),
  isPartiallyRefunded: z.boolean(),
  refundAmount: z.number().optional(),
  refundHistory: z.array(RefundHistorySchema).nullable(),
  experienceSettings: ExperienceSettingsSchema,
  internalNotes: z.string().nullable(),
  brand: z.object({
    id: z.string(),
    name: z.string()
  }),
  isDisputed: z.boolean(),
  disputedReason: z.string().nullable(),
  priceTiers: z.array(BookingPriceTierSchema),
  cardBrand: z.string().nullable().optional(),
  cardLast4: z.string().nullable().optional()
});
var BrandsLogisticSummarySchema = z.object({
  brandId: z.string(),
  host: MinimalHostSchema.optional(),
  brand: BrandSchema.pick({ id: true, name: true }).extend({ logo: IMediaReferenceSchema.nullable() }).optional(),
  experience: z.object({ id: z.string(), title: z.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
  resourceGroup: z.object({
    id: z.string(),
    resourceGroupCollectionId: z.string(),
    title: z.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  totalParticipants: z.string(),
  averageParticipants: z.string(),
  averageBookingWindowInMinutes: z.string(),
  totalBookings: z.string()
}).strict();
var BrandsLogisticSummaryResponseSchema = paginateResponseSchema(BrandsLogisticSummarySchema).strict();
var GetBrandsLogisticsSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["totalParticipants", "averageBookingWindowInSeconds", "totalBookings"]
}).extend({
  groupBy: z.enum(financialSummaryGroupingOptions)
});
var GetBrandsLogisticsSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `v1/${entityType}/${entityId}/logistics?${buildQueryString(query)}`,
  responseSchema: BrandsLogisticSummaryResponseSchema,
  requestSchema: z.void(),
  querySchema: GetBrandsLogisticsSummaryQuerySchema
});
var CreatePaymentIntentRequestSchema = z.object({
  data: z.array(
    CommonBookingRequestSchema.extend({
      experienceId: z.string(),
      resourceGroupId: z.string().optional(),
      resourceQuantity: z.number().optional()
    })
  ),
  getOnlyTotalNetAmount: z.boolean().optional()
});
var CreatePaymentIntentResponseSchema = z.object({
  totalNetAmount: z.number(),
  paymentIntentSecret: z.string().nullable()
});
var CreatePaymentIntentEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, cartId }) => `/v1/brands/${brandId}/carts/${cartId}/payment_intents`,
  requestSchema: CreatePaymentIntentRequestSchema,
  responseSchema: CreatePaymentIntentResponseSchema
});
var DiscardCartEndpoint = makeEndpoint({
  url: ({ brandId, cartId }) => `/v1/brands/${brandId}/carts/${cartId}/discard`,
  method: "POST",
  requestSchema: z.void(),
  responseSchema: z.void()
});
var UpdateNotesSchema = z.object({
  notes: z.string().optional(),
  internalNotes: z.string().optional()
});
var RescheduleBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/reschedule`,
  requestSchema: z.object({
    sessionTime: LocalDateTimeStringSchema,
    sessionDuration: z.number().optional(),
    experienceId: z.string().uuid().optional(),
    sendConfirmationEmail: z.boolean().optional()
  }),
  responseSchema: z.void()
});
var BookingInquiryStatus = /* @__PURE__ */ ((BookingInquiryStatus2) => {
  BookingInquiryStatus2["REQUESTED"] = "requested";
  BookingInquiryStatus2["ACCEPTED"] = "accepted";
  BookingInquiryStatus2["DECLINED"] = "declined";
  BookingInquiryStatus2["UNAVAILABLE"] = "unavailable";
  BookingInquiryStatus2["EXPIRED"] = "expired";
  return BookingInquiryStatus2;
})(BookingInquiryStatus || {});
var DateType = /* @__PURE__ */ ((DateType2) => {
  DateType2["HOTEL"] = "hotel";
  DateType2["STANDARD"] = "standard";
  return DateType2;
})(DateType || {});
var InquiryItemType = /* @__PURE__ */ ((InquiryItemType2) => {
  InquiryItemType2["ITEM"] = "item";
  InquiryItemType2["TAX"] = "tax";
  return InquiryItemType2;
})(InquiryItemType || {});
var BookingInquiryItemSchema = z.object({
  id: z.string().uuid(),
  label: z.string(),
  type: z.nativeEnum(InquiryItemType),
  amount: z.number()
});
var BookingInquirySchema = z.object({
  id: z.string().uuid(),
  status: z.nativeEnum(BookingInquiryStatus),
  experienceId: z.string().uuid(),
  experience: z.object({
    id: z.string(),
    title: z.string()
  }),
  customerId: z.string().uuid(),
  customer: z.object({
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: z.string(),
    phoneNumber: z.string().nullable()
  }),
  purchaserId: z.string().uuid(),
  purchaser: PurchaserWithCustomQuestionsSchema.extend({
    emailAddress: EmailStringSchema,
    customQuestionResponses: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }).omit({
    id: true
  }),
  participants: z.array(
    BaseParticipantSchema.extend({
      customQuestionResponses: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
    }).omit({
      priceTierName: true
    })
  ),
  startDate: z.date().nullable(),
  endDate: z.date().nullable(),
  dateType: z.nativeEnum(DateType),
  message: z.string().nullable(),
  inquiryItems: z.array(BookingInquiryItemSchema).optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
  deletedAt: z.date().nullable()
});
var BaseBookingInquiryRequestSchema = z.object({
  customer: z.object({
    firstName: z.string(),
    lastName: z.string(),
    emailAddress: z.string(),
    phoneNumber: z.string().nullable()
  }),
  purchaser: PurchaserWithCustomQuestionsSchema.pick({
    firstName: true,
    lastName: true,
    emailAddress: true,
    phoneNumber: true,
    customQuestionResponses: true
  }).required({ emailAddress: true }),
  inquiryItems: z.array(
    z.object({
      label: z.string(),
      type: z.nativeEnum(InquiryItemType),
      amount: z.number()
    })
  ).optional(),
  startDate: DateStringSchema.nullable(),
  endDate: DateStringSchema.nullable(),
  dateType: z.nativeEnum(DateType),
  message: z.string().nullable().optional()
});
var UpdateBookingInquiryRequestSchema = BaseBookingInquiryRequestSchema.extend({
  status: z.nativeEnum(BookingInquiryStatus).optional()
});
var CreateBookingInquiryRequestSchema = BaseBookingInquiryRequestSchema.strict();
var PatchBookingInquiryRequestSchema = UpdateBookingInquiryRequestSchema.partial().strict();
var GetBookingInquiriesQuerySchema = z.object({
  page: z.number().int().min(1).default(1),
  limit: z.number().int().min(1).max(100).default(20),
  experienceId: z.string().uuid().optional(),
  status: z.nativeEnum(BookingInquiryStatus).optional(),
  searchQuery: z.string().optional(),
  withDeleted: z.boolean().optional()
});
var CreateBookingInquiryEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry`,
  requestSchema: CreateBookingInquiryRequestSchema,
  responseSchema: BookingInquirySchema
});
var PatchBookingInquiryEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, experienceId, inquiryId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry/${inquiryId}`,
  requestSchema: PatchBookingInquiryRequestSchema,
  responseSchema: BookingInquirySchema
});
var DeleteBookingInquiryEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, experienceId, inquiryId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry/${inquiryId}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var GetBookingInquiriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/inquiries`,
  requestSchema: GetBookingInquiriesQuerySchema,
  responseSchema: z.object({
    items: z.array(BookingInquirySchema),
    meta: z.object({
      totalItems: z.number(),
      itemCount: z.number(),
      itemsPerPage: z.number(),
      totalPages: z.number(),
      currentPage: z.number()
    })
  })
});
var GetBookingInquiryEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, inquiryId }) => `v1/brands/${brandId}/inquiries/${inquiryId}`,
  requestSchema: z.void(),
  responseSchema: BookingInquirySchema
});
var RearrangeCategoryRequestSchema = z.object({
  categoryIds: z.array(z.string().uuid())
}).extend({});
var RearrangeCategoryEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `brands/${brandId}/categories/rearrange`,
  responseSchema: z.void(),
  requestSchema: RearrangeCategoryRequestSchema
});
var BulkUpdateCategorySchema = z.object({
  id: z.string().uuid().optional().nullable(),
  name: z.string(),
  order: z.number()
});
var UpdateCategoriesDataSchema = z.object({
  categories: z.array(BulkUpdateCategorySchema)
});
var UpdateCategoriesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/categories`,
  responseSchema: z.void(),
  requestSchema: UpdateCategoriesDataSchema
});
var PatchTranslationsForCategoriesRequestSchema = z.object({
  translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchTranslationsForCategoriesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `/v1/brands/${brandId}/categories/i18n`,
  responseSchema: z.void(),
  requestSchema: PatchTranslationsForCategoriesRequestSchema
});
var CancellationPolicyCutoffUnit = /* @__PURE__ */ ((CancellationPolicyCutoffUnit2) => {
  CancellationPolicyCutoffUnit2["HOURS"] = "hours";
  CancellationPolicyCutoffUnit2["DAYS"] = "days";
  CancellationPolicyCutoffUnit2["WEEKS"] = "weeks";
  return CancellationPolicyCutoffUnit2;
})(CancellationPolicyCutoffUnit || {});
var GuestCancellationBookingStatus = /* @__PURE__ */ ((GuestCancellationBookingStatus2) => {
  GuestCancellationBookingStatus2["CANCELLABLE"] = "cancellable";
  GuestCancellationBookingStatus2["CANCELLED"] = "cancelled";
  GuestCancellationBookingStatus2["UNCANCELLABLE"] = "uncancellable";
  GuestCancellationBookingStatus2["DEADLINE_PASSED"] = "deadline_passed";
  return GuestCancellationBookingStatus2;
})(GuestCancellationBookingStatus || {});
var ListingPictureKind = /* @__PURE__ */ ((ListingPictureKind2) => {
  ListingPictureKind2["GALLERY"] = "gallery";
  ListingPictureKind2["COVER"] = "cover";
  ListingPictureKind2["MAP"] = "map";
  return ListingPictureKind2;
})(ListingPictureKind || {});
var ExperienceImageSizeMediaSchema = z.object({
  id: z.string().uuid(),
  uri: ExperienceImageSizeWithOriginalInUriSchema
});
var MediaLinkSchema = z.object({
  type: z.nativeEnum(MediaType),
  url: z.string().url(),
  resolution: z.nativeEnum({ ...MediaLinkResolution, ...ExperienceImageSizes })
});
var MediaInputSchema = z.object({
  id: z.string().uuid(),
  kind: z.nativeEnum(ListingPictureKind)
});
var MediaSchema = MediaInputSchema.partial({ kind: true }).extend({
  order: z.number().int().min(0).optional(),
  type: z.nativeEnum(MediaType),
  links: z.array(MediaLinkSchema)
});
var ResourceGroupCollectionEventType = /* @__PURE__ */ ((ResourceGroupCollectionEventType2) => {
  ResourceGroupCollectionEventType2["GENERAL_ADMISSION"] = "general_admission";
  ResourceGroupCollectionEventType2["RESERVED_SEATING"] = "reserved_seating";
  ResourceGroupCollectionEventType2["AUCTION"] = "auction";
  return ResourceGroupCollectionEventType2;
})(ResourceGroupCollectionEventType || {});
var ExperienceSchema = z.object({
  id: z.string().uuid(),
  title: z.string().nonempty(),
  description: z.string().nonempty().nullable(),
  status: z.nativeEnum(ExperienceStatus),
  version: z.nativeEnum(ExperienceVersion),
  coverPicture: IMediaReferenceSchema.nullable(),
  descriptionPicture: IMediaReferenceSchema.nullable(),
  isBookable: z.boolean(),
  isNoHost: z.boolean(),
  sessionDurationMinutes: z.number().min(1).nullable(),
  paymentMethods: z.array(z.nativeEnum(PaymentMethods)).nullable(),
  bookingAvailabilityMode: z.nativeEnum(BookingAvailabilityModeValue).nullable(),
  shouldValidateComplimentaryBooking: z.object({ memberCharge: z.boolean(), roomCharge: z.boolean() }).partial().nullable(),
  onlineBookingCutoffHours: z.number().nullable(),
  firstAvailableDate: z.object({
    scheduledDate: z.string(),
    sessions: z.array(
      z.object({
        startTime: z.string(),
        supportedParticipantsCount: z.number(),
        priceTiers: z.array(PriceTierSchema),
        withinOnlineBookingCutoffWindow: z.boolean().optional(),
        availableQuantityPerTier: z.record(z.number()).optional()
      })
    )
  }).nullable(),
  isUnlisted: z.boolean().nullable(),
  hostedBy: HostSchema,
  category: z.object({ id: z.string().uuid(), name: z.string() }).nullable(),
  hasPublishedVersion: z.boolean(),
  isArchived: z.boolean(),
  createdByAi: z.boolean(),
  settings: ExperienceSettingsSchema.nullable(),
  kind: z.nativeEnum(ExperienceKind).nullable(),
  minimumRequiredToBook: z.number().nullable(),
  maximumAllowedToBook: z.number().nullable(),
  number: z.string().nullable(),
  displayedCapacity: z.number().int().nullable(),
  shape: ShapeSchema.nullable(),
  position: PositionSchema.nullable(),
  maxParticipantsCount: z.number().int().nonnegative().nullable(),
  timezone: z.string(),
  emailMessage: z.string().nullable(),
  notificationEmails: z.array(EmailStringSchema).max(10).nullable(),
  notificationOverrides: ExperienceNotificationOverridesSchema.nullable(),
  integrationMeta: z.array(IntegrationMetaSchema).nullable(),
  taxes: z.array(TaxSchema).nullable(),
  type: z.nativeEnum(ExperienceType),
  isTicketed: z.boolean().optional(),
  cancellationPolicyId: z.string().uuid().nullable(),
  reschedulePolicyId: z.string().uuid().nullable(),
  customCallToAction: z.string().nullable()
});
var CustomQuestionInResourcesSchema = CustomQuestionSchema.extend({
  id: z.union([CustomQuestionSchema.shape.id, z.literal("emailAddress"), z.literal("phoneNumber")])
});
var ExperienceAsResourceSchema = ExperienceSchema.pick({
  id: true,
  title: true,
  description: true,
  status: true,
  version: true,
  isUnlisted: true,
  displayedCapacity: true,
  position: true,
  onlineBookingCutoffHours: true,
  emailMessage: true,
  notificationOverrides: true,
  notificationEmails: true,
  paymentMethods: true,
  kind: true,
  shouldValidateComplimentaryBooking: true,
  integrationMeta: true,
  sessionDurationMinutes: true,
  taxes: true,
  type: true,
  maximumAllowedToBook: true,
  minimumRequiredToBook: true,
  maxParticipantsCount: true,
  bookingAvailabilityMode: true,
  isTicketed: true,
  cancellationPolicyId: true,
  reschedulePolicyId: true
}).extend({
  shape: ExperienceSchema.shape.shape,
  customQuestions: z.array(CustomQuestionInResourcesSchema),
  priceTiers: z.array(PriceTierSchema).optional(),
  priceTierRules: z.array(PriceTierRulesSchema).optional(),
  number: ExperienceSchema.shape.number.unwrap()
});
var CancellationPolicySchema = z.object({
  active: z.boolean(),
  cutoffValue: z.number().min(0),
  cutoffUnit: z.nativeEnum(CancellationPolicyCutoffUnit),
  refundPercentage: z.number().min(0).max(100),
  notes: z.string().nonempty()
});
var PostCancellationPolicyRequestSchema = CancellationPolicySchema;
var PostCancellationPolicyResponseSchema = z.object({
  id: z.string().describe("The id of the created cancellation policy")
});
var PostCancellationPolicyEndpoint = makeEndpoint({
  title: "New cancellation policy",
  description: "Create a new cancellation policy for a brand.",
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/cancellation-policies`,
  requestSchema: PostCancellationPolicyRequestSchema,
  responseSchema: PostCancellationPolicyResponseSchema
});
var GetCancellationPolicyResponseSchema = z.object({
  id: z.string().uuid(),
  active: z.boolean(),
  cutoffValue: z.number().min(0),
  cutoffUnit: z.nativeEnum(CancellationPolicyCutoffUnit),
  refundPercentage: z.number().min(0).max(100),
  notes: z.string()
}).describe("Get all the cancellation policies.");
var GetCancellationPolicyEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, cancellationPolicyId }) => `v1/brands/${brandId}/cancellation-policies/${cancellationPolicyId}`,
  requestSchema: z.void(),
  responseSchema: GetCancellationPolicyResponseSchema
});
var GetCancellationPolicyPublicEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, cancellationPolicyId }) => `v1/brands/${brandId}/cancellation-policies/${cancellationPolicyId}`,
  requestSchema: z.void(),
  responseSchema: GetCancellationPolicyResponseSchema
});
var GetCancellationPoliciesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/cancellation-policies`,
  requestSchema: z.void(),
  responseSchema: z.array(GetCancellationPolicyResponseSchema)
});
var GetBookingsForGuestCancellationResponseSchema = z.array(
  z.object({
    bookingId: z.string().uuid(),
    title: z.string(),
    coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
    refundPercentage: z.number().min(0).max(100).nullable(),
    notes: z.string().nullable(),
    sessionDateTime: LocalDateTimeStringSchema,
    sessionDurationInMinutes: z.number(),
    status: z.nativeEnum(GuestCancellationBookingStatus),
    totalAmount: z.number(),
    refundAmount: z.number(),
    previouslyRefundedAmount: z.number(),
    remainingBalance: z.number()
  })
).describe("List the bookings associated to a cart id for guest cancellation.");
var GetBookingsForGuestCancellationQuerySchema = z.object({ token: z.string().nonempty() });
var GetBookingsForGuestCancellationEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    cartId,
    query
  }) => `v1/brands/${brandId}/carts/${cartId}/guest-cancellation?${buildQueryString(query)}`,
  querySchema: GetBookingsForGuestCancellationQuerySchema,
  requestSchema: z.void(),
  responseSchema: GetBookingsForGuestCancellationResponseSchema
});
var PostBookingCancellationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/guest-cancellation`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var PostGuestCancellationRequestSchema = z.object({
  bookingId: z.string().uuid(),
  token: z.string().nonempty()
});
var PostGuestCancellationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, cartId }) => `v1/brands/${brandId}/carts/${cartId}/guest-cancellation`,
  requestSchema: PostGuestCancellationRequestSchema,
  responseSchema: z.void()
});
var ReschedulePolicyCutoffUnit = /* @__PURE__ */ ((ReschedulePolicyCutoffUnit2) => {
  ReschedulePolicyCutoffUnit2["HOURS"] = "hours";
  ReschedulePolicyCutoffUnit2["DAYS"] = "days";
  ReschedulePolicyCutoffUnit2["WEEKS"] = "weeks";
  return ReschedulePolicyCutoffUnit2;
})(ReschedulePolicyCutoffUnit || {});
var NumberPattern = /* @__PURE__ */ ((NumberPattern2) => {
  NumberPattern2["numeric"] = "numeric";
  NumberPattern2["alphabetic"] = "alphabetic";
  return NumberPattern2;
})(NumberPattern || {});
var ResourceGroupSchema = z.object({
  id: z.string().uuid(),
  order: z.number().finite(),
  resourceGroupCollectionId: z.string().uuid(),
  version: z.nativeEnum(ExperienceVersion),
  pictures: z.array(ExperienceImageSizeMediaSchema).max(3),
  medias: z.array(MediaSchema).max(3),
  pictureIds: z.array(z.string().uuid()).max(3),
  title: z.string().trim().nonempty(),
  description: z.string().trim(),
  included: z.array(z.string()),
  experiences: z.array(ExperienceAsResourceSchema),
  defaultShape: ShapeSchema.nullable(),
  numberPattern: z.nativeEnum(NumberPattern),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime()
});
var ResourceGroupResponseSchema = ResourceGroupSchema.omit({ pictureIds: true }).extend({
  defaultPriceTiers: z.array(PriceTierSchema),
  reminder: z.string(),
  taxes: z.array(TaxSchema.and(z.object({ name: z.string() }))),
  paymentMethods: z.array(z.nativeEnum(PaymentMethods)),
  integrationMeta: z.array(IntegrationMetaSchema),
  providedItems: z.array(z.string()),
  minimumRequiredToBook: z.number().nonnegative().nullable(),
  maximumAllowedToBook: z.number().nonnegative().nullable(),
  ratings: z.object({ rating: z.number().nullable(), recommendability: z.number().nullable(), total: z.number() }),
  isExclusive: z.boolean()
});
var PostResourceGroupEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups`,
  requestSchema: ResourceGroupSchema.pick({
    order: true,
    pictureIds: true,
    title: true,
    included: true,
    defaultShape: true,
    numberPattern: true
  }).extend({
    description: ResourceGroupSchema.shape.description.optional(),
    medias: z.array(MediaSchema.omit({ kind: true })).optional()
  }).strict(),
  responseSchema: ResourceGroupResponseSchema.strict()
});
var GetResourceGroupsQuerySchema = paginateQuerySchema().merge(
  z.object({
    filters: z.array(
      z.object({
        operator: z.literal("equals"),
        name: z.literal("status"),
        value: z.nativeEnum(ExperienceVersion)
      })
    ).optional(),
    language: z.nativeEnum(LanguageCode).optional()
  })
);
var GetResourceGroupsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups?${buildQueryString(
    query
  )}`,
  requestSchema: z.void(),
  responseSchema: paginateResponseSchema(ResourceGroupResponseSchema).strict(),
  querySchema: GetResourceGroupsQuerySchema
});
var GetResourceGroupQuerySchema = z.object({
  version: z.nativeEnum(ExperienceVersion).default(
    "latest"
    /* LATEST */
  )
});
var GetResourceGroupEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}?${buildQueryString(
    query
  )}`,
  requestSchema: z.void(),
  responseSchema: ResourceGroupResponseSchema.strict(),
  querySchema: GetResourceGroupQuerySchema
});
var PatchResourceGroupEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}`,
  requestSchema: PostResourceGroupEndpoint.requestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema.strict()
});
var DeleteResourceGroupEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}`,
  requestSchema: z.void(),
  responseSchema: z.object({
    id: z.string()
  })
});
var GetTranslationsForResourceGroupQuerySchema = z.object({
  language: z.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForResourceGroupEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    version,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/version/${version}/i18n?${buildQueryString(
    query
  )}`,
  responseSchema: z.object({
    translations: z.object({
      resourceGroup: z.array(TranslationWithIdSchema),
      listingAddOns: z.array(TranslationWithIdSchema),
      customQuestions: z.array(TranslationWithIdSchema),
      listingIncluded: z.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForResourceGroupQuerySchema
});
var PatchTranslationsForResourceGroupEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    version
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/version/${version}/i18n`,
  responseSchema: z.void(),
  requestSchema: z.object({
    translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
  })
});
var import_lodash2 = __toESM(require_lodash(), 1);
var AuctionStatus = /* @__PURE__ */ ((AuctionStatus2) => {
  AuctionStatus2["PREVIEW"] = "preview";
  AuctionStatus2["OPEN"] = "open";
  AuctionStatus2["ENDED"] = "ended";
  AuctionStatus2["CLOSED"] = "closed";
  AuctionStatus2["CANCELED"] = "canceled";
  AuctionStatus2["HARD_CLOSE"] = "hard_close";
  return AuctionStatus2;
})(AuctionStatus || {});
var AuctionAmountType = /* @__PURE__ */ ((AuctionAmountType2) => {
  AuctionAmountType2["POINTS"] = "points";
  AuctionAmountType2["CASH"] = "cash";
  return AuctionAmountType2;
})(AuctionAmountType || {});
var AuctionSchema = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid(),
  resourceGroupCollectionId: z.string().uuid(),
  status: z.nativeEnum(AuctionStatus),
  amountType: z.nativeEnum(AuctionAmountType).optional(),
  startingAmount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  minBidIncrement: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  biddingOpenDateTime: z.date(),
  biddingCloseDateTime: z.date(),
  claimTimeMinutes: z.number().optional(),
  version: z.string().optional(),
  winningAmount: z.string().optional().nullable(),
  winningBidderId: z.string().optional().nullable()
});
var AuctionResponse = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid(),
  resourceGroupCollectionId: z.string().uuid(),
  status: z.nativeEnum(AuctionStatus),
  startingAmount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  minBidIncrement: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  biddingOpenDateTime: z.date(),
  biddingCloseDateTime: z.date(),
  claimTimeMinutes: z.number()
});
var AuctionApiResponseSchema = AuctionSchema.transform((auction) => ({
  ...auction,
  claimTimeMinutes: auction.claimTimeMinutes
}));
var BidderInfoSchema = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid(),
  email: z.string().email(),
  externalId: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  loyaltyTier: z.string().optional(),
  loyaltyNumber: z.string().optional(),
  createdAt: z.date(),
  updatedAt: z.date()
});
var BidResponse = z.object({
  id: z.string().uuid(),
  amountType: z.string(),
  amount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }),
  createdAt: z.date(),
  bidder: BidderInfoSchema
});
var GetBidsResponse = z.object({
  items: z.array(BidResponse),
  meta: z.object({
    totalItems: z.number(),
    itemCount: z.number(),
    itemsPerPage: z.number(),
    totalPages: z.number(),
    currentPage: z.number()
  })
});
var UpdateAuctionRequest = z.object({
  status: z.nativeEnum(AuctionStatus).optional(),
  startingAmount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  minBidIncrement: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  biddingOpenDateTime: z.string().transform((v) => new Date(v)).optional(),
  biddingCloseDateTime: z.string().transform((v) => new Date(v)).optional(),
  claimTimeMinutes: z.number().optional()
});
var UpdateAuctionEndpoint = makeEndpoint({
  method: "PUT",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId
  }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}`,
  requestSchema: UpdateAuctionRequest,
  responseSchema: AuctionResponse
});
var CreateAuctionRequest = z.object({
  startingAmount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }),
  minBidIncrement: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }),
  biddingOpenDateTime: z.string().transform((v) => new Date(v)),
  biddingCloseDateTime: z.string().transform((v) => new Date(v)),
  claimTimeMinutes: z.number()
});
var CreateAuctionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions`,
  requestSchema: CreateAuctionRequest,
  responseSchema: AuctionResponse
});
var PlaceBidRequestSchema = z.object({
  brandId: z.string().uuid(),
  id: z.string().uuid().optional(),
  amount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  maxAmount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  amountType: z.nativeEnum(AuctionAmountType).optional()
});
var PlaceBidEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids`,
  requestSchema: PlaceBidRequestSchema,
  responseSchema: z.void()
});
var BidderSchema = z.object({
  brandId: z.string().uuid(),
  id: z.string().uuid(),
  externalId: z.string(),
  email: z.string().email(),
  firstName: z.string().optional(),
  lastName: z.string().optional().nullable(),
  pointsBalance: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  phoneNumber: z.string().optional(),
  loyaltyTier: z.string().optional(),
  loyaltyNumber: z.string().optional(),
  maxBids: z.array(
    z.object({
      auctionId: z.string().uuid(),
      amount: z.string(),
      createdAt: z.date()
    })
  ).optional(),
  createdAt: z.date().optional(),
  updatedAt: z.date().optional()
});
var PartialBidderInfoSchema = z.object({
  brandId: z.string().uuid(),
  loyaltyTier: z.string().optional(),
  externalIdLast4: z.string().optional()
});
var GetBidsByBidderResponse = z.object({
  items: z.array(
    z.object({
      id: z.string().uuid(),
      amountType: z.string(),
      amount: z.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
      createdAt: z.date(),
      bidder: BidderSchema
    })
  ),
  meta: z.object({
    totalItems: z.number().optional(),
    itemCount: z.number().optional(),
    itemsPerPage: z.number().optional(),
    totalPages: z.number().optional(),
    currentPage: z.number().optional()
  })
});
var GetBidsByBidderEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId,
    field,
    value,
    page,
    limit
  }) => {
    const queryParams = new URLSearchParams();
    if (page !== void 0)
      queryParams.append("page", page.toString());
    if (limit !== void 0)
      queryParams.append("limit", limit.toString());
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    return `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids/bidder/${field}/${value}${queryString}`;
  },
  requestSchema: z.object({
    field: z.string(),
    value: z.string(),
    page: z.number().optional(),
    limit: z.number().optional()
  }),
  responseSchema: GetBidsByBidderResponse
});
var GetAuctionEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, resourceGroupCollectionId }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/`,
  requestSchema: z.object({
    brandId: z.string().uuid(),
    resourceGroupCollectionId: z.string().uuid()
  }),
  responseSchema: AuctionResponse
});
var GetBidsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId,
    page,
    limit
  }) => {
    const queryParams = new URLSearchParams();
    if (page !== void 0)
      queryParams.append("page", page.toString());
    if (limit !== void 0)
      queryParams.append("limit", limit.toString());
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    return `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids${queryString}`;
  },
  requestSchema: z.object({
    brandId: z.string().uuid(),
    resourceGroupCollectionId: z.string().uuid(),
    auctionId: z.string().uuid(),
    page: z.number().optional(),
    limit: z.number().optional()
  }),
  responseSchema: GetBidsResponse
});
var SessionSchema = z.object({
  startTime: z.string(),
  duration: z.number(),
  supportedParticipantsCount: z.number(),
  priceTiers: z.array(
    z.object({
      id: z.string().uuid(),
      name: z.string(),
      price: z.number()
    })
  ),
  availableQuantityPerTier: z.record(z.number()).optional()
});
var FirstAvailableDateSchema = z.object({
  scheduledDate: z.string(),
  sessions: z.array(SessionSchema)
});
var PromoterStatus = /* @__PURE__ */ ((PromoterStatus2) => {
  PromoterStatus2["ACTIVE"] = "active";
  PromoterStatus2["INACTIVE"] = "inactive";
  return PromoterStatus2;
})(PromoterStatus || {});
var PromoterApprovalMode = /* @__PURE__ */ ((PromoterApprovalMode2) => {
  PromoterApprovalMode2["AUTO"] = "auto";
  PromoterApprovalMode2["MANUAL"] = "manual";
  return PromoterApprovalMode2;
})(PromoterApprovalMode || {});
var PromotedListingStatus = /* @__PURE__ */ ((PromotedListingStatus2) => {
  PromotedListingStatus2["NEEDS_APPROVAL"] = "needs-approval";
  PromotedListingStatus2["NEEDS_PROVIDER_APPROVAL"] = "needs-provider-approval";
  PromotedListingStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  PromotedListingStatus2["APPROVED"] = "approved";
  PromotedListingStatus2["DECLINED"] = "declined";
  return PromotedListingStatus2;
})(PromotedListingStatus || {});
var PromoterAgreementStatus = /* @__PURE__ */ ((PromoterAgreementStatus2) => {
  PromoterAgreementStatus2["NEEDS_APPROVAL"] = "needs-approval";
  PromoterAgreementStatus2["NEEDS_PROVIDER_APPROVAL"] = "needs-provider-approval";
  PromoterAgreementStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  PromoterAgreementStatus2["APPROVED"] = "approved";
  PromoterAgreementStatus2["NEEDS_ORGANIZATION_APPROVAL"] = "needs-organization-approval";
  return PromoterAgreementStatus2;
})(PromoterAgreementStatus || {});
var ListingKind = /* @__PURE__ */ ((ListingKind2) => {
  ListingKind2["EXPERIENCE"] = "experience";
  ListingKind2["RESOURCE"] = "resource";
  ListingKind2["EVENT"] = "event";
  ListingKind2["AUCTION"] = "auction";
  return ListingKind2;
})(ListingKind || {});
var ListingVersion = /* @__PURE__ */ ((ListingVersion2) => {
  ListingVersion2["PUBLISHED"] = "published";
  ListingVersion2["LATEST"] = "latest";
  return ListingVersion2;
})(ListingVersion || {});
var ListingPictureSchema = ExperienceImageSizeMediaSchema.extend({
  kind: z.nativeEnum(ListingPictureKind)
});
var ResourceGroupSchema2 = ResourceGroupResponseSchema.extend({
  firstAvailableDate: FirstAvailableDateSchema.nullable()
});
var ListingTaxSchema = TaxSchema.and(z.object({ name: z.string() }));
var ListingSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  type: z.nativeEnum(ExperienceType).nullable(),
  partySize: z.number().nullable(),
  headline: z.string(),
  vibes: z.array(z.object({ id: z.string().uuid(), name: z.string() })),
  category: z.object({ id: z.string().uuid(), name: z.string() }).nullable(),
  coverPicture: ExperienceImageSizeMediaSchema.nullable(),
  firstAvailableDate: FirstAvailableDateSchema.nullable(),
  kind: z.nativeEnum(ListingKind),
  eventType: z.nativeEnum(ResourceGroupCollectionEventType).nullable(),
  productLine: z.nativeEnum(ProductLine),
  slug: z.string().nullable(),
  defaultPriceTiers: z.array(PriceTierSchema),
  conditionalPriceTiers: z.array(PriceTierSchema).nullable(),
  defaultMaxParticipantCount: z.number().nullable(),
  description: z.string(),
  location: ExperienceLocationWithTimezoneSchema,
  isBookable: z.boolean(),
  isUnlisted: z.boolean(),
  hostedBy: HostSchema.extend({
    profilePicture: UserImageSizeMediaSchema.nullable(),
    description: z.string().nullable()
  }).nullable(),
  isCurated: z.boolean(),
  isExclusive: z.boolean(),
  hidePrice: z.boolean(),
  bookingAvailabilityMode: z.nativeEnum(BookingAvailabilityModeValue).nullable(),
  descriptionPicture: ExperienceImageSizeMediaSchema.nullable(),
  paymentMethods: z.array(z.nativeEnum(PaymentMethods)).nullable(),
  taxes: z.array(ListingTaxSchema).nullable(),
  integrationMeta: z.array(IntegrationMetaSchema).nullable(),
  providedItems: z.array(z.string()).nullable(),
  reminder: z.string().nullable(),
  pictures: z.array(ListingPictureSchema),
  medias: z.array(
    MediaSchema.omit({
      kind: true
    }).extend({
      kind: z.nativeEnum(ListingPictureKind)
    })
  ),
  ratings: z.object({ rating: z.number().nullable(), recommendability: z.number().nullable(), total: z.number() }),
  minimumRequiredToBook: z.number().nonnegative().nullable(),
  maximumAllowedToBook: z.number().nonnegative().nullable(),
  externalField: ExternalFieldSchema.nullable(),
  map: ExperienceImageSizeMediaSchema.nullable(),
  resourceGroups: z.array(
    ResourceGroupSchema2.pick({
      id: true,
      title: true,
      firstAvailableDate: true,
      coverPicture: true,
      paymentMethods: true
    })
  ).nullable(),
  brandId: z.string().uuid(),
  listingId: z.string().uuid().nullable().optional(),
  isFeatured: z.boolean(),
  cancellationPolicyId: z.string().uuid().nullable(),
  reschedulePolicyId: z.string().uuid().nullable(),
  promotedListingId: z.string().uuid().nullable().optional(),
  promotedListingStatus: z.nativeEnum(PromotedListingStatus).nullable().optional(),
  providerBrandId: z.string().uuid().nullable().optional(),
  providerBrandName: z.string().nullable().optional(),
  auction: AuctionApiResponseSchema.nullable().optional(),
  customCallToAction: z.string().nullable()
});
var PublicListingSchema = ListingSchema.extend({
  agenda: z.string().nullable(),
  menu: z.string().nullable(),
  dates: z.array(DateStringSchema).nullable(),
  startTimes: z.array(TimeStringSchema).nullable(),
  supportedCurrencies: z.array(z.nativeEnum(Currency))
});
var PublicDetailedListingSchema = PublicListingSchema.extend({
  resourceGroups: z.array(
    ResourceGroupSchema2.extend({
      ratings: PublicListingSchema.shape.ratings,
      shouldValidateComplimentaryBooking: z.boolean(),
      addOns: z.array(PublicResponseListingAddOnSchema)
    })
  ).nullable(),
  auction: AuctionApiResponseSchema.nullable().optional(),
  shouldValidateComplimentaryBooking: z.boolean().nullable(),
  // Only available for experiences
  waitlistId: z.string().uuid().nullable(),
  addOns: z.array(PublicResponseListingAddOnSchema),
  customQuestions: z.array(CustomQuestionInResourcesSchema).nullable()
});
var PublicGetListingsQuerySchema = paginateQuerySchema({ sortBy: ["title", "kind", "date", "order"] }).omit({ q: true }).extend({
  categoryIds: z.array(z.string().uuid()).optional(),
  vibeIds: z.array(z.string().uuid()).optional(),
  kinds: z.array(z.nativeEnum(ListingKind)).optional(),
  brandIds: z.array(z.string().uuid()).optional(),
  search: z.string().optional(),
  isUnlisted: BooleanStringSchema.default("false"),
  version: z.nativeEnum(ListingVersion).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  featured: z.literal("true").optional(),
  bypassFirstAvailableDate: BooleanStringSchema.optional(),
  language: z.nativeEnum(LanguageCode).optional()
});
var PublicGetListingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/v1/listings?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: paginateResponseSchema(PublicListingSchema.strict()),
  querySchema: PublicGetListingsQuerySchema
});
var PublicGetListingQuerySchema = z.object({
  version: z.nativeEnum(ListingVersion).optional(),
  language: z.nativeEnum(LanguageCode).optional()
});
var PublicGetListingEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: PublicDetailedListingSchema.strict(),
  querySchema: PublicGetListingQuerySchema
});
var PublicGetListingIdForExperienceOrCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({ exchangeId }) => `/v1/listings/exchange-id/${exchangeId}`,
  requestSchema: z.void(),
  responseSchema: z.string()
});
var ListingStatus = /* @__PURE__ */ ((ListingStatus2) => {
  ListingStatus2["DRAFT"] = "draft";
  ListingStatus2["PENDING"] = "pending";
  ListingStatus2["PUBLISHED"] = "published";
  ListingStatus2["UNPUBLISHED"] = "unpublished";
  ListingStatus2["ARCHIVED"] = "archived";
  return ListingStatus2;
})(ListingStatus || {});
var InternalListingResourceGroupSchema = ResourceGroupSchema2.pick({
  id: true,
  title: true,
  order: true,
  firstAvailableDate: true,
  paymentMethods: true
}).extend({
  experienceIds: z.array(z.string().uuid()),
  coverPicture: ExperienceImageSizeMediaSchema.nullable(),
  pictures: z.array(ExperienceImageSizeMediaSchema).nullable().optional()
});
var InternalListingSchema = ListingSchema.extend({
  status: z.nativeEnum(ListingStatus),
  createdByAi: z.boolean(),
  headline: ListingSchema.shape.headline.nullable(),
  description: ListingSchema.shape.description.nullable(),
  isUnlisted: ListingSchema.shape.isUnlisted.nullable(),
  isExclusive: ListingSchema.shape.isExclusive.nullable(),
  resourceGroups: z.array(InternalListingResourceGroupSchema).nullable(),
  auction: AuctionApiResponseSchema.nullable().optional()
});
var ListingPromotedStatus = /* @__PURE__ */ ((ListingPromotedStatus2) => {
  ListingPromotedStatus2["ALL"] = "all";
  ListingPromotedStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  ListingPromotedStatus2["APPROVED"] = "approved";
  ListingPromotedStatus2["DECLINED"] = "declined";
  return ListingPromotedStatus2;
})(ListingPromotedStatus || {});
var InternalGetListingsQuerySchema = paginateQuerySchema({
  sortBy: ["title", "kind", "date", "status", "categoryName", "order"]
}).extend({
  filters: z.array(
    z.union([
      z.object({
        operator: z.literal("in"),
        name: z.literal("hostId"),
        value: z.array(z.string().uuid())
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("categoryId"),
        value: z.array(z.string().uuid())
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("kind"),
        value: z.array(z.nativeEnum(ListingKind))
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("productLine"),
        value: z.array(z.nativeEnum(ProductLine))
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("location"),
        value: z.array(z.string())
      }),
      z.object({
        operator: z.enum(["equals", "greater_than", "less_than"]),
        name: z.literal("price"),
        value: z.coerce.number()
      }),
      z.object({
        operator: z.literal("range"),
        name: z.literal("price"),
        value: z.object({ from: z.coerce.number(), to: z.coerce.number() })
      }),
      z.object({
        operator: z.literal("equals"),
        name: z.literal("isBookable"),
        value: BooleanStringSchema
      }),
      z.object({
        operator: z.literal("equals"),
        name: z.literal("paymentMethod"),
        value: z.nativeEnum(PaymentMethods)
      }),
      z.object({
        operator: z.literal("equals"),
        name: z.literal("isExclusive"),
        value: BooleanStringSchema
      }),
      z.object({
        operator: z.literal("in"),
        name: z.literal("status"),
        value: z.array(z.nativeEnum(ListingStatus))
      }),
      z.object({
        operator: z.literal("equals"),
        name: z.literal("createdByAi"),
        value: BooleanStringSchema
      }),
      z.object({
        operator: z.literal("equals"),
        name: z.literal("isUnlisted"),
        value: BooleanStringSchema
      })
    ])
  ).optional(),
  brandId: z.string().uuid().optional(),
  organizationId: z.string().uuid().optional(),
  listingId: z.string().uuid().optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  featured: z.literal("true").optional(),
  includePromotedListings: z.literal("true").optional(),
  promotedStatus: z.nativeEnum(ListingPromotedStatus).optional(),
  language: z.nativeEnum(LanguageCode).optional(),
  version: z.nativeEnum(ListingVersion).optional()
});
var InternalGetListingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/v1/listings?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: paginateResponseSchema(InternalListingSchema.strict()),
  querySchema: InternalGetListingsQuerySchema
});
var OrderListingsRequestSchema = z.object({
  listings: z.array(z.object({ id: z.string().uuid(), kind: z.nativeEnum(ListingKind) }))
});
var OrderListingsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/order-listings`,
  requestSchema: OrderListingsRequestSchema,
  responseSchema: z.void()
});
var InternalGetListingQuerySchema = z.object({
  version: z.nativeEnum(ListingVersion).optional(),
  brandId: z.string().uuid().optional(),
  organizationId: z.string().uuid().optional(),
  language: z.nativeEnum(LanguageCode).optional()
});
var InternalGetDetailedListingSchema = InternalListingSchema.omit({
  resourceGroups: true
}).extend({
  resourceGroups: z.array(
    InternalListingResourceGroupSchema.extend({
      addOns: z.array(ResponseListingAddOnSchema).optional()
    })
  ).nullable(),
  addOns: z.array(ResponseListingAddOnSchema).optional(),
  auction: AuctionApiResponseSchema.nullable().optional()
});
var InternalGetListingEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: InternalGetDetailedListingSchema.strict(),
  querySchema: InternalGetListingQuerySchema
});
var UpdateFeaturedListings = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/featured-listings`,
  requestSchema: z.object({ listings: z.array(z.object({ id: z.string().uuid(), order: z.number().int().nonnegative() })) }),
  responseSchema: z.void()
});
var GetOrganizationListingCustomFieldValuesSchema = z.object({
  customFieldId: z.string().uuid(),
  organizationId: z.string().uuid(),
  organizationName: z.string(),
  isRequired: z.boolean(),
  isDashboardEditable: z.boolean(),
  fieldName: z.string(),
  fieldType: z.string(),
  enumValues: z.array(z.string()),
  isMultiSelect: z.boolean(),
  defaultValues: z.array(z.string()),
  currentValues: z.array(z.string())
});
var GetOrganizationListingCustomFieldValuesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, listingId }) => `v1/brands/${brandId}/listings/${listingId}/organization-custom-fields`,
  responseSchema: z.object({ fields: z.array(GetOrganizationListingCustomFieldValuesSchema) }).strict(),
  requestSchema: z.void()
});
var PutOrganizationCustomFieldValuesRequestSchema = z.object({
  fields: z.array(
    z.object({
      customFieldId: z.string().uuid(),
      fieldType: z.string(),
      isMultiSelect: z.boolean(),
      fieldValues: z.array(z.string())
    })
  )
});
var PutOrganizationCustomFieldValuesEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, listingId }) => `/v1/brands/${brandId}/listings/${listingId}/organization-custom-fields`,
  requestSchema: PutOrganizationCustomFieldValuesRequestSchema,
  responseSchema: z.void()
});
var customField = z.object({
  externalId: z.string().nullable().optional(),
  name: z.string(),
  values: z.array(z.string().nullable())
});
var GetListingsV2ItemSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  description: z.string(),
  summary: z.string().nullable(),
  experienceId: z.string().uuid().nullable(),
  resourceGroupCollectionId: z.string().uuid().nullable(),
  kind: z.nativeEnum(ListingKind),
  productLine: z.nativeEnum(ProductLine),
  startingPrice: z.number().nullable(),
  pricePerType: z.string().nullable(),
  minParticipants: z.number().nullable(),
  maxParticipants: z.number().nullable(),
  coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
  brandId: z.string().uuid().nullable(),
  brandCurrency: z.string().nullable(),
  externalBrandReferenceId: z.string().nullable().optional(),
  location: ExperienceLocationWithTimezoneSchema.merge(
    z.object({ additionalInfo: z.string().nullable().optional() })
  ).nullable(),
  slug: z.string().nullable(),
  customFields: z.array(customField),
  rating: z.number().nullable(),
  categoryName: z.string().nullable(),
  dates: z.array(z.date()),
  hidePrice: z.boolean().nullable(),
  isUnlisted: z.boolean().nullable(),
  category: z.object({ id: z.string(), name: z.string() }).nullable(),
  vibes: z.array(z.object({ id: z.string(), name: z.string() })),
  bookingAvailabilityMode: z.nativeEnum(BookingAvailabilityModeValue).nullable(),
  isExclusive: z.boolean(),
  medias: z.array(MediaSchema.omit({ order: true }).required({ kind: true })),
  hostedById: z.string().nullable(),
  featuredOrder: z.number().nullable(),
  order: z.number().nullable(),
  createdAt: z.string().datetime().nullable(),
  publishedAt: z.string().datetime().nullable(),
  firstAvailableDate: z.date().nullable(),
  auction: AuctionSchema.nullable().optional(),
  customCallToAction: z.string().nullable()
});
var GetListingV2ResponseSchema = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid().nullable(),
  externalBrandReferenceId: z.string().nullable().optional(),
  categoryId: z.string().uuid().nullable(),
  locationId: z.string().uuid().nullable(),
  experienceId: z.string().uuid().nullable(),
  resourceGroupCollectionId: z.string().uuid().nullable(),
  kind: z.nativeEnum(ListingKind),
  productLine: z.nativeEnum(ProductLine),
  title: z.string().nullable(),
  description: z.string().nullable(),
  startingPrice: z.number().nullable(),
  pricePerType: z.string().nullable(),
  minParticipants: z.number().nullable(),
  maxParticipants: z.number().nullable(),
  status: z.nativeEnum(ListingStatus).nullable(),
  summary: z.string().nullable(),
  mediaIds: z.array(z.string().uuid()),
  vibeIds: z.array(z.string().uuid()),
  startTimes: z.array(z.string()).nullable(),
  cancellationPolicyId: z.string().uuid().nullable(),
  reschedulePolicyId: z.string().uuid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  auction: AuctionSchema.nullable().optional()
});
var listingsV2SortByOptions = [
  "startingPrice",
  "rating",
  "order",
  "featuredOrder",
  "firstAvailableDate",
  "createdAt",
  "publishedAt",
  "timeLeft"
];
var listingsV2Filters = {
  isUnlisted: BooleanStringSchema.default("false"),
  kinds: z.array(z.nativeEnum(ListingKind)).optional(),
  productLines: z.array(z.nativeEnum(ProductLine)).optional(),
  categories: z.array(z.string()).optional(),
  participantCount: z.coerce.number().optional(),
  customFields: z.array(z.object({ externalId: z.string(), value: z.string() })).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  excludePromotedListings: z.literal("true").optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
  vibeIds: z.array(z.string().uuid()).optional(),
  language: z.nativeEnum(LanguageCode).optional(),
  featured: z.literal("true").optional()
};
var GetListingsV2QuerySchema = paginateQuerySchema({
  sortBy: listingsV2SortByOptions
}).omit({ filters: true }).extend(listingsV2Filters);
var GetListingsV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v2/listings?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(GetListingsV2ItemSchema),
  requestSchema: z.void(),
  querySchema: GetListingsV2QuerySchema
});
var GetListingV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId }) => `v2/listings/${listingId}`,
  responseSchema: GetListingV2ResponseSchema,
  requestSchema: z.void()
});
var FeaturedListSchema = z.object({
  listingBrandId: z.string().uuid(),
  listingId: z.string().uuid(),
  listingTitle: z.string(),
  order: z.number().int().nonnegative()
});
var GetFeaturedListResponseSchema = z.array(FeaturedListSchema);
var GetFeaturedListEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `/v1/featured-list/brands/${brandId}`,
  responseSchema: GetFeaturedListResponseSchema,
  requestSchema: z.void()
});
var FavoriteListSchema = z.object({
  listingUserId: z.string().uuid(),
  listingId: z.string().uuid(),
  order: z.coerce.number().int().nonnegative(),
  title: z.string().nullable(),
  brandId: z.string().uuid().nullable(),
  experienceId: z.string().uuid().nullable(),
  resourceGroupCollectionId: z.string().uuid().nullable()
});
var GetFavoriteListResponseSchema = z.array(FavoriteListSchema);
var GetFavoriteListEndpoint = makeEndpoint({
  method: "GET",
  url: ({ userId, brandId }) => `/v1/favorite-list/users/${userId}/${brandId}`,
  responseSchema: GetFavoriteListResponseSchema,
  requestSchema: z.void()
});
var SetFeaturedListRequestSchema = z.array(
  z.object({
    listingId: z.string().uuid(),
    order: z.number().int().nonnegative()
  })
);
var AddRemoveFeaturedListResponseSchema = z.object({
  totalFeaturedCount: z.number().int().nonnegative()
});
var SetFeaturedListEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/featured-list/brands/${brandId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: SetFeaturedListRequestSchema
});
var SetFavoriteListRequestSchema = z.array(
  z.object({
    listingId: z.string().uuid(),
    order: z.number().int().nonnegative()
  })
);
var AddRemoveFavoriteListResponseSchema = z.object({
  totalFavoriteCount: z.number().int().nonnegative()
});
var SetFavoriteListEndpoint = makeEndpoint({
  method: "POST",
  url: ({ userId }) => `/v1/favorite-list/users/${userId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: SetFavoriteListRequestSchema
});
var AddToFeaturedListEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, listingId }) => `/v1/featured-list/brands/${brandId}/listings/${listingId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: z.void()
});
var AddToFavoriteListEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ userId, listingId }) => `/v1/favorite-list/users/${userId}/listings/${listingId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: z.void()
});
var DeleteFromFeaturedListEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, listingId }) => `/v1/featured-list/brands/${brandId}/listings/${listingId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: z.void()
});
var DeleteFromFavoriteListEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ userId, listingId }) => `/v1/favorite-list/users/${userId}/listings/${listingId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: z.void()
});
var GetListingTranslationsQuerySchema = z.object({
  language: z.nativeEnum(LanguageCode).optional()
});
var GetListingTranslationsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/i18n?${buildQueryString(query)}`,
  responseSchema: z.object({
    translations: z.array(TranslationSchema)
  }),
  requestSchema: z.void(),
  querySchema: GetListingTranslationsQuerySchema
});
var PatchListingTranslationsRequestSchema = z.object({
  translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchListingTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ listingId }) => `/v1/listings/${listingId}/i18n`,
  responseSchema: z.void(),
  requestSchema: PatchListingTranslationsRequestSchema
});
var ResourceGroupCollectionKind = /* @__PURE__ */ ((ResourceGroupCollectionKind2) => {
  ResourceGroupCollectionKind2["EVENT"] = "event";
  ResourceGroupCollectionKind2["RESERVE"] = "reserve";
  return ResourceGroupCollectionKind2;
})(ResourceGroupCollectionKind || {});
var ResourceGroupCollectionStatus = /* @__PURE__ */ ((ResourceGroupCollectionStatus2) => {
  ResourceGroupCollectionStatus2["PUBLISHED"] = "published";
  ResourceGroupCollectionStatus2["UNPUBLISHED"] = "unpublished";
  ResourceGroupCollectionStatus2["ARCHIVED"] = "archived";
  ResourceGroupCollectionStatus2["DRAFT"] = "draft";
  return ResourceGroupCollectionStatus2;
})(ResourceGroupCollectionStatus || {});
var ResourceGroupCollectionSchema = z.object({
  id: z.string().uuid(),
  order: z.number().finite().nullable(),
  brandId: z.string().uuid(),
  status: z.nativeEnum(ResourceGroupCollectionStatus),
  version: z.nativeEnum(ExperienceVersion),
  map: ExperienceImageSizeMediaSchema.nullable(),
  location: ExperienceLocationSchema,
  category: z.object({ id: z.string().uuid(), name: z.string() }),
  categoryId: z.string().uuid(),
  vibes: z.array(z.object({ id: z.string().uuid(), name: z.string(), order: z.number().nullable() })).min(1).max(3, { message: "A collection can have a maximum of 3 vibes" }),
  vibeIds: z.array(z.string().uuid()).min(1).max(3),
  isMapShown: z.boolean(),
  kind: z.nativeEnum(ResourceGroupCollectionKind).default(
    "reserve"
    /* RESERVE */
  ),
  // TODO : remove the default value
  mapId: z.string().uuid().nullable(),
  pictureIds: z.array(z.string().uuid()).max(7),
  pictures: z.array(ListingPictureSchema),
  name: z.string().trim().nonempty(),
  summary: z.string().nullable(),
  details: z.string().nullable(),
  agenda: z.string().nullable().optional(),
  reminders: z.string().nullable().optional(),
  menu: z.string().nullable().optional(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  publishedAt: z.string().datetime().nullable(),
  archivedAt: z.string().datetime().nullable(),
  dates: z.array(DateStringSchema).nullable().optional(),
  startTimes: z.array(TimeStringSchema).nullable().optional(),
  waitlistId: z.string().uuid().nullable(),
  eventType: z.nativeEnum(ResourceGroupCollectionEventType).nullable(),
  cancellationPolicyId: z.string().uuid().nullable(),
  auction: AuctionResponse.nullable().optional(),
  reschedulePolicyId: z.string().uuid().nullable(),
  isUnlisted: z.boolean().default(false),
  customCallToAction: z.string().nullable()
});
var ResourceGroupCollectionResponseSchema = ResourceGroupCollectionSchema.omit({
  mapId: true,
  pictureIds: true,
  categoryId: true,
  vibeIds: true,
  location: true
}).extend({
  vibes: ResourceGroupCollectionSchema.shape.vibes.min(0),
  location: ExperienceLocationWithTimezoneSchema,
  medias: z.array(
    MediaSchema.omit({
      kind: true
    }).extend({
      kind: z.nativeEnum(ListingPictureKind)
    })
  ).optional()
});
var PostResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/resource-group-collections`,
  requestSchema: ResourceGroupCollectionSchema.pick({
    order: true,
    location: true,
    categoryId: true,
    vibeIds: true,
    isMapShown: true,
    pictureIds: true,
    mapId: true,
    name: true,
    kind: true,
    summary: true,
    details: true,
    agenda: true,
    reminders: true,
    menu: true,
    dates: true,
    startTimes: true,
    eventType: true,
    cancellationPolicyId: true,
    reschedulePolicyId: true,
    isUnlisted: true,
    customCallToAction: true
  }).partial({ eventType: true, medias: true, pictureIds: true, cancellationPolicyId: true, reschedulePolicyId: true }).extend({
    medias: z.array(
      MediaSchema.omit({
        kind: true
      }).extend({
        kind: z.nativeEnum(ListingPictureKind)
      })
    ).refine(
      (medias) => {
        const [covers, gallery] = (0, import_lodash2.partition)(
          medias,
          (picture) => picture.kind === "cover"
          /* COVER */
        );
        return covers.length <= 3 && gallery.length <= 8;
      },
      {
        message: "At most 3 cover medias and 8 gallery medias"
      }
    ).optional(),
    pictures: z.array(
      z.object({
        id: z.string().uuid(),
        kind: z.nativeEnum(ListingPictureKind).optional()
      })
    ).refine(
      (pictures) => {
        const [covers, gallery] = (0, import_lodash2.partition)(
          pictures,
          (picture) => picture.kind === "cover"
          /* COVER */
        );
        return covers.length <= 3 && gallery.length <= 8;
      },
      {
        message: "At most 3 cover pictures and 8 gallery pictures"
      }
    ).optional()
  }).strict(),
  responseSchema: ResourceGroupCollectionResponseSchema
});
var GetResourceGroupCollectionsQuerySchema = paginateQuerySchema().merge(
  z.object({
    filters: z.array(
      z.object({
        operator: z.literal("equals"),
        name: z.literal("status"),
        value: z.nativeEnum(ExperienceVersion)
      })
    ).optional()
  })
);
var GetResourceGroupCollectionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, page, limit }) => `/v1/brands/${brandId}/resource-group-collections?page=${page}&limit=${limit}`,
  requestSchema: z.void(),
  responseSchema: paginateResponseSchema(ResourceGroupCollectionResponseSchema).strict()
});
var GetResourceGroupCollectionQuerySchema = z.object({
  version: z.nativeEnum(ExperienceVersion).default(
    "latest"
    /* LATEST */
  ),
  language: z.nativeEnum(LanguageCode).optional()
});
var DetailedResourceGroupCollectionSchema = ResourceGroupCollectionResponseSchema.extend({
  status: z.nativeEnum(ResourceGroupCollectionStatus)
});
var GetResourceGroupCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: DetailedResourceGroupCollectionSchema,
  querySchema: GetResourceGroupCollectionQuerySchema
});
var PatchResourceGroupCollectionRequestSchema = PostResourceGroupCollectionEndpoint.requestSchema.omit({ eventType: true }).extend({ archived: z.boolean() }).partial().strict();
var PatchResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}`,
  requestSchema: PatchResourceGroupCollectionRequestSchema,
  responseSchema: ResourceGroupCollectionResponseSchema.strict()
});
var ArchiveResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/archive`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var UnarchiveResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/unarchive`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var DeleteResourceGroupCollectionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var PublishResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/publish`,
  requestSchema: z.void(),
  responseSchema: ResourceGroupCollectionResponseSchema.strict()
});
var UnpublishResourceGroupCollectionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/publish`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var DateQuerySchema = z.object({
  eventDate: DateStringSchema,
  eventTime: TimeStringSchema.optional()
});
var QRCodeScanPayloadSchema = z.object({
  qrCodePayload: z.string()
});
var ParticipantScanResponse = z.object({
  participantName: z.string(),
  ticketNumber: z.string(),
  priceLabel: z.string(),
  confirmationCode: z.string(),
  eventDate: DateStringSchema,
  eventTime: TimeStringSchema
});
var CollectionEventParticipantScanEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/participants/scan?${buildQueryString(
    query
  )}`,
  requestSchema: QRCodeScanPayloadSchema,
  responseSchema: ParticipantScanResponse,
  querySchema: DateQuerySchema
});
var CloneResourceGroupCollectionResponseSchema = z.object({ resourceGroupCollectionId: z.string().uuid() });
var CloneResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/clone`,
  requestSchema: z.void(),
  responseSchema: CloneResourceGroupCollectionResponseSchema
});
var GetTranslationsForResourceGroupCollectionQuerySchema = z.object({
  language: z.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForResourceGroupCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    version,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/version/${version}/i18n?${buildQueryString(
    query
  )}`,
  responseSchema: z.object({
    translations: z.object({
      resourceGroupCollection: z.array(TranslationWithIdSchema),
      listingAddOns: z.array(TranslationWithIdSchema),
      cancellationPolicy: z.array(TranslationWithIdSchema),
      reschedulePolicy: z.array(TranslationWithIdSchema),
      location: z.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForResourceGroupCollectionQuerySchema
});
var PatchTranslationsForResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    version
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/version/${version}/i18n`,
  responseSchema: z.void(),
  requestSchema: z.object({
    translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
  })
});
var ReorderResourceGroupsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/reorder`,
  requestSchema: z.object({
    resourceGroups: z.array(
      z.object({
        id: z.string().uuid(),
        version: z.nativeEnum(ExperienceVersion),
        order: z.number().int()
      })
    ).min(1)
  }),
  responseSchema: z.void()
});
var SessionStatus = /* @__PURE__ */ ((SessionStatus2) => {
  SessionStatus2["OPEN"] = "OPEN";
  SessionStatus2["OVERLAPPED"] = "OVERLAPPED";
  SessionStatus2["CONFIRMED"] = "CONFIRMED";
  SessionStatus2["WAITLISTED"] = "WAITLISTED";
  SessionStatus2["OVERLAPPED_BY_WAITLIST"] = "OVERLAPPED_BY_WAITLIST";
  return SessionStatus2;
})(SessionStatus || {});
var GetSessionsQuerySchema = z.object({
  experienceId: z.string().uuid().optional(),
  resourceGroupCollectionId: z.string().uuid().optional(),
  resourceGroupId: z.string().uuid().optional(),
  filters: FiltersSchema.optional(),
  mode: z.nativeEnum(BookingMode).optional(),
  version: z.nativeEnum(ExperienceVersion).optional(),
  hostId: z.string().uuid().optional(),
  q: z.string().optional(),
  includesAllConfirmedEvents: BooleanStringSchema.optional()
});
var SessionBookingParticipantSchema = BaseParticipantSchema.extend({
  id: z.string(),
  cancelledAt: z.string().datetime().nullable(),
  ticketNumber: z.string().nullable(),
  isCheckedIn: z.boolean(),
  priceTierId: z.string().optional()
});
var SessionBookingParticipantsSchema = z.array(SessionBookingParticipantSchema);
var SessionBookingsSchema = z.array(
  z.object({
    id: z.string(),
    mode: z.nativeEnum(BookingMode),
    purchaser: PurchaserSchema,
    participants: SessionBookingParticipantsSchema
  })
);
var GetSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      sessionId: z.string().uuid().nullable(),
      scheduleId: z.string().uuid().nullable(),
      isRepeating: z.boolean(),
      isPrivateEvent: z.boolean(),
      priceTiers: z.array(PriceTierSchema),
      startDateTime: LocalDateTimeStringSchema,
      sessionDuration: z.number().int().positive(),
      purchaserName: z.string().optional(),
      participantCount: z.number().int().nonnegative(),
      isFullyCheckedIn: z.boolean(),
      capacity: z.number().nullable(),
      // open experiences do not have a capacity
      experienceId: z.string().uuid(),
      status: z.nativeEnum(SessionStatus),
      hostedBy: HostSchema.nullable(),
      isBookableViaNegativeCutOffHours: z.boolean()
    })
  ),
  experiences: z.array(ExperienceSchema),
  resourceGroupCollections: z.array(
    ResourceGroupCollectionResponseSchema.extend({
      resourceGroups: z.array(ResourceGroupResponseSchema)
    })
  )
});
var GetSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    from,
    to,
    query
  }) => `/v2/brands/${brandId}/sessions/${from}/${to}?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetSessionsResponseSchema,
  querySchema: GetSessionsQuerySchema
});
var GetMineSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    from,
    to,
    query
  }) => `/v2/brands/${brandId}/sessions/mine/${from}/${to}?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetSessionsResponseSchema,
  querySchema: GetSessionsQuerySchema
});
var UpdateSessionRequestSchema = z.object({
  eventCapacity: z.array(
    z.object({
      startDateTime: LocalDateTimeStringSchema,
      // should not be optional once the dashboard has been updated
      sessionDuration: z.number().int().positive().optional(),
      maxQuantity: z.number().int().nonnegative()
    })
  ).min(1)
});
var UpdateSessionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ scheduleId }) => `/v1/schedule/${scheduleId}/update-session`,
  requestSchema: UpdateSessionRequestSchema,
  responseSchema: z.void()
});
var RemoveManySessionsRequestSchema = z.object({
  from: DateStringSchema,
  to: DateStringSchema.optional(),
  sessions: z.array(
    z.object({
      experienceId: z.string().uuid(),
      duration: z.number(),
      startTime: TimeStringSchema
    })
  )
});
var RemoveManySessionsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/remove-many-sessions`,
  requestSchema: RemoveManySessionsRequestSchema,
  responseSchema: z.void()
});
var RemoveSessionRequestSchema = z.object({
  startTimes: z.array(LocalDateTimeStringSchema).min(1).max(500),
  scheduleIds: z.array(z.string().uuid()).optional(),
  from: DateStringSchema.optional(),
  to: DateStringSchema.optional(),
  sessionDuration: z.number().optional()
});
var RemoveSessionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ experienceId }) => `/v1/experiences/${experienceId}/remove-sessions`,
  requestSchema: RemoveSessionRequestSchema,
  responseSchema: z.void()
});
var GetConfirmedSessionsQuerySchema = paginateQuerySchema().omit({ filters: true, sortDir: true, sortBy: true }).extend({
  startDate: DateStringSchema.optional(),
  endDate: DateStringSchema.optional(),
  experienceId: z.string().uuid().optional(),
  resourceGroupCollectionId: z.string().uuid().optional(),
  hostId: z.string().uuid().optional()
});
var ConfirmedSessionsCollectionsSchema = ResourceGroupCollectionSchema.pick({
  id: true,
  name: true,
  kind: true,
  eventType: true
});
var ConfirmedSessionSchema = z.object({
  eventId: z.string().uuid(),
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z.number(),
  participantsCount: z.number(),
  isPrivate: z.boolean(),
  experience: z.object({
    id: z.string().uuid(),
    title: z.string(),
    hostName: z.string().nullable(),
    location: ExperienceLocationWithTimezoneSchema,
    maxParticipantsCount: z.number(),
    isBookable: z.boolean(),
    resourceGroupId: z.string().uuid().nullable(),
    kind: z.nativeEnum(ExperienceKind),
    resourceGroupCollectionId: z.string().uuid().nullable()
  }),
  collection: ConfirmedSessionsCollectionsSchema.nullable(),
  eventCapacity: z.object({ maxQuantity: z.number() }).nullable()
});
var GetConfirmedSessionsResponseSchema = paginateResponseSchema(ConfirmedSessionSchema);
var GetConfirmedSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/confirmed-sessions?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetConfirmedSessionsResponseSchema,
  querySchema: GetConfirmedSessionsQuerySchema
});
var GetMineConfirmedSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/confirmed-sessions/mine?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetConfirmedSessionsResponseSchema,
  querySchema: GetConfirmedSessionsQuerySchema
});
var ReschedulePolicySchema = z.object({
  id: z.string().uuid(),
  active: z.boolean(),
  cutoffValue: z.number().min(0),
  cutoffUnit: z.nativeEnum(ReschedulePolicyCutoffUnit),
  notes: z.string().nonempty()
});
var CreateReschedulePolicyRequestSchema = ReschedulePolicySchema.omit({ id: true });
var CreateReschedulePolicyResponseSchema = ReschedulePolicySchema.pick({ id: true });
var GetReschedulePolicyResponseSchema = ReschedulePolicySchema;
var ReschedulableStatus = /* @__PURE__ */ ((ReschedulableStatus2) => {
  ReschedulableStatus2["ALLOWED"] = "ALLOWED";
  ReschedulableStatus2["NOT_ALLOWED"] = "NOT_ALLOWED";
  return ReschedulableStatus2;
})(ReschedulableStatus || {});
var ReschedulableBookingSchema = z.object({
  bookingId: z.string().uuid(),
  coverMedia: z.any(),
  customerId: z.string().uuid(),
  experienceTitle: z.string().nullable(),
  eventStartDateTime: z.date(),
  eventSessionDuration: z.any(),
  eventSessionDurationInMinutes: z.number(),
  experienceTimeZoneId: z.string().nullable(),
  experienceMediaIds: z.array(z.string().uuid()),
  reschedulePolicyId: z.string().uuid().nullable(),
  reschedulePolicyNotes: z.string().nullable(),
  reschedulePolicyActive: z.boolean().nullable(),
  reschedulePolicyCutoffUnit: z.nativeEnum(ReschedulePolicyCutoffUnit).nullable(),
  reschedulePolicyCutoffValue: z.number().nullable(),
  status: z.nativeEnum(ReschedulableStatus)
});
var ReschedulableBookingsSchema = z.array(ReschedulableBookingSchema).describe("List of reschedulable bookings");
var GetBookingsForGuestRescheduleResponseSchema = z.array(ReschedulableBookingSchema).describe("List the bookings associated to a cart id for guest cancellation.");
var GetBookingsForGuestRescheduleQuerySchema = z.object({
  token: z.string().nonempty(),
  languageCode: z.string().optional()
});
var GetBookingsForGuestRescheduleEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    cartId,
    query
  }) => `v1/brands/${brandId}/carts/${cartId}/guest-reschedule?${buildQueryString(query)}`,
  querySchema: GetBookingsForGuestRescheduleQuerySchema,
  requestSchema: z.void(),
  responseSchema: GetBookingsForGuestRescheduleResponseSchema
});
var CreateReschedulePolicyEndpoint = makeEndpoint({
  title: "New reschedule policy",
  description: "Create a new reschedule policy for a brand.",
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/reschedule-policies`,
  requestSchema: CreateReschedulePolicyRequestSchema,
  responseSchema: CreateReschedulePolicyResponseSchema
});
var GetReschedulePolicyEndpoint = makeEndpoint({
  method: "GET",
  description: "Get a reschedule policy by ID.",
  url: ({ brandId, reschedulePolicyId }) => `v1/brands/${brandId}/reschedule-policies/${reschedulePolicyId}`,
  requestSchema: z.void(),
  responseSchema: GetReschedulePolicyResponseSchema
});
var GetSessionsToRescheduleQuerySchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  allowOverbooking: z.string().optional()
});
var SessionsToReschedule = z.array(
  z.object({
    sessionId: z.string().uuid().nullable(),
    scheduleId: z.string().uuid().nullable(),
    isRepeating: z.boolean(),
    isPrivateEvent: z.boolean(),
    priceTiers: z.array(PriceTierSchema),
    startDateTime: LocalDateTimeStringSchema,
    sessionDuration: z.number().int().positive(),
    purchaserName: z.string().optional(),
    participantCount: z.number().int().nonnegative(),
    isFullyCheckedIn: z.boolean(),
    capacity: z.number().nullable(),
    // open experiences do not have a capacity
    experienceId: z.string().uuid(),
    overlappedEvent: z.boolean().optional(),
    status: z.nativeEnum(SessionStatus),
    hostedBy: HostSchema.nullable(),
    isBookableViaNegativeCutOffHours: z.boolean()
  })
);
var GetSessionsToRescheduleResourceGroupCollection = ResourceGroupCollectionResponseSchema.extend({
  resourceGroups: z.array(ResourceGroupResponseSchema)
});
var GetSessionsToRescheduleResponseSchema = z.object({
  sessions: SessionsToReschedule,
  experiences: z.array(ExperienceSchema),
  experienceId: z.string().uuid(),
  // The ID of the experience used to query sessions
  resourceGroupCollections: z.array(GetSessionsToRescheduleResourceGroupCollection)
});
var GetSessionsToRescheduleEndpoint = makeEndpoint({
  title: "All sessions to reschedule a booking",
  description: "It returns all the sessions that are eligible for a rebook scenario.",
  method: "GET",
  url: ({ bookingId, query }) => `v1/bookings/${bookingId}/sessions-to-reschedule?${buildQueryString(query)}`,
  querySchema: GetSessionsToRescheduleQuerySchema,
  requestSchema: z.void(),
  responseSchema: GetSessionsToRescheduleResponseSchema
});
var BaseCreditCodeSchema = z.object({
  id: z.string().uuid()
});
var CreateCreditCodeRequestSchema = z.object({
  code: z.string(),
  externalTransactionId: z.string().nullable(),
  description: z.string().nullable(),
  cardPurchaseTransactionId: z.string().nullable(),
  redeemableByEmailAddress: z.string(),
  isRedeemableByAnyUser: z.boolean().default(false),
  redeemableOnOrganizations: z.array(z.string()).nullable(),
  redeemableOnBrands: z.array(z.string()).nullable(),
  originalValue: z.number().default(0),
  expiresAt: z.string().datetime().nullable()
});
var SearchCreditCodeRequestSchema = z.object({
  code: z.string()
});
var CreditCodeHistorySchema = z.object({
  id: z.string().uuid(),
  userId: z.string().uuid(),
  redeemedOn: z.string().datetime(),
  redeemedAmount: z.number(),
  beforeValue: z.number(),
  afterValue: z.number(),
  cartId: z.string().uuid()
});
var CreditCodeHistoriesSchema = z.object({
  histories: z.array(CreditCodeHistorySchema).nullable()
});
var GetCreditCodeResponseSchema = BaseCreditCodeSchema.merge(CreateCreditCodeRequestSchema);
var CreditCodeRedeemRefundRequestSchema = z.object({
  code: z.string(),
  userEmail: z.string().nullable(),
  transactionAmount: z.number().positive(),
  cartId: z.string().uuid()
});
var ValidateListingsRequestSchema = z.object({
  listingIds: z.array(z.string().uuid())
});
var ValidateListingsResponseSchema = z.object({
  validListingIds: z.array(z.string().uuid()).nullable(),
  invalidListingIds: z.array(z.string().uuid()).nullable()
});
var CreateCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: CreateCreditCodeRequestSchema
});
var GetCreditCodeEndpoint = makeEndpoint({
  method: "GET",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: z.void()
});
var GeneralSearchCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes/search`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: SearchCreditCodeRequestSchema
});
var RedeemCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/redeem`,
  responseSchema: z.object({
    redemptionCode: z.string().uuid()
    // Id of the credit code history object
  }),
  requestSchema: CreditCodeRedeemRefundRequestSchema
});
var RefundCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/refund`,
  responseSchema: z.object({
    redemptionCode: z.string().uuid()
    // Id of the credit code history object
  }),
  requestSchema: CreditCodeRedeemRefundRequestSchema
});
var DeleteCreditCodeEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var GetCreditCodeHistoriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/histories`,
  responseSchema: CreditCodeHistoriesSchema,
  requestSchema: z.void()
});
var ValidateListingsEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes/validate-listings`,
  responseSchema: ValidateListingsResponseSchema,
  requestSchema: ValidateListingsRequestSchema
});
var FromCurrency = /* @__PURE__ */ ((FromCurrency2) => {
  FromCurrency2["AED"] = "AED";
  FromCurrency2["ALL"] = "ALL";
  FromCurrency2["AMD"] = "AMD";
  FromCurrency2["AOA"] = "AOA";
  FromCurrency2["ARS"] = "ARS";
  FromCurrency2["AUD"] = "AUD";
  FromCurrency2["AZN"] = "AZN";
  FromCurrency2["BAM"] = "BAM";
  FromCurrency2["BDT"] = "BDT";
  FromCurrency2["BGN"] = "BGN";
  FromCurrency2["BHD"] = "BHD";
  FromCurrency2["BND"] = "BND";
  FromCurrency2["BOB"] = "BOB";
  FromCurrency2["BRL"] = "BRL";
  FromCurrency2["BSD"] = "BSD";
  FromCurrency2["BTN"] = "BTN";
  FromCurrency2["BWP"] = "BWP";
  FromCurrency2["CAD"] = "CAD";
  FromCurrency2["CHF"] = "CHF";
  FromCurrency2["CLP"] = "CLP";
  FromCurrency2["COP"] = "COP";
  FromCurrency2["CRC"] = "CRC";
  FromCurrency2["CZK"] = "CZK";
  FromCurrency2["DKK"] = "DKK";
  FromCurrency2["DOP"] = "DOP";
  FromCurrency2["DZD"] = "DZD";
  FromCurrency2["EGP"] = "EGP";
  FromCurrency2["ETB"] = "ETB";
  FromCurrency2["EUR"] = "EUR";
  FromCurrency2["GBP"] = "GBP";
  FromCurrency2["GHS"] = "GHS";
  FromCurrency2["GMD"] = "GMD";
  FromCurrency2["GTQ"] = "GTQ";
  FromCurrency2["GYD"] = "GYD";
  FromCurrency2["HKD"] = "HKD";
  FromCurrency2["HUF"] = "HUF";
  FromCurrency2["IDR"] = "IDR";
  FromCurrency2["ILS"] = "ILS";
  FromCurrency2["INR"] = "INR";
  FromCurrency2["JMD"] = "JMD";
  FromCurrency2["JOD"] = "JOD";
  FromCurrency2["JPY"] = "JPY";
  FromCurrency2["KES"] = "KES";
  FromCurrency2["KHR"] = "KHR";
  FromCurrency2["KRW"] = "KRW";
  FromCurrency2["KWD"] = "KWD";
  FromCurrency2["KZT"] = "KZT";
  FromCurrency2["LAK"] = "LAK";
  FromCurrency2["LKR"] = "LKR";
  FromCurrency2["MAD"] = "MAD";
  FromCurrency2["MDL"] = "MDL";
  FromCurrency2["MGA"] = "MGA";
  FromCurrency2["MKD"] = "MKD";
  FromCurrency2["MNT"] = "MNT";
  FromCurrency2["MOP"] = "MOP";
  FromCurrency2["MUR"] = "MUR";
  FromCurrency2["MXN"] = "MXN";
  FromCurrency2["MYR"] = "MYR";
  FromCurrency2["MZN"] = "MZN";
  FromCurrency2["NAD"] = "NAD";
  FromCurrency2["NGN"] = "NGN";
  FromCurrency2["NOK"] = "NOK";
  FromCurrency2["NZD"] = "NZD";
  FromCurrency2["OMR"] = "OMR";
  FromCurrency2["PEN"] = "PEN";
  FromCurrency2["PHP"] = "PHP";
  FromCurrency2["PKR"] = "PKR";
  FromCurrency2["PLN"] = "PLN";
  FromCurrency2["PYG"] = "PYG";
  FromCurrency2["QAR"] = "QAR";
  FromCurrency2["RON"] = "RON";
  FromCurrency2["RSD"] = "RSD";
  FromCurrency2["RWF"] = "RWF";
  FromCurrency2["SAR"] = "SAR";
  FromCurrency2["SEK"] = "SEK";
  FromCurrency2["SGD"] = "SGD";
  FromCurrency2["THB"] = "THB";
  FromCurrency2["TND"] = "TND";
  FromCurrency2["TRY"] = "TRY";
  FromCurrency2["TTD"] = "TTD";
  FromCurrency2["TWD"] = "TWD";
  FromCurrency2["TZS"] = "TZS";
  FromCurrency2["UYU"] = "UYU";
  FromCurrency2["UZS"] = "UZS";
  FromCurrency2["VND"] = "VND";
  FromCurrency2["XAF"] = "XAF";
  FromCurrency2["XCD"] = "XCD";
  FromCurrency2["XOF"] = "XOF";
  FromCurrency2["ZAR"] = "ZAR";
  return FromCurrency2;
})(FromCurrency || {});
var ToCurrency = /* @__PURE__ */ ((ToCurrency2) => {
  ToCurrency2["USD"] = "USD";
  return ToCurrency2;
})(ToCurrency || {});
var PostCurrencyRatesEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/currency-conversion-rates",
  requestSchema: z.void(),
  responseSchema: z.void()
});
var GetConvertedCurrencyQuerySchema = z.object({
  fromCurrency: z.union([z.nativeEnum(FromCurrency), z.nativeEnum(ToCurrency)]),
  toCurrency: z.union([z.nativeEnum(FromCurrency), z.nativeEnum(ToCurrency)]),
  amount: z.coerce.number()
});
var GetConvertedCurrencyResponseSchema = z.object({
  convertedAmount: z.number()
});
var GetConvertedCurrencyEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/convert-currency?${buildQueryString(query)}`,
  requestSchema: z.void(),
  querySchema: GetConvertedCurrencyQuerySchema,
  responseSchema: GetConvertedCurrencyResponseSchema
});
var EventParticipantsResponse = z.object({
  items: z.array(BookingWithParticipantSchema)
});
var GetParticipantsForCollectionWebsocketSchema = z.object({
  collectionId: z.string().uuid(),
  eventDate: DateStringSchema,
  brandId: z.string().uuid()
});
var GetCollectionEventParticipantsQuerySchema = z.object({
  eventDate: DateStringSchema,
  brandId: z.string().uuid(),
  q: z.string().optional()
});
var GetEventParticipantsQuerySchema = z.object({
  q: z.string().optional()
});
var GetCollectionEventParticipantsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    collectionId,
    query
  }) => `/v1/collection/${collectionId}/participants?${buildQueryString(query)}`,
  responseSchema: EventParticipantsResponse,
  requestSchema: z.void(),
  querySchema: GetCollectionEventParticipantsQuerySchema
});
var GetEventParticipantsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ eventId, ...query }) => {
    const entries = Object.entries(query).filter((keyValue) => keyValue[1] !== void 0);
    return `events/${eventId}/participants?${new URLSearchParams(Object.fromEntries(entries)).toString()}`;
  },
  responseSchema: EventParticipantsResponse,
  requestSchema: z.void()
});
var ParticipantsCheckInSchema = z.object({
  items: z.array(BookingWithParticipantSchema)
});
var PostParticipantsCheckInEndpoint = makeEndpoint({
  method: "POST",
  url: ({ eventId }) => `v1/events/${eventId}/participants/check-in`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z.object({
    participantIds: z.array(z.string())
  })
});
var PostParticipantsCheckOutEndpoint = makeEndpoint({
  method: "POST",
  url: ({ eventId }) => `v1/events/${eventId}/participants/check-out`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z.object({
    participantIds: z.array(z.string())
  })
});
var CreateSchedulesRequestSchema = z.object({
  id: z.string().uuid().optional(),
  startDate: DateStringSchema,
  startTimes: z.array(TimeStringSchema).min(1),
  recurrencePattern: z.object({
    weekdays: z.array(z.number().min(1).max(7)),
    until: DateStringSchema.nullable()
  }).optional(),
  sessionDuration: z.number().int().min(1).optional(),
  experienceIds: z.array(z.string().uuid()).min(1),
  durations: z.array(
    z.object({
      experienceId: z.string().uuid(),
      sessionDuration: z.number().int().min(1)
    })
  ).optional()
});
var CreateSchedulesEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v2/schedules",
  responseSchema: z.void(),
  requestSchema: CreateSchedulesRequestSchema.strict()
});
var GetSchedulesForExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: () => "/v2/experiences/:experienceId/schedules",
  responseSchema: z.void(),
  requestSchema: z.void()
});
var UpdateScheduleEndpoint = makeEndpoint({
  method: "PATCH",
  url: () => "/v2/schedules/:scheduleId",
  responseSchema: z.void(),
  requestSchema: z.object({
    status: z.enum(["scheduled", "cancelled"])
  })
});
var GetExperienceResourceGroupCollectionIdEndpointSchema = z.object({
  resourceGroupCollectionId: z.string().uuid()
});
var GetExperienceResourceGroupCollectionIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ experienceId }) => `/v1/experiences/${experienceId}/resource-group-collection-id`,
  requestSchema: z.void(),
  responseSchema: GetExperienceResourceGroupCollectionIdEndpointSchema
});
var IntegrationAddOnSchema = z.object({
  code: z.string(),
  available: z.boolean(),
  description: z.string(),
  name: z.string().optional()
});
var IntegrationAddOnsResponseSchema = z.object({
  items: z.array(IntegrationAddOnSchema)
});
var integrationPrefix = (brandId) => integrationUrl({
  brandId,
  integrationType: "integrations:alice"
  /* ALICE */
});
var SendBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `${integrationPrefix(brandId)}/send-booking`,
  requestSchema: z.object({
    reservationId: z.string(),
    bookingId: z.string().uuid()
  }),
  responseSchema: z.void()
});
var AliceCredentialSchema = z.object({
  hotelId: z.string()
});
var getAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }) => `${integrationPrefix(brandId)}/credential`,
  method: "GET",
  responseSchema: AliceCredentialSchema,
  requestSchema: z.void()
});
var postAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }) => `${integrationPrefix(brandId)}/credential`,
  method: "POST",
  responseSchema: z.void(),
  requestSchema: AliceCredentialSchema
});
var ANALYTICS_EVENT = /* @__PURE__ */ ((ANALYTICS_EVENT2) => {
  ANALYTICS_EVENT2["VIEW_HOME"] = "view_home";
  ANALYTICS_EVENT2["VIEW_COLLECTION"] = "view_collection";
  ANALYTICS_EVENT2["VIEW_HOSTS"] = "view_hosts";
  ANALYTICS_EVENT2["VIEW_EVENTS"] = "view_activates";
  ANALYTICS_EVENT2["VIEW_ACTIVITIES"] = "view_activities";
  ANALYTICS_EVENT2["VIEW_ADDONS"] = "view_addons";
  ANALYTICS_EVENT2["CLICK_EXPERIENCE"] = "click_experience";
  ANALYTICS_EVENT2["VIEW_CALENDAR"] = "view_calendar";
  ANALYTICS_EVENT2["VIEW_EXPERIENCE_DETAIL"] = "view_experience_detail";
  ANALYTICS_EVENT2["RESERVABLE_EXPERIENCE_CLICK_BOOK_BUTTON"] = "reservable_experience_click_book_button";
  ANALYTICS_EVENT2["OPEN_EXPERIENCE_CLICK_BOOK_BUTTON"] = "open_experience_click_book_button";
  ANALYTICS_EVENT2["VIEW_PARTICIPANT_INFO"] = "view_participant_info";
  ANALYTICS_EVENT2["CLICK_ADD_TO_CART_BUTTON"] = "click_add_to_cart_button";
  ANALYTICS_EVENT2["CLICK_PROCEED_TO_CHECKOUT_BUTTON"] = "click_proceed_to_checkout_button";
  ANALYTICS_EVENT2["VIEW_CHECKOUT"] = "view_checkout";
  ANALYTICS_EVENT2["VIEW_BOOKING_CONFIRMATION"] = "view_booking_confirmation";
  ANALYTICS_EVENT2["CLICK_COMPLETE_PAYMENT_BUTTON"] = "click_complete_payment_button";
  return ANALYTICS_EVENT2;
})(ANALYTICS_EVENT || {});
var AnalyticsEventConfigurationSchema = z.object({
  enabled: z.boolean(),
  property_mapping: z.record(z.string())
});
var AnalyticsConfigurationSchema = z.object({
  defaultTracking: z.boolean().optional(),
  initializeSdk: z.boolean().optional(),
  globalVariables: z.record(z.unknown()),
  events: z.record(AnalyticsEventConfigurationSchema)
});
var publicIntegrationConfigUrl = ({ brandId }) => `v1/brands/${brandId}/integrations/analytics`;
var TealiumCredentialSchema = z.object({
  profile: z.string(),
  account: z.string(),
  environment: z.string()
});
var AnalyticsConfigEndpoint = makeEndpoint({
  method: "GET",
  url: publicIntegrationConfigUrl,
  responseSchema: IntegrationConfigResponseSchema,
  requestSchema: z.void()
});
var AnalyticsEventRequestSchema = z.object({
  providers: z.array(z.enum(Integrations[
    "analytics"
    /* ANALYTICS */
  ])).optional(),
  event: z.nativeEnum(ANALYTICS_EVENT),
  payload: z.record(z.string())
});
var AnalyticsEventSchema = AnalyticsEventRequestSchema.extend({
  brandId: z.string().uuid()
});
var AnalyticsEventEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/analytics/event`,
  responseSchema: z.void(),
  requestSchema: AnalyticsEventRequestSchema
});
var GetAnalyticsIntegrationConfigEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, integrationType }) => `${integrationUrl({ brandId, integrationType })}/config`,
  responseSchema: AnalyticsConfigurationSchema,
  requestSchema: z.void()
});
var GetAnalyticsIntegrationCredentialEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, integrationType }) => `${integrationUrl({ brandId, integrationType })}/credential`,
  responseSchema: TealiumCredentialSchema,
  requestSchema: z.void()
});
var GtmIntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true
}).extend({
  defaultTracking: z.boolean()
});
var Ga4IntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true
}).extend({
  enabled: z.boolean()
});
var GetGtmIntegrationConfigEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `${integrationUrl({
    brandId,
    integrationType: "integrations:gtmAnalytics"
    /* GTM_ANALYTICS */
  })}/config`,
  responseSchema: GtmIntegrationConfigResponse,
  requestSchema: z.void()
});
var GetIntegrationGuestRequestQuerySchema = z.object({
  firstName: z.string(),
  lastName: z.string(),
  reservationId: z.string(),
  emailAddress: z.string(),
  phoneNumber: z.string(),
  arrivalDate: z.string(),
  departureDate: z.string(),
  roomNumber: z.string()
}).partial().strict();
var GetIntegrationGuestResponseSchema = z.object({
  data: z.array(
    z.object({
      reservationId: z.string(),
      confirmationId: z.string(),
      arrivalDate: z.string(),
      departureDate: z.string(),
      status: z.string(),
      firstName: z.string().optional(),
      lastName: z.string().optional(),
      email: z.string().optional(),
      phoneNumber: z.string().optional(),
      roomNumber: z.string().optional()
    })
  )
});
var OperaHotelDetailsSchema = z.object({
  region: z.string(),
  tenantCode: z.string(),
  hotelId: z.string(),
  ssdUrl: z.string()
});
var OperaResourceBasedCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z.literal(
    "resource-based"
    /* RESOURCE_BASED */
  ).default(
    "resource-based"
    /* RESOURCE_BASED */
  ),
  appKey: z.string(),
  host: z.string(),
  clientId: z.string(),
  clientSecret: z.string(),
  extSystemCode: z.string(),
  username: z.string(),
  password: z.string()
});
var OperaClientCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z.literal(
    "client-credentials"
    /* CLIENT_CREDENTIALS */
  ),
  appKey: z.string(),
  host: z.string(),
  clientId: z.string(),
  clientSecret: z.string(),
  extSystemCode: z.string(),
  enterpriseId: z.string()
});
var OperaCredentialsSchema = z.union([OperaResourceBasedCredentialsSchema, OperaClientCredentialsSchema]);
var ResponseListingIncludedSchema = z.object({
  id: z.string().uuid(),
  includedLabel: z.string(),
  order: z.number().nullable()
});
var GetListingIncludedQuerySchema = z.object({
  experienceId: z.string().uuid(),
  resourceGroupCollectionId: z.string().uuid(),
  resourceGroupId: z.string().uuid(),
  version: z.nativeEnum(ExperienceVersion)
}).partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true }).strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var GetListingIncludedEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/listing-included?${buildQueryString(query)}`,
  responseSchema: z.object({ included: z.array(ResponseListingIncludedSchema) }).strict(),
  requestSchema: z.void(),
  querySchema: GetListingIncludedQuerySchema
});
var PostListingIncludedRequestSchema = z.object({
  includedLabel: z.string(),
  experienceId: z.string().uuid(),
  resourceGroupCollectionId: z.string().uuid(),
  resourceGroupId: z.string().uuid(),
  order: z.number().nullable(),
  version: z.nativeEnum(ExperienceVersion)
}).partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true }).strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var PostListingIncludedEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/listing-included`,
  responseSchema: z.void(),
  requestSchema: PostListingIncludedRequestSchema,
  querySchema: z.void()
});
var GetListingRevenueResponseSchema = z.object({
  priceTiers: z.array(
    z.object({
      priceTierId: z.string().nullable(),
      priceTierName: z.string(),
      revenue: z.number(),
      participantCount: z.number()
    })
  ),
  totalCapacity: z.number()
});
var GetListingRevenueQuerySchema = z.object({
  date: DateStringSchema,
  startTime: TimeStringSchema.optional(),
  sessionDuration: z.string().pipe(z.coerce.number().positive()).optional()
  // minutes
});
var GetListingRevenueEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/revenue?${buildQueryString(query)}`,
  requestSchema: z.void(),
  responseSchema: GetListingRevenueResponseSchema,
  querySchema: GetListingRevenueQuerySchema
});
var PublicGetListingSessionsQuerySchema = z.object({
  from: DateStringSchema,
  to: DateStringSchema,
  resourceGroupId: z.string().uuid().optional(),
  experienceId: z.string().uuid().optional(),
  version: z.nativeEnum(ListingVersion).optional(),
  includeEventsAfterBookingDeadline: z.literal("true").optional(),
  waitlistEntryId: z.string().uuid().optional()
});
var PublicGetListingSessionsResponseSchema = z.object({
  sessions: z.array(
    z.object({
      sessionId: z.string().uuid().nullable(),
      scheduleId: z.string().uuid().nullable(),
      isRepeating: z.boolean(),
      isPrivateEvent: z.boolean(),
      priceTiers: z.array(PriceTierSchema.required({ maxQuantity: true }).extend({ participantsCount: z.number().min(0) })),
      startDateTime: LocalDateTimeStringSchema,
      duration: z.number().int().positive(),
      participantCount: z.number().int().nonnegative(),
      capacity: z.number().nullable(),
      // open experiences do not have a capacity
      experienceId: z.string().uuid(),
      status: z.nativeEnum(SessionStatus),
      hostedBy: HostSchema.nullable()
    })
  )
});
var PublicGetListingSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/sessions?${buildQueryString(query)}`,
  responseSchema: PublicGetListingSessionsResponseSchema,
  requestSchema: z.void(),
  querySchema: PublicGetListingSessionsQuerySchema
});
var CreateSignedUrlsEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v1/media/signed-urls",
  requestSchema: z.object({
    fileNames: z.array(z.string())
  }),
  responseSchema: z.array(
    z.object({
      mediaId: z.string().uuid(),
      signedUrl: z.string()
    })
  )
});
var ProcessVideosEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v1/media/videos/process",
  requestSchema: z.object({
    mediaIds: z.array(z.string().uuid())
  }),
  responseSchema: z.void()
});
var UploadDocumentEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/documents`,
  responseSchema: DocumentSchema,
  requestSchema: UploadDocumentRequestSchema
});
var GetDocumentsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/documents?${buildQueryString(query)}`,
  responseSchema: GetDocumentsResponseSchema,
  requestSchema: z.void(),
  querySchema: GetDocumentsQuerySchema
});
var GetDocumentSignedUrlEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}/signed-url`,
  responseSchema: GetDocumentSignedUrlResponseSchema,
  requestSchema: z.void()
});
var UpdateDocumentEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: DocumentSchema,
  requestSchema: UpdateDocumentRequestSchema
});
var DeleteDocumentEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var Metric = /* @__PURE__ */ ((Metric2) => {
  Metric2["CART_COUNT"] = "cart_count";
  Metric2["NET_AMOUNT"] = "net_amount";
  Metric2["TOTAL_PAID"] = "total_paid";
  Metric2["NET_REVENUE"] = "net_revenue";
  Metric2["ALL"] = "all";
  return Metric2;
})(Metric || {});
var requestSchema = z.object({
  start_datetime: z.string(),
  end_datetime: z.string(),
  metric: z.nativeEnum(Metric),
  property_code: z.string().optional(),
  confirmation_code: z.string().optional()
}).refine((data) => new Date(data.end_datetime) >= new Date(data.start_datetime), {
  message: "end_datetime must be after or equal to start_datetime",
  path: ["end_datetime"]
});
var sharedResponseSchema = z.object({
  brandIds: z.number(),
  propertyCode: z.string().nullable()
});
var responseSchema = z.union([
  sharedResponseSchema.merge(
    z.object({ metric: z.literal(
      "cart_count"
      /* CART_COUNT */
    ), results: z.object({ confirmationCodesCount: z.number() }) })
  ),
  sharedResponseSchema.merge(
    z.object({ metric: z.literal(
      "net_amount"
      /* NET_AMOUNT */
    ), results: z.object({ netAmount: z.number() }) })
  ),
  sharedResponseSchema.merge(
    z.object({ metric: z.literal(
      "total_paid"
      /* TOTAL_PAID */
    ), results: z.object({ totalPaid: z.number() }) })
  ),
  sharedResponseSchema.merge(
    z.object({ metric: z.literal(
      "net_revenue"
      /* NET_REVENUE */
    ), results: z.object({ netRevenue: z.number() }) })
  ),
  sharedResponseSchema.merge(
    z.object({
      metric: z.literal(
        "all"
        /* ALL */
      ),
      results: z.object({
        confirmationCodesCount: z.number(),
        total: z.number(),
        discountAmount: z.number(),
        subtotal: z.number(),
        taxesNotIncludedInPrice: z.number(),
        taxesIncludedInPrice: z.number(),
        totalPaid: z.number(),
        hostPayout: z.number(),
        creditCardFee: z.number(),
        netDeposited: z.number(),
        grossAmount: z.number(),
        grossRevenue: z.number(),
        netAmount: z.number(),
        netRevenue: z.number()
      })
    })
  )
]);
var GetMetricsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/metrics?${buildQueryString(query)}`,
  responseSchema,
  requestSchema
});
var OrganizationRole = /* @__PURE__ */ ((OrganizationRole2) => {
  OrganizationRole2["ADMIN"] = "admin";
  return OrganizationRole2;
})(OrganizationRole || {});
var OrganizationSchema = z.object({
  id: z.string().uuid(),
  name: z.string().trim().min(1, "Name is required"),
  segment: z.string().nullable(),
  parentOrganizationId: z.string().uuid("Invalid organization id supplied as parent organization").nullable().optional()
});
var OrganizationTreeSchema = OrganizationSchema.extend({
  brandCount: z.number().optional(),
  userCount: z.number().optional(),
  userPermissions: z.array(z.string()).optional(),
  childOrganizations: z.lazy(() => OrganizationTreeSchema.array())
});
var OrganizationDetailResponseSchema = OrganizationSchema.pick({
  id: true,
  name: true,
  segment: true,
  parentOrganizationId: true
}).extend({
  products: z.array(z.nativeEnum(ProductLine)).nullable(),
  userPermissions: z.array(z.string()),
  parentOrganizationName: z.string().nullable(),
  childrenOrganizations: OrganizationTreeSchema.array().optional(),
  isTopLevel: z.boolean().optional(),
  createdById: z.string().uuid().nullable(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  deletedAt: z.string().datetime().nullable()
});
var CreateOrganizationSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
});
var CreateOrganizationFormSchema = OrganizationSchema.pick({
  name: true,
  parentOrganizationId: true
}).extend({
  segment: z.array(z.string().nullable())
});
var UpdateOrganizationSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
}).partial().strict();
var UpdateOrganizationFormSchema = OrganizationSchema.pick({
  name: true,
  parentOrganizationId: true
}).extend({
  segment: z.array(z.string().nullable())
}).partial().strict();
var OrganizationPaginatedResponseSchema = paginateResponseSchema(
  OrganizationSchema.pick({
    id: true,
    name: true,
    segment: true,
    parentOrganizationId: true
  }).extend({
    products: z.array(z.nativeEnum(ProductLine)).nullable(),
    brandCount: z.number(),
    userCount: z.number(),
    userPermissions: z.array(z.string()).optional(),
    childOrganizations: OrganizationTreeSchema.array()
  })
).strict();
var OrganizationTreeResponseSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
}).extend({
  childOrganizations: OrganizationTreeSchema.array().optional()
});
var MinimalOrganizationListResponseSchema = z.array(
  OrganizationSchema.pick({
    id: true,
    name: true,
    segment: true,
    parentOrganizationId: true
  }).extend({
    childOrganizations: OrganizationTreeSchema.array()
  })
);
var OrganizationSortBy = /* @__PURE__ */ ((OrganizationSortBy2) => {
  OrganizationSortBy2["NAME"] = "name";
  OrganizationSortBy2["CREATED_AT"] = "createdAt";
  return OrganizationSortBy2;
})(OrganizationSortBy || {});
var PaginatedOrganizationsRequestQuerySchema = z.object({
  q: z.string().optional(),
  parentOrganizationId: z.string().uuid().optional(),
  subOrganizations: z.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  page: z.coerce.number().min(1).default(1),
  limit: z.coerce.number().min(1).default(10),
  sortBy: z.nativeEnum(OrganizationSortBy).optional(),
  sortDir: z.nativeEnum(SortOrder).optional()
}).strict();
var MinimalOrganizationListRequestQuerySchema = PaginatedOrganizationsRequestQuerySchema.pick({
  q: true,
  parentOrganizationId: true,
  subOrganizations: true
});
var BooleanQuerySchema = BooleanStringSchema.transform((str) => str.toLowerCase() === "true");
var OrganizationsDetailRequestQuerySchema = z.object({
  showChildren: BooleanQuerySchema.optional(),
  showIsTopLevel: BooleanQuerySchema.optional()
}).strict();
var OrganizationFeatureFlagsResponseSchema = z.object({
  [
    "apiAccess"
    /* API_ACCESS */
  ]: z.boolean()
});
var AssignBrandToOrganizationSchema = z.object({
  brandIds: z.array(z.string().uuid()).min(1)
}).strict();
var AssignBrandToOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/brands`,
  responseSchema: z.void(),
  requestSchema: AssignBrandToOrganizationSchema
});
var RemoveBrandFromOrganizationEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId, brandId }) => `v1/organizations/${organizationId}/brands/${brandId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var AssignOrganizationToAnotherOrganizationSchema = z.object({
  organizationId: z.string().uuid()
}).strict();
var AssignOrganizationToAnotherOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/organizations`,
  responseSchema: z.void(),
  requestSchema: AssignOrganizationToAnotherOrganizationSchema
});
var PaginatedOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations`,
  responseSchema: OrganizationPaginatedResponseSchema,
  requestSchema: PaginatedOrganizationsRequestQuerySchema
});
var PaginatedMinimalOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/minimal`,
  responseSchema: MinimalOrganizationListResponseSchema,
  requestSchema: MinimalOrganizationListRequestQuerySchema
});
var GetOrganizationEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: OrganizationDetailResponseSchema,
  requestSchema: OrganizationsDetailRequestQuerySchema
});
var CreateOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/organizations`,
  responseSchema: z.void(),
  requestSchema: CreateOrganizationSchema
});
var UpdateOrganizationEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: z.void(),
  requestSchema: UpdateOrganizationSchema
});
var DeleteOrganizationEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var MinimalOrganizationListEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/minimal`,
  responseSchema: MinimalOrganizationListResponseSchema,
  requestSchema: MinimalOrganizationListRequestQuerySchema
});
var BrandsDashboardStatsResponseSchema = z.object({
  totalBookingAmount: z.number(),
  averageBookingAmount: z.number(),
  averageBookingWindowInMinutes: z.number(),
  totalParticipantCount: z.number(),
  averageParticipantCount: z.number(),
  averageRating: z.number().nullable(),
  netPromoterScore: z.number().nullable(),
  netProfit: z.number(),
  totalHostEarning: z.number(),
  totalEarned: z.number(),
  futurePayout: z.number()
});
var BrandsReviewSummaryResponseSchema = paginateResponseSchema(
  z.object({
    host: MinimalHostSchema.optional(),
    brand: BrandSchema.pick({ id: true, name: true }).extend({ logo: IMediaReferenceSchema.nullable() }).optional(),
    experience: z.object({ id: z.string(), title: z.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
    resourceGroup: z.object({ id: z.string(), title: z.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
    totalReviews: z.number(),
    averageRating: z.number(),
    npsScore: z.number().nullable(),
    reviewPercentage: z.number()
  })
).strict();
var OrganizationFeatureFlagsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/features`,
  responseSchema: OrganizationFeatureFlagsResponseSchema,
  requestSchema: z.void()
});
var NestedOrganizationMembershipsOfUserResponseSchema = z.object({
  id: z.string(),
  membershipOrganizationId: z.string(),
  permissions: z.array(z.string())
});
var GetNestedOrganizationMembershipsOfUserResponseSchemaEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/me/memberships`,
  responseSchema: z.array(NestedOrganizationMembershipsOfUserResponseSchema),
  requestSchema: z.void()
});
var GetOrganizationPromoterBrandsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/promoter-brands`,
  responseSchema: z.array(BrandSchema),
  requestSchema: z.void()
});
var UpdatePromoterAgreementApprovalResponseSchema = z.object({
  id: z.string().uuid()
});
var UpdatePromoterAgreementApprovalSchema = z.object({
  status: z.nativeEnum(PromoterAgreementStatus),
  updatedByUserId: z.string().uuid()
});
var UpdatePromoterAgreementApprovalEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId, agreementId }) => `v1/organizations/${organizationId}/promoter-agreement/${agreementId}/update-approval`,
  responseSchema: UpdatePromoterAgreementApprovalResponseSchema,
  requestSchema: UpdatePromoterAgreementApprovalSchema
});
var GetActiveOrganizationAgreementEndpointResponseSchema = z.array(
  z.object({
    id: z.string().uuid()
  })
);
var GetActiveOrganizationAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId, promoterId }) => `v1/organizations/${organizationId}/promoters/${promoterId}/promoter-agreement`,
  responseSchema: GetActiveOrganizationAgreementEndpointResponseSchema,
  requestSchema: z.void()
});
var OrganizationUserStatus = /* @__PURE__ */ ((OrganizationUserStatus2) => {
  OrganizationUserStatus2["ACTIVE"] = "active";
  OrganizationUserStatus2["INVITED"] = "invited";
  return OrganizationUserStatus2;
})(OrganizationUserStatus || {});
var OrganizationUserFilterQuery = /* @__PURE__ */ ((OrganizationUserFilterQuery2) => {
  OrganizationUserFilterQuery2["ORGANIZATION_ADMIN"] = "orgAdmin";
  OrganizationUserFilterQuery2["ALL"] = "all";
  return OrganizationUserFilterQuery2;
})(OrganizationUserFilterQuery || {});
var OrganizationUserStatusesSchema = z.nativeEnum(OrganizationUserStatus);
var OrganizationUserRolesSchema = z.nativeEnum(OrganizationRole);
var OrganizationUserSchema = z.object({
  profilePicture: z.object({
    id: z.string(),
    uri: z.object({ original: z.string() }).and(z.record(z.string()))
  }).nullable(),
  firstName: z.string(),
  lastName: z.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z.string().nullable(),
  role: OrganizationUserRolesSchema,
  title: z.string().nullable(),
  status: OrganizationUserStatusesSchema,
  permissions: z.array(z.nativeEnum(PERMISSION)),
  products: z.array(z.nativeEnum(ProductLine)).nullable(),
  id: z.string().uuid()
});
var OrganizationPaginatedUserSchema = OrganizationUserSchema.pick({
  profilePicture: true,
  firstName: true,
  lastName: true,
  emailAddress: true,
  phoneNumber: true,
  title: true,
  status: true,
  permissions: true,
  products: true,
  id: true
}).extend({
  role: z.union([OrganizationUserRolesSchema, BrandMembershipRolesSchema]),
  isOrganizationUser: z.boolean().optional(),
  lastAccessedAt: z.string().nullable().optional(),
  associatedOrgIds: z.array(z.string()).optional(),
  associatedBrandIds: z.array(z.string()).optional()
});
var PaginatedOrganizationUsersResponseSchema = paginateResponseSchema(OrganizationPaginatedUserSchema);
var PaginatedOrganizationUsersRequestQuerySchema = paginateQuerySchema({
  sortBy: ["firstName", "lastName", "role", "status"]
}).extend({ role: z.nativeEnum(OrganizationUserFilterQuery) });
var CreateOrganizationUserRequestSchema = OrganizationUserSchema.pick({
  emailAddress: true,
  firstName: true,
  lastName: true,
  permissions: true,
  products: true
}).partial({ products: true });
var UpdateOrganizationUsersRequestSchema = OrganizationUserSchema.pick({
  emailAddress: true,
  firstName: true,
  lastName: true,
  role: true,
  permissions: true,
  products: true
}).partial();
var GetOrganizationUsersEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/users`,
  responseSchema: PaginatedOrganizationUsersResponseSchema,
  requestSchema: PaginatedOrganizationUsersRequestQuerySchema
});
var AddOrganizationUserEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/users`,
  responseSchema: z.void(),
  requestSchema: CreateOrganizationUserRequestSchema
});
var UpdateOrganizationUserEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/users/${userId}`,
  responseSchema: z.void(),
  requestSchema: UpdateOrganizationUsersRequestSchema
});
var DeleteOrganizationAdminEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/users/${userId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var ResendOrganizationUserInviteEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/members/${userId}/resend-invitation`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var FindPromoterResponseSchema = z.object({
  id: z.string().uuid(),
  brandId: z.string().uuid(),
  status: z.nativeEnum(PromoterStatus),
  name: z.string(),
  description: z.string(),
  experienceUrl: z.string().nullable(),
  approvalMode: z.nativeEnum(PromoterApprovalMode),
  defaultPercentCommission: z.number().lte(1).nullable(),
  defaultFlatCommission: z.number().nullable(),
  updatedByUserId: z.string().uuid().nullable()
});
var FindPromoterEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId }) => `v1/promoters/${promoterId}`,
  responseSchema: FindPromoterResponseSchema,
  requestSchema: z.void()
});
var FindApprovedPromotersByBrandResponseSchema = z.array(
  z.object({
    id: z.string().uuid(),
    brandId: z.string().uuid(),
    status: z.nativeEnum(PromoterStatus),
    name: z.string(),
    description: z.string()
  })
);
var FindApprovedPromotersByBrandEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/promoters/approved-promoters-by-brand/${brandId}`,
  responseSchema: FindApprovedPromotersByBrandResponseSchema,
  requestSchema: z.void()
});
var UpdateProviderListingStatusSchema = z.object({
  promoterId: z.string().uuid(),
  isApproved: z.boolean(),
  providerUserId: z.string().uuid()
});
var UpdateProviderListingStatusEndpoint = makeEndpoint({
  method: "POST",
  url: ({ providerBrandId, listingId }) => `v1/providers/${providerBrandId}/listings/${listingId}/update-approval`,
  responseSchema: z.void(),
  requestSchema: UpdateProviderListingStatusSchema
});
var UpdatePromoterListingStatusSchema = z.object({
  isApproved: z.boolean(),
  promoterUserId: z.string().uuid()
});
var UpdatePromoterListingStatusEndpoint = makeEndpoint({
  method: "POST",
  url: ({ promoterId, promotedListingId }) => `v1/promoters/${promoterId}/promoted-listings/${promotedListingId}/update-approval`,
  responseSchema: z.void(),
  requestSchema: UpdatePromoterListingStatusSchema
});
var FindApprovedPromotedIdsByBrandSchema = z.object({
  promoterId: z.string().uuid().nullable(),
  promoterBrandId: z.string().nullable(),
  promotedListingId: z.string().uuid().nullable(),
  listingId: z.string().uuid().nullable()
});
var FindApprovedPromotedIdsByBrandEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/providers/${brandId}/promoter-ids`,
  responseSchema: z.array(FindApprovedPromotedIdsByBrandSchema),
  requestSchema: z.void()
});
var FindActivePromoterAgreementSchema = z.object({
  id: z.string().uuid(),
  promoterId: z.string().uuid(),
  promoterName: z.string(),
  promoterDescription: z.string(),
  promoterBrandId: z.string().uuid(),
  isPublicChannel: z.boolean(),
  status: z.nativeEnum(PromoterAgreementStatus),
  providerOrganizationId: z.string().uuid().nullable(),
  providerBrandId: z.string().uuid().nullable(),
  providerListingId: z.string().uuid().nullable(),
  percentCommission: z.number().nullable(),
  flatCommission: z.number().nullable(),
  currency: z.string().nullable(),
  agreementStartDate: z.date().nullable(),
  agreementEndDate: z.date().nullable()
});
var FindActivePromoterAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, promoterId }) => `v1/providers/${brandId}/promoters/${promoterId}/agreement`,
  responseSchema: FindActivePromoterAgreementSchema.nullable(),
  requestSchema: z.void()
});
var FindActivePromoterAgreementsSchema = z.array(FindActivePromoterAgreementSchema);
var FindActivePromoterAgreementsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/providers/${brandId}/promoter-agreements`,
  responseSchema: FindActivePromoterAgreementsSchema,
  requestSchema: z.void()
});
var GetListingsForPromoterQuerySchema = paginateQuerySchema({
  sortBy: ["startingPrice", "rating", "order", "featuredOrder", "firstAvailableDate", "createdAt", "publishedAt"]
}).omit({ filters: true }).extend({
  kinds: z.array(z.nativeEnum(ListingKind)).optional(),
  productLines: z.array(z.nativeEnum(ProductLine)).optional(),
  categories: z.array(z.string()).optional(),
  isUnlisted: BooleanStringSchema.optional(),
  participantCount: z.coerce.number().optional(),
  customFields: z.array(z.object({ externalId: z.string(), value: z.string() })).optional(),
  from: z.string().optional(),
  to: z.string().optional(),
  language: z.nativeEnum(LanguageCode).optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
  vibeIds: z.array(z.string().uuid()).optional(),
  featured: z.literal("true").optional()
});
var customField2 = z.object({
  externalId: z.string().nullable().optional(),
  name: z.string(),
  values: z.array(z.string().nullable())
});
var GetListingsForPromoterResponseSchema = z.object({
  id: z.string().uuid(),
  title: z.string(),
  description: z.string(),
  summary: z.string().nullable(),
  experienceId: z.string().uuid().nullable(),
  resourceGroupCollectionId: z.string().uuid().nullable(),
  kind: z.nativeEnum(ListingKind),
  productLine: z.nativeEnum(ProductLine),
  startingPrice: z.number().nullable(),
  pricePerType: z.string().nullable(),
  minParticipants: z.number().nullable(),
  maxParticipants: z.number().nullable(),
  coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
  brandId: z.string().uuid().nullable(),
  brandCurrency: z.string().nullable(),
  externalBrandReferenceId: z.string().nullable().optional(),
  location: ExperienceLocationWithTimezoneSchema.merge(
    z.object({ additionalInfo: z.string().nullable().optional() })
  ).nullable(),
  slug: z.string().nullable(),
  customFields: z.array(customField2).optional(),
  rating: z.number().nullable(),
  categoryName: z.string().nullable(),
  dates: z.array(z.date()).nullable(),
  hidePrice: z.boolean().nullable(),
  isUnlisted: z.boolean().nullable(),
  bookingAvailabilityMode: z.nativeEnum(BookingAvailabilityModeValue).nullable(),
  isExclusive: z.boolean(),
  category: z.object({ id: z.string(), name: z.string() }).nullable(),
  vibes: z.array(z.object({ id: z.string(), name: z.string() })),
  medias: z.array(MediaSchema.omit({ order: true }).required({ kind: true })),
  hostedById: z.string().nullable(),
  featuredOrder: z.number().nullable(),
  order: z.number().nullable(),
  createdAt: z.string().datetime().nullable(),
  publishedAt: z.string().datetime().nullable(),
  firstAvailableDate: z.date().nullable()
});
var GetListingsForPromoterEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId, query }) => `v1/promoters/${promoterId}/listings?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(GetListingsForPromoterResponseSchema),
  requestSchema: z.void(),
  querySchema: GetListingsForPromoterQuerySchema
});
var ProviderListingStatusSchema = z.array(
  z.object({
    promoterId: z.string().uuid(),
    promoterName: z.string(),
    promoterDescription: z.string(),
    promoterBrandId: z.string().uuid(),
    promoterLogoUri: z.string().nullable(),
    percentCommission: z.number(),
    promotedListingId: z.string().uuid().nullable().optional(),
    listingId: z.string().uuid().nullable().optional(),
    status: z.nativeEnum(PromotedListingStatus).nullable().optional()
  })
);
var GetProviderListingStatusEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, listingId }) => `v1/providers/${brandId}/listings/${listingId}/status`,
  responseSchema: ProviderListingStatusSchema,
  requestSchema: z.void()
});
var promoterListingStatusObject = z.object({
  listingId: z.string().uuid(),
  providerBrandId: z.string().uuid(),
  promotedListingId: z.string().uuid(),
  promotedListingStatus: z.nativeEnum(PromotedListingStatus)
});
var promoterListingStatusResponse = z.array(promoterListingStatusObject);
var GetPromoterListingStatusEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId }) => `v1/promoters/${promoterId}/listing-status`,
  responseSchema: promoterListingStatusResponse,
  requestSchema: z.void()
});
var GetListingCountByPromoterCustomFieldResponseSchema = z.object({
  items: z.array(
    z.object({
      fieldValues: z.array(z.string()),
      count: z.number()
    })
  ),
  totalItems: z.number()
});
var GetListingCountByPromoterCustomFieldEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId, externalId }) => `/v1/promoters/${promoterId}/promoter-custom-fields/count-by-custom-field/${externalId}`,
  requestSchema: z.void(),
  responseSchema: GetListingCountByPromoterCustomFieldResponseSchema
});
var GetListingCountByOrganizationCustomFieldResponseSchema = z.object({
  items: z.array(
    z.object({
      value: z.string(),
      count: z.number()
    })
  ),
  totalItems: z.number()
});
var GetListingCountByOrganizationCustomFieldEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, externalId }) => `/v1/promoters/${brandId}/organization-custom-fields/count-by-custom-field/${externalId}`,
  requestSchema: z.void(),
  responseSchema: GetListingCountByOrganizationCustomFieldResponseSchema
});
var CreatePromoterSchema = z.object({
  brandId: z.string().uuid(),
  name: z.string(),
  description: z.string(),
  experienceUrl: z.string().optional(),
  defaultPercentCommission: z.number(),
  updatedByUserId: z.string().uuid()
});
var CreatePromoterEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/promoters/`,
  responseSchema: z.string().uuid(),
  requestSchema: CreatePromoterSchema
});
var CreatePromoterAgreementSchema = z.object({
  providerOrganizationId: z.string().uuid().optional(),
  providerBrandId: z.string().uuid().optional(),
  percentCommission: z.number().min(0).max(1)
}).refine((data) => data.providerOrganizationId || data.providerBrandId, {
  message: "Either providerOrganizationId or providerBrandId must be provided",
  path: ["providerOrganizationId", "providerBrandId"]
  // path of error
});
var CreatePromoterAgreementResponseSchema = z.object({
  id: z.string().uuid()
});
var CreatePromoterAgreementEndpoint = makeEndpoint({
  method: "POST",
  url: ({ promoterId }) => `v1/promoters/${promoterId}/promoter-agreement`,
  responseSchema: CreatePromoterAgreementResponseSchema,
  requestSchema: CreatePromoterAgreementSchema
});
var CreatePromoterAgreementsForAllOrgBrandsResponseSchema = z.object({
  agreementsCreated: z.number(),
  promotersCreated: z.number()
});
var CreatePromoterAgreementForAllOrgBrandsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/promoters/organizations/${organizationId}/promoter-agreement-for-all-brands`,
  responseSchema: CreatePromoterAgreementsForAllOrgBrandsResponseSchema,
  requestSchema: z.void()
});
var UpdatePromoterAgreementApprovalResponseSchema2 = z.object({
  id: z.string().uuid()
});
var UpdatePromoterAgreementApprovalSchema2 = z.object({
  status: z.nativeEnum(PromoterAgreementStatus),
  updatedByUserId: z.string().uuid()
});
var UpdateBrandPromoterAgreementApprovalEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, agreementId }) => `v1/promoters/${brandId}/promoter-agreement/${agreementId}/update-approval`,
  responseSchema: UpdatePromoterAgreementApprovalResponseSchema2,
  requestSchema: UpdatePromoterAgreementApprovalSchema2
});
var GetActiveBrandAgreementEndpointResponseSchema = z.array(
  z.object({
    id: z.string().uuid()
  })
);
var GetActiveBrandAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, promoterId }) => `v1/promoters/${brandId}/promoters/${promoterId}/promoter-agreement`,
  responseSchema: GetActiveBrandAgreementEndpointResponseSchema,
  requestSchema: z.void()
});
var stringBooleanSchema = z.union([z.boolean(), z.literal("true"), z.literal("false")]).transform((val) => {
  if (typeof val === "boolean") {
    return val;
  }
  return String(val) === "true";
});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["CHARGE"] = "charge";
  TransactionType2["LOYALTY_POINTS"] = "loyaltyPoints";
  TransactionType2["TRANSFER"] = "transfer";
  TransactionType2["REFUND"] = "refund";
  TransactionType2["REVERSE"] = "reverse";
  TransactionType2["DEBIT"] = "debit";
  TransactionType2["VOID"] = "void";
  return TransactionType2;
})(TransactionType || {});
var ExperienceReportStaticColumns01 = [
  "experienceDate",
  "startTime",
  "endTime",
  "duration",
  "transactionDate",
  "firstName",
  "lastName",
  "email",
  "confirmationCode",
  "experienceName",
  "totalParticipants"
  /* TOTAL_PARTICIPANTS */
];
var ExperienceReportStaticColumns02 = [
  "total",
  "totalPaid",
  "discountAmount",
  "refunds",
  "paymentMethod",
  "bookingStatus",
  "checkInStatus",
  "category",
  "guestNotes",
  "internalNotes"
  /* INTERNAL_NOTES */
];
var ExperienceReportColumn = [
  ...ExperienceReportStaticColumns01,
  "priceTiers",
  "addOns",
  ...ExperienceReportStaticColumns02,
  "customQuestions"
  /* CUSTOM_QUESTIONS */
];
var ExperienceReportSortBy = [
  "startDateTime",
  "transactionDate"
  /* TRANSACTION_DATE */
];
var baseExperienceReportFilters = {
  from: z.union([DateStringSchema, z.string().datetime()]).optional(),
  to: z.union([DateStringSchema, z.string().datetime()]).optional(),
  showNegativeDiscountValues: stringBooleanSchema.optional(),
  confirmationCode: z.string().optional(),
  cartId: z.string().optional(),
  experienceIds: z.array(z.string().uuid()).optional(),
  collectionIds: z.array(z.string().uuid()).optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
  email: z.string().optional(),
  lastName: z.string().optional(),
  page: z.coerce.number().optional(),
  limit: z.coerce.number().optional(),
  debug: stringBooleanSchema.optional()
};
var experienceReportFiltersSchema = z.object(baseExperienceReportFilters);
var BaseExperienceReportRequestSchema = z.object({
  columns: z.array(z.enum(ExperienceReportColumn)),
  params: experienceReportFiltersSchema,
  sortBy: z.enum(ExperienceReportSortBy),
  sortDir: z.enum(["ASC", "DESC"]).optional(),
  format: z.enum([
    "csv",
    "pdf"
    /* PDF */
  ]).optional()
});
var BrandExperienceReportRequestSchema = BaseExperienceReportRequestSchema.extend({
  brandId: z.string().uuid().optional()
});
var ExperienceReportRequestSchema = BrandExperienceReportRequestSchema;
var ExperienceReportWithHeaderSchema = z.object({
  "Experience Date": z.string().optional(),
  "Start Time": z.string().optional(),
  "End Time": z.string().optional(),
  Duration: z.string().optional(),
  "Transaction Date UTC": z.string().optional(),
  "First Name": z.string().optional(),
  "Last Name": z.string().optional(),
  Email: z.string().optional(),
  "Confirmation Code": z.string().optional(),
  "Experience Name": z.string().optional(),
  "Total Participants": z.string().optional(),
  // PRICE TIERS
  // ADD ONS
  "Total Price": z.string().optional(),
  "Total Paid": z.string().optional(),
  "Discount Amount": z.string().optional(),
  Refunds: z.string().optional(),
  "Payment Method": z.string().optional(),
  "Booking Status": z.string().optional(),
  "Check-In Status": z.string().optional(),
  Category: z.string().optional(),
  "Guest Notes": z.string().optional(),
  "Internal Notes": z.string().optional()
  // CUSTOM QUESTIONS
});
var PreviewExperienceReportRequestSchema = experienceReportFiltersSchema.extend({
  sortBy: z.enum(ExperienceReportSortBy)
});
var experienceReportItemSchema = z.object({
  experienceDate: z.string(),
  startTime: z.string(),
  endTime: z.string(),
  duration: z.string(),
  transactionDate: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  confirmationCode: z.string(),
  experienceName: z.string(),
  totalParticipants: z.number(),
  priceTiers: z.record(z.number().or(z.literal(""))),
  addOns: z.record(z.number().or(z.literal(""))),
  total: z.number(),
  totalPaid: z.number(),
  discountAmount: z.number().or(z.literal("")),
  refunds: z.number().or(z.literal("")),
  paymentMethod: z.string(),
  bookingStatus: z.string(),
  checkInStatus: z.string().nullable(),
  category: z.string().nullable(),
  guestNotes: z.string().nullable(),
  internalNotes: z.string().nullable(),
  customQuestions: z.record(z.string())
});
var PreviewExperienceReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/experiences?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(experienceReportItemSchema),
  requestSchema: z.void(),
  querySchema: PreviewExperienceReportRequestSchema
});
var FinancialReportV2Column = [
  "externalReferenceId",
  // ORG ONLY
  "brandName",
  // ORG ONLY
  "currency",
  "experienceDate",
  "transactionDate",
  "transactionMonth",
  // ORG ONLY
  "firstName",
  "lastName",
  "email",
  "confirmationCode",
  "paymentType",
  "paymentMethod",
  "accountNumber",
  "experienceName",
  "pricingLabel",
  "itemType",
  "quantity",
  "startTime",
  "duration",
  "hostName",
  "total",
  "discountAmount",
  "subtotal",
  "grossRevenue",
  // ORG ONLY
  "netRevenue",
  // ORG ONLY
  "totalPaid",
  "hostPayout",
  "creditCardFee",
  "netDeposited",
  "discountCode",
  "dateDeposited",
  "notes",
  "internalNotes",
  "reservationId",
  "taxes",
  "cartId",
  "createdBy",
  "category",
  "listingStatus",
  "bookingUrl",
  "promoterSource",
  "approvedPromoters"
  /* APPROVED_PROMOTERS */
];
var FinancialReportV2SortBy = [
  "startDateTime",
  "transactionDate"
  /* TRANSACTION_DATE */
];
var baseFinancialReportV2Filters = {
  from: z.union([DateStringSchema, z.string().datetime()]).optional(),
  to: z.union([DateStringSchema, z.string().datetime()]).optional(),
  showNegativeDiscountValues: stringBooleanSchema.optional(),
  transactionType: z.array(z.enum([
    "charge",
    "refund",
    "debit"
    /* DEBIT */
  ])).optional(),
  collectionIds: z.array(z.string().uuid()).optional(),
  eventId: z.string().uuid().optional(),
  experienceIds: z.array(z.string().uuid()).optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
  hostIds: z.array(z.string().uuid()).optional(),
  confirmationCode: z.string().optional(),
  cartId: z.string().optional(),
  transactionId: z.string().optional(),
  paymentMethod: z.array(z.nativeEnum(PaymentMethods)).optional(),
  itemType: z.array(z.nativeEnum(ItemType)).optional(),
  bookingStatus: z.array(z.nativeEnum(BookingStatus)).optional(),
  debug: stringBooleanSchema.optional()
};
var financialReportV2FiltersSchema = z.object(baseFinancialReportV2Filters);
var BaseFinancialReportV2RequestSchema = z.object({
  params: financialReportV2FiltersSchema,
  sortBy: z.enum(FinancialReportV2SortBy),
  columns: z.array(z.enum(FinancialReportV2Column)),
  format: z.enum([
    "csv",
    "pdf"
    /* PDF */
  ]).optional()
});
var BrandFinancialReportV2RequestSchema = BaseFinancialReportV2RequestSchema.extend({ brandId: z.string().uuid() });
var OrganizationFinancialReportV2RequestSchema = BaseFinancialReportV2RequestSchema.extend({
  organizationId: z.string().uuid()
});
var FinancialReportV2RequestSchema = z.union([
  BrandFinancialReportV2RequestSchema,
  OrganizationFinancialReportV2RequestSchema
]);
var PreviewFinancialV2RequestSchema = financialReportV2FiltersSchema.extend({
  limit: z.coerce.number().optional(),
  page: z.coerce.number().optional(),
  sortBy: z.enum(FinancialReportV2SortBy),
  organizationId: z.string().uuid().optional()
});
var financialReportV2ItemSchema = z.object({
  [
    "externalReferenceId"
    /* EXTERNAL_REFERENCE_ID */
  ]: z.string().nullable().optional(),
  [
    "brandName"
    /* BRAND_NAME */
  ]: z.string().optional(),
  [
    "currency"
    /* CURRENCY */
  ]: z.string(),
  [
    "experienceDate"
    /* EXPERIENCE_DATE */
  ]: z.string(),
  [
    "transactionDate"
    /* TRANSACTION_DATE */
  ]: z.string(),
  [
    "transactionMonth"
    /* TRANSACTION_MONTH */
  ]: z.string().optional(),
  [
    "firstName"
    /* FIRST_NAME */
  ]: z.string().nullable(),
  [
    "lastName"
    /* LAST_NAME */
  ]: z.string().nullable(),
  [
    "email"
    /* EMAIL */
  ]: z.string().nullable(),
  [
    "confirmationCode"
    /* CONFIRMATION_CODE */
  ]: z.string().nullable(),
  [
    "paymentType"
    /* PAYMENT_TYPE */
  ]: z.string(),
  [
    "paymentMethod"
    /* PAYMENT_METHOD */
  ]: z.string(),
  [
    "accountNumber"
    /* ACCOUNT */
  ]: z.string().nullable(),
  [
    "experienceName"
    /* EXPERIENCE_NAME */
  ]: z.string(),
  [
    "pricingLabel"
    /* PRICING_LABEL */
  ]: z.string().nullable(),
  [
    "itemType"
    /* ITEM_TYPE */
  ]: z.string().nullable(),
  [
    "quantity"
    /* QUANTITY */
  ]: z.number().nullable(),
  [
    "startTime"
    /* START_TIME */
  ]: z.string().nullable(),
  [
    "duration"
    /* DURATION */
  ]: z.string(),
  [
    "hostName"
    /* HOST */
  ]: z.string().nullable(),
  [
    "total"
    /* TOTAL */
  ]: z.number().nullable(),
  [
    "discountAmount"
    /* DISCOUNT_AMOUNT */
  ]: z.number().nullable(),
  [
    "subtotal"
    /* SUBTOTAL */
  ]: z.number().nullable(),
  [
    "grossRevenue"
    /* GROSS_REVENUE */
  ]: z.number().nullable().optional(),
  [
    "netRevenue"
    /* NET_REVENUE */
  ]: z.number().nullable().optional(),
  [
    "totalPaid"
    /* TOTAL_PAID */
  ]: z.number().nullable(),
  [
    "hostPayout"
    /* HOST_PAYOUT */
  ]: z.number().nullable(),
  [
    "creditCardFee"
    /* CREDIT_CARD */
  ]: z.number().nullable(),
  [
    "netDeposited"
    /* NET_DEPOSITED */
  ]: z.number().nullable(),
  [
    "discountCode"
    /* DISCOUNT_CODE */
  ]: z.string().nullable(),
  [
    "dateDeposited"
    /* DATE_DEPOSITED */
  ]: z.string().nullable(),
  [
    "notes"
    /* NOTES */
  ]: z.string().nullable(),
  [
    "internalNotes"
    /* INTERNAL_NOTES */
  ]: z.string().nullable(),
  [
    "reservationId"
    /* RESERVATION_ID */
  ]: z.string().nullable(),
  [
    "taxes"
    /* TAXES */
  ]: z.record(z.number().nullable()),
  [
    "cartId"
    /* CART_ID */
  ]: z.string().nullable(),
  [
    "createdBy"
    /* CREATED_BY */
  ]: z.string().nullable(),
  [
    "category"
    /* CATEGORY */
  ]: z.string().nullable(),
  [
    "listingStatus"
    /* LISTING_STATUS */
  ]: z.string().nullable(),
  [
    "bookingUrl"
    /* BOOKING_URL */
  ]: z.string().nullable(),
  [
    "promoterSource"
    /* PROMOTER_SOURCE */
  ]: z.string().nullable(),
  [
    "approvedPromoters"
    /* APPROVED_PROMOTERS */
  ]: z.string().nullable()
});
var debugErrorsSchema = z.object({
  key: z.string(),
  expectedFromTransactions: z.number(),
  receivedFromReport: z.number()
}).or(
  z.object({
    knownIssue: z.string()
  })
);
var PreviewFinancialV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/financials/v2?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(financialReportV2ItemSchema).merge(
    z.object({
      debugErrors: z.record(z.array(debugErrorsSchema)).optional()
    })
  ),
  requestSchema: z.void(),
  querySchema: PreviewFinancialV2RequestSchema
});
var webhookOnlyDataSchema = z.object({
  brandId: z.string(),
  experienceId: z.string(),
  bookingId: z.string().nullable(),
  bookingSourceUrl: z.string().url().nullable(),
  loyaltyPoints: z.number().nullable(),
  loyaltyMemberId: z.string().nullable(),
  externalAnalyticsUserId: z.string().nullable()
});
var webhookFinancialReportV2ItemSchema = financialReportV2ItemSchema.omit({
  [
    "experienceDate"
    /* EXPERIENCE_DATE */
  ]: true,
  [
    "taxes"
    /* TAXES */
  ]: true
}).extend({
  [
    "experienceDate"
    /* EXPERIENCE_DATE */
  ]: DateStringSchema,
  [
    "taxes"
    /* TAXES */
  ]: z.record(z.number())
}).merge(webhookOnlyDataSchema);
var FinancialReportV2WithHeaderSchema = z.object({
  "External Reference ID": z.string().optional(),
  "Brand Name": z.string().optional(),
  Currency: z.string().optional(),
  "Experience Date": z.string().optional(),
  "Transaction Date UTC": z.string().optional(),
  "Transaction Month UTC": z.string().optional(),
  "First Name": z.string().optional(),
  "Last Name": z.string().optional(),
  Email: z.string().optional(),
  "Confirmation Code": z.string().optional(),
  Type: z.string().optional(),
  "Payment Method": z.string().optional(),
  Account: z.string().optional(),
  "Experience Name": z.string().optional(),
  "Item Label": z.string().optional(),
  "Item Type": z.string().optional(),
  Quantity: z.string().optional(),
  "Start Time": z.string().optional(),
  Duration: z.string().optional(),
  Host: z.string().optional(),
  Total: z.string().optional(),
  "Discount Amount": z.string().optional(),
  Subtotal: z.string().optional(),
  "Gross Revenue": z.string().optional(),
  "Net Revenue": z.string().optional(),
  "Total Paid": z.string().optional(),
  "Host Payout": z.string().optional(),
  "Credit Card": z.string().optional(),
  "Net Deposited": z.string().optional(),
  "Discount Code": z.string().optional(),
  "Date Deposited": z.string().optional(),
  "Guest Notes": z.string().optional(),
  "Internal Notes": z.string().optional(),
  "Reservation ID": z.string().optional(),
  "Cart ID": z.string().optional(),
  "Created By": z.string().optional(),
  Category: z.string().optional(),
  "Listing Status": z.string().optional(),
  "Booking URL": z.string().optional(),
  "Promoter Source": z.string().optional(),
  "Approved Promoters": z.string().optional()
});
var FinancialReportColumn = [
  "externalReferenceId",
  "brandName",
  "currency",
  "experienceDate",
  "transactionDate",
  "transactionMonth",
  "firstName",
  "lastName",
  "confirmationCode",
  "paymentType",
  "paymentMethod",
  "accountNumber",
  "description",
  "duration",
  "hostName",
  "total",
  "discountAmount",
  "subtotal",
  "grossRevenue",
  "netRevenue",
  "taxes",
  "totalPaid",
  "hostPayout",
  "creditCardFee",
  "netDeposited",
  "quantity",
  "discountCode",
  "dateDeposited",
  "notes",
  "internalNotes",
  "reservationId",
  "cartId",
  "createdBy",
  "category",
  "listingStatus",
  "bookingUrl",
  "promoterSource",
  "approvedPromoters"
  /* APPROVED_PROMOTERS */
];
var financialColumnsMap = {
  [
    "externalReferenceId"
    /* EXTERNAL_REFERENCE_ID */
  ]: "External Reference ID",
  [
    "brandName"
    /* BRAND_NAME */
  ]: "Brand Name",
  [
    "currency"
    /* CURRENCY */
  ]: "Currency",
  [
    "experienceDate"
    /* EXPERIENCE_DATE */
  ]: "Experience Date",
  [
    "transactionDate"
    /* TRANSACTION_DATE */
  ]: "Transaction Date UTC",
  [
    "transactionMonth"
    /* TRANSACTION_MONTH */
  ]: "Transaction Month UTC",
  [
    "firstName"
    /* FIRST_NAME */
  ]: "First Name",
  [
    "lastName"
    /* LAST_NAME */
  ]: "Last Name",
  [
    "confirmationCode"
    /* CONFIRMATION_CODE */
  ]: "Confirmation Code",
  [
    "paymentType"
    /* PAYMENT_TYPE */
  ]: "Type",
  [
    "paymentMethod"
    /* PAYMENT_METHOD */
  ]: "Payment Method",
  [
    "accountNumber"
    /* ACCOUNT */
  ]: "Account",
  [
    "description"
    /* DESCRIPTION */
  ]: "Description",
  [
    "duration"
    /* DURATION */
  ]: "Duration",
  [
    "hostName"
    /* HOST */
  ]: "Host",
  [
    "total"
    /* TOTAL */
  ]: "Total",
  [
    "discountAmount"
    /* DISCOUNT_AMOUNT */
  ]: "Discount Amount",
  [
    "subtotal"
    /* SUBTOTAL */
  ]: "Subtotal",
  [
    "grossRevenue"
    /* GROSS_REVENUE */
  ]: "Gross Revenue",
  [
    "netRevenue"
    /* NET_REVENUE */
  ]: "Net Revenue",
  [
    "taxes"
    /* TAXES */
  ]: "Taxes",
  [
    "totalPaid"
    /* TOTAL_PAID */
  ]: "Total Paid",
  [
    "hostPayout"
    /* HOST_PAYOUT */
  ]: "Host Payout",
  [
    "creditCardFee"
    /* CREDIT_CARD */
  ]: "Credit Card",
  [
    "netDeposited"
    /* NET_DEPOSITED */
  ]: "Net Deposited",
  [
    "quantity"
    /* QUANTITY */
  ]: "Quantity",
  [
    "discountCode"
    /* DISCOUNT_CODE */
  ]: "Discount Code",
  [
    "dateDeposited"
    /* DATE_DEPOSITED */
  ]: "Date Deposited",
  [
    "notes"
    /* NOTES */
  ]: "Guest Notes",
  [
    "internalNotes"
    /* INTERNAL_NOTES */
  ]: "Internal Notes",
  [
    "reservationId"
    /* RESERVATION_ID */
  ]: "Reservation ID",
  [
    "cartId"
    /* CART_ID */
  ]: "Cart ID",
  [
    "createdBy"
    /* CREATED_BY */
  ]: "Created By",
  [
    "category"
    /* CATEGORY */
  ]: "Category",
  [
    "listingStatus"
    /* LISTING_STATUS */
  ]: "Listing Status",
  [
    "bookingUrl"
    /* BOOKING_URL */
  ]: "Booking URL",
  [
    "promoterSource"
    /* PROMOTER_SOURCE */
  ]: "Promoter Source",
  [
    "approvedPromoters"
    /* APPROVED_PROMOTERS */
  ]: "Approved Promoters"
};
var FinancialReportSortBy = [
  "startDateTime",
  "transactionDate"
  /* TRANSACTION_DATE */
];
var financialReportInfoSchema = {
  filters: {
    from: "datestring",
    to: "datestring",
    experienceId: "uuid",
    resourceGroupCollectionId: "uuid",
    eventId: "uuid",
    searchParams: "string",
    transactionType: Object.values(TransactionType),
    showNegativeDiscountValues: "boolean"
  },
  sortBy: FinancialReportSortBy,
  columns: Object.entries(financialColumnsMap).map(([key, value]) => ({
    label: value,
    field: key
  }))
};
var BaseFinancialReportRequestSchema = z.object({
  params: z.object({
    from: z.union([DateStringSchema, z.string().datetime()]).optional(),
    to: z.union([DateStringSchema, z.string().datetime()]).optional(),
    experienceId: z.string().optional().nullable(),
    resourceGroupCollectionId: z.string().uuid().optional().nullable(),
    eventId: z.string().optional().nullable(),
    searchParams: z.string().optional().nullable(),
    transactionType: z.nativeEnum(TransactionType).optional().nullable(),
    showNegativeDiscountValues: z.boolean().optional().nullable()
  }),
  sortBy: z.enum(FinancialReportSortBy),
  columns: z.array(z.enum(FinancialReportColumn)),
  format: z.enum([
    "csv",
    "pdf"
    /* PDF */
  ]).optional()
});
var BrandFinancialReportRequestSchema = BaseFinancialReportRequestSchema.extend({ brandId: z.string().uuid() });
var OrganizationFinancialReportRequestSchema = BaseFinancialReportRequestSchema.extend({
  organizationId: z.string().uuid()
});
var FinancialReportRequestSchema = z.union([
  BrandFinancialReportRequestSchema,
  OrganizationFinancialReportRequestSchema
]);
var FinancialReportWithHeaderSchema = z.object({
  "External Reference ID": z.string().optional(),
  "Brand Name": z.string().optional(),
  Currency: z.string().optional(),
  "Experience Date": z.string().optional(),
  "Transaction Date UTC": z.string().optional(),
  "Transaction Month UTC": z.string().optional(),
  "First Name": z.string().optional(),
  "Last Name": z.string().optional(),
  "Confirmation Code": z.string().optional(),
  Type: z.string().optional(),
  "Payment Method": z.string().optional(),
  Account: z.string().optional(),
  Description: z.string().optional(),
  Duration: z.string().optional(),
  Host: z.string().optional(),
  Total: z.string().optional(),
  "Discount Amount": z.string().optional(),
  Subtotal: z.string().optional(),
  "Gross Revenue": z.string().optional(),
  "Net Revenue": z.string().optional(),
  "Total Paid": z.string().optional(),
  "Host Payout": z.string().optional(),
  "Credit Card": z.string().optional(),
  "Net Deposited": z.string().optional(),
  Quantity: z.string().optional(),
  "Discount Code": z.string().optional(),
  "Date Deposited": z.string().optional(),
  "Guest Notes": z.string().optional(),
  "Internal Notes": z.string().optional(),
  "Reservation ID": z.string().optional(),
  "Cart ID": z.string().optional(),
  "Created By": z.string().optional(),
  Category: z.string().optional(),
  "Listing Status": z.string().optional(),
  "Booking URL": z.string().optional(),
  "Promoter Source": z.string().optional(),
  "Approved Promoters": z.string().optional()
});
var GuestReportColumn = [
  "experienceDate",
  "transactionDate",
  "firstName",
  "lastName",
  "email",
  "phone",
  "confirmationCode",
  "experienceName",
  "startTime",
  "endTime",
  "pricingLabel",
  "itemType",
  "total",
  "totalPaid",
  "refunds",
  "bookingStatus",
  "category",
  "cartId",
  "checkInStatus",
  "hostName",
  "paymentMethod",
  "accountNumber",
  "notes",
  "internalNotes",
  "customQuestionAnswer"
  /* CUSTOM_QUESTION_ANSWERS */
];
var GuestReportSortBy = [
  "startDateTime",
  "bookedAt"
  /* BOOKED_AT */
];
var baseGuestReportFilters = {
  from: DateStringSchema.optional(),
  to: DateStringSchema.optional(),
  experienceIds: z.array(z.string().uuid()).optional(),
  collectionIds: z.array(z.string().uuid()).optional(),
  eventId: z.string().uuid().optional(),
  categoryIds: z.array(z.string().uuid()).optional(),
  hostIds: z.array(z.string().uuid()).optional(),
  bookingStatus: z.array(z.nativeEnum(BookingStatus)).optional(),
  itemType: z.array(z.nativeEnum(ItemType)).optional(),
  confirmationCode: z.string().optional(),
  cartId: z.string().optional(),
  email: z.string().optional(),
  lastName: z.string().optional(),
  showNegativeRefundValues: stringBooleanSchema.optional(),
  transactionType: z.nativeEnum(TransactionType).optional().nullable(),
  debug: stringBooleanSchema.optional()
};
var guestReportFiltersSchema = z.object(baseGuestReportFilters);
var GuestReportRequestSchema = z.object({
  params: guestReportFiltersSchema,
  sortBy: z.enum(GuestReportSortBy),
  columns: z.array(z.enum(GuestReportColumn)),
  brandId: z.string().uuid().optional(),
  format: z.enum([
    "csv",
    "pdf"
    /* PDF */
  ]).optional()
});
var PreviewGuestReportRequestSchema = guestReportFiltersSchema.extend({
  limit: z.coerce.number().optional(),
  page: z.coerce.number().optional(),
  sortBy: z.enum(GuestReportSortBy)
});
var guestReportItemSchema = z.object({
  experienceDate: z.string(),
  transactionDate: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  email: z.string(),
  phone: z.string(),
  confirmationCode: z.string(),
  experienceName: z.string(),
  startTime: z.string(),
  endTime: z.string(),
  pricingLabel: z.string(),
  itemType: z.string(),
  total: z.number(),
  totalPaid: z.number(),
  refunds: z.number().or(z.literal("")),
  bookingStatus: z.string(),
  category: z.string(),
  cartId: z.string(),
  checkInStatus: z.string(),
  hostName: z.string(),
  paymentMethod: z.string(),
  accountNumber: z.string(),
  notes: z.string(),
  internalNotes: z.string(),
  customQuestionAnswer: z.record(z.unknown())
});
var PreviewGuestReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/guests?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(guestReportItemSchema),
  requestSchema: z.void(),
  querySchema: PreviewGuestReportRequestSchema
});
var GuestReportWithHeaderSchema = z.object({
  "Experience Date": z.string().optional(),
  "Transaction Date UTC": z.string().optional(),
  "First Name": z.string().optional(),
  "Last Name": z.string().optional(),
  Email: EmailStringSchema.optional(),
  Phone: z.string().optional(),
  "Confirmation Code": z.string().optional(),
  Experience: z.string().optional(),
  "Start Time": z.string().optional(),
  "End Time": z.string().optional(),
  "Pricing Label": z.string().optional(),
  "Item Type": z.string().optional(),
  "Item Price": z.string().optional(),
  "Total Paid": z.string().optional(),
  Refunds: z.string().optional(),
  "Booking Status": z.string().optional(),
  Category: z.string().optional(),
  "Cart ID": z.string().optional(),
  "Check In Status": z.string().optional(),
  Host: z.string().optional(),
  "Guest Notes": z.string().optional(),
  "Internal Notes": z.string().optional(),
  "Payment Method": z.string().optional(),
  Account: z.string().optional()
});
var ReportStatus = /* @__PURE__ */ ((ReportStatus2) => {
  ReportStatus2["PENDING"] = "pending";
  ReportStatus2["SUCCESS"] = "success";
  ReportStatus2["FAILED"] = "failed";
  return ReportStatus2;
})(ReportStatus || {});
var ReportErrorsSchema = z.object({
  message: z.string()
});
var ReportType = /* @__PURE__ */ ((ReportType2) => {
  ReportType2["BRANDS"] = "brands";
  ReportType2["FINANCIAL"] = "financial";
  ReportType2["FINANCIAL_V2"] = "financial-v2";
  ReportType2["EXPERIENCE"] = "experience";
  ReportType2["GUEST"] = "guest";
  return ReportType2;
})(ReportType || {});
var brandReportInfoSchema = {
  filters: {
    brandStatuses: Object.values(BrandStatus)
  },
  sortBy: [],
  columns: []
};
var BrandReportRequestSchema = z.object({
  params: z.object({
    brandStatuses: z.array(z.nativeEnum(BrandStatus))
  }),
  format: z.enum([
    "csv",
    "pdf"
    /* PDF */
  ]).optional()
});
var ReportRequestSchema = z.union([BrandReportRequestSchema, FinancialReportRequestSchema]);
var FindReportResponseSchema = z.object({
  id: z.string(),
  payload: z.record(z.string(), z.unknown()),
  type: z.nativeEnum(ReportType),
  status: z.nativeEnum(ReportStatus),
  errors: ReportErrorsSchema.nullable(),
  createdById: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  media: z.object({
    id: z.string(),
    originalName: z.string(),
    uri: z.object({
      original: z.string()
    })
  }).nullable()
});
var GenerateReportRequestSchema = z.union([
  BrandReportRequestSchema,
  ExperienceReportRequestSchema,
  FinancialReportRequestSchema,
  GuestReportRequestSchema,
  FinancialReportV2RequestSchema
]);
var ReportDataByTypeSchema = {
  [
    "brands"
    /* BRANDS */
  ]: BrandReportHeaderSchema,
  [
    "financial"
    /* FINANCIAL */
  ]: z.union([FinancialReportWithHeaderSchema, z.record(z.string(), z.unknown())]),
  [
    "financial-v2"
    /* FINANCIAL_V2 */
  ]: z.union([FinancialReportV2WithHeaderSchema, z.record(z.string(), z.unknown())]),
  [
    "experience"
    /* EXPERIENCE */
  ]: z.union([ExperienceReportWithHeaderSchema, z.record(z.string(), z.unknown())]),
  [
    "guest"
    /* GUEST */
  ]: GuestReportWithHeaderSchema
};
var PostReportEndpoint = makeEndpoint({
  method: "POST",
  url: ({ type }) => `v2/reports/${type}`,
  responseSchema: FindReportResponseSchema,
  requestSchema: GenerateReportRequestSchema
});
var GetReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportId }) => `v2/reports/${reportId}`,
  responseSchema: FindReportResponseSchema,
  requestSchema: z.void()
});
var infoItemSchema = z.object({
  fieldType: z.enum(["text", "single-select", "multi-select", "checkbox", "date"]),
  label: z.string(),
  key: z.string(),
  values: z.array(z.object({ label: z.string(), value: z.string() })).optional()
});
var reportInfoResponseSchema = z.object({
  filters: z.array(infoItemSchema),
  experiences: z.array(
    z.object({
      label: z.string(),
      value: z.string(),
      kind: z.enum(["experience", "collection"])
    })
  )
});
var GetReportInfoEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportType }) => `v2/reports/info/${reportType}`,
  responseSchema: reportInfoResponseSchema,
  requestSchema: z.void()
});
var DownloadReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportId }) => `v2/reports/${reportId}/download`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var bulkResourcesCommonFields = ExperienceAsResourceSchema.pick({
  customQuestions: true,
  priceTiers: true,
  priceTierRules: true,
  sessionDurationMinutes: true,
  isTicketed: true,
  cancellationPolicyId: true,
  reschedulePolicyId: true
}).partial({ sessionDurationMinutes: true }).extend({
  bookingAvailabilityMode: ExperienceAsResourceSchema.shape.bookingAvailabilityMode.unwrap().optional(),
  displayedCapacity: ExperienceAsResourceSchema.shape.displayedCapacity.unwrap().optional(),
  description: ExperienceAsResourceSchema.shape.description.unwrap().optional(),
  isUnlisted: ExperienceAsResourceSchema.shape.isUnlisted.unwrap().optional(),
  onlineBookingCutoffHours: ExperienceAsResourceSchema.shape.onlineBookingCutoffHours.unwrap().optional(),
  emailMessage: ExperienceAsResourceSchema.shape.emailMessage.unwrap().optional(),
  notificationEmails: ExperienceAsResourceSchema.shape.notificationEmails.unwrap().optional(),
  notificationOverrides: ExperienceAsResourceSchema.shape.notificationOverrides.unwrap().optional(),
  paymentMethods: ExperienceAsResourceSchema.shape.paymentMethods.unwrap().optional(),
  shouldValidateComplimentaryBooking: ExperienceAsResourceSchema.shape.shouldValidateComplimentaryBooking.unwrap().optional(),
  integrationMeta: ExperienceAsResourceSchema.shape.integrationMeta.unwrap().optional(),
  taxes: ExperienceAsResourceSchema.shape.taxes.unwrap().optional()
});
var bulkResourcesUniqueFields = ExperienceAsResourceSchema.extend({
  id: ExperienceAsResourceSchema.shape.id.optional(),
  maxParticipantsCount: ExperienceAsResourceSchema.shape.maxParticipantsCount.optional()
}).pick({
  id: true,
  title: true,
  number: true,
  position: true,
  shape: true,
  maximumAllowedToBook: true,
  minimumRequiredToBook: true,
  maxParticipantsCount: true
});
var BulkCreateExperiencesRequestSchema = z.object({
  commonFields: bulkResourcesCommonFields,
  experiences: z.array(bulkResourcesUniqueFields)
});
var BulkCreateExperiencesEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/experiences`,
  requestSchema: BulkCreateExperiencesRequestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema
});
var BulkUpdateExperiencesRequestSchema = z.object({
  commonFields: bulkResourcesCommonFields.partial(),
  experiences: z.array(bulkResourcesUniqueFields.required({ id: true }))
});
var BulkUpdateExperiencesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/experiences`,
  requestSchema: BulkUpdateExperiencesRequestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema
});
var DeleteResourceEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceId, status }) => `v1/experiences/${resourceId}?status=${status}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var BulkCreateSchedulesRequestSchema = z.object({
  startDate: DateStringSchema,
  startTimes: z.array(TimeStringSchema),
  recurrencePattern: z.object({
    weekdays: z.array(z.number().min(1).max(7)),
    until: DateStringSchema
  }).optional(),
  sessionDuration: z.number().min(1).int()
});
var BulkCreateSchedulesEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/schedules`,
  requestSchema: BulkCreateSchedulesRequestSchema.strict(),
  responseSchema: z.void()
});
var BulkDeleteSessionsRequestSchema = z.object({
  sessions: z.array(z.object({ startDateTime: LocalDateTimeStringSchema }))
});
var BulkDeleteSessionsEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/sessions`,
  requestSchema: BulkDeleteSessionsRequestSchema.strict(),
  responseSchema: z.void()
});
var Rating = /* @__PURE__ */ ((Rating2) => {
  Rating2[Rating2["ONE"] = 1] = "ONE";
  Rating2[Rating2["TWO"] = 2] = "TWO";
  Rating2[Rating2["THREE"] = 3] = "THREE";
  Rating2[Rating2["FOUR"] = 4] = "FOUR";
  Rating2[Rating2["FIVE"] = 5] = "FIVE";
  return Rating2;
})(Rating || {});
var Recommendability = /* @__PURE__ */ ((Recommendability2) => {
  Recommendability2[Recommendability2["ONE"] = 1] = "ONE";
  Recommendability2[Recommendability2["TWO"] = 2] = "TWO";
  Recommendability2[Recommendability2["THREE"] = 3] = "THREE";
  Recommendability2[Recommendability2["FOUR"] = 4] = "FOUR";
  Recommendability2[Recommendability2["FIVE"] = 5] = "FIVE";
  Recommendability2[Recommendability2["SIX"] = 6] = "SIX";
  Recommendability2[Recommendability2["SEVEN"] = 7] = "SEVEN";
  Recommendability2[Recommendability2["EIGHT"] = 8] = "EIGHT";
  Recommendability2[Recommendability2["NINE"] = 9] = "NINE";
  Recommendability2[Recommendability2["TEN"] = 10] = "TEN";
  return Recommendability2;
})(Recommendability || {});
var PostReviewRequestSchema = z.object({
  rating: z.coerce.number().transform((n) => {
    const res = z.nativeEnum(Rating).safeParse(n);
    return res.success ? res.data : 5;
  }),
  recommendability: z.coerce.number().transform((n) => {
    const res = z.nativeEnum(Recommendability).safeParse(n);
    return res.success ? res.data : 10;
  }),
  text: z.string(),
  token: z.string()
});
var PostReviewEndpoint = makeEndpoint({
  method: "POST",
  url: () => "v1/reviews",
  responseSchema: z.void(),
  requestSchema: PostReviewRequestSchema
});
var BrandsReviewsSummaryResponseSchema = z.object({
  brandId: z.string(),
  host: z.object({
    id: z.string(),
    fullName: z.string(),
    profilePicture: IMediaReferenceSchema.nullable()
  }).optional(),
  brand: z.object({
    id: z.string(),
    name: z.string(),
    logo: IMediaReferenceSchema.nullable()
  }).optional(),
  experience: z.object({
    id: z.string(),
    title: z.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  resourceGroup: z.object({
    id: z.string(),
    title: z.string(),
    resourceGroupCollectionId: z.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  totalReviews: z.string(),
  averageRating: z.string(),
  npsScore: z.string().nullable(),
  reviewPercentage: z.string()
}).strict();
var GetBrandsReviewsSummaryResponseSchema = paginateResponseSchema(BrandsReviewsSummaryResponseSchema);
var GetBrandsReviewsSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["averageRating", "npsScore", "totalReviews", "reviewPercentage"]
}).omit({ filters: true }).extend({
  sortOrder: z.enum(["ASC", "DESC"]).optional(),
  groupBy: z.enum(summaryGroupingOptions)
});
var GetBrandsReviewsSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `v1/${entityType}/${entityId}/review-summary?${buildQueryString(query)}`,
  responseSchema: GetBrandsReviewsSummaryResponseSchema,
  requestSchema: z.void(),
  querySchema: GetBrandsReviewsSummaryQuerySchema
});
var StaffUserStatus = /* @__PURE__ */ ((StaffUserStatus2) => {
  StaffUserStatus2["ACTIVE"] = "active";
  StaffUserStatus2["DEACTIVATED"] = "deactivated";
  StaffUserStatus2["INVITED"] = "invited";
  return StaffUserStatus2;
})(StaffUserStatus || {});
var StatusesSchema = z.nativeEnum(StaffUserStatus);
var RolesSchema = z.nativeEnum(StaffRole);
var StaffUserSchema = z.object({
  profilePicture: z.object({
    id: z.string(),
    uri: z.object({ original: z.string() }).and(z.record(z.string()))
  }).nullable(),
  firstName: z.string(),
  lastName: z.string(),
  email: EmailStringSchema,
  phoneNumber: z.string().nullable(),
  role: RolesSchema,
  status: StatusesSchema,
  permissions: z.array(z.nativeEnum(PERMISSION)),
  id: z.string().uuid()
});
var GetStaffUsersResponseSchema = paginateResponseSchema(StaffUserSchema);
var GetStaffUsersQuerySchema = paginateQuerySchema({
  sortBy: ["firstName", "lastName", "role", "status"]
});
var CreateStaffUsersRequestSchema = StaffUserSchema.pick({
  email: true,
  firstName: true,
  lastName: true,
  role: true
}).extend({
  permissions: StaffUserSchema.shape.permissions.optional()
});
var UpdateStaffUsersRequestSchema = StaffUserSchema.pick({
  email: true,
  firstName: true,
  lastName: true,
  role: true,
  permissions: true
}).partial();
var SurveyQuestionType = /* @__PURE__ */ ((SurveyQuestionType2) => {
  SurveyQuestionType2["SCALE_3"] = "SCALE_3";
  SurveyQuestionType2["BINARY"] = "BINARY";
  return SurveyQuestionType2;
})(SurveyQuestionType || {});
var SurveyQuestionTypeSchema = z.nativeEnum(SurveyQuestionType);
var SurveyQuestionsSchema = z.object({
  surveyQuestionId: z.string().uuid(),
  surveyQuestionHistoryId: z.string().uuid(),
  active: z.boolean(),
  weight: z.number(),
  type: SurveyQuestionTypeSchema,
  label: z.string(),
  isAnalyticsActive: z.boolean().optional().nullable(),
  analyticsTitle: z.string().optional().nullable(),
  analyticsDescription: z.string().optional().nullable()
});
var SurveyQuestionWithAggregateAnswerSchema = z.object({
  surveyQuestionId: z.string(),
  active: z.boolean(),
  weight: z.number(),
  type: SurveyQuestionTypeSchema,
  label: z.string(),
  isAnalyticsActive: z.boolean().optional().nullable(),
  analyticsTitle: z.string().optional().nullable(),
  analyticsDescription: z.string().optional().nullable(),
  answers: z.array(
    z.object({
      answer: z.string().nullable(),
      count: z.number()
    })
  )
});
var SurveyQuestionWithAggregateAnswerResponseSchema = z.array(SurveyQuestionWithAggregateAnswerSchema);
var GetSurveyQuestionsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/survey-questions`,
  requestSchema: z.void(),
  responseSchema: z.array(SurveyQuestionsSchema)
});
var PostSurveyQuestionsEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/survey-questions`,
  requestSchema: SurveyQuestionsSchema,
  responseSchema: z.void()
});
var DeleteSurveyQuestionsEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ surveyQuestionId }) => `v1/survey-questions/${surveyQuestionId}`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var PatchSurveyQuestionsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ surveyQuestionId }) => `v1/survey-questions/${surveyQuestionId}`,
  requestSchema: SurveyQuestionsSchema.pick({
    active: true,
    isAnalyticsActive: true,
    analyticsTitle: true,
    analyticsDescription: true
  }),
  responseSchema: z.void()
});
var GetBrandSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/survey-questions/aggregate-answers`,
  requestSchema: z.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});
var GetOrganizationSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId, currency }) => `v1/organizations/${organizationId}/survey-questions/aggregate-answers/${currency}`,
  requestSchema: z.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});
var GetOwnSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ currency }) => `v1/survey-questions/me/aggregate-answers/${currency}`,
  requestSchema: z.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});
var SurveySchema = z.object({
  id: z.string().uuid(),
  questions: z.array(
    SurveyQuestionsSchema.pick({ surveyQuestionHistoryId: true, type: true, label: true }).extend({
      answer: z.string().nullable()
    })
  )
});
var SurveyQuestionAnswerSchema = z.object({
  surveyQuestionHistoryId: z.string().uuid(),
  answer: z.string()
});
var SurveyAnswersSchema = z.object({
  answers: z.array(SurveyQuestionAnswerSchema)
});
var PostSurveyRequestSchema = z.object({
  cartId: z.string().uuid()
});
var PostSurveyResponseSchema = SurveySchema;
var PostSurveyAnswersRequestSchema = SurveyAnswersSchema;
var PostSurveyEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/surveys`,
  requestSchema: PostSurveyRequestSchema,
  responseSchema: PostSurveyResponseSchema.optional()
});
var PostAnswersEndpoint = makeEndpoint({
  method: "POST",
  url: ({ surveyId }) => `v1/surveys/${surveyId}/answers`,
  requestSchema: PostSurveyAnswersRequestSchema,
  responseSchema: z.void()
});
var MembershipCurrenciesOfUserQueryRequestSchema = z.object({
  organizationId: z.string().uuid().optional()
});
var GetMembershipCurrenciesOfUserEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/users/me/currencies`,
  requestSchema: MembershipCurrenciesOfUserQueryRequestSchema,
  responseSchema: z.array(z.string())
});
var GetTranslationsForVibesQuerySchema = z.object({
  vibeId: z.string().uuid().optional(),
  language: z.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForVibesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/vibes/i18n?${buildQueryString(query)}`,
  responseSchema: z.object({
    translations: z.array(TranslationSchema)
  }),
  requestSchema: z.void(),
  querySchema: GetTranslationsForVibesQuerySchema
});
var RearrangeVibeRequestSchema = z.object({
  vibeIds: z.array(z.string().uuid())
});
var RearrangeVibeEndpoint = makeEndpoint({
  method: "PUT",
  url: (params) => `v1/brands/${params.brandId}/vibes/rearrange`,
  responseSchema: z.void(),
  requestSchema: RearrangeVibeRequestSchema
});
var BulkUpdateVibeSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  name: z.string(),
  order: z.number()
});
var UpdateVibesDataSchema = z.object({
  vibes: z.array(BulkUpdateVibeSchema)
});
var UpdateVibesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/vibes`,
  responseSchema: z.void(),
  requestSchema: UpdateVibesDataSchema
});
var PatchVibesTranslationsRequestSchema = z.object({
  translations: z.array(TranslationSchema.omit({ createdAt: true, updatedAt: true, version: true }))
});
var PatchVibesTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `/v1/${brandId}/vibes/i18n`,
  requestSchema: PatchVibesTranslationsRequestSchema,
  responseSchema: z.void()
});
var WaitlistMode = /* @__PURE__ */ ((WaitlistMode2) => {
  WaitlistMode2["AUTO"] = "auto";
  WaitlistMode2["MANUAL"] = "manual";
  WaitlistMode2["NONE"] = "none";
  return WaitlistMode2;
})(WaitlistMode || {});
var WaitlistSchema = z.object({
  id: z.string().uuid(),
  claimTime: z.number().nullable(),
  mode: z.nativeEnum(WaitlistMode),
  shouldShowRemovedEntries: z.boolean()
}).strict();
var UpdateWaitlistRequestSchema = WaitlistSchema.omit({ id: true }).partial();
var UpdateWaitlistEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: UpdateWaitlistRequestSchema,
  responseSchema: z.void()
});
var GetWaitlistEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z.void(),
  responseSchema: WaitlistSchema
});
var PublicWaitlistSchema = WaitlistSchema.omit({ claimTime: true });
var PublicGetWaitlistEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z.void(),
  responseSchema: PublicWaitlistSchema
});
var WaitlistEntryStatus = /* @__PURE__ */ ((WaitlistEntryStatus2) => {
  WaitlistEntryStatus2["REMOVED"] = "removed";
  WaitlistEntryStatus2["WAITING"] = "waiting";
  WaitlistEntryStatus2["OFFERED"] = "offered";
  WaitlistEntryStatus2["ACCEPTED"] = "accepted";
  WaitlistEntryStatus2["DECLINED"] = "declined";
  WaitlistEntryStatus2["EXPIRED"] = "expired";
  WaitlistEntryStatus2["OPENING_AVAILABLE"] = "opening-available";
  return WaitlistEntryStatus2;
})(WaitlistEntryStatus || {});
var JoinWaitlistRequestSchema = z.object({
  sessionStartDate: DateStringSchema,
  sessionStartTime: TimeStringSchema,
  sessionDuration: z.number(),
  purchaser: PurchaserWithCustomQuestionsSchema.omit({ id: true }),
  participants: z.array(ParticipantSchema).min(1)
});
var JoinWaitlistResponseSchema = z.void({});
var JoinWaitlistEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries`,
  requestSchema: JoinWaitlistRequestSchema,
  responseSchema: JoinWaitlistResponseSchema
});
var WaitlistParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z.string().uuid(),
  priceTierName: z.string().optional().nullable(),
  cancelledAt: z.string().datetime().nullable(),
  customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
});
var WaitlistPurchaserSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z.string().uuid(),
  customQuestionAnswers: z.array(CustomQuestionAnswerBookingResponseSchema).optional()
});
var WaitlistEntrySchema = z.object({
  id: z.string().uuid(),
  status: z.nativeEnum(WaitlistEntryStatus),
  resourceGroupCollectionId: z.string().uuid(),
  startDate: DateStringSchema,
  startTime: TimeStringSchema,
  sessionDuration: z.number(),
  participants: z.array(WaitlistParticipantSchema),
  purchaser: WaitlistPurchaserSchema,
  expiresAt: z.string().datetime().nullable()
});
var GetWaitlistEntriesQuerySchema = paginateQuerySchema().extend({
  sessionDate: DateStringSchema.optional(),
  sessionStartTime: TimeStringSchema.optional(),
  filters: z.array(
    z.object({
      operator: z.literal("in"),
      name: z.literal("status"),
      value: z.array(z.nativeEnum(WaitlistEntryStatus))
    })
  ).optional()
});
var GetWaitlistEntriesResponseSchema = paginateResponseSchema(WaitlistEntrySchema);
var GetWaitlistEntriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    waitlistId,
    query
  }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries?${buildQueryString(query)}`,
  responseSchema: GetWaitlistEntriesResponseSchema,
  requestSchema: z.void(),
  querySchema: GetWaitlistEntriesQuerySchema
});
var SendWaitlistInvitationOfferEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/offer-invitation`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var OrderWaitlistEntriesRequestSchema = z.object({
  waitlistEntryIds: z.array(z.string().uuid()).min(1)
});
var OrderWaitlistEntriesEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/order-waitlist-entries`,
  requestSchema: OrderWaitlistEntriesRequestSchema,
  responseSchema: z.void()
});
var RemoveGuestFromWaitlistEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/remove`,
  requestSchema: z.void(),
  responseSchema: z.void()
});
var WaitlistEntryPublicSchema = WaitlistEntrySchema.omit({});
var GetWaitlistEntryPublicEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlist-invitation-offered/${waitlistEntryId}`,
  responseSchema: WaitlistEntryPublicSchema,
  requestSchema: z.void()
});
var WebhookEvents = /* @__PURE__ */ ((WebhookEvents2) => {
  WebhookEvents2["BOOKING_CANCELLED"] = "booking.cancelled";
  WebhookEvents2["EXPERIENCE_PUBLISHED"] = "experience.published";
  WebhookEvents2["LISTING_PUBLISHED"] = "listing.published";
  WebhookEvents2["LISTING_UNPUBLISHED"] = "listing.unpublished";
  WebhookEvents2["BOOKING_COMPLETED"] = "booking.completed";
  WebhookEvents2["BOOKING_REFUNDED"] = "booking.refunded";
  WebhookEvents2["BOOKING_RESCHEDULED"] = "booking.rescheduled";
  WebhookEvents2["FINANCIAL_REPORT_UPDATED"] = "financialReport.updated";
  WebhookEvents2["FINANCIAL_REPORT_V2_UPDATED"] = "financialReportV2.updated";
  WebhookEvents2["REVIEW_COMPLETED"] = "review.completed";
  return WebhookEvents2;
})(WebhookEvents || {});
var WebhookResponseSchema = z.object({
  id: z.string(),
  url: z.string().url(),
  events: z.array(z.nativeEnum(WebhookEvents)),
  status: z.boolean(),
  userId: z.string().uuid(),
  secret: z.string().nullable().optional(),
  brandId: z.string().uuid().nullable(),
  organizationId: z.string().uuid().nullable(),
  createdAt: z.string().datetime()
});
var PaginatedWebhookResponseSchema = paginateResponseSchema(WebhookResponseSchema);
var WebhookRequestSchema = z.object({
  url: z.string().url(),
  events: z.array(z.nativeEnum(WebhookEvents)).min(1),
  status: z.boolean(),
  secret: z.string().optional()
});
var GetPaginatedWebhooksEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/webhooks`,
  responseSchema: PaginatedWebhookResponseSchema,
  requestSchema: z.void()
});
var GetWebhookDetailEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: WebhookResponseSchema,
  requestSchema: z.void()
});
var CreateWebhookEndpoint = makeEndpoint({
  method: "POST",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/webhooks`,
  responseSchema: z.void(),
  requestSchema: WebhookRequestSchema
});
var UpdateWebhookEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: z.void(),
  requestSchema: WebhookRequestSchema
});
var DeleteWebhookEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: z.void(),
  requestSchema: z.void()
});
var WebhookEventHistoryStatus = /* @__PURE__ */ ((WebhookEventHistoryStatus2) => {
  WebhookEventHistoryStatus2["SUCCESS"] = "success";
  WebhookEventHistoryStatus2["FAILED"] = "failed";
  return WebhookEventHistoryStatus2;
})(WebhookEventHistoryStatus || {});
var WebhookEventStatus = /* @__PURE__ */ ((WebhookEventStatus2) => {
  WebhookEventStatus2["PENDING"] = "pending";
  WebhookEventStatus2["SUCCESS"] = "success";
  WebhookEventStatus2["FAILED"] = "failed";
  return WebhookEventStatus2;
})(WebhookEventStatus || {});
var PaginatedWebhookEventHistoryQueryRequestSchema = z.object({
  from: z.string().optional(),
  to: z.string().optional(),
  status: z.nativeEnum(WebhookEventHistoryStatus).optional()
});
var PaginatedWebhookEventHistoryResponseSchema = paginateResponseSchema(
  z.object({
    id: z.string(),
    event: z.nativeEnum(WebhookEvents),
    status: z.nativeEnum(WebhookEventHistoryStatus),
    createdAt: z.string().datetime()
  })
);
var WebhookEventHistoryDetailResponseSchema = z.object({
  id: z.string(),
  url: z.string().url(),
  status: z.nativeEnum(WebhookEventHistoryStatus),
  response: z.record(z.string(), z.unknown()),
  webhookEventId: z.string().uuid(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
  webhookEvent: z.object({
    id: z.string().uuid(),
    event: z.nativeEnum(WebhookEvents),
    payload: z.record(z.string(), z.unknown()),
    status: z.nativeEnum(WebhookEventStatus),
    retryCount: z.number(),
    webhookId: z.string().uuid(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime()
  })
});
var GetPaginatedWebhookEventHistoryEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history`,
  responseSchema: PaginatedWebhookEventHistoryResponseSchema,
  requestSchema: PaginatedWebhookEventHistoryQueryRequestSchema
});
var FindWebhookEventHistoryDetailEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    webhookId,
    webhookEventHistoryId
  }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history/${webhookEventHistoryId}`,
  responseSchema: WebhookEventHistoryDetailResponseSchema,
  requestSchema: z.void()
});
var AuthenticateResponseSchema = z.object({
  accessToken: z.string(),
  expiresIn: z.number(),
  tokenType: z.string(),
  clientId: z.string()
});
var AuthenticateRequestSchema = z.object({
  code: z.string(),
  redirectUrl: z.string()
});
var AuthenticateEndpoint = makeEndpoint({
  method: "POST",
  url: () => "hyatt/authenticate",
  responseSchema: AuthenticateResponseSchema,
  requestSchema: AuthenticateRequestSchema
});
var MemberProfileEndpoint = makeEndpoint({
  method: "GET",
  url: () => "hyatt/member",
  requestSchema: z.object({
    accessToken: z.string().nonempty("Access Token is required")
  }),
  responseSchema: z.object({
    loyaltyId: z.string().nonempty(),
    memberSince: z.string().nonempty(),
    tierCode: z.string().nonempty(),
    tierExpiration: z.string().nonempty(),
    firstName: z.string().nonempty(),
    points: z.string().nonempty()
  })
});
var DurationSchema = z.object({
  id: z.string().uuid().optional(),
  label: z.string(),
  duration: z.number()
});
var FindDurationsByDurationSetIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema)
});
var FindDurationsByDurationSetIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ durationSetId }) => `v1/duration-set/${durationSetId}`,
  responseSchema: FindDurationsByDurationSetIdResponseSchema,
  requestSchema: z.void()
});
var CreateDurationsForExperienceResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema)
});
var CreateDurationsForExperienceRequestSchema = z.object({
  durations: z.array(
    z.object({
      label: z.string(),
      duration: z.number()
    })
  )
});
var CreateDurationsForExperienceEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: CreateDurationsForExperienceResponseSchema,
  requestSchema: CreateDurationsForExperienceRequestSchema
});
var CreateDurationsForResourceGroupResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  durations: z.array(DurationSchema)
});
var CreateDurationsForResourceGroupRequestSchema = z.object({
  durations: z.array(DurationSchema)
});
var CreateDurationsForResourceGroupEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupId }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: CreateDurationsForResourceGroupResponseSchema,
  requestSchema: CreateDurationsForResourceGroupRequestSchema
});
var UpdateDurationRequestSchema = z.object({
  label: z.string()
});
var UpdateDurationEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ durationId }) => `v1/durations/${durationId}`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationRequestSchema
});
var UpdateDurationsByExperienceIdRequestSchema = z.object({
  durations: z.array(
    z.object({
      id: z.string().uuid().optional(),
      label: z.string(),
      duration: z.number()
    })
  )
});
var UpdateDurationsByExperienceIdEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationsByExperienceIdRequestSchema
});
var UpdateDurationsByResourceGroupIdRequestSchema = z.object({
  durations: z.array(DurationSchema)
});
var UpdateDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, resourceGroupId }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: z.void(),
  requestSchema: UpdateDurationsByResourceGroupIdRequestSchema
});
var FindDurationsByExperienceIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  version: z.string(),
  durations: z.array(DurationSchema)
});
var FindDurationsByExperienceIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, experienceId, version }) => `v1/brands/${brandId}/experiences/${experienceId}/durations/${version}`,
  responseSchema: FindDurationsByExperienceIdResponseSchema,
  requestSchema: z.void()
});
var FindDurationsByResourceGroupIdResponseSchema = z.object({
  durationSetId: z.string().uuid(),
  version: z.string(),
  durations: z.array(DurationSchema)
});
var FindDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, resourceGroupId, version }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations/${version}`,
  responseSchema: FindDurationsByResourceGroupIdResponseSchema,
  requestSchema: z.void()
});
var SuggestedTipSchema = z.object({
  isDefault: z.boolean(),
  percentage: z.number()
});
var OrderTypeSchema = z.object({
  orderTypeRef: z.number(),
  name: z.string(),
  serviceLevelTime: z.number().optional(),
  suggestedTips: z.array(SuggestedTipSchema).optional()
});
var OrderChannelSchema = z.object({
  orderChannelId: z.number(),
  name: z.record(z.string()),
  // e.g. { "en-US": "Default" }
  isDefault: z.boolean(),
  serviceLevelTime: z.number().optional()
});
var PostalAddressSchema = z.object({
  addressLine1: z.string(),
  addressLine2: z.string().optional(),
  floor: z.string().optional(),
  locality: z.string(),
  region: z.string(),
  postalCode: z.string(),
  country: z.string(),
  notes: z.string().optional()
});
var GeoLocationSchema = z.object({
  latitude: z.number(),
  longitude: z.number()
});
var ExtensionDataSchema = z.unknown();
var PhoneNumberSchema2 = z.string();
var SimphonyRevenueCenterSchema = z.object({
  orgShortName: z.string(),
  locRef: z.string(),
  rvcRef: z.number(),
  name: z.string(),
  orderTypes: z.array(OrderTypeSchema).optional(),
  orderChannels: z.array(OrderChannelSchema).optional(),
  tables: z.array(z.string()).optional(),
  consumerName: z.string().optional(),
  address: PostalAddressSchema.optional(),
  geoLocation: GeoLocationSchema.optional(),
  extensions: ExtensionDataSchema.optional(),
  phoneNumber: PhoneNumberSchema2.optional()
});
var SimphonyMenuItemSchema = z.object({
  menuItemId: z.number(),
  definitionSequence: z.number(),
  name: z.string(),
  quantity: z.number(),
  unitPrice: z.number(),
  priceSequence: z.number(),
  total: z.number(),
  seat: z.number(),
  referenceText: z.string(),
  surcharge: z.number(),
  itemDiscounts: z.array(z.any()),
  condiments: z.array(z.any()),
  extensions: z.array(z.any())
});
var SimphonyMenuCategorySchema = z.object({
  id: z.number(),
  name: z.string(),
  items: z.array(SimphonyMenuItemSchema)
});
var MenuPriceSchema = z.object({
  price: z.number(),
  priceSequence: z.number()
});
var CondimentGroupRuleSchema = z.object({
  condimentGroupRef: z.number(),
  minimumCount: z.number(),
  maximumCount: z.number()
});
var SimphonyMenuDefinitionSchema = z.object({
  name: z.record(z.string()),
  prices: z.array(MenuPriceSchema),
  condimentGroupRules: z.array(CondimentGroupRuleSchema).optional(),
  allergens: z.array(z.string()).optional()
});
var SimphonyMenuItemDetailSchema = SimphonyMenuItemSchema.extend({
  familyGroupRef: z.number(),
  definitions: z.array(SimphonyMenuDefinitionSchema)
});
var condimentItemSchema = z.object({
  condimentId: z.number(),
  name: z.record(z.string())
});
var SimphonyMenuDetailSchema = z.object({
  menuItems: z.array(SimphonyMenuItemDetailSchema),
  condimentItems: z.array(condimentItemSchema)
});
var SimphonyMenuSummarySchema = z.object({
  categories: z.array(SimphonyMenuCategorySchema),
  items: z.array(SimphonyMenuItemSchema),
  status: z.string(),
  message: z.string().optional()
});
var SimphonyTenderItemSchema = z.object({
  tenderId: z.number(),
  name: z.string(),
  tenderMediaId: z.number(),
  tenderMediaRef: z.number(),
  tenderMediaObjectNumber: z.number()
});
var SimphonyTenderCollectionSchema = z.object({
  items: z.array(SimphonyTenderItemSchema),
  status: z.string(),
  message: z.string().optional()
});

// src/lib/Shape.ts
import { LatLngBounds as LatLngBounds2 } from "leaflet";
import { v4 as uuid } from "uuid";
var Shape = class {
  constructor({
    id,
    x,
    y,
    width,
    height,
    color,
    opacity,
    label,
    draggable,
    onClick
  }) {
    __publicField(this, "id");
    __publicField(this, "x");
    __publicField(this, "y");
    __publicField(this, "width");
    __publicField(this, "height");
    __publicField(this, "color");
    __publicField(this, "opacity");
    __publicField(this, "label");
    __publicField(this, "draggable");
    __publicField(this, "onClick");
    this.id = id;
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.color = color;
    this.opacity = opacity;
    this.label = label;
    this.draggable = draggable;
    this.onClick = onClick;
  }
  get props() {
    return {
      id: this.id,
      type: this.type,
      x: this.x,
      y: this.y,
      width: this.width,
      height: this.height,
      color: this.color,
      opacity: this.opacity,
      label: this.label,
      draggable: this.draggable,
      onClick: this.onClick
    };
  }
  get bounds() {
    return new LatLngBounds2([
      [this.y, this.x],
      [this.y + this.height, this.x + this.width]
    ]);
  }
  setPosition(x, y) {
    this.x = x;
    this.y = y;
  }
  setWidth(width) {
    this.width = width;
  }
  setHeight(height) {
    this.height = height;
  }
  setColor(color) {
    this.color = color;
  }
};
var RectangleShape = class extends Shape {
  constructor({
    id = uuid(),
    x,
    y,
    width = 50,
    height = 50,
    color = "#f3f3f3",
    opacity = 1,
    label = "",
    draggable = true,
    onClick
  }) {
    super({
      id,
      type: ShapeType.RECTANGLE,
      x,
      y,
      width,
      height,
      color,
      opacity,
      label,
      draggable,
      onClick
    });
    __publicField(this, "type", ShapeType.RECTANGLE);
  }
};
var CircleShape = class extends Shape {
  constructor({
    id = uuid(),
    x,
    y,
    width = 50,
    height = 50,
    color = "#f3f3f3",
    opacity = 1,
    label = "",
    draggable = true,
    onClick
  }) {
    super({
      id,
      type: ShapeType.CIRCLE,
      x,
      y,
      width,
      height,
      color,
      opacity,
      label,
      draggable,
      onClick
    });
    __publicField(this, "type", ShapeType.CIRCLE);
  }
};

// src/lib/utils.ts
var getShapeConstructor = (type) => {
  switch (type) {
    case ShapeType.RECTANGLE:
      return RectangleShape;
    case ShapeType.CIRCLE:
      return CircleShape;
    default:
      throw new Error("unkown shape type");
  }
};
var getImageDimensions = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      resolve({
        width: img.naturalWidth || img.width || 0,
        height: img.naturalHeight || img.height || 0
      });
    };
    img.onerror = function() {
      reject(new Error(`Failed to load image's URL: ${url}`));
    };
    img.src = url;
  });
};

// src/components/ShapesContext.tsx
import { jsx } from "react/jsx-runtime";
var ShapesContext = createContext({
  shapes: {},
  addShape: () => {
    throw new Error("Not implemented");
  },
  removeShape: () => {
    throw new Error("Not implemented");
  }
});
var ShapesContextProvider = ({ children }) => {
  const [shapes, setShapes] = useState2({});
  const addShape = (shapeType, shapeProps) => {
    const shapeConstructor = getShapeConstructor(shapeType);
    const shape = new shapeConstructor(shapeProps);
    setShapes((prevShapes) => ({ ...prevShapes, [shape.id]: shape }));
  };
  const removeShape = (shapeId) => {
    setShapes((prevShapes) => {
      const newShapes = { ...prevShapes };
      delete newShapes[shapeId];
      return newShapes;
    });
  };
  return /* @__PURE__ */ jsx(ShapesContext.Provider, { value: { shapes, addShape, removeShape }, children });
};

// src/hooks/useShapes.ts
var useShapes = () => useContext(ShapesContext);

// src/hooks/useGetImageDimensions.ts
import { useEffect as useEffect2, useState as useState3 } from "react";
var useGetImageDimensions = (src) => {
  const [dimensions, setDimensions] = useState3(null);
  const onMount = async (url) => {
    const { width, height } = await getImageDimensions(url);
    setDimensions({
      width,
      height,
      ratio: width && height ? width / height : 1
    });
  };
  useEffect2(() => {
    onMount(src);
  }, [src]);
  return dimensions;
};

// src/components/DraggableRectangle.tsx
import { jsx as jsx2 } from "react/jsx-runtime";
var DraggableRectangle = ({
  canDragOutsideMap,
  mapSize,
  ...shape
}) => {
  const { bounds, shapeRef } = useDraggableShape(
    shape,
    canDragOutsideMap,
    mapSize
  );
  return /* @__PURE__ */ jsx2(
    Rectangle,
    {
      ref: shapeRef,
      bounds,
      color: "#FFFFFF",
      opacity: 1,
      fillOpacity: 1,
      fillColor: shape.color,
      className: shape.className,
      children: shape.children
    },
    `${shape.id}-${shape.color}`
  );
};

// src/components/DraggableCircle.tsx
import { Circle } from "react-leaflet";
import { jsx as jsx3 } from "react/jsx-runtime";
var DraggableCircle = ({
  canDragOutsideMap,
  mapSize,
  currentMapScale,
  ...shape
}) => {
  const { bounds, shapeRef } = useDraggableShape(
    shape,
    canDragOutsideMap,
    mapSize
  );
  const scaledRadius = Math.round(shape.width / 2 / currentMapScale * 1e3) / 1e3;
  return /* @__PURE__ */ jsx3(
    Circle,
    {
      ref: shapeRef,
      radius: scaledRadius,
      center: bounds.getCenter(),
      color: "#FFFFFF",
      opacity: 1,
      fillOpacity: 1,
      fillColor: shape.color,
      className: shape.className,
      children: shape.children
    },
    `${shape.id}-${shape.color}`
  );
};

// src/components/DraggableTable.tsx
import { useMemo, useRef as useRef2, useState as useState4 } from "react";
import L from "leaflet";
import { Marker } from "react-leaflet";
import { jsx as jsx4 } from "react/jsx-runtime";
var getAuthorizedValue = (value, min, max) => {
  if (value < min) {
    return min;
  }
  return Math.min(value, max);
};
function generateSvg({
  tableNumber,
  numberOfSeats,
  svgScaleFactor,
  rotation = 0,
  hover = false
}) {
  const fillColor = hover ? "url(#gradHover)" : "url(#grad1)";
  const baseTableCircleRadius = 50 * svgScaleFactor;
  const tableCircleSizePerSeat = 3 * svgScaleFactor;
  const mainCircleRadius = baseTableCircleRadius + tableCircleSizePerSeat * numberOfSeats;
  const seatCircleRadius = 25 * svgScaleFactor;
  const spacing = -15;
  const distanceFromCenter = mainCircleRadius + seatCircleRadius + spacing;
  const viewBoxSize = (distanceFromCenter + seatCircleRadius) * 2;
  const svgWidth = viewBoxSize;
  const svgHeight = viewBoxSize;
  const centerX = svgWidth / 2;
  const centerY = svgHeight / 2;
  let svgString = `
        <svg width="${svgWidth}" height="${svgHeight}" viewBox="0 0 ${viewBoxSize} ${viewBoxSize}" xmlns="http://www.w3.org/2000/svg">
        <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style="stop-color:rgb(255,255,255);stop-opacity:1" />
        <stop offset="100%" style="stop-color:rgb(245,245,245);stop-opacity:1" />
        </linearGradient>
        <linearGradient id="gradHover" x1="0%" y1="0%" x2="0%" y2="100%">
        <stop offset="0%" style="stop-color:#F3F3F3;stop-opacity:1" /> <!-- Lighter or different color for hover -->
        <stop offset="100%" style="stop-color:#E5E5E5;stop-opacity:1" />
        </linearGradient>
        <filter id="f1" x="0" y="0" width="200%" height="200%">
        <feOffset result="offOut" in="SourceGraphic" dx="0" dy="2" />
        <feGaussianBlur result="blurOut" in="offOut" stdDeviation="2" />
        <feBlend in="SourceGraphic" in2="blurOut" mode="normal" />
        </filter>
        <filter id="shadow" x="-50%" y="-50%" width="200%" height="200%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="2" result="blur" /> <!-- Blur effect -->
        <feOffset in="blur" dx="0" dy="2" result="offsetBlur" /> <!-- Shadow offset -->
        <feFlood flood-color="rgba(0,0,0,0.5)" result="color"/> <!-- Change 'red' to your desired shadow color -->
        <feComposite in="color" in2="offsetBlur" operator="in" result="shadow" />
        <feComponentTransfer in="shadow" result="transparency">
        <feFuncA type="linear" slope="0.3"/> <!-- Adjust transparency -->
        </feComponentTransfer>
        <feMerge> 
        <feMergeNode in="transparency"/>
        <feMergeNode in="SourceGraphic"/>
        </feMerge>
        </filter>
        </defs>
        <g transform="translate(${centerX}, ${centerY}) rotate(${rotation} 0 0)">`;
  for (let i = 0; i < numberOfSeats; i++) {
    const angle = i / numberOfSeats * (2 * Math.PI);
    const seatX = distanceFromCenter * Math.cos(angle);
    const seatY = distanceFromCenter * Math.sin(angle);
    svgString += `
            <circle cx="${seatX}" cy="${seatY}" r="${seatCircleRadius}" fill="${fillColor}" stroke="#00000033" stroke-width="1" filter="url(#f1)"/>`;
  }
  svgString += `
            <circle cx="0" cy="0" r="${mainCircleRadius}" fill="${fillColor}" stroke="#CCCCCC" stroke-width="1" filter="url(#shadow)"/>
            <text x="0" y="0" font-size="${mainCircleRadius / 2}" font-family="'Arial'" font-weight="bold" text-anchor="middle" fill="#000000CC" dy="-.25em">${tableNumber}</text>
            <text x="0" y="${mainCircleRadius / 4}" font-size="${mainCircleRadius / 3}" font-family="'Arial'" text-anchor="middle" fill="#00000099" dy=".5em">${numberOfSeats} seats</text>`;
  svgString += `</g></svg>`;
  return {
    html: svgString,
    iconSize: [svgWidth, svgHeight],
    iconAncor: [
      svgWidth * svgScaleFactor / 2,
      svgHeight * svgScaleFactor / 2
    ]
  };
}
var DraggableTable = (shape) => {
  const { x, y, label, onDrag } = shape;
  const markerRef = useRef2(null);
  const [isHovered, setIsHovered] = useState4(false);
  const position = {
    lng: x,
    lat: y
  };
  const svgProps = useMemo(() => {
    return generateSvg({
      tableNumber: `${label}`,
      numberOfSeats: shape.maximumAllowedToBook ?? 0,
      svgScaleFactor: 0.5,
      rotation: 0,
      hover: isHovered || shape.isSelected
    });
  }, [label, shape.maximumAllowedToBook, isHovered, shape.isSelected]);
  const icon = useMemo(() => {
    return L.divIcon({
      className: "svg-icon",
      ...svgProps
    });
  }, [svgProps]);
  const eventHandlers = useMemo(
    () => ({
      dragstart() {
        const marker = markerRef.current;
        if (marker != null) {
          const element = marker.getElement();
          if (element) {
            element.style.zIndex = "1000";
          }
        }
      },
      dragend() {
        const marker = markerRef.current;
        if (marker != null) {
          const element = marker.getElement();
          if (element) {
            element.style.zIndex = "auto";
          }
          const latLng = marker.getLatLng();
          onDrag?.({
            ...shape,
            x: getAuthorizedValue(latLng.lng, 0, shape.mapSize.width),
            y: getAuthorizedValue(latLng.lat, 0, shape.mapSize.height)
          });
        }
      },
      mouseover() {
        setIsHovered(true);
      },
      mouseout() {
        setIsHovered(false);
      },
      click() {
        shape.onClick?.(shape);
      }
    }),
    [onDrag, shape]
  );
  return /* @__PURE__ */ jsx4(
    Marker,
    {
      draggable: shape.draggable,
      eventHandlers,
      position,
      ref: markerRef,
      icon
    }
  );
};

// src/components/Shape.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var RawShape = (props) => {
  switch (props.type) {
    case ShapeType.RECTANGLE:
      return /* @__PURE__ */ jsx5(DraggableRectangle, { ...props });
    case ShapeType.CIRCLE:
      return /* @__PURE__ */ jsx5(DraggableCircle, { ...props });
    case ShapeType.TABLE:
      return /* @__PURE__ */ jsx5(DraggableTable, { ...props });
    default:
      return null;
  }
};
var Shape2 = (props) => {
  return /* @__PURE__ */ jsx5(RawShape, { ...props, className: "customMapShape" });
};

// src/components/MapStyle.tsx
import { jsx as jsx6 } from "react/jsx-runtime";
var MapStyle = () => {
  return /* @__PURE__ */ jsx6("style", { children: `.leaflet-pane,
        .leaflet-tile,
        .leaflet-marker-icon,
        .leaflet-marker-shadow,
        .leaflet-tile-container,
        .leaflet-pane > svg,
        .leaflet-pane > canvas,
        .leaflet-zoom-box,
        .leaflet-image-layer,
        .leaflet-layer {
        position: absolute;
        left: 0;
        top: 0;
      }
        .leaflet-container {
        overflow: hidden;
      }
        .leaflet-tile,
        .leaflet-marker-icon,
        .leaflet-marker-shadow {
        -webkit-user-select: none;
        -moz-user-select: none;
        user-select: none;
        -webkit-user-drag: none;
      }
        /* Prevents IE11 from highlighting tiles in blue */
        .leaflet-tile::selection {
        background: transparent;
      }
        /* Safari renders non-retina tile on retina better with this, but Chrome is worse */
        .leaflet-safari .leaflet-tile {
        image-rendering: -webkit-optimize-contrast;
      }
        /* hack that prevents hw layers "stretching" when loading new tiles */
        .leaflet-safari .leaflet-tile-container {
        width: 1600px;
        height: 1600px;
        -webkit-transform-origin: 0 0;
      }
        .leaflet-marker-icon,
        .leaflet-marker-shadow {
        display: block;
      }
        /* .leaflet-container svg: reset svg max-width decleration shipped in Joomla! (joomla.org) 3.x */
        /* .leaflet-container img: map is broken in FF if you have max-width: 100% on tiles */
        .leaflet-container .leaflet-overlay-pane svg {
        max-width: none !important;
        max-height: none !important;
      }
        .leaflet-container .leaflet-marker-pane img,
        .leaflet-container .leaflet-shadow-pane img,
        .leaflet-container .leaflet-tile-pane img,
        .leaflet-container img.leaflet-image-layer,
        .leaflet-container .leaflet-tile {
        max-width: none !important;
        max-height: none !important;
        width: auto;
        padding: 0;
      }
        
        .leaflet-container img.leaflet-tile {
        /* See: https://bugs.chromium.org/p/chromium/issues/detail?id=600120 */
        mix-blend-mode: plus-lighter;
      }
        
        .leaflet-container.leaflet-touch-zoom {
        -ms-touch-action: pan-x pan-y;
        touch-action: pan-x pan-y;
      }
        .leaflet-container.leaflet-touch-drag {
        -ms-touch-action: pinch-zoom;
        /* Fallback for FF which doesn't support pinch-zoom */
        touch-action: none;
        touch-action: pinch-zoom;
      }
        .leaflet-container.leaflet-touch-drag.leaflet-touch-zoom {
        -ms-touch-action: none;
        touch-action: none;
      }
        .leaflet-container {
        -webkit-tap-highlight-color: transparent;
      }
        .leaflet-container a {
        -webkit-tap-highlight-color: rgba(51, 181, 229, 0.4);
      }
        .leaflet-tile {
        filter: inherit;
        visibility: hidden;
      }
        .leaflet-tile-loaded {
        visibility: inherit;
      }
        .leaflet-zoom-box {
        width: 0;
        height: 0;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        z-index: 800;
      }
        /* workaround for https://bugzilla.mozilla.org/show_bug.cgi?id=888319 */
        .leaflet-overlay-pane svg {
        -moz-user-select: none;
      }
        
        .leaflet-pane         { z-index: 400; }
        
        .leaflet-tile-pane    { z-index: 200; }
        .leaflet-overlay-pane { z-index: 400; }
        .leaflet-shadow-pane  { z-index: 500; }
        .leaflet-marker-pane  { z-index: 600; }
        .leaflet-tooltip-pane   { z-index: 650; }
        .leaflet-popup-pane   { z-index: 700; }
        
        .leaflet-map-pane canvas { z-index: 100; }
        .leaflet-map-pane svg    { z-index: 200; }
        
        .leaflet-vml-shape {
        width: 1px;
        height: 1px;
      }
        .lvml {
        behavior: url(#default#VML);
        display: inline-block;
        position: absolute;
      }
        
        
        /* control positioning */
        
        .leaflet-control {
        position: relative;
        z-index: 800;
        pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
        pointer-events: auto;
      }
        .leaflet-top,
        .leaflet-bottom {
        position: absolute;
        pointer-events: none;
      }
        .leaflet-top {
        top: 0;
      }
        .leaflet-right {
        right: 0;
      }
        .leaflet-bottom {
        bottom: 0;
      }
        .leaflet-left {
        left: 0;
      }
        .leaflet-control {
        float: left;
        clear: both;
      }
        .leaflet-right .leaflet-control {
        float: right;
      }
        .leaflet-top .leaflet-control {
        margin-top: 10px;
      }
        .leaflet-bottom .leaflet-control {
        margin-bottom: 10px;
      }
        .leaflet-left .leaflet-control {
        margin-left: 10px;
      }
        .leaflet-right .leaflet-control {
        margin-right: 10px;
      }
        
        
        /* zoom and fade animations */
        
        .leaflet-fade-anim .leaflet-popup {
        opacity: 0;
        -webkit-transition: opacity 0.2s linear;
        -moz-transition: opacity 0.2s linear;
        transition: opacity 0.2s linear;
      }
        .leaflet-fade-anim .leaflet-map-pane .leaflet-popup {
        opacity: 1;
      }
        .leaflet-zoom-animated {
        -webkit-transform-origin: 0 0;
        -ms-transform-origin: 0 0;
        transform-origin: 0 0;
      }
        svg.leaflet-zoom-animated {
        will-change: transform;
      }
        
        .leaflet-zoom-anim .leaflet-zoom-animated {
        -webkit-transition: -webkit-transform 0.25s cubic-bezier(0,0,0.25,1);
        -moz-transition:    -moz-transform 0.25s cubic-bezier(0,0,0.25,1);
        transition:         transform 0.25s cubic-bezier(0,0,0.25,1);
      }
        .leaflet-zoom-anim .leaflet-tile,
        .leaflet-pan-anim .leaflet-tile {
        -webkit-transition: none;
        -moz-transition: none;
        transition: none;
      }
        
        .leaflet-zoom-anim .leaflet-zoom-hide {
        visibility: hidden;
      }
        
        
        /* cursors */
        
        .leaflet-interactive {
        cursor: pointer;
      }
        .leaflet-grab {
        cursor: -webkit-grab;
        cursor:    -moz-grab;
        cursor:         grab;
      }
        .leaflet-crosshair,
        .leaflet-crosshair .leaflet-interactive {
        cursor: crosshair;
      }
        .leaflet-popup-pane,
        .leaflet-control {
        cursor: auto;
      }
        .leaflet-dragging .leaflet-grab,
        .leaflet-dragging .leaflet-grab .leaflet-interactive,
        .leaflet-dragging .leaflet-marker-draggable {
        cursor: move;
        cursor: -webkit-grabbing;
        cursor:    -moz-grabbing;
        cursor:         grabbing;
      }
        
        /* marker & overlays interactivity */
        .leaflet-marker-icon,
        .leaflet-marker-shadow,
        .leaflet-image-layer,
        .leaflet-pane > svg path,
        .leaflet-tile-container {
        pointer-events: none;
      }
        
        .leaflet-marker-icon.leaflet-interactive,
        .leaflet-image-layer.leaflet-interactive,
        .leaflet-pane > svg path.leaflet-interactive,
        svg.leaflet-image-layer.leaflet-interactive path {
        pointer-events: visiblePainted; /* IE 9-10 doesn't have auto */
        pointer-events: auto;
      }
        
        /* visual tweaks */
        
        .leaflet-container {
        background: #ddd;
        outline-offset: 1px;
      }
        .leaflet-container a {
        color: #0078A8;
      }
        .leaflet-zoom-box {
        border: 2px dotted #38f;
        background: rgba(255,255,255,0.5);
      }
        
        
        /* general typography */
        .leaflet-container {
        font-family: "Helvetica Neue", Arial, Helvetica, sans-serif;
        font-size: 12px;
        font-size: 0.75rem;
        line-height: 1.5;
      }
        
        
        /* general toolbar styles */
        
        .leaflet-bar {
        box-shadow: 0 1px 5px rgba(0,0,0,0.65);
        border-radius: 4px;
      }
        .leaflet-bar a {
        background-color: #fff;
        border-bottom: 1px solid #ccc;
        width: 26px;
        height: 26px;
        line-height: 26px;
        display: block;
        text-align: center;
        text-decoration: none;
        color: black;
      }
        .leaflet-bar a,
        .leaflet-control-layers-toggle {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        display: block;
      }
        .leaflet-bar a:hover,
        .leaflet-bar a:focus {
        background-color: #f4f4f4;
      }
        .leaflet-bar a:first-child {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
        .leaflet-bar a:last-child {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        border-bottom: none;
      }
        .leaflet-bar a.leaflet-disabled {
        cursor: default;
        background-color: #f4f4f4;
        color: #bbb;
      }
        
        .leaflet-touch .leaflet-bar a {
        width: 30px;
        height: 30px;
        line-height: 30px;
      }
        .leaflet-touch .leaflet-bar a:first-child {
        border-top-left-radius: 2px;
        border-top-right-radius: 2px;
      }
        .leaflet-touch .leaflet-bar a:last-child {
        border-bottom-left-radius: 2px;
        border-bottom-right-radius: 2px;
      }
        
        /* zoom control */
        
        .leaflet-control-zoom-in,
        .leaflet-control-zoom-out {
        font: bold 18px 'Lucida Console', Monaco, monospace;
        text-indent: 1px;
      }
        
        .leaflet-touch .leaflet-control-zoom-in, .leaflet-touch .leaflet-control-zoom-out  {
        font-size: 22px;
      }
        
        
        /* layers control */
        
        .leaflet-control-layers {
        box-shadow: 0 1px 5px rgba(0,0,0,0.4);
        background: #fff;
        border-radius: 5px;
      }
        .leaflet-control-layers-toggle {
        background-image: url(images/layers.png);
        width: 36px;
        height: 36px;
      }
        .leaflet-retina .leaflet-control-layers-toggle {
        background-image: url(images/layers-2x.png);
        background-size: 26px 26px;
      }
        .leaflet-touch .leaflet-control-layers-toggle {
        width: 44px;
        height: 44px;
      }
        .leaflet-control-layers .leaflet-control-layers-list,
        .leaflet-control-layers-expanded .leaflet-control-layers-toggle {
        display: none;
      }
        .leaflet-control-layers-expanded .leaflet-control-layers-list {
        display: block;
        position: relative;
      }
        .leaflet-control-layers-expanded {
        padding: 6px 10px 6px 6px;
        color: #333;
        background: #fff;
      }
        .leaflet-control-layers-scrollbar {
        overflow-y: scroll;
        overflow-x: hidden;
        padding-right: 5px;
      }
        .leaflet-control-layers-selector {
        margin-top: 2px;
        position: relative;
        top: 1px;
      }
        .leaflet-control-layers label {
        display: block;
        font-size: 13px;
        font-size: 1.08333em;
      }
        .leaflet-control-layers-separator {
        height: 0;
        border-top: 1px solid #ddd;
        margin: 5px -10px 5px -6px;
      }
        
        /* Default icon URLs */
        .leaflet-default-icon-path { /* used only in path-guessing heuristic, see L.Icon.Default */
        background-image: url(images/marker-icon.png);
      }
        
        
        /* attribution and scale controls */
        
        .leaflet-container .leaflet-control-attribution {
        background: #fff;
        background: rgba(255, 255, 255, 0.8);
        margin: 0;
      }
        .leaflet-control-attribution,
        .leaflet-control-scale-line {
        padding: 0 5px;
        color: #333;
        line-height: 1.4;
      }
        .leaflet-control-attribution a {
        text-decoration: none;
      }
        .leaflet-control-attribution a:hover,
        .leaflet-control-attribution a:focus {
        text-decoration: underline;
      }
        .leaflet-attribution-flag {
        display: inline !important;
        vertical-align: baseline !important;
        width: 1em;
        height: 0.6669em;
      }
        .leaflet-left .leaflet-control-scale {
        margin-left: 5px;
      }
        .leaflet-bottom .leaflet-control-scale {
        margin-bottom: 5px;
      }
        .leaflet-control-scale-line {
        border: 2px solid #777;
        border-top: none;
        line-height: 1.1;
        padding: 2px 5px 1px;
        white-space: nowrap;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.8);
        text-shadow: 1px 1px #fff;
      }
        .leaflet-control-scale-line:not(:first-child) {
        border-top: 2px solid #777;
        border-bottom: none;
        margin-top: -2px;
      }
        .leaflet-control-scale-line:not(:first-child):not(:last-child) {
        border-bottom: 2px solid #777;
      }
        
        .leaflet-touch .leaflet-control-attribution,
        .leaflet-touch .leaflet-control-layers,
        .leaflet-touch .leaflet-bar {
        box-shadow: none;
      }
        .leaflet-touch .leaflet-control-layers,
        .leaflet-touch .leaflet-bar {
        border: 2px solid rgba(0,0,0,0.2);
        background-clip: padding-box;
      }
        
        
        /* popup */
        
        .leaflet-popup {
        position: absolute;
        text-align: center;
        margin-bottom: 20px;
      }
        .leaflet-popup-content-wrapper {
        padding: 1px;
        text-align: left;
        border-radius: 12px;
      }
        .leaflet-popup-content {
        margin: 13px 24px 13px 20px;
        line-height: 1.3;
        font-size: 13px;
        font-size: 1.08333em;
        min-height: 1px;
      }
        .leaflet-popup-content p {
        margin: 17px 0;
        margin: 1.3em 0;
      }
        .leaflet-popup-tip-container {
        width: 40px;
        height: 20px;
        position: absolute;
        left: 50%;
        margin-top: -1px;
        margin-left: -20px;
        overflow: hidden;
        pointer-events: none;
      }
        .leaflet-popup-tip {
        width: 17px;
        height: 17px;
        padding: 1px;
        
        margin: -10px auto 0;
        pointer-events: auto;
        
        -webkit-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        transform: rotate(45deg);
      }
        .leaflet-popup-content-wrapper,
        .leaflet-popup-tip {
        background: white;
        color: #333;
        box-shadow: 0 3px 14px rgba(0,0,0,0.4);
      }
        .leaflet-container a.leaflet-popup-close-button {
        position: absolute;
        top: 0;
        right: 0;
        border: none;
        text-align: center;
        width: 24px;
        height: 24px;
        font: 16px/24px Tahoma, Verdana, sans-serif;
        color: #757575;
        text-decoration: none;
        background: transparent;
      }
        .leaflet-container a.leaflet-popup-close-button:hover,
        .leaflet-container a.leaflet-popup-close-button:focus {
        color: #585858;
      }
        .leaflet-popup-scrolled {
        overflow: auto;
      }
        
        .leaflet-oldie .leaflet-popup-content-wrapper {
        -ms-zoom: 1;
      }
        .leaflet-oldie .leaflet-popup-tip {
        width: 24px;
        margin: 0 auto;
        
        -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678)";
        filter: progid:DXImageTransform.Microsoft.Matrix(M11=0.70710678, M12=0.70710678, M21=-0.70710678, M22=0.70710678);
      }
        
        .leaflet-oldie .leaflet-control-zoom,
        .leaflet-oldie .leaflet-control-layers,
        .leaflet-oldie .leaflet-popup-content-wrapper,
        .leaflet-oldie .leaflet-popup-tip {
        border: 1px solid #999;
      }
        
        
        /* div icon */
        
        .leaflet-div-icon {
        background: #fff;
        border: 1px solid #666;
      }
        
        
        /* Tooltip */
        /* Base styles for the element that has a tooltip */
        .leaflet-tooltip {
        position: absolute;
        padding: 6px;
        background-color: #fff;
        border: 1px solid #fff;
        border-radius: 3px;
        color: #222;
        white-space: nowrap;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
        pointer-events: none;
        box-shadow: 0 1px 3px rgba(0,0,0,0.4);
      }
        .leaflet-tooltip.leaflet-interactive {
        cursor: pointer;
        pointer-events: auto;
      }
        .leaflet-tooltip-top:before,
        .leaflet-tooltip-bottom:before,
        .leaflet-tooltip-left:before,
        .leaflet-tooltip-right:before {
        position: absolute;
        pointer-events: none;
        border: 6px solid transparent;
        background: transparent;
        content: "";
      }
        
        /* Directions */
        
        .leaflet-tooltip-bottom {
        margin-top: 6px;
      }
        .leaflet-tooltip-top {
        margin-top: -6px;
      }
        .leaflet-tooltip-bottom:before,
        .leaflet-tooltip-top:before {
        left: 50%;
        margin-left: -6px;
      }
        .leaflet-tooltip-top:before {
        bottom: 0;
        margin-bottom: -12px;
        border-top-color: #fff;
      }
        .leaflet-tooltip-bottom:before {
        top: 0;
        margin-top: -12px;
        margin-left: -6px;
        border-bottom-color: #fff;
      }
        .leaflet-tooltip-left {
        margin-left: -6px;
      }
        .leaflet-tooltip-right {
        margin-left: 6px;
      }
        .leaflet-tooltip-left:before,
        .leaflet-tooltip-right:before {
        top: 50%;
        margin-top: -6px;
      }
        .leaflet-tooltip-left:before {
        right: 0;
        margin-right: -12px;
        border-left-color: #fff;
      }
        .leaflet-tooltip-right:before {
        left: 0;
        margin-left: -12px;
        border-right-color: #fff;
      }
        
        /* Printing */
        
        @media print {
        /* Prevent printers from removing background-images of controls. */
        .leaflet-control {
        -webkit-print-color-adjust: exact;
        print-color-adjust: exact;
      }
      }

      .customMapShape {
        filter: drop-shadow(4px 4px 16px rgba(0, 0, 0, 0.25));
        -webkit-filter: drop-shadow(4px 4px 16px rgba(0, 0, 0, 0.25));
      }
      ` });
};

// src/components/PinStyles.tsx
import { jsx as jsx7 } from "react/jsx-runtime";
var PinStyles = () => {
  return /* @__PURE__ */ jsx7("style", { children: `
    .way-map path {
      stroke-width: 1px !important;
      stroke-opacity: 1 !important;
      position: relative;
      filter: drop-shadow(0px 0px 16px rgba(0, 0, 0, 0.25));
    }

    .way-map path.selected {
      stroke-opacity: 1 !important;
      filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.6));
    }

    .way-map path.focused {
      filter: drop-shadow(0px 0px 32px rgba(0, 0, 0, 0.6));
    }

    .way-map path.disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }

    .shape-tooltip {
      background: unset;
      border: none;
      box-shadow: none;
    }
  
    .shape-tooltip span {
      font-size: 1.2em;
      color: #fff;
    }

    .shape-tooltip span.selected {
      color: #000 !important;
    }
    ` });
};

// src/components/Map.tsx
import { Fragment, jsx as jsx8, jsxs } from "react/jsx-runtime";
var useOnMapZoom = (mapRef, onZoom) => {
  const handleZoom = useCallback2(() => {
    onZoom(Math.round((mapRef.current?.getZoom() ?? 0) * 1e3) / 1e3);
  }, [mapRef, onZoom]);
  useEffect3(() => {
    mapRef.current?.on("zoomend", handleZoom);
    const _map = mapRef.current;
    return () => {
      _map?.off("zoomend", handleZoom);
    };
  }, [mapRef.current, handleZoom]);
};
var useZoomInfo = (imageUrl, width, height) => {
  const frameAspectRatio = width / height;
  const imgDimensions = useGetImageDimensions(imageUrl) || {
    width: 1,
    height: 1,
    ratio: 1
  };
  const referenceSide = frameAspectRatio < imgDimensions.ratio ? "height" : "width";
  const frame = {
    width,
    height
  };
  const scaledImage = {
    width: imgDimensions.width * (frame[referenceSide] / imgDimensions[referenceSide]),
    height: imgDimensions.height * (frame[referenceSide] / imgDimensions[referenceSide])
  };
  let minZoom = 0;
  if (imgDimensions.ratio > frameAspectRatio) {
    minZoom = -Math.log2(imgDimensions.ratio / frameAspectRatio);
  } else {
    minZoom = -Math.log2(frameAspectRatio / imgDimensions.ratio);
  }
  const maxZoom = 3;
  return {
    minZoom: Math.round(minZoom * 1e3) / 1e3,
    maxZoom,
    scaledImage,
    imgDimensions
  };
};
async function newFrame() {
  return new Promise(requestAnimationFrame);
}
var ZOOM_ANIMATION_FRAMES = 15;
var Map2 = ({
  mapRef,
  height,
  width,
  assetUrl,
  alt,
  shapes,
  draggable = true,
  canDragOutsideMap = false,
  onShapeClick,
  onShapeDrag,
  onMapClick,
  translate
}) => {
  const { minZoom, maxZoom, scaledImage, imgDimensions } = useZoomInfo(
    assetUrl ?? default_bg_default,
    width,
    height
  );
  const [currentMapZoom, setCurrentMapZoom] = useState5(minZoom);
  useOnMapZoom(mapRef, setCurrentMapZoom);
  useEffect3(() => {
    setCurrentMapZoom(minZoom);
    mapRef.current?.setZoom(minZoom);
  }, [mapRef.current, minZoom]);
  const currentMapScale = useMemo2(() => {
    return mapRef.current?.getZoomScale(currentMapZoom, minZoom) ?? 1;
  }, [mapRef.current, currentMapZoom, minZoom]);
  const bounds = [
    [0, 0],
    [scaledImage.height, scaledImage.width]
  ];
  const handleZoomIn = useCallback2(async () => {
    if (mapRef.current && currentMapZoom !== maxZoom) {
      const nextZoom = Math.min(maxZoom, currentMapZoom + 1);
      const zoomDiff = nextZoom - currentMapZoom;
      for (let i = 1; i < ZOOM_ANIMATION_FRAMES - 1; i++) {
        mapRef.current.setZoom(
          currentMapZoom + zoomDiff * i / ZOOM_ANIMATION_FRAMES
        );
        await newFrame();
      }
      mapRef.current.setZoom(nextZoom);
      setCurrentMapZoom(nextZoom);
    }
  }, [maxZoom, currentMapZoom, mapRef]);
  const handleZoomOut = useCallback2(async () => {
    if (mapRef.current && currentMapZoom !== minZoom) {
      const nextZoom = Math.max(minZoom, currentMapZoom - 1);
      const zoomDiff = nextZoom - currentMapZoom;
      for (let i = 1; i < ZOOM_ANIMATION_FRAMES - 1; i++) {
        mapRef.current.setZoom(
          currentMapZoom + zoomDiff * i / ZOOM_ANIMATION_FRAMES
        );
        await newFrame();
      }
      mapRef.current.setZoom(nextZoom);
      setCurrentMapZoom(nextZoom);
    }
  }, [minZoom, currentMapZoom, mapRef]);
  if (imgDimensions.width === 1 || imgDimensions.height === 1) {
    return null;
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx8(MapStyle, {}),
    /* @__PURE__ */ jsx8(
      MapWrapper,
      {
        "data-testid": "mapresource",
        className: "way-map",
        onClick: onMapClick,
        children: /* @__PURE__ */ jsxs(
          MapContainer,
          {
            crs: CRS.Simple,
            zoom: currentMapZoom,
            minZoom,
            maxZoom,
            center: [scaledImage.height / 2, scaledImage.width / 2],
            ref: mapRef,
            bounds,
            maxBounds: bounds,
            style: {
              height,
              width,
              position: "relative",
              overflow: "hidden",
              backgroundImage: `url(${assetUrl ?? default_bg_default})`,
              backgroundSize: "cover"
            },
            wheelPxPerZoomLevel: 10,
            zoomSnap: 1e-3,
            zoomAnimation: false,
            touchZoom: true,
            doubleClickZoom: false,
            zoomControl: false,
            children: [
              /* @__PURE__ */ jsxs(CustomControls, { children: [
                /* @__PURE__ */ jsx8(
                  CustomZoomButton,
                  {
                    "aria-label": translate?.("zoomIn") ?? "zoom in",
                    onClick: handleZoomIn,
                    children: "+"
                  }
                ),
                /* @__PURE__ */ jsx8(
                  CustomZoomButton,
                  {
                    "aria-label": translate?.("zoomOut") ?? "zoom out",
                    onClick: handleZoomOut,
                    children: "-"
                  }
                )
              ] }),
              /* @__PURE__ */ jsx8(PinStyles, {}),
              /* @__PURE__ */ jsx8(BackgroundFilter, {}),
              /* @__PURE__ */ jsx8(
                ImageOverlay,
                {
                  bounds,
                  url: assetUrl ?? default_bg_default,
                  alt
                }
              ),
              Object.values(shapes).map((shape) => /* @__PURE__ */ jsx8(
                Shape2,
                {
                  ...shape,
                  x: shape.x * scaledImage.width / 100,
                  y: scaledImage.height - shape.y * scaledImage.height / 100,
                  onClick: (s) => {
                    onShapeClick?.(s);
                    shape.onClick?.(s);
                  },
                  onDrag: (s) => {
                    s.x = s.x * 100 / scaledImage.width;
                    s.y = 100 - s.y * 100 / scaledImage.height;
                    onShapeDrag?.(s);
                    shape.onDrag?.(s);
                  },
                  currentMapScale,
                  draggable: draggable && shape.draggable,
                  canDragOutsideMap,
                  mapSize: scaledImage
                },
                `${shape.id}-${shape.label}-${shape.color}`
              ))
            ]
          }
        )
      }
    )
  ] });
};
var MapWrapper = styled.div`
  position: relative;

  .leaflet-control-attribution {
    display: none;
  }
`;
var BackgroundFilter = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(30px);
`;
var CustomControls = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  margin: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 500;
  width: 30px;
  height: 60px;
  box-shadow: var(
    --way-design-boxShadow-s,
    0px 4px 6px -1px rgba(0, 0, 0, 0.04)
  );
`;
var CustomZoomButton = styled.button`
  appearance: auto;
  background: revert;
  width: 100%;
  height: 50%;
  border-width: 0;
  font-size: 1.75em;
  cursor: pointer;

  &:first-child {
    border-bottom: 1px solid lightgray;
  }
`;

// src/utils/shape.formatter.ts
var DESKTOP_PIN_SIZE = 36;
var MOBILE_PIN_SIZE = 24;
var formatResourceAsShape = ({
  resource,
  size,
  isSelected = false,
  isFocused = false,
  draggable = false
}) => ({
  id: resource.id,
  type: resource.shape.type,
  x: resource.position?.x || 0,
  y: resource.position?.y || 0,
  name: resource.title,
  width: size,
  height: size,
  color: resource.shape.color,
  disabled: resource.unavailable ?? false,
  tooltip: resource.unavailable ? "Unavailable" : void 0,
  opacity: 1,
  label: resource.number[0] === "#" ? resource.number.slice(1) : resource.number,
  draggable,
  isSelected,
  isFocused,
  maximumAllowedToBook: resource.maximumAllowedToBook
});
function formatResourceGroupToShapes(resourceGroup, containerSize, imageSize, { focusedResources, selectedResource, draggable } = {}) {
  const shapes = {};
  const isMobile = containerSize.width < 400 || containerSize.height < 400;
  let pinSize = isMobile ? MOBILE_PIN_SIZE : DESKTOP_PIN_SIZE;
  const containerRatio = containerSize.width / containerSize.height;
  const imageRatio = imageSize.width / imageSize.height;
  const mapVsContainerRatio = containerRatio / imageRatio;
  if (mapVsContainerRatio) {
    if (containerRatio < imageRatio) {
      pinSize = pinSize / mapVsContainerRatio;
    } else {
      pinSize = pinSize * mapVsContainerRatio;
    }
  }
  Object.values(resourceGroup.experiences).forEach((experience) => {
    if (experience.shape && experience.number) {
      shapes[experience.id] = formatResourceAsShape({
        resource: experience,
        size: pinSize,
        isFocused: focusedResources?.has(experience.id) || false,
        isSelected: selectedResource === experience.id,
        draggable
      });
    }
  });
  return shapes;
}
function getShapesFromResourceGroups(resourceGroups, containerSize, imageSize, customOption = {}) {
  const shapes = {};
  resourceGroups.forEach((group) => {
    Object.assign(
      shapes,
      formatResourceGroupToShapes(
        group,
        containerSize,
        imageSize,
        customOption
      )
    );
  });
  return shapes;
}
export {
  CircleShape,
  DraggableCircle,
  DraggableRectangle,
  Map2 as Map,
  RectangleShape,
  Shape,
  ShapesContext,
  ShapesContextProvider,
  getShapesFromResourceGroups,
  useDraggableShape,
  useGetImageDimensions,
  useShapes
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.js.map